/**
 * ZIP Code to Earthwise Seed Climate Region Mapping
 * Generated: 2025-12-15T16:27:25.058Z
 * Source: zip_to_region_final.csv
 * Total ZIP codes: 32657
 *
 * Regions:
 * 1w - Cold & Humid West
 * 1e - Cold & Humid East
 * 2w - Cool & Humid West
 * 2e - Cool & Humid East
 * 3w - Temperate & Humid West
 * 3e - Temperate & Humid East
 * 4  - Hot & Humid
 * 5  - Cool & Dry
 * 6  - Hot & Dry
 * 7  - Temperate & Mixed
 */

const zipToClimateRegion = {
  "81137": "5",
  "80823": "5",
  "81237": "5",
  "81251": "5",
  "81435": "5",
  "81413": "5",
  "81040": "5",
  "80745": "5",
  "81252": "5",
  "81330": "5",
  "83352": "5",
  "83836": "5",
  "83283": "5",
  "83867": "5",
  "83554": "5",
  "83442": "5",
  "83611": "5",
  "83617": "5",
  "83341": "5",
  "83332": "5",
  "83321": "5",
  "15445": "2e",
  "16114": "2e",
  "18224": "2e",
  "18825": "2e",
  "18822": "2e",
  "17855": "2e",
  "17048": "2e",
  "17342": "2e",
  "15488": "2e",
  "18933": "2e",
  "18946": "2e",
  "16620": "2e",
  "15753": "2e",
  "18920": "2e",
  "16332": "2e",
  "18441": "2e",
  "19436": "2e",
  "17749": "2e",
  "19490": "2e",
  "18936": "2e",
  "68431": "2w",
  "68364": "2w",
  "68658": "2w",
  "68788": "2w",
  "68018": "2w",
  "68050": "2w",
  "68855": "2w",
  "68834": "2w",
  "68874": "2w",
  "68015": "2w",
  "68414": "2w",
  "68812": "2w",
  "68632": "2w",
  "68421": "2w",
  "68417": "2w",
  "68878": "2w",
  "68734": "2w",
  "68820": "2w",
  "68719": "2w",
  "68778": "2w",
  "68637": "2w",
  "68332": "2w",
  "68773": "2w",
  "68635": "2w",
  "68667": "2w",
  "68379": "2w",
  "68380": "2w",
  "68382": "2w",
  "68745": "2w",
  "68722": "2w",
  "68790": "2w",
  "68783": "2w",
  "68111": "2w",
  "68131": "2w",
  "68510": "2w",
  "68025": "2w",
  "68108": "2w",
  "68524": "2w",
  "69351": "2w",
  "68028": "2w",
  "69367": "5",
  "68406": "2w",
  "68046": "2w",
  "68416": "2w",
  "68365": "2w",
  "68142": "2w",
  "68164": "2w",
  "68116": "2w",
  "69143": "2w",
  "69358": "5",
  "69169": "2w",
  "68357": "2w",
  "68649": "2w",
  "68947": "2w",
  "68633": "2w",
  "66866": "2w",
  "67522": "2w",
  "67735": "2w",
  "67020": "2w",
  "66438": "2w",
  "66540": "2w",
  "66090": "2w",
  "67480": "2w",
  "66406": "2w",
  "66403": "2w",
  "67232": "2w",
  "67117": "2w",
  "66109": "2w",
  "66621": "2w",
  "66543": "2w",
  "67647": "2w",
  "66428": "2w",
  "66415": "2w",
  "67452": "2w",
  "67854": "2w",
  "66423": "2w",
  "66861": "2w",
  "66434": "2w",
  "66085": "2w",
  "67478": "2w",
  "67731": "2w",
  "66550": "2w",
  "67467": "2w",
  "66071": "2w",
  "66970": "2w",
  "67423": "2w",
  "66761": "2w",
  "66714": "2w",
  "67660": "2w",
  "67638": "2w",
  "67674": "2w",
  "67623": "2w",
  "19731": "2e",
  "19736": "2e",
  "19702": "2e",
  "19701": "2e",
  "19803": "2e",
  "19735": "2e",
  "19732": "2e",
  "19979": "2e",
  "19940": "3e",
  "19804": "2e",
  "19802": "2e",
  "19810": "2e",
  "19709": "2e",
  "19960": "2e",
  "19968": "2e",
  "19958": "2e",
  "19967": "3e",
  "19805": "2e",
  "19734": "2e",
  "19716": "2e",
  "19950": "2e",
  "19933": "2e",
  "19956": "3e",
  "19955": "2e",
  "19934": "2e",
  "19941": "2e",
  "19953": "2e",
  "19964": "2e",
  "19936": "2e",
  "19902": "2e",
  "19977": "2e",
  "19710": "2e",
  "19717": "2e",
  "19943": "2e",
  "19963": "2e",
  "19730": "2e",
  "19954": "2e",
  "19945": "3e",
  "19970": "3e",
  "19939": "3e",
  "19944": "3e",
  "21874": "3e",
  "19720": "2e",
  "19706": "2e",
  "19947": "2e",
  "19971": "2e",
  "19930": "3e",
  "19951": "2e",
  "19931": "3e",
  "19707": "2e",
  "19801": "2e",
  "19703": "2e",
  "19807": "2e",
  "19904": "2e",
  "19952": "2e",
  "19946": "2e",
  "19973": "2e",
  "19938": "2e",
  "21912": "2e",
  "19975": "3e",
  "19808": "2e",
  "19711": "2e",
  "19809": "2e",
  "19901": "2e",
  "19962": "2e",
  "19966": "2e",
  "19980": "2e",
  "84408": "5",
  "84725": "5",
  "84071": "5",
  "84784": "5",
  "84054": "5",
  "84083": "5",
  "84324": "5",
  "84733": "5",
  "84086": "5",
  "84064": "5",
  "84063": "5",
  "84340": "5",
  "84060": "5",
  "84330": "5",
  "84312": "5",
  "84774": "5",
  "84306": "5",
  "84051": "5",
  "84637": "5",
  "84654": "5",
  "84620": "5",
  "84638": "5",
  "84724": "5",
  "84518": "5",
  "84522": "5",
  "84711": "5",
  "84630": "5",
  "84335": "5",
  "84663": "5",
  "84602": "5",
  "84308": "5",
  "84628": "5",
  "84648": "5",
  "84010": "5",
  "84651": "5",
  "84318": "5",
  "84653": "5",
  "84106": "5",
  "84113": "5",
  "84102": "5",
  "84096": "5",
  "84129": "5",
  "84401": "5",
  "84782": "5",
  "84029": "5",
  "84074": "5",
  "84737": "5",
  "84049": "5",
  "84039": "5",
  "84072": "5",
  "84026": "5",
  "84085": "5",
  "84336": "5",
  "84046": "5",
  "84316": "5",
  "84743": "5",
  "84078": "5",
  "84082": "5",
  "84036": "5",
  "84023": "5",
  "84061": "5",
  "84098": "5",
  "84001": "5",
  "84732": "5",
  "84512": "5",
  "84624": "5",
  "84656": "5",
  "84050": "5",
  "84640": "5",
  "84728": "5",
  "84523": "5",
  "84035": "5",
  "84516": "5",
  "84649": "5",
  "84321": "5",
  "84003": "5",
  "84716": "5",
  "03826": "2e",
  "03037": "2e",
  "03263": "1e",
  "03216": "1e",
  "03293": "1e",
  "03076": "2e",
  "03241": "1e",
  "03854": "2e",
  "03603": "1e",
  "03607": "1e",
  "03280": "1e",
  "03465": "2e",
  "03218": "1e",
  "03466": "2e",
  "03467": "2e",
  "03457": "2e",
  "03301": "1e",
  "03445": "2e",
  "03032": "2e",
  "03060": "2e",
  "03070": "2e",
  "03101": "2e",
  "03812": "1e",
  "03845": "1e",
  "03275": "2e",
  "03084": "2e",
  "03264": "1e",
  "03052": "2e",
  "03276": "1e",
  "03856": "2e",
  "03242": "1e",
  "03584": "1e",
  "03811": "2e",
  "03868": "1e",
  "03588": "1e",
  "03585": "1e",
  "03784": "1e",
  "03580": "1e",
  "03231": "1e",
  "03862": "2e",
  "03257": "1e",
  "03869": "1e",
  "03273": "1e",
  "03827": "2e",
  "03852": "1e",
  "03819": "2e",
  "03887": "1e",
  "03581": "1e",
  "03251": "1e",
  "03864": "1e",
  "03768": "1e",
  "03220": "1e",
  "62914": "3w",
  "62828": "2e",
  "61928": "2e",
  "62618": "2e",
  "60934": "2e",
  "61030": "2e",
  "61769": "2e",
  "61313": "2e",
  "61424": "2e",
  "61039": "2e",
  "61338": "2e",
  "61312": "2e",
  "61354": "2e",
  "61372": "2e",
  "61315": "2e",
  "61323": "2e",
  "61346": "2e",
  "60962": "2e",
  "62941": "3e",
  "62970": "3e",
  "61353": "2e",
  "61349": "2e",
  "61833": "2e",
  "61606": "2e",
  "61773": "2e",
  "61358": "2e",
  "62681": "2e",
  "62378": "2e",
  "62928": "3e",
  "62995": "3e",
  "61050": "2e",
  "61261": "2e",
  "61912": "2e",
  "61251": "2e",
  "61822": "2e",
  "61834": "2e",
  "61042": "2e",
  "60424": "2e",
  "62549": "2e",
  "61458": "2e",
  "61410": "2e",
  "62706": "2e",
  "60636": "2e",
  "60647": "2e",
  "60628": "2e",
  "61572": "2e",
  "60552": "2e",
  "60150": "2e",
  "60629": "2e",
  "62523": "2e",
  "62693": "2e",
  "60804": "2e",
  "62690": "2e",
  "62563": "2e",
  "61776": "2e",
  "61517": "2e",
  "62520": "2e",
  "61569": "2e",
  "61451": "2e",
  "61112": "2e",
  "61077": "2e",
  "61047": "2e",
  "61730": "2e",
  "62346": "2e",
  "62339": "2e",
  "62035": "2w",
  "60626": "2e",
  "60936": "2e",
  "62348": "2e",
  "62054": "2e",
  "62204": "2e",
  "62272": "2e",
  "61450": "2e",
  "62316": "2e",
  "62022": "2w",
  "60913": "2e",
  "62673": "2e",
  "62360": "2e",
  "61811": "2e",
  "38112": "3w",
  "37408": "4",
  "37206": "3e",
  "38362": "3e",
  "37411": "4",
  "37934": "3e",
  "38152": "3e",
  "37072": "3e",
  "37308": "3e",
  "38115": "3e",
  "37353": "3e",
  "38301": "3e",
  "37405": "3e",
  "37302": "4",
  "37203": "3e",
  "37211": "3e",
  "37143": "3e",
  "37086": "3e",
  "38132": "3w",
  "37854": "3e",
  "38141": "3e",
  "37153": "3e",
  "37167": "3e",
  "37617": "3e",
  "37857": "3e",
  "37180": "3e",
  "37016": "3e",
  "37085": "3e",
  "37618": "3e",
  "37067": "3e",
  "37356": "3e",
  "37873": "3e",
  "37110": "3e",
  "37055": "3e",
  "37365": "3e",
  "37694": "3e",
  "37869": "3e",
  "37179": "3e",
  "37615": "3e",
  "37062": "3e",
  "37745": "3e",
  "38340": "3e",
  "37083": "3e",
  "38059": "3e",
  "38332": "3e",
  "38241": "3e",
  "37096": "3e",
  "38220": "3e",
  "37766": "3e",
  "38580": "3e",
  "37150": "3e",
  "37019": "3e",
  "37339": "3e",
  "37190": "3e",
  "38562": "3e",
  "19435": "2e",
  "18823": "2e",
  "18631": "2e",
  "16680": "2e",
  "16616": "2e",
  "15413": "2e",
  "18925": "2e",
  "18640": "2e",
  "18651": "2e",
  "18844": "2e",
  "19492": "2e",
  "17090": "2e",
  "17876": "2e",
  "18812": "2e",
  "15416": "2e",
  "18980": "2e",
  "18321": "2e",
  "18512": "2e",
  "16134": "2e",
  "18828": "2e",
  "17730": "2e",
  "17886": "2e",
  "17721": "2e",
  "15460": "2e",
  "18627": "2e",
  "16036": "2e",
  "17076": "2e",
  "18225": "2e",
  "15422": "2e",
  "15484": "2e",
  "18420": "2e",
  "18962": "2e",
  "03110": "2e",
  "03590": "1e",
  "03846": "1e",
  "03886": "1e",
  "03830": "1e",
  "03304": "1e",
  "03835": "1e",
  "03229": "1e",
  "03221": "1e",
  "03071": "2e",
  "03034": "2e",
  "03766": "1e",
  "03291": "2e",
  "03287": "1e",
  "03842": "2e",
  "03780": "1e",
  "03755": "1e",
  "03765": "1e",
  "03447": "2e",
  "03461": "2e",
  "03448": "2e",
  "03441": "2e",
  "03462": "2e",
  "03284": "1e",
  "02132": "2e",
  "02746": "2e",
  "01921": "2e",
  "01966": "2e",
  "02713": "2e",
  "01603": "2e",
  "01562": "2e",
  "02790": "2e",
  "01005": "2e",
  "01505": "2e",
  "01545": "2e",
  "19406": "2e",
  "19152": "2e",
  "19473": "2e",
  "16214": "2e",
  "19072": "2e",
  "19002": "2e",
  "18656": "2e",
  "19444": "2e",
  "17821": "2e",
  "17868": "2e",
  "18076": "2e",
  "16334": "2e",
  "19027": "2e",
  "19462": "2e",
  "17881": "2e",
  "17350": "2e",
  "16125": "2e",
  "15436": "2e",
  "15486": "2e",
  "17071": "2e",
  "15437": "2e",
  "17815": "2e",
  "15447": "2e",
  "18221": "2e",
  "18821": "2e",
  "17747": "2e",
  "17032": "2e",
  "16130": "2e",
  "17303": "2e",
  "18818": "2e",
  "18440": "2e",
  "17097": "2e",
  "19374": "2e",
  "16661": "2e",
  "15469": "2e",
  "18356": "2e",
  "15444": "2e",
  "18219": "2e",
  "17865": "2e",
  "17069": "2e",
  "15451": "2e",
  "16213": "2e",
  "18333": "2e",
  "19345": "2e",
  "19367": "2e",
  "16881": "2e",
  "16830": "2e",
  "16843": "2e",
  "16838": "2e",
  "50591": "2w",
  "50541": "2w",
  "50582": "2w",
  "50520": "2w",
  "50577": "2w",
  "51440": "2w",
  "50524": "2w",
  "50327": "2w",
  "50236": "2w",
  "52404": "2w",
  "50266": "2w",
  "50064": "2w",
  "50863": "2w",
  "52572": "2w",
  "50835": "2w",
  "51238": "1w",
  "50232": "2w",
  "50005": "2w",
  "50671": "2w",
  "50658": "1w",
  "52749": "2w",
  "51343": "1w",
  "50129": "2w",
  "50862": "2w",
  "50324": "2w",
  "50681": "2w",
  "51105": "2w",
  "50063": "2w",
  "52720": "2w",
  "52766": "2w",
  "50311": "2w",
  "51106": "2w",
  "50268": "2w",
  "51431": "2w",
  "51052": "2w",
  "52050": "2w",
  "52214": "2w",
  "51041": "1w",
  "51232": "1w",
  "51528": "2w",
  "52756": "2w",
  "50042": "2w",
  "52411": "2w",
  "50531": "1w",
  "52569": "2w",
  "50569": "2w",
  "52755": "2w",
  "52341": "2w",
  "52807": "2w",
  "50530": "2w",
  "50027": "2w",
  "50574": "2w",
  "51244": "1w",
  "51525": "2w",
  "50675": "2w",
  "51249": "1w",
  "52233": "2w",
  "52751": "2w",
  "52777": "2w",
  "51560": "2w",
  "50116": "2w",
  "51575": "2w",
  "50482": "1w",
  "50118": "2w",
  "50105": "2w",
  "50274": "2w",
  "50471": "1w",
  "52655": "2w",
  "51357": "1w",
  "52567": "2w",
  "51049": "2w",
  "52147": "1w",
  "50252": "2w",
  "50450": "1w",
  "50525": "2w",
  "50446": "1w",
  "52574": "2w",
  "50473": "1w",
  "50102": "2w",
  "52721": "2w",
  "50434": "1w",
  "50478": "1w",
  "58006": "1w",
  "58004": "1w",
  "58257": "1w",
  "58249": "1w",
  "58281": "1w",
  "58365": "1w",
  "58317": "1w",
  "58528": "1w",
  "58021": "1w",
  "58379": "1w",
  "58250": "1w",
  "58238": "1w",
  "58282": "1w",
  "58265": "1w",
  "58230": "1w",
  "58008": "1w",
  "58036": "1w",
  "58352": "1w",
  "58241": "1w",
  "58372": "1w",
  "58339": "1w",
  "58636": "1w",
  "58640": "1w",
  "58632": "1w",
  "58627": "1w",
  "58645": "1w",
  "58735": "1w",
  "58531": "1w",
  "58571": "1w",
  "58625": "1w",
  "58641": "1w",
  "58554": "1w",
  "58318": "1w",
  "58783": "1w",
  "58748": "1w",
  "58852": "1w",
  "58718": "1w",
  "58727": "1w",
  "58758": "1w",
  "58438": "1w",
  "56744": "1w",
  "58501": "1w",
  "58202": "1w",
  "58785": "1w",
  "58494": "1w",
  "58480": "1w",
  "58466": "1w",
  "58562": "1w",
  "58461": "1w",
  "58569": "1w",
  "58712": "1w",
  "58794": "1w",
  "58069": "1w",
  "58053": "1w",
  "44045": "2e",
  "43420": "2e",
  "43832": "2e",
  "43431": "2e",
  "45172": "2e",
  "45132": "2e",
  "45771": "2e",
  "43320": "2e",
  "45148": "2e",
  "45880": "2e",
  "44903": "2e",
  "45715": "2e",
  "45786": "2e",
  "43127": "2e",
  "43317": "2e",
  "43793": "2e",
  "45365": "2e",
  "45782": "2e",
  "43976": "2e",
  "45302": "2e",
  "45862": "2e",
  "45780": "2e",
  "45789": "2e",
  "44624": "2e",
  "44676": "2e",
  "43901": "2e",
  "45742": "2e",
  "44665": "2e",
  "44068": "2e",
  "45435": "2e",
  "43414": "2e",
  "43909": "2e",
  "45893": "2e",
  "44901": "2e",
  "43541": "2e",
  "45848": "2e",
  "44274": "2e",
  "44555": "2e",
  "59036": "5",
  "59046": "5",
  "59070": "5",
  "59410": "5",
  "59087": "5",
  "59059": "5",
  "59601": "5",
  "59223": "1w",
  "59425": "5",
  "59482": "5",
  "59344": "1w",
  "59733": "5",
  "59463": "5",
  "59062": "5",
  "59926": "5",
  "59729": "5",
  "59913": "5",
  "59215": "1w",
  "59725": "5",
  "59037": "5",
  "59014": "5",
  "59743": "5",
  "59927": "5",
  "59754": "5",
  "59602": "5",
  "59749": "5",
  "59065": "5",
  "59735": "5",
  "59844": "5",
  "59840": "5",
  "59025": "5",
  "59832": "5",
  "59851": "5",
  "59846": "5",
  "59001": "5",
  "59061": "5",
  "59035": "5",
  "59848": "5",
  "59450": "5",
  "59446": "5",
  "59263": "1w",
  "59332": "1w",
  "59254": "1w",
  "59243": "1w",
  "59225": "1w",
  "59248": "1w",
  "59022": "5",
  "59827": "5",
  "59636": "5",
  "59483": "5",
  "59338": "1w",
  "59055": "5",
  "59313": "1w",
  "59086": "5",
  "59859": "5",
  "59454": "5",
  "59761": "5",
  "59351": "5",
  "59802": "5",
  "59479": "5",
  "59731": "5",
  "59746": "5",
  "59856": "5",
  "59919": "5",
  "59047": "5",
  "14845": "2e",
  "13357": "1e",
  "10509": "2e",
  "10177": "2e",
  "14903": "2e",
  "13760": "2e",
  "12545": "2e",
  "10154": "2e",
  "14220": "1e",
  "10920": "2e",
  "12543": "2e",
  "10502": "2e",
  "13339": "1e",
  "12582": "2e",
  "11510": "2e",
  "75428": "3w",
  "76043": "3w",
  "76459": "3w",
  "77961": "4",
  "79094": "2w",
  "78016": "6",
  "75453": "3w",
  "75942": "4",
  "75928": "4",
  "76936": "6",
  "78577": "4",
  "75010": "3w",
  "78549": "4",
  "78543": "4",
  "78599": "4",
  "76469": "6",
  "78565": "4",
  "77519": "4",
  "75062": "3w",
  "75244": "3w",
  "75205": "3w",
  "75060": "3w",
  "79525": "6",
  "75243": "3w",
  "75040": "3w",
  "75041": "3w",
  "78717": "6",
  "76379": "3w",
  "78516": "4",
  "76201": "3w",
  "78501": "4",
  "75216": "3w",
  "75241": "3w",
  "75835": "3w",
  "76474": "6",
  "79062": "2w",
  "79063": "2w",
  "75448": "3w",
  "79230": "3w",
  "79777": "6",
  "77871": "3w",
  "76869": "6",
  "78542": "4",
  "75072": "3w",
  "77657": "4",
  "76544": "6",
  "76543": "6",
  "78538": "4",
  "76437": "6",
  "75407": "3w",
  "75442": "3w",
  "75252": "3w",
  "75044": "3w",
  "75164": "3w",
  "76106": "3w",
  "78732": "6",
  "76103": "3w",
  "76063": "3w",
  "77010": "4",
  "76020": "3w",
  "76013": "3w",
  "75052": "3w",
  "78204": "6",
  "76012": "3w",
  "78234": "6",
  "76129": "3w",
  "76022": "3w",
  "78124": "6",
  "78152": "6",
  "76033": "3w",
  "78148": "6",
  "78261": "6",
  "76044": "3w",
  "76049": "3w",
  "76070": "3w",
  "78225": "6",
  "76048": "3w",
  "78211": "6",
  "78258": "6",
  "76066": "3w",
  "78002": "6",
  "78213": "6",
  "77016": "4",
  "77029": "4",
  "47236": "2e",
  "47870": "2e",
  "47851": "2e",
  "47337": "2e",
  "47435": "2e",
  "47514": "3e",
  "46045": "2e",
  "46206": "2e",
  "46704": "2e",
  "47585": "3e",
  "46534": "2e",
  "46127": "2e",
  "47660": "3e",
  "47597": "2e",
  "47424": "2e",
  "47519": "2e",
  "46235": "2e",
  "46118": "2e",
  "46224": "2e",
  "46256": "2e",
  "47948": "2e",
  "47951": "2e",
  "46254": "2e",
  "46077": "2e",
  "47575": "3e",
  "46910": "2e",
  "47432": "2e",
  "46120": "2e",
  "47841": "2e",
  "46552": "2e",
  "47633": "3e",
  "47631": "3e",
  "47620": "3e",
  "47616": "3e",
  "46759": "2e",
  "47438": "2e",
  "46731": "2e",
  "47404": "2e",
  "46970": "2e",
  "47584": "3e",
  "46761": "2e",
  "46571": "2e",
  "47283": "2e",
  "46750": "2e",
  "46590": "2e",
  "46368": "2e",
  "47371": "2e",
  "47421": "2e",
  "46143": "2e",
  "47234": "2e",
  "47380": "2e",
  "46071": "2e",
  "47138": "2e",
  "46510": "2e",
  "47336": "2e",
  "47227": "2e",
  "47170": "2e",
  "47282": "2e",
  "47959": "2e",
  "46130": "2e",
  "47982": "2e",
  "47320": "2e",
  "47991": "2e",
  "47038": "2e",
  "47374": "2e",
  "46920": "2e",
  "46985": "2e",
  "47994": "2e",
  "47955": "2e",
  "47957": "2e",
  "47172": "2e",
  "40291": "3e",
  "42081": "3e",
  "42003": "3e",
  "40509": "3e",
  "40071": "3e",
  "41005": "2e",
  "40215": "3e",
  "41169": "3e",
  "41063": "2e",
  "40025": "3e",
  "40511": "3e",
  "42701": "3e",
  "40502": "3e",
  "42301": "3e",
  "42049": "3e",
  "40003": "3e",
  "40212": "3e",
  "42171": "3e",
  "42370": "3e",
  "41049": "3e",
  "40336": "3e",
  "41006": "2e",
  "42603": "3e",
  "42347": "3e",
  "42079": "3e",
  "42088": "3e",
  "40374": "3e",
  "42170": "3e",
  "40769": "3e",
  "41179": "3e",
  "41040": "2e",
  "42743": "3e",
  "40468": "3e",
  "42518": "3e",
  "42273": "3e",
  "42038": "3e",
  "40902": "3e",
  "41603": "3e",
  "42411": "3e",
  "41640": "3e",
  "41095": "2e",
  "41086": "2e",
  "41553": "3e",
  "41311": "3e",
  "41003": "3e",
  "42437": "3e",
  "42206": "3e",
  "42653": "3e",
  "42408": "3e",
  "41659": "3e",
  "41256": "3e",
  "41840": "3e",
  "42265": "3e",
  "42254": "3e",
  "41568": "3e",
  "41539": "3e",
  "41425": "3e",
  "40040": "3e",
  "40440": "3e",
  "40915": "3e",
  "42441": "3e",
  "42324": "3e",
  "41124": "3e",
  "41201": "3e",
  "40949": "3e",
  "41621": "3e",
  "48438": "1e",
  "48167": "2e",
  "48202": "2e",
  "48150": "2e",
  "48135": "2e",
  "48141": "2e",
  "48120": "2e",
  "48059": "1e",
  "48074": "1e",
  "48166": "2e",
  "48114": "2e",
  "49827": "1e",
  "49838": "1e",
  "49876": "1e",
  "48911": "2e",
  "49508": "1e",
  "48861": "2e",
  "49302": "1e",
  "49635": "1e",
  "48733": "1e",
  "48473": "1e",
  "49101": "2e",
  "48502": "1e",
  "49029": "2e",
  "49128": "2e",
  "49506": "1e",
  "49125": "2e",
  "48529": "1e",
  "49782": "1e",
  "49113": "2e",
  "49115": "2e",
  "48476": "1e",
  "48417": "1e",
  "48821": "2e",
  "49460": "1e",
  "48437": "1e",
  "49221": "2e",
  "48390": "2e",
  "48381": "2e",
  "49258": "2e",
  "49942": "1e",
  "48896": "1e",
  "48411": "1e",
  "48306": "2e",
  "48309": "2e",
  "28342": "3e",
  "28399": "3e",
  "28601": "3e",
  "27411": "3e",
  "28526": "3e",
  "28673": "3e",
  "28754": "3e",
  "28339": "3e",
  "28021": "3e",
  "28168": "3e",
  "28326": "3e",
  "27215": "3e",
  "28174": "3e",
  "53170": "2e",
  "53192": "2e",
  "53505": "2e",
  "54232": "1e",
  "53939": "1e",
  "53962": "1e",
  "54874": "1e",
  "54127": "1e",
  "54770": "1e",
  "54213": "1e",
  "54175": "1e",
  "54616": "1e",
  "53944": "1e",
  "54082": "1e",
  "53132": "2e",
  "53215": "1e",
  "54129": "1e",
  "53575": "1e",
  "54914": "1e",
  "53065": "1e",
  "54922": "1e",
  "54896": "1e",
  "54941": "1e",
  "53156": "1e",
  "53049": "1e",
  "54301": "1e",
  "54161": "1e",
  "53233": "1e",
  "54229": "1e",
  "54123": "1e",
  "54171": "1e",
  "53090": "1e",
  "53172": "2e",
  "53089": "1e",
  "54565": "1e",
  "54457": "1e",
  "53507": "1e",
  "54173": "1e",
  "54101": "1e",
  "54940": "1e",
  "54007": "1e",
  "54135": "1e",
  "53042": "1e",
  "54552": "1e",
  "53097": "1e",
  "54659": "1e",
  "53558": "1e",
  "54136": "1e",
  "53531": "1e",
  "54494": "1e",
  "54745": "1e",
  "53011": "1e",
  "53569": "1e",
  "54407": "1e",
  "53570": "2e",
  "54853": "1e",
  "54482": "1e",
  "53573": "1e",
  "53502": "2e",
  "54490": "1e",
  "54806": "1e",
  "54651": "1e",
  "54619": "1e",
  "54435": "1e",
  "54728": "1e",
  "54481": "1e",
  "53566": "2e",
  "53543": "1e",
  "54104": "1e",
  "54447": "1e",
  "54498": "1e",
  "54405": "1e",
  "53074": "1e",
  "53157": "2e",
  "53069": "1e",
  "79378": "6",
  "78028": "6",
  "79033": "2w",
  "76389": "3w",
  "75757": "3w",
  "76801": "6",
  "78389": "6",
  "78537": "4",
  "75069": "3w",
  "76501": "6",
  "76511": "6",
  "78574": "4",
  "76541": "6",
  "76357": "3w",
  "78723": "6",
  "75087": "3w",
  "76574": "6",
  "75132": "3w",
  "76116": "3w",
  "76164": "3w",
  "76127": "3w",
  "76114": "3w",
  "78208": "6",
  "75156": "3w",
  "76133": "3w",
  "76132": "3w",
  "76014": "3w",
  "76017": "3w",
  "78210": "6",
  "76262": "3w",
  "76182": "3w",
  "75022": "3w",
  "78219": "6",
  "78101": "6",
  "76093": "3w",
  "78244": "6",
  "78223": "6",
  "76078": "3w",
  "76487": "3w",
  "78227": "6",
  "76439": "3w",
  "78946": "6",
  "78155": "6",
  "78248": "6",
  "78257": "6",
  "79789": "6",
  "78827": "6",
  "79383": "6",
  "75853": "3w",
  "77614": "4",
  "78360": "6",
  "75669": "3w",
  "75886": "3w",
  "75694": "3w",
  "75659": "3w",
  "75115": "3w",
  "75573": "3w",
  "75973": "4",
  "79535": "6",
  "75765": "3w",
  "75475": "3w",
  "79372": "6",
  "79025": "2w",
  "75754": "3w",
  "78842": "6",
  "78611": "6",
  "78065": "6",
  "78164": "6",
  "78029": "6",
  "75429": "3w",
  "75109": "3w",
  "76686": "3w",
  "76642": "3w",
  "76831": "6",
  "78116": "6",
  "78111": "6",
  "79008": "2w",
  "76880": "6",
  "78526": "4",
  "78520": "4",
  "60469": "2e",
  "60429": "2e",
  "60475": "2e",
  "60487": "2e",
  "60190": "2e",
  "60157": "2e",
  "60184": "2e",
  "60510": "2e",
  "60514": "2e",
  "60174": "2e",
  "60101": "2e",
  "60183": "2e",
  "60134": "2e",
  "60136": "2e",
  "60144": "2e",
  "60051": "2e",
  "60099": "2e",
  "62075": "2e",
  "61813": "2e",
  "62875": "2e",
  "62439": "2e",
  "62460": "2e",
  "62640": "2e",
  "62414": "2e",
  "62230": "2e",
  "61336": "2e",
  "62363": "2e",
  "62366": "2e",
  "62668": "2e",
  "62638": "2e",
  "61326": "2e",
  "62895": "2e",
  "61542": "2e",
  "61427": "2e",
  "62988": "3e",
  "62056": "2e",
  "61363": "2e",
  "62685": "2e",
  "61532": "2e",
  "62447": "2e",
  "62510": "2e",
  "62555": "2e",
  "62556": "2e",
  "62947": "3e",
  "62517": "2e",
  "61285": "2e",
  "61052": "2e",
  "61377": "2e",
  "61540": "2e",
  "61740": "2e",
  "61311": "2e",
  "61743": "2e",
  "61369": "2e",
  "61379": "2e",
  "61350": "2e",
  "62219": "2e",
  "62462": "2e",
  "62445": "2e",
  "62217": "2e",
  "62053": "2e",
  "61483": "2e",
  "62611": "2e",
  "62631": "2e",
  "62870": "2e",
  "62899": "2e",
  "62361": "2e",
  "62656": "2e",
  "61855": "2e",
  "62833": "2e",
  "61431": "2e",
  "62353": "2e",
  "61543": "2e",
  "62033": "2e",
  "62051": "2e",
  "62572": "2e",
  "62557": "2e",
  "61340": "2e",
  "62341": "2e",
  "61839": "2e",
  "62336": "2e",
  "62450": "2e",
  "62617": "2e",
  "62649": "2e",
  "62806": "2e",
  "62844": "2e",
  "62633": "2e",
  "62815": "2e",
  "76654": "3w",
  "76561": "6",
  "75390": "3w",
  "75207": "3w",
  "79350": "6",
  "75231": "3w",
  "79838": "6",
  "78368": "6",
  "75134": "3w",
  "75439": "3w",
  "75476": "3w",
  "77969": "6",
  "79547": "6",
  "75770": "3w",
  "78564": "6",
  "76427": "3w",
  "75496": "3w",
  "75068": "3w",
  "76370": "3w",
  "79785": "6",
  "79780": "6",
  "76884": "6",
  "76888": "6",
  "75562": "3w",
  "77837": "3w",
  "76645": "3w",
  "78025": "6",
  "75944": "4",
  "76650": "3w",
  "75135": "3w",
  "75110": "3w",
  "78151": "6",
  "76635": "3w",
  "78117": "6",
  "77359": "3w",
  "78235": "6",
  "77396": "4",
  "77032": "4",
  "77078": "4",
  "77076": "4",
  "78670": "6",
  "77504": "4",
  "77505": "4",
  "77087": "4",
  "77054": "4",
  "77532": "4",
  "78015": "6",
  "77530": "4",
  "77081": "4",
  "35233": "4",
  "30527": "4",
  "30165": "4",
  "30105": "4",
  "30701": "4",
  "30118": "4",
  "31824": "4",
  "39867": "4",
  "31501": "4",
  "32833": "4",
  "31557": "4",
  "31518": "4",
  "33877": "4",
  "32227": "4",
  "33570": "4",
  "32816": "4",
  "31794": "4",
  "31035": "4",
  "31011": "4",
  "31642": "4",
  "33715": "4",
  "33065": "4",
  "32352": "4",
  "32712": "4",
  "34787": "4",
  "32203": "4",
  "32832": "4",
  "33782": "4",
  "31629": "4",
  "31620": "4",
  "31532": "4",
  "39819": "4",
  "31084": "4",
  "33772": "4",
  "33778": "4",
  "30568": "4",
  "32033": "4",
  "33777": "4",
  "32580": "4",
  "32547": "4",
  "30821": "4",
  "33774": "4",
  "30464": "4",
  "30573": "4",
  "34685": "4",
  "31747": "4",
  "34638": "4",
  "34736": "4",
  "33523": "4",
  "32097": "4",
  "34744": "4",
  "32966": "4",
  "32901": "4",
  "32940": "4",
  "32796": "4",
  "33324": "4",
  "33328": "4",
  "33956": "4",
  "32948": "4",
  "32949": "4",
  "32129": "4",
  "32118": "4",
  "39824": "4",
  "30263": "4",
  "33556": "4",
  "30471": "4",
  "34138": "4",
  "31773": "4",
  "39851": "4",
  "30441": "4",
  "33853": "4",
  "31071": "4",
  "33838": "4",
  "31096": "4",
  "31790": "4",
  "30456": "4",
  "30426": "4",
  "32817": "4",
  "32266": "4",
  "32814": "4",
  "31735": "4",
  "30822": "4",
  "33954": "4",
  "33063": "4",
  "32536": "4",
  "32776": "4",
  "33972": "4",
  "34747": "4",
  "31720": "4",
  "31778": "4",
  "31738": "4",
  "30525": "4",
  "31623": "4",
  "33776": "4",
  "30562": "4",
  "33066": "4",
  "33313": "4",
  "34739": "4",
  "34661": "4",
  "34609": "4",
  "33848": "4",
  "32926": "4",
  "32925": "4",
  "32950": "4",
  "32350": "4",
  "30147": "4",
  "31901": "4",
  "30542": "4",
  "30307": "4",
  "30317": "4",
  "31905": "4",
  "31409": "4",
  "32192": "4",
  "32444": "4",
  "33409": "4",
  "36544": "4",
  "36562": "4",
  "35603": "4",
  "36064": "4",
  "35621": "4",
  "36057": "4",
  "33168": "4",
  "33916": "4",
  "32681": "4",
  "33014": "4",
  "04415": "1e",
  "04987": "1e",
  "04855": "1e",
  "04236": "1e",
  "04083": "1e",
  "04463": "1e",
  "04780": "1e",
  "04686": "1e",
  "04654": "1e",
  "04655": "1e",
  "04002": "1e",
  "04042": "1e",
  "04453": "1e",
  "04088": "1e",
  "04983": "1e",
  "04530": "1e",
  "04554": "1e",
  "04578": "1e",
  "04859": "1e",
  "04547": "1e",
  "04342": "1e",
  "04010": "1e",
  "04563": "1e",
  "04497": "1e",
  "04667": "1e",
  "04776": "1e",
  "04631": "1e",
  "04562": "1e",
  "04649": "1e",
  "04847": "1e",
  "04955": "1e",
  "04964": "1e",
  "04614": "1e",
  "04421": "1e",
  "04011": "1e",
  "04095": "1e",
  "04049": "1e",
  "04953": "1e",
  "04259": "1e",
  "04456": "1e",
  "04105": "1e",
  "04428": "1e",
  "04062": "1e",
  "04344": "1e",
  "04039": "1e",
  "04949": "1e",
  "04252": "1e",
  "04693": "1e",
  "04258": "1e",
  "04219": "1e",
  "04255": "1e",
  "04450": "1e",
  "04921": "1e",
  "03910": "2e",
  "04734": "1e",
  "04766": "1e",
  "12084": "2e",
  "14080": "2e",
  "12222": "2e",
  "12120": "2e",
  "11746": "2e",
  "10517": "2e",
  "11950": "2e",
  "13063": "1e",
  "14476": "1e",
  "13743": "2e",
  "14169": "1e",
  "94951": "7",
  "94941": "7",
  "94562": "7",
  "91316": "6",
  "94583": "7",
  "94596": "7",
  "94619": "7",
  "94601": "7",
  "94509": "7",
  "93555": "6",
  "93461": "7",
  "93524": "6",
  "93657": "6",
  "91360": "6",
  "93287": "6",
  "95821": "7",
  "92132": "6",
  "91362": "6",
  "93250": "6",
  "95823": "7",
  "95826": "7",
  "93066": "6",
  "95330": "7",
  "93234": "7",
  "95833": "7",
  "91377": "6",
  "92014": "6",
  "92067": "6",
  "92311": "6",
  "92301": "6",
  "92399": "6",
  "92119": "6",
  "92356": "6",
  "95454": "7",
  "95570": "7",
  "92131": "6",
  "94133": "7",
  "96002": "7",
  "95988": "7",
  "92398": "6",
  "95618": "7",
  "95470": "7",
  "93962": "7",
  "94108": "7",
  "95466": "7",
  "95459": "7",
  "95569": "7",
  "93409": "7",
  "92870": "6",
  "93433": "7",
  "93955": "7",
  "92024": "6",
  "92054": "6",
  "92056": "6",
  "92078": "6",
  "96016": "5",
  "92065": "6",
  "92059": "6",
  "92082": "6",
  "95603": "6",
  "95746": "6",
  "94114": "7",
  "95661": "6",
  "92127": "6",
  "95663": "6",
  "95713": "6",
  "95722": "6",
  "95714": "6",
  "96142": "5",
  "95634": "6",
  "95667": "6",
  "95635": "6",
  "92678": "6",
  "92879": "6",
  "92881": "6",
  "95623": "6",
  "92860": "6",
  "95684": "6",
  "92591": "6",
  "95918": "6",
  "93426": "7",
  "92252": "6",
  "96003": "7",
  "92277": "6",
  "92278": "6",
  "92118": "6",
  "95776": "7",
  "93925": "7",
  "92243": "6",
  "92249": "6",
  "95494": "7",
  "95445": "7",
  "92341": "6",
  "92378": "6",
  "95427": "7",
  "95545": "7",
  "93923": "7",
  "92385": "6",
  "92317": "6",
  "76054": "3w",
  "76039": "3w",
  "76011": "3w",
  "75785": "3w",
  "79381": "6",
  "78001": "6",
  "76455": "6",
  "77857": "6",
  "76578": "6",
  "76203": "3w",
  "75661": "3w",
  "78362": "4",
  "78387": "6",
  "78370": "6",
  "77622": "4",
  "75057": "3w",
  "78665": "6",
  "75249": "3w",
  "75181": "3w",
  "75574": "3w",
  "75658": "3w",
  "79770": "6",
  "78391": "6",
  "75858": "3w",
  "76845": "6",
  "75413": "3w",
  "75564": "3w",
  "76692": "3w",
  "78011": "6",
  "76631": "3w",
  "78622": "6",
  "75102": "3w",
  "77878": "3w",
  "78074": "6",
  "79721": "6",
  "76241": "3w",
  "75150": "3w",
  "79106": "2w",
  "77451": "4",
  "77466": "4",
  "77441": "4",
  "77461": "4",
  "77445": "3w",
  "77450": "4",
  "77357": "4",
  "77563": "4",
  "77406": "4",
  "77873": "3w",
  "79042": "2w",
  "77665": "4",
  "79092": "2w",
  "78881": "6",
  "79096": "2w",
  "75966": "4",
  "78071": "6",
  "75932": "4",
  "78962": "6",
  "75432": "3w",
  "77831": "3w",
  "78851": "6",
  "77580": "4",
  "76446": "6",
  "79029": "2w",
  "76941": "6",
  "79355": "6",
  "79744": "6",
  "75926": "3w",
  "79772": "6",
  "77957": "6",
  "79083": "2w",
  "79220": "6",
  "79830": "6",
  "79225": "3w",
  "79739": "6",
  "75028": "3w",
  "76010": "3w",
  "76009": "3w",
  "78259": "6",
  "06423": "2e",
  "06067": "2e",
  "06512": "2e",
  "06710": "2e",
  "06753": "2e",
  "06072": "2e",
  "06610": "2e",
  "06905": "2e",
  "06801": "2e",
  "06704": "2e",
  "06812": "2e",
  "06489": "2e",
  "06778": "2e",
  "06422": "2e",
  "06442": "2e",
  "06016": "2e",
  "06232": "2e",
  "06779": "2e",
  "29045": "4",
  "29409": "4",
  "29634": "4",
  "29655": "4",
  "29360": "4",
  "29138": "4",
  "29065": "4",
  "29009": "4",
  "29178": "4",
  "29512": "4",
  "29488": "4",
  "29032": "4",
  "29824": "4",
  "29836": "4",
  "29638": "4",
  "29812": "4",
  "29543": "4",
  "29849": "4",
  "29331": "4",
  "29580": "4",
  "29566": "4",
  "29074": "4",
  "29844": "4",
  "29924": "4",
  "29838": "4",
  "29918": "4",
  "29934": "4",
  "29208": "4",
  "29939": "4",
  "29943": "4",
  "29659": "4",
  "29564": "4",
  "29349": "3e",
  "29330": "3e",
  "29160": "4",
  "29377": "4",
  "29414": "4",
  "23882": "3e",
  "23894": "3e",
  "23140": "3e",
  "20164": "2e",
  "20152": "2e",
  "22026": "3e",
  "23801": "3e",
  "23842": "3e",
  "23899": "3e",
  "22735": "3e",
  "23310": "3e",
  "22713": "3e",
  "23920": "3e",
  "24484": "3e",
  "22709": "3e",
  "23954": "3e",
  "22726": "3e",
  "24579": "3e",
  "20187": "2e",
  "23968": "3e",
  "23976": "3e",
  "23915": "3e",
  "22639": "2e",
  "23922": "3e",
  "24216": "3e",
  "22742": "3e",
  "23177": "3e",
  "24265": "3e",
  "22971": "3e",
  "23250": "3e",
  "24413": "3e",
  "23130": "3e",
  "24581": "3e",
  "22438": "3e",
  "23085": "3e",
  "24073": "3e",
  "16422": "2e",
  "18354": "2e",
  "18335": "2e",
  "16113": "2e",
  "16671": "2e",
  "15472": "2e",
  "18935": "2e",
  "16866": "2e",
  "15848": "2e",
  "16666": "2e",
  "83245": "5",
  "83857": "5",
  "83353": "5",
  "83420": "5",
  "83604": "5",
  "83253": "5",
  "83526": "5",
  "83336": "5",
  "83651": "5",
  "83852": "5",
  "83622": "5",
  "83860": "5",
  "83847": "5",
  "83241": "5",
  "83543": "5",
  "83127": "5",
  "83872": "5",
  "83243": "5",
  "83454": "5",
  "83826": "5",
  "83607": "5",
  "83861": "5",
  "83647": "5",
  "83211": "5",
  "83327": "5",
  "83522": "5",
  "87530": "5",
  "87528": "5",
  "87419": "5",
  "87041": "5",
  "88135": "2w",
  "88103": "2w",
  "87508": "5",
  "88352": "6",
  "88254": "6",
  "87316": "5",
  "87038": "5",
  "87718": "5",
  "88416": "5",
  "87752": "5",
  "88267": "6",
  "87715": "5",
  "87569": "5",
  "87547": "5",
  "87365": "5",
  "88355": "6",
  "87060": "5",
  "88119": "6",
  "88434": "2w",
  "87035": "5",
  "88310": "6",
  "87575": "5",
  "87322": "5",
  "87375": "5",
  "88341": "6",
  "88240": "6",
  "98340": "7",
  "98367": "7",
  "98110": "7",
  "98349": "7",
  "98527": "7",
  "98230": "5",
  "99123": "5",
  "98603": "7",
  "99171": "5",
  "98821": "5",
  "98373": "7",
  "98829": "5",
  "99138": "5",
  "99341": "5",
  "98619": "5",
  "98566": "7",
  "98651": "5",
  "98030": "5",
  "99218": "5",
  "98824": "5",
  "98512": "7",
  "99012": "5",
  "99105": "5",
  "98068": "5",
  "98684": "7",
  "98208": "5",
  "98029": "5",
  "98050": "5",
  "98053": "5",
  "98629": "7",
  "98686": "7",
  "98361": "5",
  "98940": "5",
  "98416": "7",
  "99223": "5",
  "99025": "5",
  "98244": "5",
  "98596": "7",
  "14420": "1e",
  "14511": "1e",
  "13437": "1e",
  "13159": "2e",
  "14102": "1e",
  "55983": "1w",
  "56562": "1w",
  "56668": "1w",
  "55601": "1w",
  "56013": "1w",
  "56583": "1w",
  "55106": "1w",
  "56501": "1w",
  "56349": "1w",
  "56585": "1w",
  "55421": "1w",
  "56187": "1w",
  "55615": "1w",
  "56167": "1w",
  "56003": "1w",
  "56637": "1w",
  "56355": "1w",
  "56248": "1w",
  "56309": "1w",
  "55021": "1w",
  "56052": "1w",
  "55122": "1w",
  "56324": "1w",
  "55046": "1w",
  "56474": "1w",
  "56087": "1w",
  "56450": "1w",
  "56386": "1w",
  "56756": "1w",
  "56551": "1w",
  "56041": "1w",
  "56435": "1w",
  "56541": "1w",
  "56222": "1w",
  "55072": "1w",
  "23509": "3e",
  "24266": "3e",
  "23608": "3e",
  "24174": "3e",
  "23023": "3e",
  "23511": "3e",
  "23298": "3e",
  "22538": "3e",
  "22908": "3e",
  "24142": "3e",
  "24595": "3e",
  "24095": "3e",
  "24612": "3e",
  "72372": "3w",
  "72055": "3w",
  "72562": "3w",
  "71675": "3w",
  "72644": "3w",
  "72662": "3w",
  "71851": "3w",
  "71730": "3w",
  "71639": "3w",
  "72863": "3w",
  "71666": "3w",
  "71971": "3w",
  "72680": "3w",
  "65733": "3w",
  "72616": "3w",
  "72424": "3w",
  "72858": "3w",
  "72843": "3w",
  "72842": "3w",
  "72626": "3w",
  "72025": "3w",
  "72623": "3w",
  "72672": "3w",
  "72455": "3w",
  "72394": "3w",
  "71743": "3w",
  "72675": "3w",
  "71935": "3w",
  "71728": "3w",
  "72829": "3w",
  "72340": "3w",
  "72085": "3w",
  "72035": "3w",
  "72903": "3w",
  "72467": "3w",
  "72204": "3w",
  "72450": "3w",
  "72209": "3w",
  "72133": "3w",
  "72182": "3w",
  "72023": "3w",
  "72122": "3w",
  "72936": "3w",
  "72944": "3w",
  "71901": "3w",
  "72738": "3w",
  "72756": "3w",
  "72358": "3e",
  "72350": "3w",
  "72428": "3w",
  "71964": "3w",
  "72391": "3w",
  "72934": "3w",
  "72086": "3w",
  "72921": "3w",
  "71929": "3w",
  "72058": "3w",
  "72346": "3w",
  "72039": "3w",
  "71832": "3w",
  "72641": "3w",
  "72655": "3w",
  "72178": "3w",
  "58269": "1w",
  "58076": "1w",
  "58523": "1w",
  "58847": "1w",
  "58565": "1w",
  "58772": "1w",
  "58746": "1w",
  "58830": "1w",
  "67216": "2w",
  "67211": "2w",
  "66524": "2w",
  "67017": "2w",
  "66002": "2w",
  "67566": "2w",
  "66536": "2w",
  "66221": "2w",
  "66203": "2w",
  "66220": "2w",
  "67448": "2w",
  "67425": "2w",
  "67107": "2w",
  "67432": "2w",
  "66436": "2w",
  "66608": "2w",
  "67008": "2w",
  "66535": "2w",
  "66617": "2w",
  "67442": "2w",
  "67661": "2w",
  "67578": "2w",
  "67485": "2w",
  "67635": "2w",
  "66425": "2w",
  "66527": "2w",
  "66516": "2w",
  "67428": "2w",
  "67342": "2w",
  "67659": "2w",
  "67625": "2w",
  "67005": "2w",
  "67430": "2w",
  "66083": "2w",
  "67653": "2w",
  "67422": "2w",
  "66041": "2w",
  "66552": "2w",
  "67628": "2w",
  "67038": "2w",
  "67055": "2w",
  "67009": "2w",
  "67530": "2w",
  "67547": "2w",
  "67667": "2w",
  "67436": "2w",
  "67632": "2w",
  "66779": "2w",
  "66701": "2w",
  "67801": "2w",
  "66853": "2w",
  "67013": "2w",
  "67140": "2w",
  "67583": "2w",
  "67444": "2w",
  "67476": "2w",
  "67025": "2w",
  "67142": "2w",
  "67058": "2w",
  "67026": "2w",
  "67004": "2w",
  "67564": "2w",
  "67529": "2w",
  "66080": "2w",
  "66843": "2w",
  "67065": "2w",
  "66953": "2w",
  "67747": "2w",
  "67110": "2w",
  "66215": "2w",
  "67567": "2w",
  "67640": "2w",
  "81152": "5",
  "81077": "5",
  "81131": "5",
  "87571": "5",
  "87746": "5",
  "87123": "5",
  "87072": "5",
  "88317": "6",
  "88411": "2w",
  "88023": "6",
  "88026": "6",
  "87510": "5",
  "88203": "6",
  "87507": "5",
  "87124": "5",
  "87121": "5",
  "88041": "6",
  "88430": "2w",
  "88316": "6",
  "88312": "6",
  "88301": "6",
  "87110": "5",
  "87016": "5",
  "88042": "6",
  "87537": "5",
  "87301": "5",
  "87320": "5",
  "88336": "6",
  "88421": "5",
  "87565": "5",
  "87573": "5",
  "87731": "5",
  "87052": "5",
  "87566": "5",
  "88314": "6",
  "88114": "6",
  "87418": "5",
  "88436": "2w",
  "87558": "5",
  "87753": "5",
  "87714": "5",
  "88350": "6",
  "87519": "5",
  "88115": "6",
  "88034": "6",
  "87936": "6",
  "87580": "5",
  "87032": "5",
  "87724": "5",
  "87828": "6",
  "88401": "5",
  "88136": "6",
  "87012": "5",
  "87549": "5",
  "88232": "6",
  "87505": "5",
  "88007": "6",
  "87319": "5",
  "87017": "5",
  "88125": "6",
  "88220": "6",
  "87506": "5",
  "87122": "5",
  "87321": "5",
  "87538": "5",
  "87930": "6",
  "87943": "6",
  "87315": "5",
  "87548": "5",
  "87825": "6",
  "87064": "5",
  "87104": "5",
  "87037": "5",
  "88132": "6",
  "17066": "2e",
  "15864": "2e",
  "16638": "2e",
  "16678": "2e",
  "15771": "2e",
  "15827": "2e",
  "15841": "2e",
  "16249": "2e",
  "18445": "2e",
  "16623": "2e",
  "16914": "2e",
  "17729": "2e",
  "16920": "2e",
  "16948": "2e",
  "18853": "2e",
  "16927": "2e",
  "17060": "2e",
  "16621": "2e",
  "16654": "2e",
  "15764": "2e",
  "18371": "2e",
  "15537": "2e",
  "18469": "2e",
  "15729": "2e",
  "17029": "2e",
  "16659": "2e",
  "18814": "2e",
  "17239": "2e",
  "18421": "2e",
  "15716": "2e",
  "15765": "2e",
  "90275": "6",
  "95008": "7",
  "90605": "6",
  "95113": "7",
  "91001": "6",
  "95030": "7",
  "94087": "7",
  "94043": "7",
  "94089": "7",
  "90639": "6",
  "94305": "7",
  "92604": "6",
  "95991": "7",
  "92780": "6",
  "92590": "6",
  "92620": "6",
  "92626": "6",
  "90747": "6",
  "94010": "7",
  "94070": "7",
  "90245": "6",
  "93563": "6",
  "91384": "6",
  "90052": "6",
  "95064": "7",
  "95062": "7",
  "90621": "6",
  "91342": "6",
  "92801": "6",
  "91345": "6",
  "95006": "7",
  "94591": "7",
  "90016": "6",
  "90007": "6",
  "90021": "6",
  "91733": "6",
  "92103": "6",
  "96061": "5",
  "93307": "6",
  "96058": "7",
  "93221": "6",
  "93271": "6",
  "95205": "7",
  "96024": "7",
  "91732": "6",
  "90501": "6",
  "90802": "6",
  "90808": "6",
  "93314": "6",
  "94110": "7",
  "93268": "6",
  "93517": "5",
  "93641": "6",
  "91709": "6",
  "96015": "5",
  "92104": "6",
  "96037": "7",
  "95728": "5",
  "95549": "7",
  "93277": "6",
  "95354": "7",
  "91764": "6",
  "95426": "7",
  "96057": "7",
  "96039": "7",
  "95965": "6",
  "43968": "2e",
  "43762": "2e",
  "43727": "2e",
  "43756": "2e",
  "44223": "2e",
  "44203": "2e",
  "45390": "2e",
  "44304": "2e",
  "45362": "2e",
  "44141": "2e",
  "44117": "2e",
  "45327": "2e",
  "45042": "2e",
  "44614": "2e",
  "44646": "2e",
  "44710": "2e",
  "44703": "2e",
  "44730": "2e",
  "44266": "2e",
  "44260": "2e",
  "44255": "2e",
  "44202": "2e",
  "43739": "2e",
  "44645": "2e",
  "44278": "2e",
  "44449": "2e",
  "44113": "2e",
  "44851": "2e",
  "44055": "2e",
  "44510": "2e",
  "44406": "2e",
  "44410": "2e",
  "45123": "2e",
  "43130": "2e",
  "43567": "2e",
  "45338": "2e",
  "45359": "2e",
  "45371": "2e",
  "44847": "2e",
  "44672": "2e",
  "44514": "2e",
  "44076": "2e",
  "45036": "2e",
  "44094": "2e",
  "45370": "2e",
  "45305": "2e",
  "43045": "2e",
  "44505": "2e",
  "45693": "2e",
  "44826": "2e",
  "45440": "2e",
  "45312": "2e",
  "45623": "2e",
  "44814": "2e",
  "43110": "2e",
  "44484": "2e",
  "43438": "2e",
  "45156": "2e",
  "44114": "2e",
  "43842": "2e",
  "44442": "2e",
  "45766": "2e",
  "45690": "2e",
  "45648": "2e",
  "45640": "2e",
  "45119": "2e",
  "33983": "4",
  "33953": "4",
  "32821": "4",
  "33976": "4",
  "33770": "4",
  "33755": "4",
  "31622": "4",
  "31007": "4",
  "31810": "4",
  "32343": "4",
  "32750": "4",
  "30537": "4",
  "33771": "4",
  "32766": "4",
  "32765": "4",
  "34667": "4",
  "32767": "4",
  "35098": "4",
  "35571": "4",
  "33426": "4",
  "33472": "4",
  "32226": "4",
  "33183": "4",
  "33172": "4",
  "33713": "4",
  "36904": "4",
  "35745": "3e",
  "30238": "4",
  "30559": "4",
  "30541": "4",
  "30522": "4",
  "30619": "4",
  "30141": "4",
  "33914": "4",
  "33442": "4",
  "33189": "4",
  "33950": "4",
  "33177": "4",
  "34268": "4",
  "34109": "4",
  "33618": "4",
  "35077": "4",
  "30571": "4",
  "30453": "4",
  "33884": "4",
  "33510": "4",
  "33809": "4",
  "33530": "4",
  "32810": "4",
  "31714": "4",
  "32812": "4",
  "31549": "4",
  "32221": "4",
  "32211": "4",
  "30808": "4",
  "31044": "4",
  "30017": "4",
  "30183": "4",
  "31014": "4",
  "30139": "4",
  "32220": "4",
  "34113": "4",
  "31327": "4",
  "34140": "4",
  "33559": "4",
  "32449": "4",
  "32530": "4",
  "31822": "4",
  "30415": "4",
  "33030": "4",
  "30557": "4",
  "30553": "4",
  "33547": "4",
  "30417": "4",
  "36754": "4",
  "04927": "1e",
  "04055": "1e",
  "04442": "1e",
  "04936": "1e",
  "04543": "1e",
  "04553": "1e",
  "04676": "1e",
  "04854": "1e",
  "04652": "1e",
  "04239": "1e",
  "04862": "1e",
  "04648": "1e",
  "04743": "1e",
  "04745": "1e",
  "04574": "1e",
  "04863": "1e",
  "04958": "1e",
  "04917": "1e",
  "04061": "1e",
  "04957": "1e",
  "04963": "1e",
  "04003": "1e",
  "04350": "1e",
  "04109": "1e",
  "04063": "1e",
  "04412": "1e",
  "04260": "1e",
  "04107": "1e",
  "04092": "1e",
  "04973": "1e",
  "97064": "7",
  "97443": "7",
  "97495": "7",
  "97869": "5",
  "97146": "7",
  "97846": "5",
  "89429": "5",
  "89001": "5",
  "89315": "5",
  "89503": "5",
  "89107": "5",
  "89820": "5",
  "89449": "5",
  "89030": "5",
  "89113": "5",
  "89129": "5",
  "89032": "5",
  "89442": "5",
  "89019": "5",
  "89161": "5",
  "89021": "5",
  "89005": "5",
  "89141": "5",
  "89039": "5",
  "89158": "5",
  "89018": "5",
  "89445": "5",
  "89010": "5",
  "89437": "5",
  "89521": "5",
  "89106": "5",
  "89706": "5",
  "89821": "5",
  "89109": "5",
  "89149": "5",
  "89704": "5",
  "89130": "5",
  "89128": "5",
  "89441": "5",
  "89115": "5",
  "89451": "5",
  "89450": "5",
  "97850": "5",
  "97825": "5",
  "97736": "5",
  "97857": "5",
  "97732": "5",
  "97624": "5",
  "97601": "7",
  "97051": "7",
  "97134": "7",
  "97843": "5",
  "97750": "5",
  "97110": "7",
  "97883": "5",
  "97909": "5",
  "97057": "5",
  "97390": "7",
  "97504": "7",
  "97401": "7",
  "97045": "7",
  "97301": "7",
  "97408": "7",
  "97477": "7",
  "97370": "7",
  "97759": "5",
  "97456": "7",
  "97488": "7",
  "97205": "7",
  "97216": "7",
  "97424": "7",
  "97451": "7",
  "97452": "7",
  "97325": "7",
  "97239": "7",
  "97219": "7",
  "97233": "7",
  "97137": "7",
  "97338": "7",
  "97119": "7",
  "97327": "7",
  "97386": "7",
  "97055": "7",
  "97086": "7",
  "97049": "5",
  "97329": "7",
  "97465": "7",
  "97041": "5",
  "97476": "7",
  "97410": "7",
  "97471": "7",
  "97416": "7",
  "97814": "5",
  "97029": "5",
  "97801": "5",
  "97494": "7",
  "97481": "7",
  "97859": "5",
  "98204": "5",
  "98288": "5",
  "98662": "7",
  "98606": "7",
  "98224": "5",
  "99124": "5",
  "98925": "5",
  "98376": "7",
  "99354": "5",
  "98144": "5",
  "99003": "5",
  "99166": "5",
  "98593": "7",
  "98239": "5",
  "98901": "5",
  "98506": "7",
  "99009": "5",
  "98118": "5",
  "98222": "5",
  "99156": "5",
  "98584": "7",
  "99403": "5",
  "98855": "5",
  "98249": "5",
  "99113": "5",
  "99205": "5",
  "99217": "5",
  "98847": "5",
  "99122": "5",
  "98117": "5",
  "98611": "7",
  "98356": "7",
  "98362": "7",
  "98006": "5",
  "98377": "5",
  "98816": "5",
  "98832": "5",
  "98923": "5",
  "98605": "5",
  "98002": "5",
  "98263": "5",
  "99173": "5",
  "99181": "5",
  "98235": "5",
  "98346": "7",
  "99013": "5",
  "99129": "5",
  "98258": "5",
  "98499": "7",
  "99143": "5",
  "99333": "5",
  "98580": "7",
  "98823": "5",
  "98583": "7",
  "98039": "5",
  "98335": "7",
  "98252": "5",
  "98351": "7",
  "98388": "7",
  "98271": "5",
  "98422": "5",
  "98939": "5",
  "98498": "7",
  "98612": "7",
  "24738": "3e",
  "25071": "3e",
  "25306": "3e",
  "25061": "3e",
  "25107": "3e",
  "26133": "2e",
  "26181": "2e",
  "26546": "2e",
  "26506": "2e",
  "26287": "2e",
  "26343": "2e",
  "25259": "3e",
  "25275": "2e",
  "25276": "2e",
  "26629": "3e",
  "26755": "2e",
  "26136": "2e",
  "26282": "3e",
  "26293": "3e",
  "26271": "2e",
  "26339": "2e",
  "25267": "2e",
  "25141": "3e",
  "26159": "2e",
  "25043": "3e",
  "26438": "2e",
  "25981": "3e",
  "24976": "3e",
  "26385": "2e",
  "26366": "2e",
  "25958": "3e",
  "26386": "2e",
  "26676": "3e",
  "26377": "2e",
  "25111": "3e",
  "26610": "3e",
  "25125": "3e",
  "25557": "3e",
  "25571": "3e",
  "26291": "3e",
  "24938": "3e",
  "25550": "2e",
  "25634": "3e",
  "25621": "3e",
  "25113": "3e",
  "25688": "3e",
  "25285": "3e",
  "25181": "3e",
  "24816": "3e",
  "24887": "3e",
  "24830": "3e",
  "24888": "3e",
  "25699": "3e",
  "25028": "3e",
  "24622": "3e",
  "24873": "3e",
  "25030": "3e",
  "26812": "2e",
  "26884": "2e",
  "26845": "2e",
  "26731": "2e",
  "26739": "2e",
  "26720": "2e",
  "26851": "2e",
  "25420": "2e",
  "25403": "2e",
  "25419": "2e",
  "26342": "2e",
  "25570": "3e",
  "25812": "3e",
  "25854": "3e",
  "25534": "3e",
  "25213": "3e",
  "25901": "3e",
  "25530": "3e",
  "25517": "3e",
  "03233": "1e",
  "03238": "1e",
  "03750": "1e",
  "03602": "1e",
  "03455": "2e",
  "03446": "2e",
  "03431": "2e",
  "03470": "2e",
  "03770": "1e",
  "03249": "1e",
  "03055": "2e",
  "03833": "2e",
  "03597": "1e",
  "03442": "2e",
  "03849": "1e",
  "03883": "1e",
  "03857": "2e",
  "03885": "2e",
  "03855": "1e",
  "03261": "1e",
  "03278": "1e",
  "03839": "1e",
  "03234": "1e",
  "03230": "1e",
  "03897": "1e",
  "03844": "2e",
  "03255": "1e",
  "03036": "2e",
  "03215": "1e",
  "03109": "2e",
  "03847": "1e",
  "03608": "1e",
  "03604": "1e",
  "03237": "1e",
  "03246": "1e",
  "03605": "1e",
  "03753": "1e",
  "03102": "2e",
  "03561": "1e",
  "03777": "1e",
  "03282": "1e",
  "03598": "1e",
  "03038": "2e",
  "03047": "2e",
  "03850": "1e",
  "03222": "1e",
  "03592": "1e",
  "03875": "1e",
  "03440": "1e",
  "03235": "1e",
  "03570": "1e",
  "03848": "2e",
  "03841": "2e",
  "03740": "1e",
  "03077": "2e",
  "03044": "2e",
  "03268": "1e",
  "03820": "1e",
  "03851": "1e",
  "03865": "2e",
  "03583": "1e",
  "03748": "1e",
  "03817": "1e",
  "03262": "1e",
  "03450": "2e",
  "03601": "1e",
  "03269": "1e",
  "03781": "1e",
  "03809": "1e",
  "03810": "1e",
  "03443": "2e",
  "91910": "6",
  "93215": "6",
  "93225": "6",
  "95372": "6",
  "95828": "7",
  "95309": "6",
  "93043": "6",
  "93285": "6",
  "93621": "6",
  "95608": "7",
  "91361": "6",
  "92111": "6",
  "95628": "6",
  "92359": "6",
  "95678": "6",
  "92344": "6",
  "92307": "6",
  "91911": "6",
  "91932": "6",
  "95691": "7",
  "92364": "6",
  "95546": "7",
  "92251": "6",
  "92071": "6",
  "94111": "7",
  "93453": "7",
  "95913": "7",
  "92280": "6",
  "92327": "6",
  "95551": "7",
  "93402": "7",
  "95695": "7",
  "95540": "7",
  "93430": "7",
  "95937": "7",
  "95627": "7",
  "92382": "6",
  "93401": "7",
  "95698": "7",
  "95653": "7",
  "95606": "7",
  "93444": "7",
  "93921": "7",
  "92823": "6",
  "92259": "6",
  "94123": "7",
  "92004": "6",
  "93953": "7",
  "96096": "7",
  "92391": "6",
  "95694": "7",
  "93954": "7",
  "92832": "6",
  "95460": "7",
  "92315": "6",
  "95463": "7",
  "95432": "7",
  "93920": "7",
  "93928": "7",
  "92305": "6",
  "93940": "7",
  "95425": "7",
  "96047": "7",
  "93445": "7",
  "95537": "7",
  "92250": "6",
  "95482": "7",
  "93424": "7",
  "92805": "6",
  "92807": "6",
  "94115": "7",
  "93422": "7",
  "96008": "7",
  "96013": "5",
  "93452": "7",
  "92011": "6",
  "94501": "7",
  "92040": "6",
  "92091": "6",
  "93943": "7",
  "93933": "7",
  "92061": "6",
  "92028": "6",
  "92036": "6",
  "91905": "6",
  "91980": "6",
  "92694": "6",
  "92530": "6",
  "96119": "5",
  "96123": "5",
  "92561": "6",
  "92260": "6",
  "92211": "6",
  "92270": "6",
  "92210": "6",
  "94503": "7",
  "90068": "6",
  "90038": "6",
  "90028": "6",
  "13202": "1e",
  "14608": "1e",
  "13864": "2e",
  "11234": "2e",
  "14626": "1e",
  "11436": "2e",
  "13214": "1e",
  "11365": "2e",
  "14627": "1e",
  "10464": "2e",
  "14610": "1e",
  "14618": "1e",
  "14221": "1e",
  "10017": "2e",
  "10577": "2e",
  "10165": "2e",
  "14814": "2e",
  "14889": "2e",
  "14838": "2e",
  "14861": "2e",
  "10018": "2e",
  "14812": "2e",
  "13802": "2e",
  "13790": "2e",
  "10022": "2e",
  "10522": "2e",
  "11426": "2e",
  "12531": "2e",
  "10960": "2e",
  "11967": "2e",
  "11581": "2e",
  "11710": "2e",
  "10591": "2e",
  "10954": "2e",
  "14526": "1e",
  "10952": "2e",
  "13090": "1e",
  "13112": "1e",
  "11379": "2e",
  "11778": "2e",
  "13367": "1e",
  "10931": "2e",
  "13746": "2e",
  "75214": "3w",
  "78941": "6",
  "78705": "6",
  "61428": "2e",
  "61529": "2e",
  "61109": "2e",
  "60511": "2e",
  "62677": "2e",
  "62514": "2e",
  "61528": "2e",
  "61011": "2e",
  "61080": "2e",
  "60950": "2e",
  "61802": "2e",
  "61063": "2e",
  "62548": "2e",
  "61084": "2e",
  "62311": "2e",
  "52646": "2w",
  "52580": "2w",
  "50653": "1w",
  "52632": "2w",
  "24731": "3e",
  "24818": "3e",
  "26059": "2e",
  "26060": "2e",
  "25845": "3e",
  "25826": "3e",
  "24716": "3e",
  "24847": "3e",
  "24719": "3e",
  "24828": "3e",
  "25045": "3e",
  "26534": "2e",
  "25202": "3e",
  "26582": "2e",
  "25124": "3e",
  "26250": "2e",
  "26416": "2e",
  "26201": "2e",
  "26349": "2e",
  "26210": "2e",
  "26412": "2e",
  "26722": "2e",
  "26601": "3e",
  "26624": "3e",
  "26817": "2e",
  "26444": "2e",
  "26259": "2e",
  "26152": "2e",
  "26263": "2e",
  "26411": "2e",
  "25235": "3e",
  "26636": "3e",
  "26443": "2e",
  "26276": "2e",
  "26035": "2e",
  "78567": "4",
  "77063": "4",
  "77375": "4",
  "77485": "4",
  "77430": "4",
  "77478": "4",
  "77378": "4",
  "77328": "4",
  "77382": "4",
  "77564": "4",
  "77510": "4",
  "77511": "4",
  "77833": "6",
  "77418": "6",
  "77434": "6",
  "77521": "4",
  "77428": "4",
  "77442": "6",
  "75938": "4",
  "78934": "6",
  "77412": "6",
  "75571": "3w",
  "79244": "3w",
  "78829": "6",
  "79201": "3w",
  "79236": "6",
  "78940": "6",
  "78146": "6",
  "79782": "6",
  "79313": "6",
  "77661": "4",
  "77617": "4",
  "76261": "3w",
  "79336": "6",
  "78852": "6",
  "75638": "3w",
  "79537": "6",
  "79852": "6",
  "77836": "6",
  "78594": "4",
  "75681": "3w",
  "78598": "4",
  "78590": "4",
  "75976": "3w",
  "77963": "6",
  "78050": "6",
  "78608": "6",
  "78837": "6",
  "78841": "6",
  "77856": "3w",
  "75937": "3w",
  "78010": "6",
  "75402": "3w",
  "78012": "6",
  "76666": "3w",
  "78661": "6",
  "76628": "3w",
  "77867": "3w",
  "76681": "3w",
  "76639": "3w",
  "78609": "6",
  "75144": "3w",
  "76678": "3w",
  "76676": "3w",
  "75105": "3w",
  "78004": "6",
  "79606": "6",
  "78566": "4",
  "76310": "3w",
  "77701": "4",
  "77477": "4",
  "77074": "4",
  "77484": "4",
  "77381": "4",
  "77550": "4",
  "77551": "4",
  "77354": "4",
  "77417": "4",
  "77515": "4",
  "77422": "4",
  "77566": "4",
  "77591": "4",
  "77539": "4",
  "77523": "4",
  "76649": "6",
  "78935": "6",
  "79227": "3w",
  "79019": "2w",
  "49775": "1e",
  "48767": "1e",
  "49615": "1e",
  "48653": "1e",
  "49307": "1e",
  "49893": "1e",
  "49812": "1e",
  "49874": "1e",
  "49320": "1e",
  "49336": "1e",
  "49799": "1e",
  "49623": "1e",
  "48465": "1e",
  "49895": "1e",
  "48891": "1e",
  "48765": "1e",
  "48877": "1e",
  "49925": "1e",
  "49724": "1e",
  "49770": "1e",
  "49929": "1e",
  "48647": "1e",
  "48636": "1e",
  "48737": "1e",
  "49829": "1e",
  "49960": "1e",
  "48864": "2e",
  "49451": "1e",
  "49056": "2e",
  "49437": "1e",
  "49224": "2e",
  "49264": "2e",
  "49316": "2e",
  "49111": "2e",
  "49935": "1e",
  "49903": "1e",
  "49450": "2e",
  "49091": "2e",
  "49442": "1e",
  "48873": "1e",
  "49103": "2e",
  "49970": "1e",
  "48607": "1e",
  "49050": "2e",
  "48017": "2e",
  "49247": "2e",
  "49415": "1e",
  "49266": "2e",
  "49271": "2e",
  "49235": "2e",
  "49286": "2e",
  "49288": "2e",
  "49619": "1e",
  "49117": "2e",
  "48509": "1e",
  "48414": "1e",
  "49066": "2e",
  "48386": "2e",
  "49917": "1e",
  "49248": "2e",
  "49927": "1e",
  "49074": "2e",
  "48069": "2e",
  "49104": "2e",
  "49289": "2e",
  "48329": "2e",
  "48327": "2e",
  "49816": "1e",
  "48125": "2e",
  "48127": "2e",
  "48176": "2e",
  "48657": "1e",
  "49633": "1e",
  "48658": "1e",
  "48435": "1e",
  "48760": "1e",
  "48223": "2e",
  "48137": "2e",
  "69353": "5",
  "68669": "2w",
  "68042": "2w",
  "68882": "2w",
  "68814": "2w",
  "68837": "2w",
  "68446": "2w",
  "68742": "2w",
  "68711": "2w",
  "69210": "2w",
  "68746": "2w",
  "68443": "2w",
  "68323": "2w",
  "68626": "2w",
  "68875": "2w",
  "68950": "2w",
  "68634": "2w",
  "68836": "2w",
  "68881": "2w",
  "68739": "2w",
  "68757": "2w",
  "68730": "2w",
  "68749": "2w",
  "68507": "2w",
  "68504": "2w",
  "68110": "2w",
  "69144": "2w",
  "68831": "2w",
  "68883": "2w",
  "68102": "2w",
  "68901": "2w",
  "68516": "2w",
  "69347": "2w",
  "68776": "2w",
  "68339": "2w",
  "68368": "2w",
  "68114": "2w",
  "68301": "2w",
  "68659": "2w",
  "68641": "2w",
  "68048": "2w",
  "68328": "2w",
  "68064": "2w",
  "68621": "2w",
  "69345": "5",
  "82082": "5",
  "68137": "2w",
  "68930": "2w",
  "68638": "2w",
  "68010": "2w",
  "68409": "2w",
  "68935": "2w",
  "68627": "2w",
  "69038": "2w",
  "68758": "2w",
  "68941": "2w",
  "68423": "2w",
  "68326": "2w",
  "68340": "2w",
  "68063": "2w",
  "69044": "2w",
  "68038": "2w",
  "68944": "2w",
  "68322": "2w",
  "68182": "2w",
  "69130": "2w",
  "68740": "2w",
  "68070": "2w",
  "68321": "2w",
  "68648": "2w",
  "68467": "2w",
  "68870": "2w",
  "68036": "2w",
  "68450": "2w",
  "68764": "2w",
  "68821": "2w",
  "68756": "2w",
  "68761": "2w",
  "68940": "2w",
  "68844": "2w",
  "68924": "2w",
  "68846": "2w",
  "68729": "2w",
  "68718": "2w",
  "14134": "2e",
  "14012": "1e",
  "11096": "2e",
  "13154": "1e",
  "14556": "2e",
  "13460": "2e",
  "14424": "1e",
  "14463": "1e",
  "12590": "2e",
  "13024": "1e",
  "12062": "2e",
  "12168": "2e",
  "12018": "2e",
  "12828": "1e",
  "13679": "1e",
  "13646": "1e",
  "12074": "1e",
  "13650": "1e",
  "74947": "3w",
  "73560": "3w",
  "73062": "3w",
  "73118": "3w",
  "73116": "3w",
  "73104": "3w",
  "73109": "3w",
  "74523": "3w",
  "74572": "3w",
  "74578": "3w",
  "73007": "3w",
  "73169": "3w",
  "74015": "3w",
  "74932": "3w",
  "73111": "3w",
  "73008": "3w",
  "73026": "3w",
  "74829": "3w",
  "73025": "3w",
  "74944": "3w",
  "74332": "3w",
  "74454": "3w",
  "74429": "3w",
  "74959": "3w",
  "74577": "3w",
  "74552": "3w",
  "74129": "3w",
  "73440": "3w",
  "73142": "3w",
  "73027": "3w",
  "74010": "3w",
  "74046": "3w",
  "74050": "3w",
  "73135": "3w",
  "73134": "3w",
  "73520": "3w",
  "74946": "3w",
  "73543": "3w",
  "74133": "3w",
  "74137": "3w",
  "74136": "3w",
  "74117": "3w",
  "73718": "2w",
  "74119": "3w",
  "74068": "3w",
  "73033": "3w",
  "74850": "3w",
  "74370": "3w",
  "74333": "2w",
  "74343": "3w",
  "74840": "3w",
  "74535": "3w",
  "42733": "3e",
  "40402": "3e",
  "41810": "3e",
  "40313": "3e",
  "42056": "3e",
  "41701": "3e",
  "42262": "3e",
  "42207": "3e",
  "40958": "3e",
  "41262": "3e",
  "42127": "3e",
  "40445": "3e",
  "42352": "3e",
  "40310": "3e",
  "40771": "3e",
  "40939": "3e",
  "40371": "3e",
  "42436": "3e",
  "42413": "3e",
  "41847": "3e",
  "41142": "3e",
  "42374": "3e",
  "41181": "3e",
  "40063": "3e",
  "42051": "3e",
  "42101": "3e",
  "41016": "2e",
  "40036": "3e",
  "40065": "3e",
  "40150": "3e",
  "40503": "3e",
  "40379": "3e",
  "40324": "3e",
  "40026": "3e",
  "40022": "3e",
  "40516": "3e",
  "41168": "3e",
  "41075": "2e",
  "41174": "3e",
  "40504": "3e",
  "42054": "3e",
  "41031": "3e",
  "42718": "3e",
  "40337": "3e",
  "42732": "3e",
  "42327": "3e",
  "42164": "3e",
  "42036": "3e",
  "40311": "3e",
  "42035": "3e",
  "42451": "3e",
  "40008": "3e",
  "41348": "3e",
  "42369": "3e",
  "40069": "3e",
  "41557": "3e",
  "42519": "3e",
  "41365": "3e",
  "42748": "3e",
  "41630": "3e",
  "41815": "3e",
  "41352": "3e",
  "41046": "2e",
  "40486": "3e",
  "41171": "3e",
  "42721": "3e",
  "40456": "3e",
  "41214": "3e",
  "42450": "3e",
  "41083": "2e",
  "42367": "3e",
  "40359": "3e",
  "40840": "3e",
  "41146": "3e",
  "42649": "3e",
  "41044": "3e",
  "42024": "3w",
  "42029": "3e",
  "41265": "3e",
  "42214": "3e",
  "42765": "3e",
  "41204": "3e",
  "41332": "3e",
  "42157": "3e",
  "41232": "3e",
  "41655": "3e",
  "41861": "3e",
  "40115": "3e",
  "41612": "3e",
  "41740": "3e",
  "41203": "3e",
  "46117": "2e",
  "46710": "2e",
  "46376": "2e",
  "47280": "2e",
  "46798": "2e",
  "18220": "2e",
  "16501": "2e",
  "19602": "2e",
  "17985": "2e",
  "17967": "2e",
  "17964": "2e",
  "17404": "2e",
  "17945": "2e",
  "17981": "2e",
  "19606": "2e",
  "17951": "2e",
  "19530": "2e",
  "17067": "2e",
  "19124": "2e",
  "17033": "2e",
  "17064": "2e",
  "17077": "2e",
  "18065": "2e",
  "18066": "2e",
  "17929": "2e",
  "17972": "2e",
  "19133": "2e",
  "17980": "2e",
  "17922": "2e",
  "18032": "2e",
  "17982": "2e",
  "19551": "2e",
  "19559": "2e",
  "16426": "2e",
  "17517": "2e",
  "17728": "2e",
  "16143": "2e",
  "16430": "2e",
  "17271": "2e",
  "17522": "2e",
  "15904": "2e",
  "19125": "2e",
  "16412": "2e",
  "17569": "2e",
  "18045": "2e",
  "17102": "2e",
  "17737": "2e",
  "17754": "2e",
  "16636": "2e",
  "18619": "2e",
  "16613": "2e",
  "25093": "3e",
  "25081": "3e",
  "25024": "3e",
  "25204": "3e",
  "24843": "3e",
  "25169": "3e",
  "24836": "3e",
  "24920": "3e",
  "25022": "3e",
  "24866": "3e",
  "25696": "3e",
  "24604": "3e",
  "25021": "3e",
  "25564": "3e",
  "25624": "3e",
  "25671": "3e",
  "25133": "3e",
  "26866": "2e",
  "26217": "3e",
  "25428": "2e",
  "26351": "2e",
  "26619": "3e",
  "26611": "2e",
  "26838": "2e",
  "25159": "3e",
  "26031": "2e",
  "25535": "3e",
  "25846": "3e",
  "25917": "3e",
  "26056": "2e",
  "25161": "3e",
  "25119": "3e",
  "26033": "2e",
  "25090": "3e",
  "26576": "2e",
  "26559": "2e",
  "25209": "3e",
  "24714": "3e",
  "25922": "3e",
  "25823": "3e",
  "24747": "3e",
  "24733": "3e",
  "25844": "3e",
  "24729": "3e",
  "24985": "3e",
  "24869": "3e",
  "25064": "3e",
  "25303": "3e",
  "24854": "3e",
  "25510": "3e",
  "25545": "3e",
  "26032": "2e",
  "26753": "2e",
  "26074": "2e",
  "24867": "3e",
  "25916": "3e",
  "26155": "2e",
  "24849": "3e",
  "26150": "2e",
  "26570": "2e",
  "26544": "2e",
  "25083": "3e",
  "25103": "3e",
  "25035": "3e",
  "26588": "2e",
  "26169": "2e",
  "26590": "2e",
  "25036": "3e",
  "26241": "2e",
  "26237": "2e",
  "26346": "2e",
  "25266": "3e",
  "25239": "2e",
  "25241": "2e",
  "26224": "3e",
  "26757": "2e",
  "26808": "2e",
  "26623": "3e",
  "26705": "2e",
  "25431": "2e",
  "26354": "2e",
  "26716": "2e",
  "26410": "2e",
  "26524": "2e",
  "26260": "2e",
  "26426": "2e",
  "25446": "2e",
  "24951": "3e",
  "24945": "3e",
  "24970": "3e",
  "24916": "3e",
  "26571": "2e",
  "26560": "2e",
  "26202": "3e",
  "25601": "3e",
  "24927": "3e",
  "24868": "3e",
  "24831": "3e",
  "25505": "3e",
  "25638": "3e",
  "25287": "2e",
  "25672": "3e",
  "25053": "3e",
  "24861": "3e",
  "50066": "2w",
  "52001": "2w",
  "50010": "2w",
  "50038": "2w",
  "52401": "2w",
  "50701": "2w",
  "50668": "2w",
  "51046": "1w",
  "50229": "2w",
  "50674": "2w",
  "52550": "2w",
  "51058": "1w",
  "50069": "2w",
  "52333": "2w",
  "52335": "2w",
  "52240": "2w",
  "51466": "2w",
  "50104": "2w",
  "52804": "2e",
  "52048": "2w",
  "52077": "2w",
  "52340": "2w",
  "52046": "2w",
  "52746": "2w",
  "50171": "2w",
  "52802": "2e",
  "52801": "2e",
  "50544": "2w",
  "50134": "2w",
  "52768": "2w",
  "50007": "2w",
  "52302": "2w",
  "50611": "2w",
  "50226": "2w",
  "52171": "1w",
  "50313": "2w",
  "52314": "2w",
  "52158": "1w",
  "51011": "1w",
  "51561": "2w",
  "50138": "2w",
  "50225": "2w",
  "50468": "1w",
  "52339": "2w",
  "50452": "2w",
  "50439": "1w",
  "51546": "2w",
  "50160": "2w",
  "51576": "2w",
  "50254": "2w",
  "50131": "2w",
  "04073": "1e",
  "04037": "1e",
  "04429": "1e",
  "04416": "1e",
  "17331": "2e",
  "19363": "2e",
  "18071": "2e",
  "18086": "2e",
  "18232": "2e",
  "18661": "2e",
  "18351": "2e",
  "19128": "2e",
  "15201": "2e",
  "17319": "2e",
  "17120": "2e",
  "17111": "2e",
  "18012": "2e",
  "15560": "2e",
  "15510": "2e",
  "17302": "2e",
  "17036": "2e",
  "17098": "2e",
  "17313": "2e",
  "18966": "2e",
  "19056": "2e",
  "19067": "2e",
  "19040": "2e",
  "18942": "2e",
  "17045": "2e",
  "17813": "2e",
  "15687": "2e",
  "16023": "2e",
  "16041": "2e",
  "16928": "2e",
  "15825": "2e",
  "16218": "2e",
  "16942": "2e",
  "18837": "2e",
  "15662": "2e",
  "15618": "2e",
  "15680": "2e",
  "16946": "2e",
  "18831": "2e",
  "85035": "6",
  "85353": "6",
  "86443": "5",
  "86024": "6",
  "85745": "6",
  "85629": "6",
  "85351": "6",
  "85309": "6",
  "86032": "5",
  "85912": "6",
  "85939": "6",
  "85362": "6",
  "86303": "6",
  "85635": "6",
  "86333": "6",
  "85934": "6",
  "86029": "5",
  "85704": "6",
  "85367": "6",
  "85718": "6",
  "85119": "6",
  "85135": "6",
  "86338": "6",
  "86351": "6",
  "85379": "6",
  "85545": "6",
  "85932": "6",
  "85621": "6",
  "85924": "6",
  "85026": "6",
  "85210": "6",
  "85024": "6",
  "85027": "6",
  "85281": "6",
  "85339": "6",
  "86005": "5",
  "85048": "6",
  "85207": "6",
  "85009": "6",
  "86053": "5",
  "85930": "6",
  "85209": "6",
  "86034": "5",
  "85017": "6",
  "86030": "5",
  "85087": "6",
  "85639": "6",
  "85033": "6",
  "85021": "6",
  "66514": "2w",
  "67416": "2w",
  "66429": "2w",
  "66024": "2w",
  "67012": "2w",
  "67743": "2w",
  "67443": "2w",
  "67131": "2w",
  "67410": "2w",
  "67431": "2w",
  "66501": "2w",
  "67756": "2w",
  "66775": "2w",
  "66956": "2w",
  "67146": "2w",
  "67642": "2w",
  "67650": "2w",
  "66783": "2w",
  "67459": "2w",
  "66016": "2w",
  "66717": "2w",
  "67484": "2w",
  "66012": "2w",
  "67671": "2w",
  "66211": "2w",
  "66967": "2w",
  "67482": "2w",
  "68327": "2w",
  "66754": "2w",
  "67516": "2w",
  "67762": "2w",
  "66015": "2w",
  "66720": "2w",
  "67622": "2w",
  "67629": "2w",
  "66738": "2w",
  "67518": "2w",
  "67857": "2w",
  "67111": "2w",
  "67003": "2w",
  "67901": "2w",
  "67103": "2w",
  "67127": "2w",
  "66961": "2w",
  "66742": "2w",
  "66870": "2w",
  "66777": "2w",
  "67138": "2w",
  "67523": "2w",
  "66095": "2w",
  "67761": "2w",
  "67764": "2w",
  "67748": "2w",
  "67836": "2w",
  "67137": "2w",
  "66943": "2w",
  "66933": "2w",
  "66014": "2w",
  "67861": "2w",
  "66773": "2w",
  "66958": "2w",
  "67835": "2w",
  "66755": "2w",
  "67347": "2w",
  "67071": "2w",
  "66079": "2w",
  "67877": "2w",
  "66214": "2w",
  "66756": "2w",
  "66549": "2w",
  "66503": "2w",
  "77071": "4",
  "77019": "4",
  "77027": "4",
  "77089": "4",
  "77075": "4",
  "77041": "4",
  "77481": "4",
  "77582": "4",
  "77368": "4",
  "77623": "4",
  "77341": "3w",
  "75478": "3w",
  "76450": "3w",
  "78802": "6",
  "75933": "4",
  "79247": "3w",
  "79250": "6",
  "79532": "6",
  "79503": "6",
  "77612": "4",
  "76435": "6",
  "76226": "3w",
  "78569": "4",
  "76354": "3w",
  "79536": "6",
  "75254": "3w",
  "76306": "3w",
  "78363": "6",
  "75081": "3w",
  "75670": "3w",
  "78596": "4",
  "76530": "6",
  "78160": "6",
  "78043": "6",
  "76240": "3w",
  "79764": "6",
  "78947": "6",
  "76077": "3w",
  "78861": "6",
  "78629": "6",
  "75477": "3w",
  "79765": "6",
  "79763": "6",
  "77986": "6",
  "75470": "3w",
  "75416": "3w",
  "77807": "3w",
  "78756": "6",
  "75206": "3w",
  "78658": "6",
  "78722": "6",
  "78614": "6",
  "79701": "6",
  "78122": "6",
  "79761": "6",
  "75941": "3w",
  "75943": "3w",
  "79346": "6",
  "76930": "6",
  "79379": "6",
  "79778": "6",
  "78631": "6",
  "79756": "6",
  "78582": "6",
  "75831": "3w",
  "75931": "4",
  "78621": "6",
  "75652": "3w",
  "75551": "3w",
  "78382": "4",
  "78372": "6",
  "76842": "6",
  "78380": "6",
  "75640": "3w",
  "75951": "4",
  "79009": "2w",
  "79079": "2w",
  "79502": "6",
  "79316": "6",
  "79031": "6",
  "79566": "6",
  "76230": "3w",
  "76525": "6",
  "79517": "6",
  "78833": "6",
  "79745": "6",
  "76871": "6",
  "76901": "6",
  "79530": "6",
  "79001": "2w",
  "75481": "3w",
  "76565": "6",
  "75420": "3w",
  "79505": "3w",
  "79719": "6",
  "79245": "3w",
  "76820": "6",
  "78580": "4",
  "78221": "6",
  "76486": "3w",
  "78228": "6",
  "77868": "3w",
  "77835": "6",
  "76249": "3w",
  "78250": "6",
  "77830": "3w",
  "78240": "6",
  "77875": "3w",
  "79078": "2w",
  "79855": "6",
  "75956": "4",
  "76848": "6",
  "79251": "2w",
  "75752": "3w",
  "79119": "2w",
  "76464": "6",
  "75039": "3w",
  "75234": "3w",
  "79563": "6",
  "79508": "6",
  "78642": "6",
  "79520": "6",
  "77630": "4",
  "79560": "6",
  "78589": "4",
  "79110": "2w",
  "76208": "3w",
  "76554": "6",
  "75414": "3w",
  "78161": "6",
  "77984": "6",
  "78959": "6",
  "78055": "6",
  "78850": "6",
  "78885": "6",
  "78956": "6",
  "78059": "6",
  "79401": "6",
  "75435": "3w",
  "78064": "6",
  "77978": "4",
  "76472": "3w",
  "78113": "6",
  "77987": "6",
  "75092": "3w",
  "76667": "3w",
  "76682": "3w",
  "78409": "6",
  "79411": "6",
  "78041": "6",
  "76268": "3w",
  "77974": "6",
  "75058": "3w",
  "50444": "1w",
  "51009": "1w",
  "50483": "1w",
  "51331": "1w",
  "52752": "2w",
  "51432": "2w",
  "50620": "1w",
  "08721": "2e",
  "08880": "2e",
  "07935": "2e",
  "07470": "2e",
  "07456": "2e",
  "08021": "2e",
  "08027": "2e",
  "08015": "2e",
  "08075": "2e",
  "08004": "2e",
  "08077": "2e",
  "08527": "2e",
  "55979": "1w",
  "55952": "1w",
  "55741": "1w",
  "55705": "1w",
  "56670": "1w",
  "56171": "1w",
  "56314": "1w",
  "56270": "1w",
  "55798": "1w",
  "56321": "1w",
  "55781": "1w",
  "56232": "1w",
  "55305": "1w",
  "55920": "1w",
  "55803": "1w",
  "55713": "1w",
  "55807": "1e",
  "56029": "1w",
  "55364": "1w",
  "55926": "1w",
  "55344": "1w",
  "56644": "1w",
  "56523": "1w",
  "56352": "1w",
  "56723": "1w",
  "55431": "1w",
  "56287": "1w",
  "56121": "1w",
  "56140": "1w",
  "87068": "5",
  "87327": "5",
  "87461": "5",
  "87053": "5",
  "87045": "5",
  "87942": "6",
  "87824": "6",
  "88118": "6",
  "87832": "6",
  "87515": "5",
  "88348": "6",
  "88081": "6",
  "88415": "2w",
  "87730": "5",
  "87402": "5",
  "87522": "5",
  "88231": "6",
  "88263": "6",
  "87540": "5",
  "87048": "5",
  "87040": "5",
  "87577": "5",
  "88339": "6",
  "88264": "6",
  "87722": "5",
  "87310": "5",
  "87749": "5",
  "88347": "6",
  "79835": "6",
  "88004": "6",
  "87750": "5",
  "87821": "6",
  "87939": "6",
  "88056": "6",
  "88134": "5",
  "87511": "5",
  "87516": "5",
  "88210": "6",
  "88116": "6",
  "88046": "6",
  "88344": "6",
  "16836": "2e",
  "15801": "2e",
  "15856": "2e",
  "16847": "2e",
  "19311": "2e",
  "19320": "2e",
  "19358": "2e",
  "15866": "2e",
  "19085": "2e",
  "19064": "2e",
  "19373": "2e",
  "15024": "2e",
  "15076": "2e",
  "19078": "2e",
  "19033": "2e",
  "16055": "2e",
  "19082": "2e",
  "16729": "2e",
  "15143": "2e",
  "15003": "2e",
  "15241": "2e",
  "15147": "2e",
  "15218": "2e",
  "15035": "2e",
  "15131": "2e",
  "15129": "2e",
  "15068": "2e",
  "15135": "2e",
  "15089": "2e",
  "16157": "2e",
  "15220": "2e",
  "15204": "2e",
  "16063": "2e",
  "15330": "2e",
  "15033": "2e",
  "15067": "2e",
  "15690": "2e",
  "15419": "2e",
  "15028": "2e",
  "15477": "2e",
  "15601": "2e",
  "15644": "2e",
  "15676": "2e",
  "15674": "2e",
  "15365": "2e",
  "15072": "2e",
  "16511": "2e",
  "53593": "1e",
  "54208": "1e",
  "54859": "1e",
  "54836": "1e",
  "54835": "1e",
  "54817": "1e",
  "53515": "1e",
  "53130": "1e",
  "53137": "1e",
  "53066": "1e",
  "54749": "1e",
  "53095": "1e",
  "53002": "1e",
  "53027": "1e",
  "54169": "1e",
  "54302": "1e",
  "53532": "1e",
  "54150": "1e",
  "54821": "1e",
  "53597": "1e",
  "54137": "1e",
  "53005": "1e",
  "53590": "1e",
  "54911": "1e",
  "53562": "1e",
  "53013": "1e",
  "53718": "1e",
  "54547": "1e",
  "54870": "1e",
  "54530": "1e",
  "54740": "1e",
  "54487": "1e",
  "53091": "1e",
  "54829": "1e",
  "54501": "1e",
  "54837": "1e",
  "54470": "1e",
  "54967": "1e",
  "54746": "1e",
  "54670": "1e",
  "54485": "1e",
  "53518": "1e",
  "54014": "1e",
  "53050": "1e",
  "54766": "1e",
  "54930": "1e",
  "54657": "1e",
  "53827": "1e",
  "53825": "1e",
  "53803": "2e",
  "53581": "1e",
  "54751": "1e",
  "53807": "2e",
  "54452": "1e",
  "54763": "1e",
  "53039": "1e",
  "53099": "1e",
  "53812": "2e",
  "54888": "1e",
  "54479": "1e",
  "53582": "1e",
  "54769": "1e",
  "53811": "2e",
  "53817": "1e",
  "54858": "1e",
  "53098": "1e",
  "53083": "1e",
  "53403": "2e",
  "53182": "2e",
  "53545": "2e",
  "53405": "2e",
  "54962": "1e",
  "53594": "1e",
  "54202": "1e",
  "53186": "1e",
  "53549": "1e",
  "54217": "1e",
  "53204": "1e",
  "54210": "1e",
  "54758": "1e",
  "54166": "1e",
  "54873": "1e",
  "54154": "1e",
  "54235": "1e",
  "54121": "1e",
  "53188": "1e",
  "54952": "1e",
  "54913": "1e",
  "54180": "1e",
  "53949": "1e",
  "53103": "1e",
  "54303": "1e",
  "54110": "1e",
  "54979": "1e",
  "49713": "1e",
  "49866": "1e",
  "49707": "1e",
  "48601": "1e",
  "49085": "2e",
  "48768": "1e",
  "48723": "1e",
  "48762": "1e",
  "48823": "2e",
  "48638": "1e",
  "49014": "2e",
  "49961": "1e",
  "49822": "1e",
  "48845": "1e",
  "49777": "1e",
  "49733": "1e",
  "49701": "1e",
  "48456": "1e",
  "48770": "1e",
  "49667": "1e",
  "49639": "1e",
  "49886": "1e",
  "49748": "1e",
  "49611": "1e",
  "48629": "1e",
  "49656": "1e",
  "48740": "1e",
  "48742": "1e",
  "49710": "1e",
  "48434": "1e",
  "49421": "1e",
  "49312": "1e",
  "48818": "1e",
  "48401": "1e",
  "49837": "1e",
  "49971": "1e",
  "48627": "1e",
  "48422": "1e",
  "49640": "1e",
  "49347": "1e",
  "48834": "1e",
  "48838": "1e",
  "49752": "1e",
  "49330": "1e",
  "48917": "2e",
  "48233": "2e",
  "48242": "2e",
  "49012": "2e",
  "48820": "1e",
  "48854": "2e",
  "48897": "2e",
  "49325": "2e",
  "49283": "2e",
  "49249": "2e",
  "49263": "2e",
  "49306": "1e",
  "48835": "1e",
  "49946": "1e",
  "49950": "1e",
  "64110": "2w",
  "65657": "3w",
  "64507": "2w",
  "64113": "2w",
  "64857": "2w",
  "64421": "2w",
  "64848": "2w",
  "63880": "3w",
  "63847": "3w",
  "63304": "2w",
  "63373": "2w",
  "65050": "2w",
  "63353": "2w",
  "65566": "2w",
  "65735": "2w",
  "63441": "2w",
  "65440": "3w",
  "65479": "3w",
  "63879": "3w",
  "64735": "2w",
  "63825": "3w",
  "63849": "3w",
  "65762": "3w",
  "63846": "3w",
  "64471": "2w",
  "63430": "2w",
  "63962": "3w",
  "63465": "2w",
  "63533": "2w",
  "52573": "2w",
  "64441": "2w",
  "63653": "2w",
  "65239": "2w",
  "65740": "3w",
  "65564": "3w",
  "64664": "2w",
  "64756": "2w",
  "64781": "2w",
  "64650": "2w",
  "63039": "2w",
  "65649": "2w",
  "63047": "2w",
  "65727": "2w",
  "65623": "3w",
  "65278": "2w",
  "52542": "2w",
  "63939": "3w",
  "63744": "3w",
  "65470": "2w",
  "65062": "2w",
  "63873": "3w",
  "64769": "2w",
  "65663": "2w",
  "64019": "2w",
  "65436": "2w",
  "63347": "2w",
  "63362": "2w",
  "63390": "2w",
  "64868": "3w",
  "65688": "3w",
  "64873": "2w",
  "65785": "2w",
  "63345": "2w",
  "63823": "3w",
  "63631": "2w",
  "64018": "2w",
  "63103": "2w",
  "64164": "2w",
  "64725": "2w",
  "64096": "2w",
  "64011": "2w",
  "65548": "3w",
  "64021": "2w",
  "64001": "2w",
  "63111": "2w",
  "64118": "2w",
  "65251": "2w",
  "65788": "3w",
  "63120": "2w",
  "64131": "2w",
  "64037": "2w",
  "63021": "2w",
  "63837": "3w",
  "64804": "2w",
  "64430": "2w",
  "65777": "3w",
  "63144": "2w",
  "64831": "3w",
  "64722": "2w",
  "64847": "3w",
  "64752": "2w",
  "64863": "3w",
  "64014": "2w",
  "64052": "2w",
  "93407": "7",
  "93932": "7",
  "93449": "7",
  "92806": "6",
  "95449": "7",
  "92266": "6",
  "95607": "7",
  "94104": "7",
  "92274": "6",
  "92275": "6",
  "96062": "7",
  "92009": "6",
  "96028": "5",
  "93944": "7",
  "92057": "6",
  "92029": "6",
  "96040": "5",
  "95631": "6",
  "95650": "6",
  "92027": "6",
  "96148": "5",
  "95604": "5",
  "95648": "6",
  "95765": "6",
  "91916": "6",
  "91931": "6",
  "92147": "6",
  "92887": "6",
  "92869": "6",
  "96009": "5",
  "92676": "6",
  "96114": "5",
  "96109": "5",
  "96128": "5",
  "92563": "6",
  "92585": "6",
  "92567": "6",
  "92545": "6",
  "92553": "6",
  "92220": "6",
  "92240": "6",
  "92223": "6",
  "92282": "6",
  "90069": "6",
  "90032": "6",
  "94559": "7",
  "94510": "7",
  "95421": "7",
  "94922": "7",
  "95441": "7",
  "95472": "7",
  "95450": "7",
  "92321": "6",
  "95468": "7",
  "95562": "7",
  "92273": "6",
  "92333": "6",
  "93420": "7",
  "96033": "7",
  "95554": "7",
  "92231": "6",
  "94118": "7",
  "96069": "7",
  "96071": "5",
  "92020": "6",
  "91901": "6",
  "92010": "6",
  "95717": "6",
  "92060": "6",
  "95668": "7",
  "91935": "6",
  "92672": "6",
  "92066": "6",
  "95703": "6",
  "95736": "6",
  "96150": "5",
  "92267": "6",
  "95614": "6",
  "95720": "6",
  "95762": "6",
  "92508": "6",
  "94158": "7",
  "96136": "5",
  "96121": "5",
  "95962": "6",
  "92555": "6",
  "95692": "6",
  "92651": "6",
  "92549": "6",
  "92264": "6",
  "92544": "6",
  "92230": "6",
  "92543": "6",
  "90029": "6",
  "94533": "7",
  "95465": "7",
  "94592": "7",
  "94585": "7",
  "95687": "7",
  "94512": "7",
  "90067": "6",
  "91206": "6",
  "94950": "7",
  "91371": "6",
  "94595": "7",
  "94598": "7",
  "91773": "6",
  "91722": "6",
  "91702": "6",
  "94564": "7",
  "94553": "7",
  "94602": "7",
  "11204": "2e",
  "14111": "2e",
  "12047": "2e",
  "10962": "2e",
  "10536": "2e",
  "14085": "2e",
  "10075": "2e",
  "14127": "2e",
  "10548": "2e",
  "12046": "2e",
  "12045": "2e",
  "12007": "2e",
  "13902": "2e",
  "12083": "2e",
  "10979": "2e",
  "10547": "2e",
  "10578": "2e",
  "13119": "1e",
  "13116": "1e",
  "11953": "2e",
  "13074": "1e",
  "13153": "1e",
  "11787": "2e",
  "13103": "1e",
  "11557": "2e",
  "13134": "1e",
  "13314": "1e",
  "14736": "2e",
  "13464": "2e",
  "12198": "2e",
  "14561": "1e",
  "12822": "1e",
  "13618": "1e",
  "13673": "1e",
  "12835": "1e",
  "12184": "2e",
  "12148": "2e",
  "12086": "1e",
  "12430": "2e",
  "12405": "2e",
  "12824": "1e",
  "12878": "1e",
  "12072": "1e",
  "12407": "2e",
  "12422": "2e",
  "12811": "1e",
  "12846": "1e",
  "12160": "2e",
  "12978": "1e",
  "12834": "1e",
  "11790": "2e",
  "12838": "1e",
  "12849": "1e",
  "11980": "2e",
  "14418": "2e",
  "11507": "2e",
  "11547": "2e",
  "11977": "2e",
  "13684": "1e",
  "13667": "1e",
  "13668": "1e",
  "13617": "1e",
  "31009": "4",
  "30413": "4",
  "32771": "4",
  "33071": "4",
  "32351": "4",
  "32732": "4",
  "32708": "4",
  "30423": "4",
  "32701": "4",
  "33762": "4",
  "33981": "4",
  "34679": "4",
  "33763": "4",
  "33761": "4",
  "34668": "4",
  "33785": "4",
  "33920": "4",
  "30293": "4",
  "31753": "4",
  "34711": "4",
  "34654": "4",
  "34655": "4",
  "33525": "4",
  "34690": "4",
  "33543": "4",
  "34788": "4",
  "33574": "4",
  "34797": "4",
  "33309": "4",
  "33928": "4",
  "32034": "4",
  "34743": "4",
  "34741": "4",
  "33973": "4",
  "32011": "4",
  "32907": "4",
  "32976": "4",
  "32934": "4",
  "32110": "4",
  "33957": "4",
  "33812": "4",
  "31807": "4",
  "33558": "4",
  "39840": "4",
  "30275": "4",
  "33579": "4",
  "30427": "4",
  "30434": "4",
  "31789": "4",
  "33898": "4",
  "30473": "4",
  "34761": "4",
  "33867": "4",
  "31647": "4",
  "33948": "4",
  "32080": "4",
  "97454": "7",
  "97707": "5",
  "97430": "7",
  "97703": "5",
  "97459": "7",
  "97420": "7",
  "97206": "7",
  "97227": "7",
  "97461": "7",
  "97027": "7",
  "97503": "7",
  "97450": "7",
  "97466": "7",
  "97431": "7",
  "97381": "7",
  "97231": "7",
  "97034": "7",
  "97371": "7",
  "97351": "7",
  "97024": "7",
  "97467": "7",
  "97383": "7",
  "97344": "7",
  "97014": "5",
  "97030": "7",
  "97389": "7",
  "97123": "7",
  "97114": "7",
  "97070": "7",
  "97336": "7",
  "97377": "7",
  "97128": "7",
  "97005": "7",
  "97078": "7",
  "97113": "7",
  "97050": "5",
  "97867": "5",
  "97469": "7",
  "97754": "5",
  "97367": "7",
  "97834": "5",
  "97388": "7",
  "97630": "5",
  "97838": "5",
  "97880": "5",
  "97366": "7",
  "97641": "5",
  "97820": "5",
  "97873": "5",
  "97720": "5",
  "97918": "5",
  "97118": "7",
  "97604": "7",
  "97627": "7",
  "97053": "7",
  "97040": "5",
  "97108": "7",
  "97903": "5",
  "97901": "5",
  "97037": "5",
  "97449": "7",
  "97203": "7",
  "97330": "7",
  "97760": "5",
  "97419": "7",
  "97303": "7",
  "97317": "7",
  "97537": "7",
  "97392": "7",
  "97026": "7",
  "97201": "7",
  "97236": "7",
  "97124": "7",
  "97225": "7",
  "97035": "7",
  "97326": "7",
  "97358": "7",
  "97002": "7",
  "97032": "7",
  "97378": "7",
  "97375": "7",
  "97017": "7",
  "97348": "7",
  "97148": "7",
  "97117": "7",
  "95123": "7",
  "95046": "7",
  "92606": "6",
  "92253": "6",
  "92861": "6",
  "91331": "6",
  "91325": "6",
  "90630": "6",
  "95003": "7",
  "90014": "6",
  "90047": "6",
  "90232": "6",
  "90062": "6",
  "90018": "6",
  "94578": "7",
  "96080": "7",
  "95458": "7",
  "90036": "6",
  "93301": "6",
  "95469": "7",
  "95338": "6",
  "93906": "7",
  "95230": "6",
  "95202": "7",
  "95949": "6",
  "94590": "7",
  "90806": "6",
  "93603": "6",
  "90813": "6",
  "95340": "6",
  "93645": "6",
  "90063": "6",
  "90405": "6",
  "96056": "5",
  "93610": "6",
  "91710": "6",
  "95369": "6",
  "95380": "7",
  "94541": "7",
  "93601": "6",
  "95251": "6",
  "90066": "6",
  "95311": "6",
  "90803": "6",
  "95503": "7",
  "93637": "6",
  "91367": "6",
  "90220": "6",
  "90701": "6",
  "90606": "6",
  "91303": "6",
  "90012": "6",
  "95252": "6",
  "95334": "7",
  "93673": "6",
  "93015": "6",
  "93654": "6",
  "90045": "6",
  "91106": "6",
  "96137": "5",
  "92236": "6",
  "94040": "7",
  "94041": "7",
  "94005": "7",
  "90831": "6",
  "90274": "6",
  "94019": "7",
  "94037": "7",
  "95538": "7",
  "96104": "5",
  "95374": "7",
  "95977": "6",
  "93545": "6",
  "90713": "6",
  "90305": "6",
  "95423": "7",
  "96032": "7",
  "93522": "6",
  "95986": "6",
  "90262": "6",
  "91107": "6",
  "90013": "6",
  "96021": "7",
  "96135": "5",
  "95367": "7",
  "95301": "7",
  "91775": "6",
  "91780": "6",
  "93620": "7",
  "95211": "7",
  "93901": "7",
  "95550": "7",
  "95556": "7",
  "93109": "7",
  "95938": "7",
  "92821": "6",
  "93727": "6",
  "91761": "6",
  "93454": "7",
  "93440": "7",
  "93304": "6",
  "93067": "7",
  "93247": "6",
  "95316": "7",
  "95966": "6",
  "92337": "6",
  "93260": "6",
  "95375": "6",
  "92113": "6",
  "95240": "7",
  "93251": "7",
  "93224": "7",
  "93258": "6",
  "93263": "6",
  "93640": "7",
  "93270": "6",
  "93523": "6",
  "91320": "6",
  "92134": "6",
  "92346": "6",
  "91311": "6",
  "95673": "7",
  "92354": "6",
  "93648": "6",
  "93627": "6",
  "92129": "6",
  "92372": "6",
  "96125": "5",
  "95944": "5",
  "95758": "7",
  "95429": "7",
  "92281": "6",
  "92124": "6",
  "95519": "7",
  "92309": "6",
  "95428": "7",
  "92332": "6",
  "93451": "7",
  "93428": "7",
  "94931": "7",
  "94954": "7",
  "95452": "7",
  "94970": "7",
  "94937": "7",
  "94929": "7",
  "94567": "7",
  "94573": "7",
  "91748": "6",
  "91750": "6",
  "94803": "7",
  "94565": "7",
  "94603": "7",
  "91768": "6",
  "94608": "7",
  "94933": "7",
  "94957": "7",
  "28308": "3e",
  "28307": "3e",
  "28711": "3e",
  "28371": "3e",
  "27284": "3e",
  "28792": "3e",
  "28223": "3e",
  "28273": "3e",
  "28501": "3e",
  "28525": "3e",
  "28610": "3e",
  "27405": "3e",
  "27302": "3e",
  "28682": "3e",
  "27891": "3e",
  "27022": "3e",
  "28164": "3e",
  "27505": "3e",
  "27205": "3e",
  "27371": "3e",
  "28016": "3e",
  "28468": "4",
  "28467": "4",
  "27819": "3e",
  "28456": "3e",
  "27288": "3e",
  "27610": "3e",
  "27612": "3e",
  "28607": "3e",
  "28457": "3e",
  "28722": "3e",
  "27855": "3e",
  "27305": "3e",
  "27950": "3e",
  "28702": "3e",
  "27944": "3e",
  "27929": "3e",
  "27964": "3e",
  "28785": "3e",
  "28139": "3e",
  "27869": "3e",
  "27808": "3e",
  "28905": "3e",
  "28748": "3e",
  "28334": "3e",
  "27040": "3e",
  "28757": "3e",
  "28390": "3e",
  "28602": "3e",
  "28429": "3e",
  "28538": "3e",
  "28092": "3e",
  "27041": "3e",
  "28006": "3e",
  "28173": "3e",
  "28103": "3e",
  "27523": "3e",
  "27252": "3e",
  "28470": "4",
  "28462": "3e",
  "27317": "3e",
  "28133": "3e",
  "27410": "3e",
  "28442": "3e",
  "28622": "3e",
  "28432": "4",
  "28433": "3e",
  "27814": "3e",
  "28717": "3e",
  "28537": "3e",
  "27976": "3e",
  "27910": "3e",
  "27259": "3e",
  "28571": "3e",
  "27376": "3e",
  "27818": "3e",
  "28734": "3e",
  "27570": "3e",
  "28386": "3e",
  "27847": "3e",
  "28669": "3e",
  "28670": "3e",
  "29340": "4",
  "29556": "4",
  "29649": "4",
  "29518": "4",
  "29166": "4",
  "29692": "4",
  "29826": "4",
  "29042": "4",
  "29594": "4",
  "29821": "4",
  "29177": "4",
  "29469": "4",
  "29724": "4",
  "29921": "4",
  "29053": "4",
  "29651": "4",
  "29369": "4",
  "29302": "4",
  "29329": "4",
  "29560": "4",
  "29591": "4",
  "29471": "4",
  "29203": "4",
  "29847": "4",
  "29729": "4",
  "29204": "4",
  "29617": "4",
  "29170": "4",
  "29031": "4",
  "29153": "4",
  "29905": "4",
  "29075": "4",
  "29816": "4",
  "29451": "4",
  "29707": "3e",
  "29682": "4",
  "29614": "4",
  "29130": "4",
  "29126": "4",
  "29686": "4",
  "29374": "4",
  "29702": "3e",
  "29810": "4",
  "29832": "4",
  "29726": "4",
  "29148": "4",
  "24649": "3e",
  "22503": "3e",
  "24101": "3e",
  "22940": "3e",
  "24526": "3e",
  "23523": "3e",
  "22448": "3e",
  "22578": "3e",
  "24250": "3e",
  "22514": "3e",
  "22646": "2e",
  "24175": "3e",
  "24064": "3e",
  "23230": "3e",
  "23221": "3e",
  "22842": "3e",
  "24269": "3e",
  "24318": "3e",
  "22435": "3e",
  "22655": "2e",
  "23696": "3e",
  "23693": "3e",
  "24374": "3e",
  "24375": "3e",
  "22827": "3e",
  "24224": "3e",
  "24521": "3e",
  "22911": "3e",
  "24211": "3e",
  "24054": "3e",
  "24061": "3e",
  "22946": "3e",
  "28654": "3e",
  "28375": "3e",
  "28626": "3e",
  "28528": "3e",
  "28367": "3e",
  "27582": "3e",
  "28363": "3e",
  "27954": "3e",
  "27968": "3e",
  "27943": "3e",
  "27861": "3e",
  "28077": "3e",
  "28343": "4",
  "27295": "3e",
  "28625": "3e",
  "27545": "3e",
  "27265": "3e",
  "28678": "3e",
  "28479": "3e",
  "27253": "3e",
  "28104": "3e",
  "28761": "3e",
  "28642": "3e",
  "27617": "3e",
  "27519": "3e",
  "28203": "3e",
  "27830": "3e",
  "28574": "3e",
  "28546": "3e",
  "28206": "3e",
  "28333": "3e",
  "28513": "3e",
  "28312": "3e",
  "27837": "3e",
  "27878": "3e",
  "27829": "3e",
  "27708": "3e",
  "11961": "2e",
  "11957": "2e",
  "12585": "2e",
  "11777": "2e",
  "11005": "2e",
  "14441": "2e",
  "11954": "2e",
  "11020": "2e",
  "11963": "2e",
  "11042": "2e",
  "11975": "2e",
  "11960": "2e",
  "13648": "1e",
  "13676": "1e",
  "13625": "1e",
  "11956": "2e",
  "14837": "2e",
  "12507": "2e",
  "12504": "2e",
  "12604": "2e",
  "11549": "2e",
  "14571": "1e",
  "11576": "2e",
  "13614": "1e",
  "11972": "2e",
  "13696": "1e",
  "12914": "1e",
  "12512": "2e",
  "13649": "1e",
  "11803": "2e",
  "11958": "2e",
  "56030": "1w",
  "56363": "1w",
  "55903": "1w",
  "56097": "1w",
  "56511": "1w",
  "56554": "1w",
  "56186": "1w",
  "56650": "1w",
  "55105": "1w",
  "56514": "1w",
  "56170": "1w",
  "56291": "1w",
  "56688": "1w",
  "56074": "1w",
  "56119": "1w",
  "56274": "1w",
  "55038": "1w",
  "55073": "1w",
  "50276": "2w",
  "50263": "2w",
  "50167": "2w",
  "51441": "2w",
  "50659": "1w",
  "50025": "2w",
  "52049": "2w",
  "50115": "2w",
  "50234": "2w",
  "52356": "2w",
  "52361": "2w",
  "50155": "2w",
  "51467": "2w",
  "50673": "2w",
  "50050": "2w",
  "50538": "2w",
  "50058": "2w",
  "51462": "2w",
  "50532": "2w",
  "52203": "2w",
  "38677": "3e",
  "39654": "4",
  "38730": "3e",
  "38841": "3e",
  "38844": "4",
  "39324": "4",
  "39095": "4",
  "39108": "4",
  "38871": "3e",
  "39063": "4",
  "39750": "4",
  "39090": "4",
  "38865": "3e",
  "38843": "4",
  "39476": "4",
  "38846": "3e",
  "38751": "3e",
  "39756": "4",
  "38753": "4",
  "38754": "4",
  "39191": "4",
  "38658": "3e",
  "39766": "4",
  "39701": "4",
  "39209": "4",
  "39560": "4",
  "39203": "4",
  "39534": "4",
  "75159": "3w",
  "76102": "3w",
  "76134": "3w",
  "76110": "3w",
  "76119": "3w",
  "76104": "3w",
  "76001": "3w",
  "76120": "3w",
  "76155": "3w",
  "76137": "3w",
  "78209": "6",
  "76088": "3w",
  "76041": "3w",
  "75125": "3w",
  "75161": "3w",
  "78222": "6",
  "78224": "6",
  "76234": "3w",
  "76247": "3w",
  "78239": "6",
  "76476": "3w",
  "77350": "4",
  "77346": "4",
  "78255": "6",
  "78130": "6",
  "78648": "6",
  "78655": "6",
  "77017": "4",
  "77021": "4",
  "77025": "4",
  "77098": "4",
  "77062": "4",
  "77069": "4",
  "77449": "4",
  "77088": "4",
  "77533": "4",
  "78931": "6",
  "75558": "3w",
  "75449": "3w",
  "79223": "3w",
  "75865": "3w",
  "76874": "6",
  "75654": "3w",
  "75497": "3w",
  "76637": "6",
  "77855": "3w",
  "76466": "6",
  "75117": "3w",
  "75479": "3w",
  "76862": "6",
  "77662": "4",
  "78576": "4",
  "79603": "6",
  "79562": "6",
  "75251": "3w",
  "75209": "3w",
  "76579": "6",
  "76557": "6",
  "75225": "3w",
  "75215": "3w",
  "76207": "3w",
  "75210": "3w",
  "76559": "6",
  "78579": "4",
  "76205": "3w",
  "76573": "6",
  "75090": "3w",
  "75702": "3w",
  "98238": "5",
  "98424": "5",
  "98671": "7",
  "98644": "7",
  "99126": "5",
  "98556": "7",
  "98358": "7",
  "98198": "5",
  "98513": "7",
  "98281": "5",
  "99023": "5",
  "98391": "5",
  "98467": "7",
  "98670": "5",
  "98022": "5",
  "98354": "5",
  "98021": "5",
  "98166": "5",
  "98660": "7",
  "98661": "7",
  "98032": "5",
  "98051": "5",
  "98664": "7",
  "98148": "5",
  "98158": "5",
  "98642": "7",
  "98845": "5",
  "98295": "5",
  "98116": "5",
  "98134": "5",
  "98103": "5",
  "99005": "5",
  "99141": "5",
  "99121": "5",
  "98532": "7",
  "98846": "5",
  "98570": "7",
  "98541": "7",
  "99161": "5",
  "99203": "5",
  "99224": "5",
  "98119": "5",
  "98109": "5",
  "98121": "5",
  "98355": "5",
  "98568": "7",
  "98942": "5",
  "98528": "7",
  "98625": "7",
  "98027": "5",
  "98033": "5",
  "67843": "2w",
  "67059": "2w",
  "67867": "2w",
  "66740": "2w",
  "67673": "2w",
  "67336": "2w",
  "66864": "2w",
  "66871": "2w",
  "66857": "2w",
  "67109": "2w",
  "67214": "2w",
  "66521": "2w",
  "66442": "2w",
  "66606": "2w",
  "67218": "2w",
  "67037": "2w",
  "67215": "2w",
  "66018": "2w",
  "66049": "2w",
  "67561": "2w",
  "66605": "2w",
  "67203": "2w",
  "67123": "2w",
  "66097": "2w",
  "66208": "2w",
  "66204": "2w",
  "67505": "2w",
  "67228": "2w",
  "66017": "2w",
  "66419": "2w",
  "67357": "2w",
  "66086": "2w",
  "66418": "2w",
  "67220": "2w",
  "66047": "2w",
  "66830": "2w",
  "66210": "2w",
  "67041": "2w",
  "67473": "2w",
  "67474": "2w",
  "67337": "2w",
  "67749": "2w",
  "66748": "2w",
  "67335": "2w",
  "66851": "2w",
  "67487": "2w",
  "67354": "2w",
  "67744": "2w",
  "66732": "2w",
  "67849": "2w",
  "66507": "2w",
  "66058": "2w",
  "67418": "2w",
  "66021": "2w",
  "67481": "2w",
  "67545": "2w",
  "67741": "2w",
  "66541": "2w",
  "66622": "2w",
  "68420": "2w",
  "67364": "2w",
  "66938": "2w",
  "67445": "2w",
  "67736": "2w",
  "66072": "2w",
  "66075": "2w",
  "67068": "2w",
  "66753": "2w",
  "66762": "2w",
  "67047": "2w",
  "67120": "2w",
  "67106": "2w",
  "67018": "2w",
  "67457": "2w",
  "69216": "2w",
  "68462": "2w",
  "68974": "2w",
  "69001": "2w",
  "69023": "2w",
  "69040": "2w",
  "68660": "2w",
  "69045": "2w",
  "69042": "2w",
  "68465": "2w",
  "68655": "2w",
  "68023": "2w",
  "68424": "2w",
  "69021": "2w",
  "68847": "2w",
  "68442": "2w",
  "68841": "2w",
  "69157": "2w",
  "68429": "2w",
  "68843": "2w",
  "68514": "2w",
  "68133": "2w",
  "69339": "5",
  "68372": "2w",
  "68964": "2w",
  "68434": "2w",
  "68138": "2w",
  "68154": "2w",
  "68865": "2w",
  "68713": "2w",
  "68780": "2w",
  "68879": "2w",
  "68842": "2w",
  "68862": "2w",
  "68856": "2w",
  "68852": "2w",
  "68858": "2w",
  "68624": "2w",
  "68777": "2w",
  "68418": "2w",
  "68014": "2w",
  "68976": "2w",
  "68329": "2w",
  "68873": "2w",
  "68016": "2w",
  "68747": "2w",
  "68710": "2w",
  "68727": "2w",
  "68751": "2w",
  "69155": "2w",
  "69122": "2w",
  "68810": "2w",
  "68505": "2w",
  "68588": "2w",
  "68107": "2w",
  "68104": "2w",
  "68124": "2w",
  "69162": "5",
  "68651": "2w",
  "68957": "2w",
  "68977": "2w",
  "68067": "2w",
  "68629": "2w",
  "68939": "2w",
  "68960": "2w",
  "68466": "2w",
  "69221": "2w",
  "69219": "2w",
  "68022": "2w",
  "69142": "2w",
  "68440": "2w",
  "68402": "2w",
  "68531": "2w",
  "69350": "2w",
  "68642": "2w",
  "68030": "2w",
  "68527": "2w",
  "69032": "2w",
  "69024": "2w",
  "68933": "2w",
  "68019": "2w",
  "68644": "2w",
  "68464": "2w",
  "69354": "5",
  "57735": "5",
  "10588": "2e",
  "10927": "2e",
  "11040": "2e",
  "10985": "2e",
  "11793": "2e",
  "11563": "2e",
  "11357": "2e",
  "14092": "1e",
  "13322": "1e",
  "13104": "1e",
  "10453": "2e",
  "12308": "2e",
  "13309": "1e",
  "13301": "1e",
  "12307": "2e",
  "12438": "2e",
  "12060": "2e",
  "12115": "2e",
  "12544": "2e",
  "13440": "1e",
  "13501": "1e",
  "13069": "1e",
  "12305": "2e",
  "13316": "1e",
  "13028": "1e",
  "14505": "1e",
  "14423": "1e",
  "10468": "2e",
  "13493": "1e",
  "11554": "2e",
  "14141": "2e",
  "11780": "2e",
  "11783": "2e",
  "13205": "1e",
  "14070": "2e",
  "10301": "2e",
  "11215": "2e",
  "14202": "1e",
  "10128": "2e",
  "11213": "2e",
  "12027": "1e",
  "14517": "2e",
  "57570": "2w",
  "57601": "1w",
  "57722": "5",
  "57579": "1w",
  "57585": "1w",
  "57548": "1w",
  "57621": "1w",
  "57633": "1w",
  "57521": "1w",
  "57367": "1w",
  "57370": "1w",
  "57644": "1w",
  "57355": "1w",
  "57362": "1w",
  "57361": "1w",
  "57438": "1w",
  "57017": "1w",
  "57042": "1w",
  "57078": "2w",
  "57717": "1w",
  "57371": "1w",
  "57037": "1w",
  "57029": "1w",
  "57401": "1w",
  "57251": "1w",
  "57468": "1w",
  "57636": "1w",
  "57226": "1w",
  "57238": "1w",
  "57452": "1w",
  "57021": "1w",
  "57012": "1w",
  "57032": "1w",
  "57465": "1w",
  "57030": "1w",
  "57702": "5",
  "57274": "1w",
  "57034": "1w",
  "57719": "1w",
  "57761": "1w",
  "57785": "1w",
  "57369": "1w",
  "15845": "2e",
  "18426": "2e",
  "16947": "2e",
  "18458": "2e",
  "16245": "2e",
  "18451": "2e",
  "16256": "2e",
  "17084": "2e",
  "18847": "2e",
  "18462": "2e",
  "17063": "2e",
  "16226": "2e",
  "15744": "2e",
  "18632": "2e",
  "15784": "2e",
  "18302": "2e",
  "15774": "2e",
  "15522": "2e",
  "16650": "2e",
  "18473": "2e",
  "18456": "2e",
  "15550": "2e",
  "18470": "2e",
  "18438": "2e",
  "83201": "5",
  "83811": "5",
  "83803": "5",
  "83660": "5",
  "83619": "5",
  "83623": "5",
  "83204": "5",
  "83669": "5",
  "83214": "5",
  "83281": "5",
  "83263": "5",
  "83213": "5",
  "85225": "6",
  "85266": "6",
  "85085": "6",
  "85204": "6",
  "85310": "6",
  "85257": "6",
  "85032": "6",
  "85023": "6",
  "85041": "6",
  "85050": "6",
  "85054": "6",
  "85044": "6",
  "46161": "2e",
  "47382": "2e",
  "46732": "2e",
  "47995": "2e",
  "47987": "2e",
  "47436": "2e",
  "46052": "2e",
  "47940": "2e",
  "47578": "2e",
  "47561": "2e",
  "46538": "2e",
  "47965": "2e",
  "47224": "2e",
  "47879": "2e",
  "47882": "2e",
  "47648": "3e",
  "46062": "2e",
  "46941": "2e",
  "46990": "2e",
  "47577": "3e",
  "46958": "2e",
  "46919": "2e",
  "47523": "3e",
  "47525": "3e",
  "47588": "3e",
  "47136": "3e",
  "46953": "2e",
  "47346": "2e",
  "46802": "2e",
  "47905": "2e",
  "46819": "2e",
  "46986": "2e",
  "46147": "2e",
  "46219": "2e",
  "46227": "2e",
  "47458": "2e",
  "46229": "2e",
  "40047": "3e",
  "40390": "3e",
  "40272": "3e",
  "41139": "3e",
  "40220": "3e",
  "40517": "3e",
  "40241": "3e",
  "41101": "3e",
  "40076": "3e",
  "41121": "3e",
  "41033": "2e",
  "40222": "3e",
  "40211": "3e",
  "40162": "3e",
  "40160": "3e",
  "41001": "2e",
  "42784": "3e",
  "41635": "3e",
  "40360": "3e",
  "40472": "3e",
  "42633": "3e",
  "42160": "3e",
  "41093": "3e",
  "41339": "3e",
  "40177": "3e",
  "40513": "3e",
  "42041": "3e",
  "40243": "3e",
  "41085": "2e",
  "41601": "3e",
  "41649": "3e",
  "40422": "3e",
  "42503": "3e",
  "41008": "2e",
  "42133": "3e",
  "41858": "3e",
  "40447": "3e",
  "41164": "3e",
  "42166": "3e",
  "40913": "3e",
  "42647": "3e",
  "41098": "2e",
  "42220": "3e",
  "42404": "3e",
  "42021": "3w",
  "40988": "3e",
  "40143": "3e",
  "42629": "3e",
  "42276": "3e",
  "42211": "3e",
  "40009": "3e",
  "01984": "2e",
  "02557": "2e",
  "02575": "2e",
  "02747": "2e",
  "01522": "2e",
  "01583": "2e",
  "01610": "2e",
  "01585": "2e",
  "01608": "2e",
  "01037": "2e",
  "01440": "2e",
  "01094": "2e",
  "01523": "2e",
  "01510": "2e",
  "01109": "2e",
  "01515": "2e",
  "01366": "2e",
  "01020": "2e",
  "01516": "2e",
  "01540": "2e",
  "01069": "2e",
  "01034": "2e",
  "01521": "2e",
  "01568": "2e",
  "01033": "2e",
  "01527": "2e",
  "01950": "2e",
  "02071": "2e",
  "02035": "2e",
  "02190": "2e",
  "02191": "2e",
  "02457": "2e",
  "02465": "2e",
  "01222": "2e",
  "01772": "2e",
  "01611": "2e",
  "01003": "2e",
  "01529": "2e",
  "01965": "2e",
  "01969": "2e",
  "01832": "2e",
  "02176": "2e",
  "01835": "2e",
  "02171": "2e",
  "02481": "2e",
  "02021": "2e",
  "02343": "2e",
  "02762": "2e",
  "02482": "2e",
  "02459": "2e",
  "02453": "2e",
  "01886": "2e",
  "01749": "2e",
  "01262": "2e",
  "02760": "2e",
  "02703": "2e",
  "02766": "2e",
  "02494": "2e",
  "02360": "2e",
  "02302": "2e",
  "02339": "2e",
  "02324": "2e",
  "02571": "2e",
  "02532": "2e",
  "02542": "2e",
  "02559": "2e",
  "01224": "2e",
  "01098": "2e",
  "02769": "2e",
  "02763": "2e",
  "02702": "2e",
  "02072": "2e",
  "02050": "2e",
  "02347": "2e",
  "02538": "2e",
  "02116": "2e",
  "02657": "2e",
  "02639": "2e",
  "02163": "2e",
  "02663": "2e",
  "02067": "2e",
  "02184": "2e",
  "02093": "2e",
  "02142": "2e",
  "02472": "2e",
  "01773": "2e",
  "01083": "2e",
  "01436": "2e",
  "01107": "2e",
  "01010": "2e",
  "01537": "2e",
  "01081": "2e",
  "01011": "2e",
  "01009": "2e",
  "01089": "2e",
  "02169": "2e",
  "02375": "2e",
  "02584": "2e",
  "01569": "2e",
  "01035": "2e",
  "01525": "2e",
  "01951": "2e",
  "01854": "2e",
  "01830": "2e",
  "01810": "2e",
  "01876": "2e",
  "01860": "2e",
  "02025": "2e",
  "01718": "2e",
  "01731": "2e",
  "01432": "2e",
  "01748": "2e",
  "23870": "3e",
  "23846": "3e",
  "23936": "3e",
  "23868": "3e",
  "23966": "3e",
  "24460": "3e",
  "20137": "2e",
  "24412": "3e",
  "24435": "3e",
  "23959": "3e",
  "23347": "3e",
  "24528": "3e",
  "23408": "3e",
  "22714": "3e",
  "24167": "3e",
  "22736": "3e",
  "23316": "3e",
  "22741": "3e",
  "23909": "3e",
  "24529": "3e",
  "23086": "3e",
  "22623": "2e",
  "22976": "3e",
  "24246": "3e",
  "23504": "3e",
  "24458": "3e",
  "22437": "3e",
  "23035": "3e",
  "23163": "3e",
  "23045": "3e",
  "23156": "3e",
  "23126": "3e",
  "23108": "3e",
  "23091": "3e",
  "23322": "3e",
  "24067": "3e",
  "24630": "3e",
  "24316": "3e",
  "23022": "3e",
  "22482": "3e",
  "22534": "3e",
  "24015": "3e",
  "22469": "3e",
  "24011": "3e",
  "23147": "3e",
  "22480": "3e",
  "22935": "3e",
  "24022": "3e",
  "35078": "4",
  "36024": "4",
  "36749": "4",
  "38852": "3e",
  "35060": "4",
  "36860": "4",
  "35953": "4",
  "36376": "4",
  "36761": "4",
  "35119": "4",
  "34211": "4",
  "36371": "4",
  "31210": "4",
  "31206": "4",
  "31052": "4",
  "31704": "4",
  "33141": "4",
  "32511": "4",
  "36319": "4",
  "30038": "4",
  "30083": "4",
  "30087": "4",
  "30084": "4",
  "30144": "4",
  "31743": "4",
  "36471": "4",
  "36475": "4",
  "36855": "4",
  "36862": "4",
  "35772": "3e",
  "35752": "4",
  "36470": "4",
  "36039": "4",
  "36539": "4",
  "35967": "4",
  "36456": "4",
  "36483": "4",
  "35136": "4",
  "35988": "4",
  "33484": "4",
  "30058": "4",
  "30814": "4",
  "30008": "4",
  "30157": "4",
  "33411": "4",
  "33449": "4",
  "33704": "4",
  "33701": "4",
  "33015": "4",
  "33955": "4",
  "33703": "4",
  "35960": "4",
  "36436": "4",
  "36540": "4",
  "35766": "3e",
  "30274": "4",
  "30168": "4",
  "30126": "4",
  "33903": "4",
  "35581": "4",
  "35543": "4",
  "15756": "2e",
  "15713": "2e",
  "17211": "2e",
  "15362": "2e",
  "15337": "2e",
  "16416": "2e",
  "15353": "2e",
  "19136": "2e",
  "19154": "2e",
  "19114": "2e",
  "16254": "2e",
  "17074": "2e",
  "19116": "2e",
  "16133": "2e",
  "18801": "2e",
  "16150": "2e",
  "16161": "2e",
  "19428": "2e",
  "19066": "2e",
  "17824": "2e",
  "16301": "2e",
  "17834": "2e",
  "16424": "2e",
  "18403": "2e",
  "17867": "2e",
  "17772": "2e",
  "16404": "2e",
  "16372": "2e",
  "18246": "2e",
  "19333": "2e",
  "18346": "2e",
  "16316": "2e",
  "18301": "2e",
  "18643": "2e",
  "18642": "2e",
  "15430": "2e",
  "16153": "2e",
  "18824": "2e",
  "15458": "2e",
  "15438": "2e",
  "85726": "6",
  "85341": "6",
  "85615": "6",
  "86337": "5",
  "85617": "6",
  "85710": "6",
  "85708": "6",
  "85748": "6",
  "85037": "6",
  "85940": "6",
  "85640": "6",
  "85646": "6",
  "07825": "2e",
  "07642": "2e",
  "07860": "2e",
  "07656": "2e",
  "07645": "2e",
  "08314": "2e",
  "08105": "2e",
  "07506": "2e",
  "07821": "2e",
  "07846": "2e",
  "07831": "2e",
  "07934": "2e",
  "07420": "2e",
  "08823": "2e",
  "08328": "2e",
  "07418": "2e",
  "98336": "5",
  "98008": "5",
  "98004": "5",
  "99301": "5",
  "98548": "7",
  "99134": "5",
  "99154": "5",
  "98638": "7",
  "98614": "7",
  "98245": "5",
  "98374": "7",
  "98375": "7",
  "98338": "7",
  "98370": "7",
  "98366": "7",
  "98337": "7",
  "98283": "5",
  "98241": "5",
  "98243": "5",
  "98936": "5",
  "99323": "5",
  "99402": "5",
  "98223": "5",
  "98380": "7",
  "98371": "7",
  "98828": "5",
  "98106": "5",
  "98278": "5",
  "98852": "5",
  "98357": "7",
  "99322": "5",
  "99157": "5",
  "98813": "5",
  "98848": "5",
  "98465": "7",
  "99216": "5",
  "98164": "5",
  "98174": "5",
  "99349": "5",
  "99345": "5",
  "99019": "5",
  "98530": "7",
  "99030": "5",
  "98321": "5",
  "98445": "7",
  "98673": "5",
  "98251": "5",
  "98065": "5",
  "98020": "5",
  "98036": "5",
  "98012": "5",
  "98682": "7",
  "98203": "5",
  "98075": "5",
  "98023": "5",
  "98001": "5",
  "98604": "7",
  "98392": "7",
  "98941": "5",
  "98396": "5",
  "02632": "2e",
  "02631": "2e",
  "02655": "2e",
  "01337": "2e",
  "01370": "2e",
  "01355": "2e",
  "01375": "2e",
  "01346": "2e",
  "01960": "2e",
  "01937": "2e",
  "01068": "2e",
  "01082": "2e",
  "01031": "2e",
  "01541": "2e",
  "01531": "2e",
  "02726": "2e",
  "01462": "2e",
  "01108": "2e",
  "01097": "2e",
  "01022": "2e",
  "01040": "2e",
  "01588": "2e",
  "01532": "2e",
  "01088": "2e",
  "01560": "2e",
  "01431": "2e",
  "01840": "2e",
  "01879": "2e",
  "01833": "2e",
  "01824": "2e",
  "01850": "2e",
  "02186": "2e",
  "01760": "2e",
  "02062": "2e",
  "01464": "2e",
  "01770": "2e",
  "02138": "2e",
  "02460": "2e",
  "02478": "2e",
  "01741": "2e",
  "01880": "2e",
  "01460": "2e",
  "01803": "2e",
  "01887": "2e",
  "01220": "2e",
  "01229": "2e",
  "01260": "2e",
  "02718": "2e",
  "02715": "2e",
  "61720": "2e",
  "60940": "2e",
  "62832": "2e",
  "62079": "2e",
  "62547": "2e",
  "62359": "2e",
  "60639": "2e",
  "61865": "2e",
  "61862": "2e",
  "61812": "2e",
  "62203": "2e",
  "60932": "2e",
  "62002": "2e",
  "62343": "2w",
  "62312": "2e",
  "61873": "2e",
  "62905": "3e",
  "62314": "2e",
  "60660": "2e",
  "60917": "2e",
  "60145": "2e",
  "60146": "2e",
  "61845": "2e",
  "61875": "2e",
  "61841": "2e",
  "61863": "2e",
  "62902": "3e",
  "61564": "2e",
  "61482": "2e",
  "61231": "2e",
  "61244": "2e",
  "61924": "2e",
  "60910": "2e",
  "61028": "2e",
  "61484": "2e",
  "60304": "2e",
  "62939": "3e",
  "61414": "2e",
  "61256": "2e",
  "60515": "2e",
  "61044": "2e",
  "61264": "2e",
  "61284": "2e",
  "61273": "2e",
  "60426": "2e",
  "62997": "2e",
  "60160": "2e",
  "60438": "2e",
  "62983": "3e",
  "61260": "2w",
  "62819": "3e",
  "62808": "2e",
  "62889": "2e",
  "62893": "2e",
  "61476": "2w",
  "60607": "2e",
  "61949": "2e",
  "61276": "2e",
  "61940": "2e",
  "62010": "2e",
  "62293": "2e",
  "61724": "2e",
  "61854": "2e",
  "61842": "2e",
  "62932": "3e",
  "61422": "2e",
  "62349": "2e",
  "62642": "2e",
  "60401": "2e",
  "62379": "2w",
  "62373": "2e",
  "60637": "2e",
  "62078": "2e",
  "61230": "2e",
  "61488": "2e",
  "61027": "2e",
  "61032": "2e",
  "61107": "2e",
  "61832": "2e",
  "61331": "2e",
  "61250": "2e",
  "61605": "2e",
  "61318": "2e",
  "62711": "2e",
  "61485": "2e",
  "61801": "2e",
  "14586": "1e",
  "12577": "2e",
  "10953": "2e",
  "10976": "2e",
  "10546": "2e",
  "10930": "2e",
  "14543": "1e",
  "13826": "2e",
  "12158": "2e",
  "10990": "2e",
  "12054": "2e",
  "10028": "2e",
  "10950": "2e",
  "14026": "1e",
  "12143": "2e",
  "11427": "2e",
  "14030": "2e",
  "14032": "1e",
  "11697": "2e",
  "14416": "1e",
  "12157": "2e",
  "13083": "1e",
  "11784": "2e",
  "11004": "2e",
  "13145": "1e",
  "13158": "2e",
  "14027": "2e",
  "14432": "1e",
  "13494": "1e",
  "12019": "1e",
  "10282": "2e",
  "14756": "2e",
  "12052": "2e",
  "14504": "1e",
  "14544": "2e",
  "13081": "2e",
  "35171": "4",
  "36553": "4",
  "35963": "4",
  "36042": "4",
  "36853": "4",
  "35986": "4",
  "36432": "4",
  "36038": "4",
  "36476": "4",
  "36273": "4",
  "35183": "4",
  "36455": "4",
  "30127": "4",
  "33445": "4",
  "34110": "4",
  "33565": "4",
  "33527": "4",
  "33473": "4",
  "36773": "4",
  "35746": "3e",
  "35764": "3e",
  "35751": "3e",
  "30148": "4",
  "30233": "4",
  "30068": "4",
  "30215": "4",
  "30802": "4",
  "30824": "4",
  "32565": "4",
  "34267": "4",
  "32801": "4",
  "33073": "4",
  "36441": "4",
  "35565": "4",
  "35582": "3e",
  "36748": "4",
  "39837": "4",
  "31649": "4",
  "31027": "4",
  "31513": "4",
  "30528": "4",
  "33859": "4",
  "33850": "4",
  "32818": "4",
  "33584": "4",
  "33815": "4",
  "31550": "4",
  "33705": "4",
  "31078": "4",
  "30047": "4",
  "30045": "4",
  "30656": "4",
  "32430": "4",
  "31811": "4",
  "30132": "4",
  "31833": "4",
  "30521": "4",
  "39862": "4",
  "31094": "4",
  "34714": "4",
  "30117": "4",
  "31321": "4",
  "30054": "4",
  "39861": "4",
  "31830": "4",
  "30180": "4",
  "33625": "4",
  "33624": "4",
  "30265": "4",
  "33781": "4",
  "33708": "4",
  "32542": "4",
  "32086": "4",
  "32544": "4",
  "33706": "4",
  "33060": "4",
  "34653": "4",
  "04920": "1e",
  "04417": "1e",
  "04358": "1e",
  "04005": "1e",
  "04928": "1e",
  "04691": "1e",
  "04769": "1e",
  "04740": "1e",
  "04856": "1e",
  "04617": "1e",
  "04956": "1e",
  "04022": "1e",
  "04537": "1e",
  "04640": "1e",
  "04478": "1e",
  "04579": "1e",
  "04294": "1e",
  "04989": "1e",
  "04938": "1e",
  "04992": "1e",
  "04029": "1e",
  "04087": "1e",
  "04108": "1e",
  "04210": "1e",
  "04064": "1e",
  "04347": "1e",
  "04777": "1e",
  "04250": "1e",
  "04779": "1e",
  "04942": "1e",
  "04220": "1e",
  "04971": "1e",
  "04616": "1e",
  "04282": "1e",
  "04256": "1e",
  "04609": "1e",
  "04986": "1e",
  "03904": "2e",
  "04454": "1e",
  "04017": "1e",
  "04940": "1e",
  "04573": "1e",
  "04576": "1e",
  "04341": "1e",
  "04851": "1e",
  "04487": "1e",
  "04217": "1e",
  "04653": "1e",
  "04424": "1e",
  "04630": "1e",
  "04742": "1e",
  "04764": "1e",
  "04457": "1e",
  "04364": "1e",
  "04680": "1e",
  "04750": "1e",
  "04733": "1e",
  "04864": "1e",
  "04911": "1e",
  "04611": "1e",
  "04357": "1e",
  "04551": "1e",
  "04978": "1e",
  "04645": "1e",
  "04041": "1e",
  "04009": "1e",
  "04048": "1e",
  "04020": "1e",
  "04434": "1e",
  "04074": "1e",
  "11417": "2e",
  "11416": "2e",
  "11374": "2e",
  "11428": "2e",
  "14620": "1e",
  "10709": "2e",
  "12771": "2e",
  "11355": "2e",
  "10025": "2e",
  "10538": "2e",
  "10603": "2e",
  "10805": "2e",
  "14213": "1e",
  "10804": "2e",
  "11103": "2e",
  "11414": "2e",
  "13361": "1e",
  "11726": "2e",
  "11779": "2e",
  "14872": "2e",
  "11419": "2e",
  "13777": "2e",
  "10956": "2e",
  "14901": "2e",
  "13212": "1e",
  "14227": "1e",
  "10579": "2e",
  "10941": "2e",
  "10541": "2e",
  "11951": "2e",
  "11003": "2e",
  "10019": "2e",
  "11598": "2e",
  "10111": "2e",
  "71107": "3w",
  "70343": "4",
  "71418": "4",
  "71357": "4",
  "71419": "4",
  "71253": "4",
  "70114": "4",
  "70503": "4",
  "71266": "4",
  "70669": "4",
  "71469": "4",
  "70112": "4",
  "71455": "4",
  "70344": "4",
  "71428": "4",
  "71403": "4",
  "70609": "4",
  "70665": "4",
  "70646": "4",
  "70820": "4",
  "70809": "4",
  "70071": "4",
  "70040": "4",
  "71220": "4",
  "70070": "4",
  "71463": "4",
  "70538": "4",
  "70460": "4",
  "70458": "4",
  "70763": "4",
  "70786": "4",
  "71129": "3w",
  "71033": "3w",
  "70444": "4",
  "70533": "4",
  "70554": "4",
  "70528": "4",
  "71049": "3w",
  "70653": "4",
  "71432": "4",
  "70760": "4",
  "70715": "4",
  "70789": "4",
  "71417": "4",
  "71424": "4",
  "71485": "4",
  "70148": "4",
  "70733": "4",
  "70449": "4",
  "70052": "4",
  "70769": "4",
  "70780": "4",
  "70466": "4",
  "23236": "3e",
  "23832": "3e",
  "23834": "3e",
  "23410": "3e",
  "23438": "3e",
  "23433": "3e",
  "23089": "3e",
  "22201": "2e",
  "22551": "3e",
  "23062": "3e",
  "23294": "3e",
  "23150": "3e",
  "23075": "3e",
  "23093": "3e",
  "23084": "3e",
  "22307": "2e",
  "22309": "2e",
  "22303": "2e",
  "23874": "3e",
  "23827": "3e",
  "23111": "3e",
  "22152": "2e",
  "20191": "2e",
  "20141": "2e",
  "20197": "2e",
  "22180": "2e",
  "20148": "2e",
  "23141": "3e",
  "22191": "3e",
  "23890": "3e",
  "20112": "3e",
  "22172": "3e",
  "23821": "3e",
  "23856": "3e",
  "24578": "3e",
  "23964": "3e",
  "22728": "3e",
  "23967": "3e",
  "22724": "3e",
  "23943": "3e",
  "24243": "3e",
  "22640": "2e",
  "22947": "3e",
  "23032": "3e",
  "23070": "3e",
  "23076": "3e",
  "24433": "3e",
  "24442": "3e",
  "23930": "3e",
  "23161": "3e",
  "24609": "3e",
  "24377": "3e",
  "24637": "3e",
  "24092": "3e",
  "22488": "3e",
  "23601": "3e",
  "23602": "3e",
  "24327": "3e",
  "24515": "3e",
  "29356": "3e",
  "29301": "4",
  "29470": "4",
  "29909": "4",
  "54772": "1e",
  "54020": "1e",
  "53820": "2e",
  "54514": "1e",
  "53556": "1e",
  "54921": "1e",
  "53024": "1e",
  "54978": "1e",
  "53176": "2e",
  "53127": "1e",
  "53033": "1e",
  "54664": "1e",
  "54555": "1e",
  "53021": "1e",
  "53925": "1e",
  "54531": "1e",
  "53955": "1e",
  "54449": "1e",
  "54801": "1e",
  "54723": "1e",
  "53550": "2e",
  "54458": "1e",
  "53930": "1e",
  "53587": "2e",
  "54539": "1e",
  "54722": "1e",
  "54241": "1e",
  "53719": "1e",
  "54759": "1e",
  "54727": "1e",
  "54726": "1e",
  "54476": "1e",
  "53525": "2e",
  "49629": "1e",
  "49858": "1e",
  "49679": "1e",
  "49718": "1e",
  "49346": "1e",
  "48703": "1e",
  "48766": "1e",
  "49740": "1e",
  "48886": "1e",
  "49636": "1e",
  "48472": "1e",
  "48749": "1e",
  "49664": "1e",
  "49722": "1e",
  "49768": "1e",
  "48454": "1e",
  "49788": "1e",
  "49747": "1e",
  "48846": "1e",
  "49272": "2e",
  "49053": "2e",
  "49277": "2e",
  "49251": "2e",
  "49254": "2e",
  "49452": "1e",
  "49073": "2e",
  "48827": "2e",
  "48840": "2e",
  "49234": "2e",
  "48849": "2e",
  "49010": "2e",
  "49233": "2e",
  "48433": "1e",
  "49614": "1e",
  "49617": "1e",
  "49920": "1e",
  "48832": "1e",
  "48310": "2e",
  "48105": "2e",
  "48191": "2e",
  "48642": "1e",
  "48613": "1e",
  "48042": "2e",
  "48316": "2e",
  "49688": "1e",
  "49620": "1e",
  "48060": "1e",
  "49657": "1e",
  "48604": "1e",
  "48195": "2e",
  "48618": "1e",
  "49696": "1e",
  "49685": "1e",
  "48342": "2e",
  "48341": "2e",
  "48005": "1e",
  "48050": "1e",
  "48732": "1e",
  "48320": "2e",
  "48314": "2e",
  "02724": "2e",
  "01012": "2e",
  "02717": "2e",
  "02043": "2e",
  "02047": "2e",
  "02556": "2e",
  "02135": "2e",
  "02134": "2e",
  "02642": "2e",
  "02601": "2e",
  "02649": "2e",
  "02537": "2e",
  "02562": "2e",
  "02638": "2e",
  "02660": "2e",
  "02641": "2e",
  "02644": "2e",
  "02671": "2e",
  "02645": "2e",
  "02114": "2e",
  "01360": "2e",
  "01339": "2e",
  "02150": "2e",
  "01096": "2e",
  "01002": "2e",
  "01379": "2e",
  "02133": "2e",
  "01906": "2e",
  "01904": "2e",
  "01901": "2e",
  "01982": "2e",
  "01605": "2e",
  "01607": "2e",
  "01609": "2e",
  "01524": "2e",
  "01473": "2e",
  "01561": "2e",
  "01128": "2e",
  "02666": "2e",
  "02141": "2e",
  "02139": "2e",
  "02740": "2e",
  "02145": "2e",
  "02122": "2e",
  "01364": "2e",
  "01380": "2e",
  "02149": "2e",
  "02205": "2e",
  "02140": "2e",
  "01923": "2e",
  "93463": "7",
  "92835": "6",
  "93254": "7",
  "93252": "6",
  "95930": "6",
  "93703": "6",
  "95364": "6",
  "92377": "6",
  "95326": "7",
  "92120": "6",
  "95379": "6",
  "95323": "6",
  "93238": "6",
  "93704": "6",
  "95207": "7",
  "93313": "6",
  "95387": "7",
  "93434": "7",
  "93711": "6",
  "95641": "7",
  "94505": "7",
  "93606": "6",
  "92101": "6",
  "93283": "6",
  "93710": "6",
  "92404": "6",
  "95376": "7",
  "93664": "6",
  "93675": "6",
  "93554": "6",
  "93255": "6",
  "93605": "6",
  "93667": "6",
  "93064": "6",
  "92121": "6",
  "92123": "6",
  "96126": "5",
  "95615": "7",
  "95680": "7",
  "92320": "6",
  "95573": "7",
  "93623": "6",
  "90064": "6",
  "91411": "6",
  "93656": "6",
  "95955": "7",
  "94515": "7",
  "91335": "6",
  "95321": "6",
  "95254": "6",
  "95975": "6",
  "95236": "7",
  "95245": "6",
  "96129": "5",
  "94586": "7",
  "95816": "7",
  "96029": "7",
  "95979": "7",
  "93513": "5",
  "93036": "6",
  "93060": "6",
  "90706": "6",
  "15712": "2e",
  "15929": "2e",
  "15351": "2e",
  "15338": "2e",
  "16312": "2e",
  "15203": "2e",
  "16326": "2e",
  "17325": "2e",
  "19401": "2e",
  "17801": "2e",
  "17845": "2e",
  "17844": "2e",
  "17847": "2e",
  "19468": "2e",
  "19046": "2e",
  "19038": "2e",
  "17878": "2e",
  "19095": "2e",
  "17840": "2e",
  "16314": "2e",
  "16327": "2e",
  "19350": "2e",
  "16131": "2e",
  "18902": "2e",
  "16110": "2e",
  "16233": "2e",
  "18706": "2e",
  "15450": "2e",
  "15433": "2e",
  "15631": "2e",
  "15443": "2e",
  "15482": "2e",
  "15480": "2e",
  "15475": "2e",
  "17889": "2e",
  "16151": "2e",
  "16692": "2e",
  "16861": "2e",
  "19301": "2e",
  "16361": "2e",
  "18617": "2e",
  "19453": "2e",
  "19025": "2e",
  "17836": "2e",
  "19472": "2e",
  "18357": "2e",
  "17880": "2e",
  "15849": "2e",
  "15721": "2e",
  "15474": "2e",
  "18913": "2e",
  "08251": "2e",
  "08319": "2e",
  "08501": "2e",
  "08752": "2e",
  "08103": "2e",
  "08346": "2e",
  "07844": "2e",
  "08740": "2e",
  "07057": "2e",
  "07461": "2e",
  "08080": "2e",
  "07439": "2e",
  "07421": "2e",
  "07851": "2e",
  "08093": "2e",
  "08089": "2e",
  "08061": "2e",
  "01420": "2e",
  "01740": "2e",
  "01105": "2e",
  "01144": "2e",
  "01566": "2e",
  "01518": "2e",
  "01571": "2e",
  "01507": "2e",
  "02564": "2e",
  "01230": "2e",
  "01007": "2e",
  "01085": "2e",
  "01050": "2e",
  "01001": "2e",
  "02356": "2e",
  "01253": "2e",
  "01240": "2e",
  "01259": "2e",
  "01264": "2e",
  "01070": "2e",
  "01775": "2e",
  "01757": "2e",
  "01501": "2e",
  "01519": "2e",
  "01745": "2e",
  "01841": "2e",
  "01852": "2e",
  "01701": "2e",
  "02188": "2e",
  "02053": "2e",
  "02038": "2e",
  "02468": "2e",
  "02461": "2e",
  "01776": "2e",
  "02458": "2e",
  "01730": "2e",
  "02180": "2e",
  "02493": "2e",
  "01474": "2e",
  "01863": "2e",
  "01450": "2e",
  "02723": "2e",
  "01257": "2e",
  "01032": "2e",
  "01243": "2e",
  "02764": "2e",
  "02367": "2e",
  "02019": "2e",
  "02061": "2e",
  "02351": "2e",
  "02301": "2e",
  "02364": "2e",
  "02333": "2e",
  "76905": "6",
  "79416": "6",
  "75604": "3w",
  "75020": "3w",
  "78945": "6",
  "78406": "4",
  "76239": "3w",
  "79410": "6",
  "76908": "6",
  "76937": "6",
  "78344": "6",
  "76934": "6",
  "75490": "3w",
  "79102": "2w",
  "76301": "3w",
  "79741": "6",
  "78411": "4",
  "78721": "6",
  "78746": "6",
  "75791": "3w",
  "79769": "6",
  "77843": "3w",
  "55390": "1w",
  "56147": "1w",
  "55353": "1w",
  "56036": "1w",
  "56721": "1w",
  "55436": "1w",
  "56312": "1w",
  "55732": "1w",
  "55780": "1w",
  "55785": "1w",
  "56310": "1w",
  "55790": "1w",
  "55345": "1w",
  "55970": "1w",
  "55805": "1w",
  "55347": "1w",
  "55953": "1w",
  "55427": "1w",
  "56535": "1w",
  "55934": "1w",
  "55438": "1w",
  "56669": "1w",
  "55018": "1w",
  "56626": "1w",
  "56384": "1w",
  "56663": "1w",
  "55786": "1w",
  "56308": "1w",
  "56296": "1w",
  "56470": "1w",
  "56343": "1w",
  "56211": "1w",
  "55117": "1w",
  "55308": "1w",
  "55319": "1w",
  "55107": "1w",
  "56098": "1w",
  "56235": "1w",
  "56482": "1w",
  "56636": "1w",
  "55006": "1w",
  "55721": "1w",
  "55082": "1w",
  "55052": "1w",
  "56433": "1w",
  "55085": "1w",
  "55053": "1w",
  "56215": "1w",
  "55975": "1w",
  "55049": "1w",
  "56359": "1w",
  "56726": "1w",
  "56662": "1w",
  "50864": "2w",
  "50103": "2w",
  "51566": "2w",
  "52327": "2w",
  "50669": "2w",
  "50264": "2w",
  "51449": "2w",
  "52133": "1w",
  "50654": "2w",
  "52041": "2w",
  "52069": "2w",
  "52040": "2w",
  "51541": "2w",
  "51034": "2w",
  "52566": "2w",
  "50144": "2w",
  "52209": "2w",
  "50120": "2w",
  "51002": "2w",
  "51570": "2w",
  "52353": "2w",
  "51047": "1w",
  "52534": "2w",
  "52132": "1w",
  "52218": "2w",
  "51019": "2w",
  "50143": "2w",
  "50566": "2w",
  "52359": "2w",
  "50588": "2w",
  "51051": "2w",
  "52345": "2w",
  "52318": "2w",
  "50554": "2w",
  "52346": "2w",
  "52585": "2w",
  "50248": "2w",
  "51358": "1w",
  "50136": "2w",
  "50527": "1w",
  "51523": "2w",
  "50604": "2w",
  "51563": "2w",
  "51645": "2w",
  "51050": "2w",
  "51028": "2w",
  "51639": "2w",
  "90804": "6",
  "90731": "6",
  "90034": "6",
  "95351": "7",
  "93669": "6",
  "90254": "6",
  "90026": "6",
  "91606": "6",
  "95249": "6",
  "95527": "7",
  "96041": "7",
  "96103": "5",
  "96106": "5",
  "91306": "6",
  "90717": "6",
  "95629": "6",
  "95675": "6",
  "93245": "6",
  "90301": "6",
  "93636": "6",
  "90221": "6",
  "94552": "7",
  "93101": "7",
  "95981": "5",
  "95642": "6",
  "90247": "6",
  "95963": "7",
  "95246": "6",
  "90024": "6",
  "90640": "6",
  "91101": "6",
  "95669": "6",
  "93646": "6",
  "11575": "2e",
  "13027": "1e",
  "12729": "2e",
  "11001": "2e",
  "10542": "2e",
  "10532": "2e",
  "14445": "1e",
  "10514": "2e",
  "10576": "2e",
  "14467": "1e",
  "10549": "2e",
  "14564": "1e",
  "11023": "2e",
  "11693": "2e",
  "10933": "2e",
  "11590": "2e",
  "13778": "2e",
  "11789": "2e",
  "13754": "2e",
  "12518": "2e",
  "50075": "2w",
  "51572": "2w",
  "52355": "2w",
  "50859": "2w",
  "52554": "2w",
  "51463": "2w",
  "50542": "2w",
  "51038": "2w",
  "52738": "2w",
  "51108": "2w",
  "50003": "2w",
  "50149": "2w",
  "50165": "2w",
  "52590": "2w",
  "51461": "2w",
  "50074": "2w",
  "50571": "2w",
  "50845": "2w",
  "50860": "2w",
  "52032": "2w",
  "50575": "2w",
  "50146": "2w",
  "50309": "2w",
  "52722": "2e",
  "50626": "2w",
  "50061": "2w",
  "50622": "2w",
  "50647": "2w",
  "51104": "2w",
  "52776": "2w",
  "50233": "2w",
  "51037": "2w",
  "50107": "2w",
  "51061": "2w",
  "50320": "2w",
  "52739": "2w",
  "52169": "2w",
  "52042": "2w",
  "52076": "2w",
  "52231": "2w",
  "52044": "2w",
  "52658": "2w",
  "52624": "2w",
  "56022": "1w",
  "56146": "1w",
  "56438": "1w",
  "55415": "1w",
  "56113": "1w",
  "56065": "1w",
  "56090": "1w",
  "56152": "1w",
  "56045": "1w",
  "56301": "1w",
  "55429": "1w",
  "55919": "1w",
  "55972": "1w",
  "56284": "1w",
  "56127": "1w",
  "56469": "1w",
  "56659": "1w",
  "55369": "1w",
  "55768": "1w",
  "56183": "1w",
  "55425": "1w",
  "55444": "1w",
  "56536": "1w",
  "55804": "1w",
  "55936": "1w",
  "56122": "1w",
  "55357": "1w",
  "55921": "1w",
  "56634": "1w",
  "56377": "1w",
  "55810": "1w",
  "56335": "1w",
  "55437": "1w",
  "56294": "1w",
  "55441": "1w",
  "55120": "1w",
  "56376": "1w",
  "55089": "1w",
  "56569": "1w",
  "55027": "1w",
  "55797": "1w",
  "55992": "1w",
  "56563": "1w",
  "56141": "1w",
  "56056": "1w",
  "56080": "1w",
  "55055": "1w",
  "55814": "1w",
  "56711": "1w",
  "56139": "1w",
  "56023": "1w",
  "56319": "1w",
  "56464": "1w",
  "56727": "1w",
  "48094": "2e",
  "48096": "2e",
  "48021": "2e",
  "48126": "2e",
  "48747": "1e",
  "48084": "2e",
  "49601": "1e",
  "48623": "1e",
  "48652": "1e",
  "48315": "2e",
  "48428": "1e",
  "49637": "1e",
  "48158": "2e",
  "48169": "2e",
  "48118": "2e",
  "48416": "1e",
  "48225": "2e",
  "48464": "1e",
  "49240": "2e",
  "48727": "1e",
  "48219": "2e",
  "48227": "2e",
  "48217": "2e",
  "48124": "2e",
  "17954": "2e",
  "19120": "2e",
  "17930": "2e",
  "17026": "2e",
  "16504": "2e",
  "17978": "2e",
  "18031": "2e",
  "17953": "2e",
  "19134": "2e",
  "19145": "2e",
  "19119": "2e",
  "19150": "2e",
  "18015": "2e",
  "17925": "2e",
  "17740": "2e",
  "18011": "2e",
  "18062": "2e",
  "18041": "2e",
  "18034": "2e",
  "16930": "2e",
  "17217": "2e",
  "16441": "2e",
  "16859": "2e",
  "17043": "2e",
  "16443": "2e",
  "17221": "2e",
  "16423": "2e",
  "17201": "2e",
  "17202": "2e",
  "16435": "2e",
  "17210": "2e",
  "19506": "2e",
  "19118": "2e",
  "16602": "2e",
  "17552": "2e",
  "17070": "2e",
  "17814": "2e",
  "16684": "2e",
  "19149": "2e",
  "16875": "2e",
  "16693": "2e",
  "16872": "2e",
  "16662": "2e",
  "17252": "2e",
  "19540": "2e",
  "17810": "2e",
  "16631": "2e",
  "06108": "2e",
  "06518": "2e",
  "06791": "2e",
  "06515": "2e",
  "06514": "2e",
  "06093": "2e",
  "06484": "2e",
  "06611": "2e",
  "06002": "2e",
  "06880": "2e",
  "06901": "2e",
  "06418": "2e",
  "06752": "2e",
  "06614": "2e",
  "06510": "2e",
  "06615": "2e",
  "06248": "2e",
  "06120": "2e",
  "06103": "2e",
  "06110": "2e",
  "06475": "2e",
  "06107": "2e",
  "06471": "2e",
  "06024": "2e",
  "06089": "2e",
  "06480": "2e",
  "06412": "2e",
  "06757": "2e",
  "06382": "2e",
  "06420": "2e",
  "06354": "2e",
  "06331": "2e",
  "06379": "2e",
  "06235": "2e",
  "06387": "2e",
  "06786": "2e",
  "06762": "2e",
  "06415": "2e",
  "06756": "2e",
  "06705": "2e",
  "06023": "2e",
  "06830": "2e",
  "06906": "2e",
  "06820": "2e",
  "06443": "2e",
  "06057": "2e",
  "06825": "2e",
  "06896": "2e",
  "06824": "2e",
  "19713": "2e",
  "19806": "2e",
  "19733": "2e",
  "22931": "3e",
  "22943": "3e",
  "23223": "3e",
  "24401": "3e",
  "22952": "3e",
  "23457": "3e",
  "24482": "3e",
  "24432": "3e",
  "29678": "4",
  "29321": "4",
  "29628": "4",
  "29440": "4",
  "29351": "4",
  "29620": "4",
  "29037": "4",
  "29568": "4",
  "29745": "3e",
  "29658": "4",
  "29646": "4",
  "29536": "4",
  "29653": "4",
  "29082": "4",
  "29570": "4",
  "29835": "4",
  "29827": "4",
  "29588": "4",
  "23851": "3e",
  "24325": "3e",
  "23308": "3e",
  "23407": "3e",
  "72107": "3w",
  "72070": "3w",
  "72860": "3w",
  "72651": "3w",
  "72573": "3w",
  "72653": "3w",
  "72127": "3w",
  "72027": "3w",
  "72373": "3w",
  "72533": "3w",
  "72567": "3w",
  "72950": "3w",
  "71643": "3w",
  "71751": "3w",
  "72387": "3w",
  "72556": "3w",
  "72537": "3w",
  "71962": "3w",
  "72566": "3w",
  "71950": "3w",
  "72478": "3w",
  "71965": "3w",
  "72528": "3w",
  "71678": "3w",
  "72411": "3w",
  "72908": "3w",
  "72476": "3w",
  "72114": "3w",
  "71665": "3w",
  "72004": "3w",
  "72152": "3w",
  "72212": "3w",
  "72065": "3w",
  "72126": "3w",
  "72113": "3w",
  "72940": "3w",
  "72701": "3w",
  "72927": "3w",
  "72704": "3w",
  "72905": "3w",
  "72104": "3w",
  "72773": "3w",
  "72948": "3w",
  "72426": "3w",
  "72946": "3w",
  "72024": "3w",
  "71921": "3w",
  "72713": "3w",
  "72083": "3w",
  "71942": "3w",
  "72348": "3w",
  "72173": "3w",
  "72718": "3w",
  "72327": "3w",
  "72384": "3w",
  "71841": "3w",
  "72670": "3w",
  "72628": "3w",
  "72052": "3w",
  "71823": "3w",
  "72066": "3w",
  "72360": "3w",
  "72466": "3w",
  "72129": "3w",
  "72529": "3w",
  "71845": "3w",
  "72112": "3w",
  "72436": "3w",
  "72342": "3e",
  "72029": "3w",
  "72543": "3w",
  "71745": "3w",
  "72638": "3w",
  "72341": "3w",
  "72374": "3w",
  "71801": "3w",
  "71670": "3w",
  "71655": "3w",
  "35816": "3e",
  "30577": "4",
  "30324": "4",
  "30554": "4",
  "30721": "4",
  "30531": "4",
  "36205": "4",
  "30755": "4",
  "30756": "4",
  "34207": "4",
  "35758": "3e",
  "35203": "4",
  "36105": "4",
  "33169": "4",
  "31561": "4",
  "35205": "4",
  "35209": "4",
  "36608": "4",
  "35673": "3e",
  "36688": "4",
  "35210": "4",
  "35127": "4",
  "36268": "4",
  "36522": "4",
  "36043": "4",
  "35579": "4",
  "35160": "4",
  "35748": "3e",
  "36351": "4",
  "31015": "4",
  "31602": "4",
  "30256": "4",
  "31712": "4",
  "30668": "4",
  "31533": "4",
  "31567": "4",
  "30056": "4",
  "30327": "4",
  "31641": "4",
  "31553": "4",
  "35094": "4",
  "35014": "4",
  "35956": "4",
  "35990": "4",
  "36578": "4",
  "35907": "4",
  "35446": "4",
  "35458": "4",
  "35896": "3e",
  "36311": "4",
  "34222": "4",
  "33598": "4",
  "31038": "4",
  "30625": "4",
  "30182": "4",
  "31552": "4",
  "32309": "4",
  "30075": "4",
  "30912": "4",
  "35459": "4",
  "36901": "4",
  "35181": "4",
  "35613": "3e",
  "35542": "4",
  "36345": "4",
  "14456": "1e",
  "13080": "1e",
  "13117": "1e",
  "14105": "1e",
  "14742": "2e",
  "14572": "2e",
  "13418": "1e",
  "14886": "2e",
  "10013": "2e",
  "12503": "2e",
  "10553": "2e",
  "12159": "2e",
  "12209": "2e",
  "10708": "2e",
  "13224": "1e",
  "10451": "2e",
  "10014": "2e",
  "11361": "2e",
  "11102": "2e",
  "11729": "2e",
  "10604": "2e",
  "14619": "1e",
  "14222": "1e",
  "10001": "2e",
  "13244": "1e",
  "11105": "2e",
  "12563": "2e",
  "10173": "2e",
  "12501": "2e",
  "10170": "2e",
  "14805": "2e",
  "11795": "2e",
  "10174": "2e",
  "12542": "2e",
  "13350": "1e",
  "12549": "2e",
  "10524": "2e",
  "14622": "1e",
  "13365": "1e",
  "14825": "2e",
  "12517": "2e",
  "14223": "1e",
  "12502": "2e",
  "12571": "2e",
  "12203": "2e",
  "12534": "2e",
  "10470": "2e",
  "10472": "2e",
  "13062": "2e",
  "14034": "2e",
  "13152": "1e",
  "14590": "1e",
  "11415": "2e",
  "11104": "2e",
  "10037": "2e",
  "14892": "2e",
  "13084": "1e",
  "13110": "1e",
  "11217": "2e",
  "14203": "1e",
  "11717": "2e",
  "11228": "2e",
  "10029": "2e",
  "12306": "2e",
  "14718": "2e",
  "14062": "2e",
  "13061": "1e",
  "13346": "1e",
  "11368": "2e",
  "14480": "1e",
  "11367": "2e",
  "12121": "2e",
  "12090": "1e",
  "12522": "2e",
  "14732": "2e",
  "12053": "2e",
  "10004": "2e",
  "11206": "2e",
  "12580": "2e",
  "12208": "2e",
  "10940": "2e",
  "14621": "1e",
  "13208": "1e",
  "10007": "2e",
  "14210": "1e",
  "10456": "2e",
  "98266": "5",
  "98274": "5",
  "98801": "5",
  "98579": "7",
  "98233": "5",
  "98557": "7",
  "98225": "5",
  "98520": "7",
  "99207": "5",
  "98226": "5",
  "98125": "5",
  "98115": "5",
  "98282": "5",
  "98814": "5",
  "99111": "5",
  "98935": "5",
  "98827": "5",
  "98831": "5",
  "98569": "7",
  "98833": "5",
  "98250": "5",
  "99201": "5",
  "98057": "5",
  "98059": "5",
  "07641": "2e",
  "08247": "2e",
  "07006": "2e",
  "07624": "2e",
  "07627": "2e",
  "07832": "2e",
  "07605": "2e",
  "08853": "2e",
  "08352": "2e",
  "07643": "2e",
  "07820": "2e",
  "08890": "2e",
  "07416": "2e",
  "07419": "2e",
  "08030": "2e",
  "08020": "2e",
  "08051": "2e",
  "08042": "2e",
  "08022": "2e",
  "08010": "2e",
  "08057": "2e",
  "08755": "2e",
  "08533": "2e",
  "08055": "2e",
  "08087": "2e",
  "08733": "2e",
  "08758": "2e",
  "08050": "2e",
  "08738": "2e",
  "07733": "2e",
  "07704": "2e",
  "08510": "2e",
  "07756": "2e",
  "08215": "2e",
  "37657": "3e",
  "37682": "3e",
  "38376": "3e",
  "38460": "3e",
  "37134": "3e",
  "37770": "3e",
  "37726": "3e",
  "37023": "3e",
  "38569": "3e",
  "38236": "3e",
  "38388": "3e",
  "37331": "3e",
  "37151": "3e",
  "37922": "3e",
  "37363": "3e",
  "37312": "3e",
  "38120": "3e",
  "37779": "3e",
  "37091": "3e",
  "37362": "4",
  "37307": "3e",
  "37204": "3e",
  "37013": "3e",
  "37232": "3e",
  "37122": "3e",
  "37064": "3e",
  "37075": "3e",
  "37188": "3e",
  "38133": "3e",
  "38016": "3e",
  "38131": "3w",
  "37129": "3e",
  "37127": "3e",
  "37620": "3e",
  "38041": "3e",
  "37036": "3e",
  "37347": "3e",
  "38075": "3e",
  "38330": "3e",
  "38558": "3e",
  "38237": "3e",
  "38201": "3e",
  "38389": "3e",
  "38042": "3e",
  "37683": "3e",
  "37145": "3e",
  "37078": "3e",
  "58647": "1w",
  "58072": "1w",
  "58643": "1w",
  "58623": "1w",
  "58056": "1w",
  "58478": "1w",
  "58483": "1w",
  "58564": "1w",
  "58497": "1w",
  "58833": "1w",
  "58792": "1w",
  "58324": "1w",
  "58495": "1w",
  "58456": "1w",
  "58436": "1w",
  "58013": "1w",
  "58439": "1w",
  "58431": "1w",
  "58058": "1w",
  "58081": "1w",
  "58059": "1w",
  "58030": "1w",
  "58335": "1w",
  "58033": "1w",
  "58622": "1w",
  "58541": "1w",
  "58656": "1w",
  "58577": "1w",
  "58646": "1w",
  "58644": "1w",
  "58801": "1w",
  "58761": "1w",
  "58787": "1w",
  "58725": "1w",
  "58845": "1w",
  "58856": "1w",
  "58651": "1w",
  "58481": "1w",
  "58027": "1w",
  "58730": "1w",
  "58325": "1w",
  "58060": "1w",
  "58043": "1w",
  "58460": "1w",
  "58433": "1w",
  "58040": "1w",
  "58041": "1w",
  "58075": "1w",
  "58220": "1w",
  "58369": "1w",
  "58038": "1w",
  "58444": "1w",
  "58054": "1w",
  "58218": "1w",
  "58452": "1w",
  "58357": "1w",
  "57642": "1w",
  "58424": "1w",
  "57660": "1w",
  "58402": "1w",
  "58630": "1w",
  "58626": "1w",
  "58854": "1w",
  "58759": "1w",
  "58778": "1w",
  "58750": "1w",
  "58853": "1w",
  "58784": "1w",
  "58773": "1w",
  "58418": "1w",
  "58368": "1w",
  "58451": "1w",
  "58793": "1w",
  "58789": "1w",
  "58374": "1w",
  "58380": "1w",
  "58233": "1w",
  "58227": "1w",
  "58243": "1w",
  "58259": "1w",
  "58236": "1w",
  "58103": "1w",
  "58203": "1w",
  "58768": "1w",
  "58705": "1w",
  "58722": "1w",
  "58104": "1w",
  "58560": "1w",
  "58240": "1w",
  "58214": "1w",
  "58771": "1w",
  "58655": "1w",
  "58650": "1w",
  "58653": "1w",
  "58620": "1w",
  "58649": "1w",
  "16244": "2e",
  "18431": "2e",
  "15759": "2e",
  "16679": "2e",
  "18415": "2e",
  "15673": "2e",
  "16633": "2e",
  "17249": "2e",
  "16910": "2e",
  "18436": "2e",
  "15521": "2e",
  "15748": "2e",
  "15725": "2e",
  "15745": "2e",
  "16350": "2e",
  "16340": "2e",
  "16436": "2e",
  "15380": "2e",
  "15359": "2e",
  "19112": "2e",
  "16354": "2e",
  "19426": "2e",
  "15334": "2e",
  "19403": "2e",
  "16317": "2e",
  "17047": "2e",
  "16137": "2e",
  "18655": "2e",
  "18635": "2e",
  "19001": "2e",
  "18705": "2e",
  "16342": "2e",
  "17823": "2e",
  "17856": "2e",
  "17857": "2e",
  "16255": "2e",
  "16346": "2e",
  "19405": "2e",
  "17872": "2e",
  "12855": "1e",
  "14041": "2e",
  "12960": "1e",
  "13136": "2e",
  "13752": "2e",
  "14167": "2e",
  "13740": "2e",
  "12017": "2e",
  "13290": "1e",
  "10271": "2e",
  "13812": "2e",
  "12309": "2e",
  "14172": "1e",
  "13471": "1e",
  "13035": "1e",
  "13476": "1e",
  "10461": "2e",
  "12842": "1e",
  "14056": "1e",
  "14897": "2e",
  "14717": "2e",
  "13343": "1e",
  "12491": "2e",
  "12738": "2e",
  "14714": "2e",
  "12475": "2e",
  "12455": "2e",
  "14591": "1e",
  "14737": "2e",
  "12722": "2e",
  "12784": "2e",
  "14840": "2e",
  "14880": "2e",
  "12864": "1e",
  "14873": "2e",
  "12737": "2e",
  "12484": "2e",
  "12489": "2e",
  "12528": "2e",
  "12561": "2e",
  "12417": "2e",
  "14719": "2e",
  "13844": "2e",
  "14885": "2e",
  "12851": "1e",
  "13814": "2e",
  "12964": "1e",
  "12872": "1e",
  "12950": "1e",
  "13124": "2e",
  "14819": "2e",
  "13856": "2e",
  "14083": "2e",
  "12106": "2e",
  "12125": "2e",
  "12037": "2e",
  "14029": "2e",
  "12530": "2e",
  "12174": "2e",
  "13142": "1e",
  "14120": "1e",
  "13502": "1e",
  "14551": "1e",
  "14304": "1e",
  "13126": "1e",
  "10457": "2e",
  "23955": "3e",
  "22851": "3e",
  "24185": "3e",
  "24228": "3e",
  "24225": "3e",
  "24315": "3e",
  "22810": "2e",
  "24360": "3e",
  "24324": "3e",
  "23173": "3e",
  "24322": "3e",
  "22625": "2e",
  "24077": "3e",
  "24260": "3e",
  "24571": "3e",
  "24104": "3e",
  "24563": "3e",
  "24202": "3e",
  "24112": "3e",
  "23681": "3e",
  "22968": "3e",
  "24527": "3e",
  "24594": "3e",
  "22903": "3e",
  "22937": "3e",
  "24631": "3e",
  "22802": "3e",
  "24566": "3e",
  "24562": "3e",
  "24472": "3e",
  "24440": "3e",
  "23225": "3e",
  "24421": "3e",
  "23603": "3e",
  "24378": "3e",
  "24351": "3e",
  "23336": "3e",
  "23072": "3e",
  "23401": "3e",
  "23422": "3e",
  "23356": "3e",
  "23426": "3e",
  "23480": "3e",
  "22213": "2e",
  "23416": "3e",
  "23112": "3e",
  "22203": "2e",
  "22972": "3e",
  "24090": "3e",
  "24012": "3e",
  "22824": "2e",
  "22644": "2e",
  "24522": "3e",
  "24256": "3e",
  "24082": "3e",
  "24530": "3e",
  "22432": "3e",
  "23055": "3e",
  "23451": "3e",
  "23460": "3e",
  "23960": "3e",
  "24314": "3e",
  "24553": "3e",
  "22572": "3e",
  "24504": "3e",
  "22845": "3e",
  "22580": "3e",
  "24603": "3e",
  "24078": "3e",
  "22556": "3e",
  "22663": "2e",
  "24586": "3e",
  "23661": "3e",
  "24441": "3e",
  "24565": "3e",
  "23324": "3e",
  "24606": "3e",
  "23668": "3e",
  "24127": "3e",
  "23188": "3e",
  "22843": "3e",
  "24485": "3e",
  "24469": "3e",
  "24053": "3e",
  "24120": "3e",
  "48453": "1e",
  "48440": "1e",
  "48204": "2e",
  "48210": "2e",
  "48211": "2e",
  "48213": "2e",
  "48234": "2e",
  "48207": "2e",
  "48184": "2e",
  "48117": "2e",
  "48162": "2e",
  "48179": "2e",
  "49238": "2e",
  "48027": "1e",
  "49746": "1e",
  "49036": "2e",
  "48739": "1e",
  "49779": "1e",
  "49820": "1e",
  "48413": "1e",
  "48380": "2e",
  "48353": "2e",
  "48022": "1e",
  "49092": "2e",
  "49969": "1e",
  "49644": "1e",
  "49011": "2e",
  "49444": "1e",
  "49008": "2e",
  "49201": "2e",
  "48625": "1e",
  "49905": "1e",
  "48856": "1e",
  "48906": "2e",
  "48507": "1e",
  "49841": "1e",
  "48415": "1e",
  "49948": "1e",
  "48731": "1e",
  "38552": "3e",
  "38047": "3e",
  "38235": "3e",
  "37450": "3e",
  "37326": "3e",
  "37394": "3e",
  "37406": "3e",
  "37404": "4",
  "38574": "3e",
  "37917": "3e",
  "37410": "4",
  "37924": "3e",
  "37080": "3e",
  "38127": "3w",
  "37115": "3e",
  "38461": "3e",
  "38474": "3e",
  "37777": "3e",
  "37742": "3e",
  "37205": "3e",
  "37208": "3e",
  "37217": "3e",
  "37135": "3e",
  "37076": "3e",
  "37022": "3e",
  "37031": "3e",
  "37774": "3e",
  "37090": "3e",
  "37880": "3e",
  "37664": "3e",
  "38015": "3e",
  "37665": "3e",
  "37397": "3e",
  "37340": "3e",
  "37165": "3e",
  "37025": "3e",
  "38261": "3e",
  "38334": "3e",
  "38251": "3e",
  "38230": "3e",
  "38463": "3e",
  "38464": "3e",
  "38344": "3e",
  "38034": "3e",
  "38077": "3e",
  "38457": "3e",
  "37318": "3e",
  "37383": "3e",
  "37367": "3e",
  "37073": "3e",
  "37641": "3e",
  "37809": "3e",
  "37061": "3e",
  "37057": "3e",
  "38477": "3e",
  "38553": "3e",
  "38333": "3e",
  "37305": "3e",
  "37301": "3e",
  "38471": "3e",
  "38501": "3e",
  "38108": "3w",
  "37915": "3e",
  "38544": "3e",
  "38548": "3e",
  "37919": "3e",
  "37207": "3e",
  "38343": "3e",
  "37912": "3e",
  "37764": "3e",
  "38579": "3e",
  "38577": "3e",
  "37729": "3e",
  "37715": "3e",
  "38589": "3e",
  "38327": "3e",
  "38454": "3e",
  "38361": "3e",
  "37820": "3e",
  "84646": "5",
  "84114": "5",
  "49045": "2e",
  "49126": "2e",
  "49628": "1e",
  "49119": "2e",
  "49453": "2e",
  "49884": "1e",
  "49901": "1e",
  "49962": "1e",
  "48841": "1e",
  "49268": "2e",
  "49256": "2e",
  "48367": "1e",
  "49279": "2e",
  "49282": "2e",
  "49335": "2e",
  "48633": "1e",
  "48091": "2e",
  "48083": "2e",
  "48304": "2e",
  "48301": "2e",
  "48041": "1e",
  "48178": "2e",
  "48075": "2e",
  "48025": "2e",
  "48331": "2e",
  "48313": "2e",
  "48036": "2e",
  "48757": "1e",
  "49663": "1e",
  "49649": "1e",
  "48659": "1e",
  "49236": "2e",
  "48744": "1e",
  "48224": "2e",
  "49229": "2e",
  "49287": "2e",
  "48209": "2e",
  "48216": "2e",
  "48206": "2e",
  "10027": "2e",
  "13354": "1e",
  "14522": "1e",
  "13732": "2e",
  "14303": "1e",
  "13146": "1e",
  "11432": "2e",
  "14454": "1e",
  "13328": "1e",
  "14510": "2e",
  "10452": "2e",
  "13490": "1e",
  "13417": "1e",
  "13036": "1e",
  "13435": "1e",
  "14067": "1e",
  "13338": "1e",
  "14081": "2e",
  "14091": "2e",
  "10469": "2e",
  "11225": "2e",
  "12180": "2e",
  "14125": "1e",
  "13033": "1e",
  "14767": "2e",
  "12154": "1e",
  "11207": "2e",
  "11423": "2e",
  "13332": "2e",
  "56266": "1w",
  "56547": "1w",
  "56401": "1w",
  "56444": "1w",
  "55449": "1w",
  "55077": "1w",
  "55076": "1w",
  "55303": "1w",
  "56651": "1w",
  "55783": "1w",
  "55008": "1w",
  "55412": "1w",
  "55071": "1w",
  "56738": "1w",
  "56434": "1w",
  "55335": "1w",
  "55605": "1w",
  "56521": "1w",
  "55024": "1w",
  "56071": "1w",
  "56633": "1w",
  "56068": "1w",
  "55949": "1w",
  "56573": "1w",
  "55990": "1w",
  "56223": "1w",
  "56381": "1w",
  "56241": "1w",
  "55965": "1w",
  "56262": "1w",
  "56655": "1w",
  "56057": "1w",
  "55940": "1w",
  "55116": "1w",
  "56295": "1w",
  "56589": "1w",
  "56028": "1w",
  "56364": "1w",
  "56550": "1w",
  "55118": "1w",
  "56172": "1w",
  "56031": "1w",
  "56553": "1w",
  "55419": "1w",
  "55420": "1w",
  "55331": "1w",
  "55012": "1w",
  "55084": "1e",
  "55362": "1w",
  "55322": "1w",
  "56123": "1w",
  "55426": "1w",
  "55020": "1w",
  "55129": "1w",
  "55043": "1w",
  "55712": "1w",
  "55945": "1w",
  "56158": "1w",
  "55404": "1w",
  "55722": "1w",
  "56524": "1w",
  "56570": "1w",
  "56055": "1w",
  "55614": "1w",
  "56578": "1w",
  "56720": "1w",
  "56345": "1w",
  "56329": "1w",
  "56683": "1w",
  "56251": "1w",
  "56667": "1w",
  "55771": "1w",
  "55784": "1w",
  "56516": "1w",
  "56658": "1w",
  "55374": "1w",
  "56043": "1w",
  "55912": "1w",
  "56078": "1w",
  "56174": "1w",
  "56016": "1w",
  "56212": "1w",
  "55725": "1w",
  "55751": "1w",
  "55430": "1w",
  "52803": "2e",
  "52761": "2w",
  "50117": "2w",
  "51554": "2w",
  "50325": "2w",
  "50076": "2w",
  "50583": "2w",
  "52175": "1w",
  "51333": "1w",
  "52593": "2w",
  "50570": "1w",
  "51601": "2w",
  "50533": "2w",
  "50851": "2w",
  "52594": "2w",
  "52065": "2w",
  "52583": "2w",
  "51465": "2w",
  "50220": "2w",
  "50235": "2w",
  "60088": "2e",
  "60073": "2e",
  "60014": "2e",
  "61462": "2e",
  "61415": "2e",
  "61520": "2e",
  "62454": "2e",
  "60446": "2e",
  "60034": "2e",
  "62849": "2e",
  "60417": "2e",
  "62464": "2e",
  "60156": "2e",
  "60410": "2e",
  "60421": "2e",
  "62443": "2e",
  "62876": "2e",
  "60451": "2e",
  "60938": "2e",
  "60930": "2e",
  "60536": "2e",
  "62080": "2e",
  "60968": "2e",
  "62601": "2e",
  "61421": "2e",
  "62854": "2e",
  "62273": "2e",
  "60974": "2e",
  "62961": "3e",
  "62807": "2e",
  "62370": "2w",
  "62340": "2e",
  "61911": "2e",
  "62809": "2e",
  "62345": "2e",
  "61501": "2e",
  "61441": "2e",
  "62009": "2e",
  "62533": "2e",
  "61936": "2e",
  "62044": "2e",
  "62069": "2e",
  "62934": "3e",
  "62672": "2e",
  "62821": "3e",
  "62540": "2e",
  "61064": "2e",
  "61270": "2e",
  "52163": "1w",
  "50672": "2w",
  "52257": "2w",
  "50546": "2w",
  "52645": "2w",
  "52623": "2w",
  "52649": "2w",
  "52630": "2w",
  "52354": "2w",
  "50246": "2w",
  "50592": "2w",
  "50558": "2w",
  "51529": "2w",
  "52225": "2w",
  "51048": "2w",
  "52652": "2w",
  "52530": "2w",
  "52206": "2w",
  "52552": "2w",
  "52656": "2w",
  "52765": "2w",
  "50021": "2w",
  "52336": "2w",
  "52227": "2w",
  "52760": "2w",
  "52778": "2w",
  "50039": "2w",
  "50150": "2w",
  "50563": "2w",
  "52571": "2w",
  "52651": "2w",
  "52769": "2w",
  "50251": "2w",
  "51030": "2w",
  "50315": "2w",
  "50321": "2w",
  "50677": "2w",
  "50667": "2w",
  "52403": "2w",
  "50670": "2w",
  "50072": "2w",
  "52309": "2w",
  "50112": "2w",
  "50676": "2w",
  "50240": "2w",
  "51012": "2w",
  "50109": "2w",
  "50535": "2w",
  "50594": "2w",
  "50612": "2w",
  "52052": "2w",
  "52165": "1w",
  "52620": "2w",
  "50543": "2w",
  "52728": "2e",
  "50557": "2w",
  "52588": "2w",
  "52748": "2w",
  "51239": "1w",
  "52245": "2w",
  "50237": "2w",
  "52806": "2w",
  "52729": "2w",
  "50433": "1w",
  "50127": "2w",
  "79903": "6",
  "78339": "6",
  "78402": "4",
  "76640": "3w",
  "79927": "6",
  "76689": "6",
  "76622": "3w",
  "79908": "6",
  "78374": "4",
  "77627": "4",
  "78593": "4",
  "75232": "3w",
  "78674": "6",
  "75036": "3w",
  "76858": "6",
  "79540": "6",
  "78014": "6",
  "79052": "2w",
  "75124": "3w",
  "79565": "6",
  "79548": "6",
  "75961": "3w",
  "79258": "3w",
  "79101": "2w",
  "75141": "3w",
  "77655": "4",
  "75417": "3w",
  "77060": "4",
  "77090": "4",
  "77050": "4",
  "78638": "6",
  "77022": "4",
  "77020": "4",
  "78132": "6",
  "78623": "6",
  "77503": "4",
  "77030": "4",
  "27982": "3e",
  "28101": "3e",
  "27202": "3e",
  "28282": "3e",
  "28352": "4",
  "27584": "3e",
  "27826": "3e",
  "27980": "3e",
  "28729": "3e",
  "28001": "3e",
  "27823": "3e",
  "27311": "3e",
  "28662": "3e",
  "28710": "3e",
  "27821": "3e",
  "27299": "3e",
  "28163": "3e",
  "27874": "3e",
  "28320": "3e",
  "28783": "3e",
  "28152": "3e",
  "28675": "3e",
  "28904": "3e",
  "28529": "3e",
  "27928": "3e",
  "28560": "3e",
  "28434": "3e",
  "28040": "3e",
  "27909": "3e",
  "28725": "3e",
  "28714": "3e",
  "28377": "3e",
  "28685": "3e",
  "28043": "3e",
  "28383": "4",
  "28372": "3e",
  "28570": "3e",
  "28379": "3e",
  "28643": "3e",
  "28520": "3e",
  "28594": "3e",
  "28345": "4",
  "27915": "3e",
  "27857": "3e",
  "27840": "3e",
  "27864": "3e",
  "28032": "3e",
  "27340": "3e",
  "27201": "3e",
  "27969": "3e",
  "28355": "3e",
  "27360": "3e",
  "27597": "3e",
  "27571": "3e",
  "27544": "3e",
  "28634": "3e",
  "27013": "3e",
  "28655": "3e",
  "27355": "3e",
  "28641": "3e",
  "28025": "3e",
  "28097": "3e",
  "28801": "3e",
  "28445": "3e",
  "28539": "3e",
  "28582": "3e",
  "27103": "3e",
  "28803": "3e",
  "27533": "3e",
  "27109": "3e",
  "27880": "3e",
  "27278": "3e",
  "27871": "3e",
  "28382": "3e",
  "28704": "3e",
  "28207": "3e",
  "28270": "3e",
  "27596": "3e",
  "27816": "3e",
  "27844": "3e",
  "27603": "3e",
  "27882": "3e",
  "27312": "3e",
  "27018": "3e",
  "28244": "3e",
  "28301": "3e",
  "28306": "3e",
  "28454": "3e",
  "28804": "3e",
  "28204": "3e",
  "28521": "3e",
  "27531": "3e",
  "28586": "3e",
  "28215": "3e",
  "27828": "3e",
  "27827": "3e",
  "28211": "3e",
  "28105": "3e",
  "28210": "3e",
  "28391": "3e",
  "28274": "3e",
  "28331": "3e",
  "27583": "3e",
  "28732": "3e",
  "27043": "3e",
  "69121": "2w",
  "68448": "2w",
  "69145": "5",
  "69133": "5",
  "69039": "2w",
  "69154": "2w",
  "68069": "2w",
  "69152": "2w",
  "68381": "2w",
  "68942": "2w",
  "69365": "2w",
  "68934": "2w",
  "69034": "2w",
  "68938": "2w",
  "68779": "2w",
  "69043": "2w",
  "69037": "2w",
  "68066": "2w",
  "68765": "2w",
  "68769": "2w",
  "68631": "2w",
  "68946": "2w",
  "68320": "2w",
  "68854": "2w",
  "68859": "2w",
  "68716": "2w",
  "68823": "2w",
  "68822": "2w",
  "68766": "2w",
  "68835": "2w",
  "68759": "2w",
  "68636": "2w",
  "68324": "2w",
  "68720": "2w",
  "68817": "2w",
  "68771": "2w",
  "68861": "2w",
  "69171": "2w",
  "68787": "2w",
  "68508": "2w",
  "68876": "2w",
  "68502": "2w",
  "68506": "2w",
  "68178": "2w",
  "68980": "2w",
  "68147": "2w",
  "69360": "2w",
  "68743": "2w",
  "68731": "2w",
  "68005": "2w",
  "68361": "2w",
  "68439": "2w",
  "68715": "2w",
  "68132": "2w",
  "69141": "5",
  "69331": "5",
  "68310": "2w",
  "68661": "2w",
  "68922": "2w",
  "69357": "5",
  "68520": "2w",
  "69151": "2w",
  "69125": "5",
  "68307": "2w",
  "68455": "2w",
  "69033": "2w",
  "69167": "2w",
  "68864": "2w",
  "68928": "2w",
  "68628": "2w",
  "68341": "2w",
  "69218": "2w",
  "69123": "2w",
  "68130": "2w",
  "68135": "2w",
  "68057": "2w",
  "69201": "2w",
  "69333": "2w",
  "68358": "2w",
  "68970": "2w",
  "68733": "2w",
  "69132": "2w",
  "68338": "2w",
  "68061": "2w",
  "68034": "2w",
  "68055": "2w",
  "68375": "2w",
  "68039": "2w",
  "69041": "2w",
  "68975": "2w",
  "68362": "2w",
  "68445": "2w",
  "68303": "2w",
  "68954": "2w",
  "68377": "2w",
  "20854": "2e",
  "21769": "2e",
  "21221": "2e",
  "21737": "2e",
  "20778": "2e",
  "21405": "2e",
  "20622": "3e",
  "20876": "2e",
  "20687": "3e",
  "20620": "3e",
  "20724": "2e",
  "21638": "2e",
  "20692": "3e",
  "20690": "3e",
  "20812": "2e",
  "20630": "3e",
  "21746": "2e",
  "20860": "2e",
  "21649": "2e",
  "21628": "2e",
  "21866": "3e",
  "21677": "3e",
  "21643": "2e",
  "21671": "2e",
  "21662": "2e",
  "21647": "2e",
  "02907": "2e",
  "02909": "2e",
  "02908": "2e",
  "02831": "2e",
  "02815": "2e",
  "02838": "2e",
  "02921": "2e",
  "02876": "2e",
  "02852": "2e",
  "02881": "2e",
  "02882": "2e",
  "02910": "2e",
  "02919": "2e",
  "02826": "2e",
  "02896": "2e",
  "02817": "2e",
  "02892": "2e",
  "02840": "2e",
  "02842": "2e",
  "02837": "2e",
  "02894": "2e",
  "02905": "2e",
  "02823": "2e",
  "02816": "2e",
  "02864": "2e",
  "02827": "2e",
  "02872": "2e",
  "02812": "2e",
  "02914": "2e",
  "02906": "2e",
  "02825": "2e",
  "02863": "2e",
  "02891": "2e",
  "02898": "2e",
  "02836": "2e",
  "02903": "2e",
  "02857": "2e",
  "95932": "7",
  "91406": "6",
  "95946": "6",
  "91423": "6",
  "91754": "6",
  "95318": "6",
  "96035": "7",
  "93291": "6",
  "95945": "6",
  "95970": "7",
  "90255": "6",
  "95248": "6",
  "90040": "6",
  "95959": "6",
  "95915": "5",
  "90815": "6",
  "90046": "6",
  "90503": "6",
  "90278": "6",
  "94066": "7",
  "96111": "5",
  "96067": "7",
  "93705": "6",
  "95360": "7",
  "93662": "6",
  "93239": "7",
  "95942": "6",
  "93665": "7",
  "91739": "6",
  "93612": "6",
  "93208": "6",
  "95948": "7",
  "92102": "6",
  "91950": "6",
  "93218": "6",
  "93261": "6",
  "93272": "6",
  "93256": "6",
  "93041": "6",
  "93660": "7",
  "95336": "7",
  "93010": "6",
  "95320": "7",
  "95825": "7",
  "95864": "7",
  "93206": "6",
  "93501": "6",
  "93516": "6",
  "95815": "7",
  "92401": "6",
  "93628": "6",
  "93226": "6",
  "93561": "6",
  "93740": "6",
  "91304": "6",
  "95621": "6",
  "93624": "7",
  "92126": "6",
  "92392": "6",
  "95936": "5",
  "96124": "5",
  "95693": "7",
  "95639": "7",
  "95605": "7",
  "95587": "7",
  "95589": "7",
  "95437": "7",
  "92257": "6",
  "95542": "7",
  "95131": "7",
  "95127": "7",
  "95117": "7",
  "95002": "7",
  "95050": "7",
  "95020": "7",
  "92254": "6",
  "90304": "6",
  "90704": "6",
  "90506": "6",
  "94002": "7",
  "94402": "7",
  "91301": "6",
  "93532": "6",
  "91381": "6",
  "92649": "6",
  "92843": "6",
  "92708": "6",
  "91790": "6",
  "95076": "7",
  "90716": "6",
  "91605": "6",
  "95018": "7",
  "95066": "7",
  "91402": "6",
  "90058": "6",
  "90001": "6",
  "90002": "6",
  "95501": "7",
  "95464": "7",
  "95023": "7",
  "90010": "6",
  "96023": "7",
  "96055": "7",
  "96092": "7",
  "95203": "7",
  "93512": "5",
  "96052": "7",
  "93546": "5",
  "94579": "7",
  "93111": "7",
  "96048": "7",
  "90710": "6",
  "90807": "6",
  "93035": "6",
  "96107": "5",
  "90242": "6",
  "95306": "6",
  "93541": "5",
  "90277": "6",
  "90033": "6",
  "96022": "7",
  "15401": "2e",
  "18709": "2e",
  "18977": "2e",
  "15459": "2e",
  "15468": "2e",
  "18372": "2e",
  "15410": "2e",
  "15473": "2e",
  "17820": "2e",
  "18834": "2e",
  "15435": "2e",
  "17920": "2e",
  "17888": "2e",
  "17320": "2e",
  "17232": "2e",
  "17568": "2e",
  "17005": "2e",
  "15462": "2e",
  "18912": "2e",
  "19108": "2e",
  "17887": "2e",
  "17835": "2e",
  "16331": "2e",
  "19456": "2e",
  "19442": "2e",
  "19457": "2e",
  "18843": "2e",
  "18430": "2e",
  "15449": "2e",
  "15455": "2e",
  "19474": "2e",
  "16645": "2e",
  "18927": "2e",
  "15757": "2e",
  "16855": "2e",
  "19317": "2e",
  "19348": "2e",
  "19073": "2e",
  "19003": "2e",
  "19017": "2e",
  "19013": "2e",
  "30538": "4",
  "30070": "4",
  "30185": "4",
  "30259": "4",
  "33626": "4",
  "30284": "4",
  "30041": "4",
  "33550": "4",
  "30108": "4",
  "33578": "4",
  "33569": "4",
  "33858": "4",
  "30064": "4",
  "30012": "4",
  "30080": "4",
  "32218": "4",
  "30297": "4",
  "33563": "4",
  "31028": "4",
  "34224": "4",
  "30742": "4",
  "36083": "4",
  "36425": "4",
  "36775": "4",
  "35768": "3e",
  "35971": "4",
  "36049": "4",
  "35046": "4",
  "36790": "4",
  "36529": "4",
  "36538": "4",
  "36518": "4",
  "36585": "4",
  "36033": "4",
  "36426": "4",
  "33436": "4",
  "30152": "4",
  "33810": "4",
  "36767": "4",
  "36524": "4",
  "36727": "4",
  "30555": "4",
  "30096": "4",
  "30281": "4",
  "30250": "4",
  "31318": "4",
  "33990": "4",
  "32571": "4",
  "33031": "4",
  "33170": "4",
  "34105": "4",
  "32570": "4",
  "32531": "4",
  "33904": "4",
  "33917": "4",
  "33637": "4",
  "35564": "4",
  "35643": "3e",
  "39866": "4",
  "31825": "4",
  "30421": "4",
  "30474": "4",
  "31060": "4",
  "31065": "4",
  "33880": "4",
  "32835": "4",
  "33830": "4",
  "31750": "4",
  "33594": "4",
  "31002": "4",
  "33881": "4",
  "32244": "4",
  "34786": "4",
  "31006": "4",
  "30536": "4",
  "30540": "4",
  "30071": "4",
  "30620": "4",
  "32583": "4",
  "32563": "4",
  "32219": "4",
  "39826": "4",
  "32829": "4",
  "31795": "4",
  "32228": "4",
  "31749": "4",
  "33067": "4",
  "33062": "4",
  "39877": "4",
  "30120": "4",
  "35651": "4",
  "30520": "4",
  "35575": "4",
  "31023": "4",
  "35577": "4",
  "39823": "4",
  "30184": "4",
  "30460": "4",
  "30028": "4",
  "31804": "4",
  "33860": "4",
  "39825": "4",
  "30230": "4",
  "34117": "4",
  "33840": "4",
  "33534": "4",
  "32820": "4",
  "33503": "4",
  "33540": "4",
  "33827": "4",
  "33847": "4",
  "20016": "2e",
  "20415": "2e",
  "66936": "2w",
  "66023": "2w",
  "66416": "2w",
  "66518": "2w",
  "67492": "2w",
  "66440": "2w",
  "66408": "2w",
  "67023": "2w",
  "66782": "2w",
  "68943": "2w",
  "67739": "2w",
  "67663": "2w",
  "66948": "2w",
  "67420": "2w",
  "67572": "2w",
  "66093": "2w",
  "66767": "2w",
  "67737": "2w",
  "67118": "2w",
  "66846": "2w",
  "67880": "2w",
  "66852": "2w",
  "67031": "2w",
  "67152": "2w",
  "67954": "2w",
  "67550": "2w",
  "67066": "2w",
  "67021": "2w",
  "67124": "2w",
  "66160": "2w",
  "67627": "2w",
  "67556": "2w",
  "67104": "2w",
  "66042": "2w",
  "67344": "2w",
  "67579": "2w",
  "66118": "2w",
  "67024": "2w",
  "67548": "2w",
  "67520": "2w",
  "67546": "2w",
  "66027": "2w",
  "67022": "2w",
  "66960": "2w",
  "66959": "2w",
  "67656": "2w",
  "66716": "2w",
  "66040": "2w",
  "66763": "2w",
  "66838": "2w",
  "66935": "2w",
  "67658": "2w",
  "67553": "2w",
  "67639": "2w",
  "66735": "2w",
  "66604": "2w",
  "67208": "2w",
  "66427": "2w",
  "66531": "2w",
  "66554": "2w",
  "67206": "2w",
  "67217": "2w",
  "66537": "2w",
  "67108": "2w",
  "67133": "2w",
  "67447": "2w",
  "66615": "2w",
  "66008": "2w",
  "66046": "2w",
  "66612": "2w",
  "67226": "2w",
  "76308": "3w",
  "76302": "3w",
  "77389": "4",
  "77535": "4",
  "77407": "4",
  "77575": "4",
  "77304": "4",
  "77385": "4",
  "77554": "4",
  "77590": "4",
  "77372": "4",
  "77414": "4",
  "77339": "4",
  "77362": "4",
  "77388": "4",
  "77584": "4",
  "77070": "4",
  "77320": "3w",
  "77483": "4",
  "77573": "4",
  "77514": "4",
  "78933": "6",
  "79054": "2w",
  "79243": "6",
  "75946": "3w",
  "78950": "6",
  "77455": "6",
  "76945": "6",
  "79064": "6",
  "79072": "6",
  "79051": "2w",
  "79248": "3w",
  "77457": "4",
  "77538": "4",
  "78870": "6",
  "76566": "6",
  "78801": "6",
  "79357": "6",
  "76233": "3w",
  "76680": "3w",
  "79912": "6",
  "76704": "3w",
  "77976": "6",
  "76957": "6",
  "79414": "6",
  "78369": "6",
  "79759": "6",
  "78719": "6",
  "78343": "6",
  "76638": "6",
  "78347": "4",
  "45624": "2e",
  "43549": "2e",
  "45171": "2e",
  "44431": "2e",
  "43138": "2e",
  "45772": "2e",
  "43316": "2e",
  "43845": "2e",
  "44861": "2e",
  "43101": "2e",
  "45631": "2e",
  "45159": "2e",
  "45614": "2e",
  "44854": "2e",
  "45879": "2e",
  "43764": "2e",
  "43782": "2e",
  "43334": "2e",
  "43315": "2e",
  "45177": "2e",
  "45779": "2e",
  "45821": "2e",
  "45068": "2e",
  "45886": "2e",
  "43728": "2e",
  "43548": "2e",
  "43946": "2e",
  "43788": "2e",
  "45734": "2e",
  "43302": "2e",
  "43711": "2e",
  "44638": "2e",
  "43977": "2e",
  "43750": "2e",
  "43974": "2e",
  "44825": "2e",
  "45118": "2e",
  "43930": "2e",
  "44313": "2e",
  "44312": "2e",
  "44147": "2e",
  "44126": "2e",
  "44112": "2e",
  "44132": "2e",
  "44647": "2e",
  "43076": "2e",
  "44231": "2e",
  "43008": "2e",
  "44429": "2e",
  "44502": "2e",
  "44428": "2e",
  "44889": "2e",
  "43140": "2e",
  "45140": "2e",
  "44824": "2e",
  "45153": "2e",
  "93309": "6",
  "95365": "6",
  "93458": "7",
  "93201": "6",
  "93429": "7",
  "95382": "7",
  "92182": "6",
  "93106": "7",
  "95385": "7",
  "95212": "7",
  "95824": "7",
  "91977": "6",
  "93243": "6",
  "95242": "7",
  "93723": "6",
  "93276": "6",
  "92324": "6",
  "95231": "7",
  "95227": "7",
  "93240": "6",
  "95366": "7",
  "97020": "7",
  "97362": "7",
  "97396": "7",
  "97068": "7",
  "97019": "7",
  "97267": "7",
  "97042": "7",
  "97008": "7",
  "97089": "7",
  "97028": "5",
  "97006": "7",
  "97106": "7",
  "97479": "7",
  "97833": "5",
  "97819": "5",
  "97031": "5",
  "99362": "5",
  "97837": "5",
  "97444": "7",
  "97033": "5",
  "97730": "5",
  "97840": "5",
  "97907": "5",
  "97753": "5",
  "95358": "7",
  "90250": "6",
  "95206": "7",
  "96031": "7",
  "95521": "7",
  "95451": "7",
  "95928": "7",
  "93220": "6",
  "95317": "7",
  "95467": "7",
  "93004": "6",
  "96086": "7",
  "93720": "6",
  "95818": "7",
  "95954": "6",
  "92833": "6",
  "95820": "7",
  "95978": "6",
  "95310": "6",
  "95914": "6",
  "95822": "7",
  "93311": "6",
  "95346": "6",
  "92407": "6",
  "93207": "6",
  "93267": "6",
  "92316": "6",
  "91902": "6",
  "95209": "7",
  "92139": "6",
  "95219": "7",
  "95901": "6",
  "93249": "7",
  "93630": "6",
  "95391": "7",
  "95220": "7",
  "95237": "7",
  "93650": "6",
  "93042": "7",
  "95253": "7",
  "93730": "6",
  "95377": "7",
  "93634": "6",
  "95838": "7",
  "93531": "6",
  "93581": "6",
  "92373": "6",
  "92107": "6",
  "93652": "6",
  "92415": "6",
  "95842": "7",
  "95843": "7",
  "95835": "7",
  "92117": "6",
  "92122": "6",
  "92130": "6",
  "92371": "6",
  "93562": "6",
  "95827": "7",
  "91759": "6",
  "95829": "7",
  "92397": "6",
  "92395": "6",
  "94571": "7",
  "95638": "6",
  "95555": "7",
  "93446": "7",
  "92145": "6",
  "91762": "6",
  "95355": "7",
  "92116": "6",
  "93021": "6",
  "95312": "7",
  "95368": "7",
  "93023": "6",
  "96034": "7",
  "92389": "5",
  "93210": "7",
  "91730": "6",
  "91786": "6",
  "95435": "7",
  "93001": "7",
  "95370": "6",
  "93725": "6",
  "95322": "7",
  "93117": "7",
  "93427": "7",
  "93223": "6",
  "93728": "6",
  "14466": "2e",
  "12118": "1e",
  "14750": "2e",
  "14063": "2e",
  "10280": "2e",
  "10465": "2e",
  "12529": "2e",
  "11201": "2e",
  "10704": "2e",
  "14882": "2e",
  "10705": "2e",
  "13901": "2e",
  "13204": "1e",
  "10009": "2e",
  "13053": "2e",
  "14607": "1e",
  "53040": "1e",
  "53019": "1e",
  "54425": "1e",
  "54956": "1e",
  "53037": "1e",
  "53076": "1e",
  "54928": "1e",
  "54491": "1e",
  "53070": "1e",
  "54560": "1e",
  "54557": "1e",
  "54527": "1e",
  "54465": "1e",
  "54451": "1e",
  "54814": "1e",
  "54634": "1e",
  "54756": "1e",
  "54423": "1e",
  "53032": "1e",
  "54103": "1e",
  "54003": "1e",
  "53528": "1e",
  "54667": "1e",
  "54865": "1e",
  "53504": "2e",
  "54628": "1e",
  "54653": "1e",
  "54463": "1e",
  "54665": "1e",
  "54177": "1e",
  "54771": "1e",
  "53826": "1e",
  "54624": "1e",
  "53520": "2e",
  "54024": "1e",
  "54840": "1e",
  "54460": "1e",
  "54731": "1e",
  "53924": "1e",
  "53510": "2e",
  "54009": "1e",
  "54762": "1e",
  "54143": "1e",
  "54004": "1e",
  "54621": "1e",
  "53554": "1e",
  "54493": "1e",
  "54846": "1e",
  "53580": "2e",
  "53804": "2e",
  "54629": "1e",
  "54430": "1e",
  "53808": "2e",
  "54155": "1e",
  "54642": "1e",
  "53506": "1e",
  "54556": "1e",
  "53561": "1e",
  "53578": "1e",
  "54839": "1e",
  "54901": "1e",
  "53016": "1e",
  "54845": "1e",
  "54812": "1e",
  "54841": "1e",
  "53585": "2e",
  "54474": "1e",
  "53177": "2e",
  "53139": "2e",
  "53168": "2e",
  "54441": "1e",
  "28652": "3e",
  "28315": "3e",
  "28736": "3e",
  "33418": "4",
  "32346": "4",
  "33032": "4",
  "33635": "4",
  "34141": "4",
  "33193": "4",
  "33825": "4",
  "32102": "4",
  "32058": "4",
  "32168": "4",
  "34972": "4",
  "32025": "4",
  "32024": "4",
  "32445": "4",
  "33029": "4",
  "34429": "4",
  "33921": "4",
  "32026": "4",
  "32428": "4",
  "32321": "4",
  "34446": "4",
  "33538": "4",
  "34986": "4",
  "33521": "4",
  "32187": "4",
  "34436": "4",
  "32550": "4",
  "32356": "4",
  "32062": "4",
  "32323": "4",
  "34498": "4",
  "33039": "4",
  "33142": "4",
  "32618": "4",
  "33629": "4",
  "34974": "4",
  "33415": "4",
  "33035": "4",
  "33834": "4",
  "32145": "4",
  "34601": "4",
  "33316": "4",
  "33312": "4",
  "32725": "4",
  "34428": "4",
  "34449": "4",
  "32096": "4",
  "33332": "4",
  "33327": "4",
  "32456": "4",
  "32131": "4",
  "32148": "4",
  "33585": "4",
  "34785": "4",
  "34442": "4",
  "34981": "4",
  "32693": "4",
  "34484": "4",
  "32459": "4",
  "33852": "4",
  "32328": "4",
  "32692": "4",
  "15466": "2e",
  "18234": "2e",
  "18970": "2e",
  "16863": "2e",
  "16821": "2e",
  "15120": "2e",
  "15015": "2e",
  "19343": "2e",
  "19050": "2e",
  "19074": "2e",
  "15030": "2e",
  "18614": "2e",
  "16726": "2e",
  "15064": "2e",
  "15020": "2e",
  "16115": "2e",
  "16136": "2e",
  "15061": "2e",
  "15021": "2e",
  "16123": "2e",
  "15243": "2e",
  "15081": "2e",
  "15233": "2e",
  "15314": "2e",
  "15329": "2e",
  "15348": "2e",
  "16351": "2e",
  "16370": "2e",
  "16260": "2e",
  "15610": "2e",
  "15612": "2e",
  "15698": "2e",
  "15342": "2e",
  "15361": "2e",
  "67521": "2w",
  "66734": "2w",
  "67850": "2w",
  "66712": "2w",
  "66733": "2w",
  "67738": "2w",
  "66770": "2w",
  "67951": "2w",
  "67869": "2w",
  "67360": "2w",
  "67345": "2w",
  "67844": "2w",
  "67112": "2w",
  "67657": "2w",
  "67417": "2w",
  "67651": "2w",
  "66872": "2w",
  "66092": "2w",
  "67838": "2w",
  "66115": "2w",
  "66781": "2w",
  "66743": "2w",
  "67150": "2w",
  "66056": "2w",
  "66091": "2w",
  "67863": "2w",
  "67519": "2w",
  "66217": "2w",
  "67143": "2w",
  "67870": "2w",
  "67490": "2w",
  "67637": "2w",
  "67837": "2w",
  "67353": "2w",
  "66780": "2w",
  "66432": "2w",
  "67060": "2w",
  "66610": "2w",
  "67204": "2w",
  "67010": "2w",
  "66104": "2w",
  "66207": "2w",
  "67581": "2w",
  "67510": "2w",
  "66616": "2w",
  "67101": "2w",
  "66205": "2w",
  "67154": "2w",
  "66035": "2w",
  "66227": "2w",
  "66508": "2w",
  "66506": "2w",
  "66060": "2w",
  "66619": "2w",
  "66050": "2w",
  "67210": "2w",
  "66054": "2w",
  "67072": "2w",
  "67664": "2w",
  "66751": "2w",
  "66749": "2w",
  "67156": "2w",
  "67475": "2w",
  "66515": "2w",
  "67330": "2w",
  "67341": "2w",
  "67757": "2w",
  "66412": "2w",
  "66949": "2w",
  "67468": "2w",
  "67439": "2w",
  "67122": "2w",
  "68325": "2w",
  "67953": "2w",
  "66758": "2w",
  "66502": "2w",
  "66607": "2w",
  "66547": "2w",
  "67470": "2w",
  "67207": "2w",
  "67202": "2w",
  "67355": "2w",
  "67950": "2w",
  "67035": "2w",
  "67557": "2w",
  "67834": "2w",
  "67427": "2w",
  "67876": "2w",
  "67544": "2w",
  "66801": "2w",
  "66219": "2w",
  "67356": "2w",
  "67513": "2w",
  "67575": "2w",
  "72333": "3w",
  "72383": "3w",
  "72522": "3w",
  "71671": "3w",
  "72553": "3w",
  "72615": "3w",
  "72949": "3w",
  "72051": "3w",
  "71674": "3w",
  "72833": "3w",
  "71747": "3w",
  "72663": "3w",
  "72617": "3w",
  "72943": "3w",
  "72470": "3w",
  "71647": "3w",
  "72635": "3w",
  "72837": "3w",
  "72830": "3w",
  "72840": "3w",
  "72857": "3w",
  "72828": "3w",
  "72677": "3w",
  "72462": "3w",
  "71960": "3w",
  "72776": "3w",
  "71970": "3w",
  "72561": "3w",
  "72619": "3w",
  "71725": "3w",
  "72668": "3w",
  "72760": "3w",
  "72639": "3w",
  "72099": "3w",
  "72404": "3w",
  "72416": "3w",
  "39212": "4",
  "39041": "4",
  "39309": "4",
  "39322": "4",
  "39565": "4",
  "39175": "4",
  "39232": "4",
  "39152": "4",
  "39426": "4",
  "39358": "4",
  "39595": "4",
  "39562": "4",
  "39345": "4",
  "38774": "3e",
  "38645": "3e",
  "39150": "4",
  "38611": "3e",
  "38901": "4",
  "38913": "3e",
  "39338": "4",
  "38828": "3e",
  "39477": "4",
  "38666": "3e",
  "38326": "3e",
  "39116": "4",
  "38838": "3e",
  "38950": "3e",
  "38921": "3e",
  "39747": "4",
  "38965": "3e",
  "38652": "3e",
  "39115": "4",
  "38930": "4",
  "39772": "4",
  "39083": "4",
  "39643": "4",
  "38720": "3e",
  "39166": "4",
  "39422": "4",
  "39437": "4",
  "38804": "3e",
  "39465": "4",
  "38733": "3e",
  "38756": "3e",
  "38748": "4",
  "66760": "2w",
  "66945": "2w",
  "67649": "2w",
  "66039": "2w",
  "67758": "2w",
  "67051": "2w",
  "67049": "2w",
  "67864": "2w",
  "66946": "2w",
  "66741": "2w",
  "67514": "2w",
  "67568": "2w",
  "66533": "2w",
  "66066": "2w",
  "67144": "2w",
  "67132": "2w",
  "66088": "2w",
  "66544": "2w",
  "66007": "2w",
  "67056": "2w",
  "66451": "2w",
  "66404": "2w",
  "66835": "2w",
  "66112": "2w",
  "66431": "2w",
  "67621": "2w",
  "67437": "2w",
  "67333": "2w",
  "67460": "2w",
  "67701": "2w",
  "67643": "2w",
  "67063": "2w",
  "67483": "2w",
  "67053": "2w",
  "66424": "2w",
  "66526": "2w",
  "67019": "2w",
  "67745": "2w",
  "67454": "2w",
  "66053": "2w",
  "67455": "2w",
  "67332": "2w",
  "66043": "2w",
  "66710": "2w",
  "66026": "2w",
  "66952": "2w",
  "67260": "2w",
  "92173": "6",
  "46537": "2e",
  "46409": "2e",
  "46789": "2e",
  "46965": "2e",
  "46703": "2e",
  "46104": "2e",
  "46943": "2e",
  "46984": "2e",
  "47574": "3e",
  "46998": "2e",
  "47160": "3e",
  "47876": "2e",
  "46937": "2e",
  "47324": "2e",
  "46624": "2e",
  "46374": "2e",
  "47501": "2e",
  "47868": "2e",
  "47512": "2e",
  "47978": "2e",
  "46226": "2e",
  "47942": "2e",
  "47921": "2e",
  "47922": "2e",
  "46268": "2e",
  "46228": "2e",
  "46208": "2e",
  "46381": "2e",
  "47546": "2e",
  "46574": "2e",
  "46133": "2e",
  "46371": "2e",
  "46770": "2e",
  "47712": "3e",
  "46408": "2e",
  "46394": "2e",
  "46321": "2e",
  "46511": "2e",
  "47431": "2e",
  "46974": "2e",
  "46931": "2e",
  "47031": "2e",
  "47006": "2e",
  "47164": "2e",
  "46737": "2e",
  "47229": "2e",
  "47356": "2e",
  "47010": "2e",
  "46580": "2e",
  "47042": "2e",
  "47106": "2e",
  "47023": "2e",
  "47388": "2e",
  "47857": "2e",
  "46181": "2e",
  "46126": "2e",
  "46961": "2e",
  "47469": "2e",
  "47433": "2e",
  "47243": "2e",
  "47369": "2e",
  "47381": "2e",
  "47952": "2e",
  "46962": "2e",
  "46050": "2e",
  "47305": "2e",
  "47715": "3e",
  "46773": "2e",
  "46743": "2e",
  "46741": "2e",
  "46070": "2e",
  "46017": "2e",
  "46987": "2e",
  "46767": "2e",
  "47708": "3e",
  "47383": "2e",
  "47166": "3e",
  "47860": "2e",
  "46774": "2e",
  "46407": "2e",
  "47226": "2e",
  "46048": "2e",
  "46745": "2e",
  "47247": "2e",
  "46102": "2e",
  "47445": "2e",
  "47174": "3e",
  "47392": "2e",
  "47866": "2e",
  "47344": "2e",
  "47351": "2e",
  "46155": "2e",
  "47123": "3e",
  "46786": "2e",
  "47916": "2e",
  "47865": "2e",
  "46125": "2e",
  "46183": "2e",
  "46377": "2e",
  "46047": "2e",
  "47590": "2e",
  "47529": "2e",
  "46366": "2e",
  "47619": "3e",
  "47471": "2e",
  "46121": "2e",
  "46033": "2e",
  "47853": "2e",
  "46766": "2e",
  "47881": "2e",
  "46926": "2e",
  "47175": "3e",
  "47120": "2e",
  "47264": "2e",
  "46746": "2e",
  "47240": "2e",
  "46582": "2e",
  "99204": "5",
  "98856": "5",
  "98834": "5",
  "98537": "7",
  "98922": "5",
  "98934": "5",
  "98943": "5",
  "98628": "5",
  "98107": "5",
  "98122": "5",
  "98531": "7",
  "99202": "5",
  "98932": "5",
  "99006": "5",
  "98841": "5",
  "99176": "5",
  "98101": "5",
  "99027": "5",
  "98546": "7",
  "98133": "5",
  "98407": "7",
  "98575": "7",
  "98007": "5",
  "98284": "5",
  "98586": "7",
  "98365": "7",
  "99359": "5",
  "99159": "5",
  "98368": "7",
  "99144": "5",
  "98588": "7",
  "98640": "7",
  "98536": "7",
  "99179": "5",
  "98387": "7",
  "99360": "5",
  "98595": "7",
  "98837": "5",
  "99363": "5",
  "98433": "7",
  "98325": "7",
  "98280": "5",
  "99125": "5",
  "99147": "5",
  "98624": "7",
  "98571": "7",
  "98616": "5",
  "99001": "5",
  "99022": "5",
  "98314": "7",
  "98220": "5",
  "98364": "7",
  "98439": "7",
  "98836": "5",
  "98286": "5",
  "98572": "7",
  "98933": "5",
  "99040": "5",
  "99356": "5",
  "99151": "5",
  "99350": "5",
  "98857": "5",
  "98830": "5",
  "99174": "5",
  "99102": "5",
  "99206": "5",
  "99336": "5",
  "95612": "7",
  "92325": "6",
  "95528": "7",
  "92322": "6",
  "93442": "7",
  "92135": "6",
  "92352": "6",
  "95536": "7",
  "95558": "7",
  "95456": "7",
  "95410": "7",
  "95679": "7",
  "92339": "6",
  "93950": "7",
  "95559": "7",
  "95511": "7",
  "92886": "6",
  "91913": "6",
  "96073": "7",
  "96065": "7",
  "96088": "7",
  "92008": "6",
  "94130": "7",
  "96017": "7",
  "91978": "6",
  "92070": "6",
  "96143": "5",
  "91906": "6",
  "96146": "5",
  "92808": "6",
  "92310": "6",
  "92501": "6",
  "94122": "7",
  "92242": "6",
  "92679": "6",
  "92692": "6",
  "92675": "6",
  "95726": "6",
  "95721": "5",
  "96130": "5",
  "49505": "1e",
  "49099": "2e",
  "49042": "2e",
  "49202": "2e",
  "49952": "1e",
  "48220": "2e",
  "49022": "2e",
  "48725": "1e",
  "49776": "1e",
  "49274": "2e",
  "49458": "1e",
  "49749": "1e",
  "49459": "1e",
  "49655": "1e",
  "49835": "1e",
  "49677": "1e",
  "48419": "1e",
  "48427": "1e",
  "49878": "1e",
  "48829": "1e",
  "48888": "1e",
  "49653": "1e",
  "48426": "1e",
  "49880": "1e",
  "48651": "1e",
  "48824": "2e",
  "48383": "2e",
  "49230": "2e",
  "49026": "2e",
  "49080": "2e",
  "49333": "2e",
  "49078": "2e",
  "49318": "1e",
  "48532": "1e",
  "48853": "1e",
  "49806": "1e",
  "49930": "1e",
  "48815": "1e",
  "48362": "1e",
  "16640": "2e",
  "19535": "2e",
  "19543": "2e",
  "17557": "2e",
  "17324": "2e",
  "19121": "2e",
  "17579": "2e",
  "19555": "2e",
  "15951": "2e",
  "15948": "2e",
  "18070": "2e",
  "16444": "2e",
  "18013": "2e",
  "15563": "2e",
  "17532": "2e",
  "18624": "2e",
  "15411": "2e",
  "17360": "2e",
  "18201": "2e",
  "15954": "2e",
  "16040": "2e",
  "18840": "2e",
  "15853": "2e",
  "15647": "2e",
  "16034": "2e",
  "15632": "2e",
  "15623": "2e",
  "16052": "2e",
  "15671": "2e",
  "16929": "2e",
  "16936": "2e",
  "16925": "2e",
  "15851": "2e",
  "16935": "2e",
  "16940": "2e",
  "18337": "2e",
  "16937": "2e",
  "16253": "2e",
  "16020": "2e",
  "15829": "2e",
  "16734": "2e",
  "15834": "2e",
  "15772": "2e",
  "16670": "2e",
  "15770": "2e",
  "15821": "2e",
  "16236": "2e",
  "16250": "2e",
  "18324": "2e",
  "15831": "2e",
  "18817": "2e",
  "33144": "4",
  "34241": "4",
  "11358": "2e",
  "10455": "2e",
  "14225": "1e",
  "14051": "1e",
  "10310": "2e",
  "10528": "2e",
  "12586": "2e",
  "13491": "1e",
  "12589": "2e",
  "10980": "2e",
  "21529": "2e",
  "21711": "2e",
  "21734": "2e",
  "21028": "2e",
  "21153": "2e",
  "21057": "2e",
  "21005": "2e",
  "21842": "3e",
  "20747": "2e",
  "21032": "2e",
  "20855": "2e",
  "20772": "2e",
  "21771": "2e",
  "21770": "2e",
  "20678": "3e",
  "20707": "2e",
  "21613": "3e",
  "20816": "2e",
  "20901": "2e",
  "20774": "2e",
  "20871": "2e",
  "21233": "2e",
  "21102": "2e",
  "20853": "2e",
  "20758": "2e",
  "21774": "2e",
  "21090": "2e",
  "20708": "2e",
  "20715": "2e",
  "20612": "3e",
  "21652": "2e",
  "21540": "2e",
  "21921": "2e",
  "21040": "2e",
  "21216": "2e",
  "21557": "2e",
  "21766": "2e",
  "21856": "3e",
  "21555": "2e",
  "21222": "2e",
  "21111": "2e",
  "21132": "2e",
  "21209": "2e",
  "21244": "2e",
  "21131": "2e",
  "21034": "2e",
  "21051": "2e",
  "20659": "3e",
  "20817": "2e",
  "20755": "2e",
  "20785": "2e",
  "20646": "3e",
  "21054": "2e",
  "21560": "2e",
  "20656": "3e",
  "21738": "2e",
  "20905": "2e",
  "20862": "2e",
  "20748": "2e",
  "21777": "2e",
  "21074": "2e",
  "20716": "2e",
  "20688": "3e",
  "21035": "2e",
  "20674": "3e",
  "20695": "2e",
  "20639": "2e",
  "20670": "3e",
  "21658": "2e",
  "20879": "2e",
  "20684": "3e",
  "20720": "2e",
  "21717": "2e",
  "21920": "2e",
  "20675": "2e",
  "21640": "2e",
  "21862": "3e",
  "21629": "2e",
  "20611": "3e",
  "21672": "3e",
  "21663": "2e",
  "21625": "2e",
  "20625": "3e",
  "21676": "2e",
  "21218": "2e",
  "21722": "2e",
  "21919": "2e",
  "21229": "2e",
  "21214": "2e",
  "21207": "2e",
  "21849": "3e",
  "21524": "2e",
  "68330": "2w",
  "68004": "2w",
  "68376": "2w",
  "68869": "2w",
  "68345": "2w",
  "68041": "2w",
  "68073": "2w",
  "68840": "2w",
  "68845": "2w",
  "68040": "2w",
  "68849": "2w",
  "68735": "2w",
  "68872": "2w",
  "68927": "2w",
  "68714": "2w",
  "68319": "2w",
  "68871": "2w",
  "68037": "2w",
  "68403": "2w",
  "68753": "2w",
  "68792": "2w",
  "71861": "3w",
  "72140": "3w",
  "72390": "3w",
  "72038": "3w",
  "72624": "3w",
  "72740": "3w",
  "72335": "3w",
  "71847": "3w",
  "72472": "3w",
  "72501": "3w",
  "72389": "3w",
  "72069": "3w",
  "72367": "3w",
  "72571": "3w",
  "72328": "3w",
  "72059": "3w",
  "71765": "3w",
  "72110": "3w",
  "71753": "3w",
  "71763": "3w",
  "72835": "3w",
  "72519": "3w",
  "72650": "3w",
  "71662": "3w",
  "72515": "3w",
  "71762": "3w",
  "72555": "3w",
  "13638": "1e",
  "12821": "1e",
  "12095": "1e",
  "12921": "1e",
  "12865": "1e",
  "12952": "1e",
  "12923": "1e",
  "12920": "1e",
  "12924": "1e",
  "12819": "1e",
  "10474": "2e",
  "13439": "1e",
  "12550": "2e",
  "11757": "2e",
  "12592": "2e",
  "10119": "2e",
  "13340": "1e",
  "11735": "2e",
  "10199": "2e",
  "10036": "2e",
  "10110": "2e",
  "11520": "2e",
  "10919": "2e",
  "11772": "2e",
  "11713": "2e",
  "11580": "2e",
  "11767": "2e",
  "10065": "2e",
  "12575": "2e",
  "10989": "2e",
  "13475": "1e",
  "13454": "1e",
  "14894": "2e",
  "12746": "2e",
  "13324": "1e",
  "14502": "1e",
  "10570": "2e",
  "10958": "2e",
  "13835": "2e",
  "11518": "2e",
  "11694": "2e",
  "10973": "2e",
  "11716": "2e",
  "98639": "5",
  "99251": "5",
  "99167": "5",
  "98641": "7",
  "98136": "5",
  "99338": "5",
  "98516": "7",
  "99321": "5",
  "98262": "5",
  "98597": "7",
  "99020": "5",
  "99155": "5",
  "98256": "5",
  "98037": "5",
  "98010": "5",
  "98675": "7",
  "98665": "7",
  "98950": "5",
  "98926": "5",
  "07649": "2e",
  "07843": "2e",
  "08063": "2e",
  "08084": "2e",
  "08031": "2e",
  "08045": "2e",
  "08090": "2e",
  "08032": "2e",
  "08016": "2e",
  "08068": "2e",
  "08052": "2e",
  "08515": "2e",
  "08753": "2e",
  "08724": "2e",
  "08019": "2e",
  "07718": "2e",
  "07758": "2e",
  "07701": "2e",
  "07737": "2e",
  "07757": "2e",
  "07727": "2e",
  "07723": "2e",
  "07703": "2e",
  "08831": "2e",
  "07010": "2e",
  "07103": "2e",
  "07626": "2e",
  "39365": "4",
  "39320": "4",
  "39326": "4",
  "39532": "4",
  "39189": "4",
  "39470": "4",
  "39567": "4",
  "38672": "3e",
  "38654": "3e",
  "39086": "4",
  "39752": "4",
  "38738": "3e",
  "38651": "3e",
  "38745": "4",
  "39168": "4",
  "38603": "3e",
  "39054": "4",
  "38647": "3e",
  "39140": "4",
  "38664": "3w",
  "39451": "4",
  "38759": "3e",
  "38947": "4",
  "39480": "4",
  "39776": "4",
  "39366": "4",
  "38764": "3e",
  "38685": "3e",
  "38839": "4",
  "38928": "3e",
  "38876": "4",
  "38661": "3e",
  "39481": "4",
  "39483": "4",
  "38676": "3e",
  "39653": "4",
  "39735": "4",
  "38851": "4",
  "39661": "4",
  "39038": "4",
  "39044": "4",
  "39069": "4",
  "39667": "4",
  "39652": "4",
  "38606": "3e",
  "39635": "4",
  "39401": "4",
  "38860": "4",
  "38879": "4",
  "39746": "4",
  "39773": "4",
  "39206": "4",
  "39204": "4",
  "39501": "4",
  "39531": "4",
  "39325": "4",
  "39058": "4",
  "39475": "4",
  "39208": "4",
  "39170": "4",
  "39073": "4",
  "39525": "4",
  "39157": "4",
  "39352": "4",
  "39167": "4",
  "39067": "4",
  "39563": "4",
  "39327": "4",
  "39336": "4",
  "38721": "4",
  "38967": "4",
  "38683": "3e",
  "38631": "3e",
  "39631": "4",
  "38655": "3e",
  "39119": "4",
  "38674": "3e",
  "38951": "4",
  "38601": "3e",
  "38736": "3e",
  "39061": "4",
  "38848": "4",
  "39630": "4",
  "89502": "5",
  "89557": "5",
  "89415": "5",
  "89014": "5",
  "89142": "5",
  "89166": "5",
  "89031": "5",
  "89086": "5",
  "89179": "5",
  "89124": "5",
  "89007": "5",
  "89029": "5",
  "89026": "5",
  "89404": "5",
  "89013": "5",
  "89043": "5",
  "89003": "5",
  "89828": "5",
  "89496": "5",
  "89447": "5",
  "89833": "5",
  "89426": "5",
  "89317": "5",
  "89422": "5",
  "89523": "5",
  "89448": "5",
  "89316": "5",
  "89101": "5",
  "89703": "5",
  "89146": "5",
  "58711": "1w",
  "58310": "1w",
  "58762": "1w",
  "58760": "1w",
  "58737": "1w",
  "58381": "1w",
  "58464": "1w",
  "58231": "1w",
  "58486": "1w",
  "58423": "1w",
  "58261": "1w",
  "58212": "1w",
  "58455": "1w",
  "58707": "1w",
  "58278": "1w",
  "58535": "1w",
  "58572": "1w",
  "58064": "1w",
  "58275": "1w",
  "58401": "1w",
  "58205": "1w",
  "58552": "1w",
  "58487": "1w",
  "58428": "1w",
  "58482": "1w",
  "58426": "1w",
  "57648": "1w",
  "58071": "1w",
  "58713": "1w",
  "58413": "1w",
  "58561": "1w",
  "58445": "1w",
  "58338": "1w",
  "58216": "1w",
  "58079": "1w",
  "58568": "1w",
  "58048": "1w",
  "58061": "1w",
  "58045": "1w",
  "58274": "1w",
  "58007": "1w",
  "58016": "1w",
  "58239": "1w",
  "58223": "1w",
  "58011": "1w",
  "58331": "1w",
  "58260": "1w",
  "58262": "1w",
  "58065": "1w",
  "58740": "1w",
  "58734": "1w",
  "58348": "1w",
  "58332": "1w",
  "58779": "1w",
  "65039": "2w",
  "64858": "2w",
  "65629": "3w",
  "65802": "2w",
  "64501": "2w",
  "65284": "2w",
  "64455": "2w",
  "64147": "2w",
  "64841": "2w",
  "63876": "3w",
  "63332": "2w",
  "63357": "2w",
  "65025": "2w",
  "65325": "2w",
  "63451": "2w",
  "63829": "3w",
  "63625": "3w",
  "63638": "3w",
  "64486": "2w",
  "63624": "3w",
  "63660": "2w",
  "65664": "2w",
  "65068": "2w",
  "65778": "3w",
  "64733": "2w",
  "64154": "2w",
  "65043": "2w",
  "65023": "2w",
  "64743": "2w",
  "65203": "2w",
  "65279": "2w",
  "64504": "2w",
  "64503": "2w",
  "64454": "2w",
  "64448": "2w",
  "65706": "2w",
  "64459": "2w",
  "64145": "2w",
  "64149": "2w",
  "64102": "2w",
  "63348": "2w",
  "63738": "3w",
  "63735": "3w",
  "63336": "2w",
  "63334": "2w",
  "64673": "2w",
  "65281": "2w",
  "65784": "3w",
  "63352": "2w",
  "65654": "3w",
  "63623": "3w",
  "64639": "2w",
  "65787": "2w",
  "64771": "2w",
  "65276": "2w",
  "65591": "2w",
  "65024": "2w",
  "65660": "3w",
  "65589": "3w",
  "63048": "2w",
  "63767": "3w",
  "63736": "3w",
  "63073": "2w",
  "63061": "2w",
  "63351": "2w",
  "63957": "3w",
  "63944": "3w",
  "65270": "2w",
  "63080": "2w",
  "63084": "2w",
  "65301": "2w",
  "63089": "2w",
  "63013": "2w",
  "65616": "3w",
  "63951": "3w",
  "65001": "2w",
  "65702": "3w",
  "65464": "3w",
  "64659": "2w",
  "63458": "2w",
  "63868": "3w",
  "64623": "2w",
  "65747": "3w",
  "74866": "3w",
  "74077": "2w",
  "74457": "3w",
  "73103": "3w",
  "73666": "2w",
  "73646": "2w",
  "74740": "3w",
  "73114": "3w",
  "73530": "3w",
  "73542": "3w",
  "74066": "3w",
  "04848": "1e",
  "04912": "1e",
  "03905": "2e",
  "04922": "1e",
  "04237": "1e",
  "04772": "1e",
  "04625": "1e",
  "04431": "1e",
  "04476": "1e",
  "04624": "1e",
  "04926": "1e",
  "04627": "1e",
  "04008": "1e",
  "04570": "1e",
  "04541": "1e",
  "04426": "1e",
  "04976": "1e",
  "04668": "1e",
  "04768": "1e",
  "04040": "1e",
  "04349": "1e",
  "04084": "1e",
  "04901": "1e",
  "04910": "1e",
  "04626": "1e",
  "04970": "1e",
  "04575": "1e",
  "13157": "1e",
  "13319": "1e",
  "13203": "1e",
  "14605": "1e",
  "12521": "2e",
  "10701": "2e",
  "10573": "2e",
  "14854": "2e",
  "14615": "1e",
  "14616": "1e",
  "10454": "2e",
  "11422": "2e",
  "10533": "2e",
  "14625": "1e",
  "10932": "2e",
  "10703": "2e",
  "14534": "1e",
  "10916": "2e",
  "11229": "2e",
  "11763": "2e",
  "13865": "2e",
  "10921": "2e",
  "10507": "2e",
  "14075": "2e",
  "10560": "2e",
  "13795": "2e",
  "10518": "2e",
  "10983": "2e",
  "13850": "2e",
  "10168": "2e",
  "12186": "2e",
  "14059": "1e",
  "12204": "2e",
  "10996": "2e",
  "10567": "2e",
  "14001": "1e",
  "13066": "1e",
  "10596": "2e",
  "12059": "2e",
  "10519": "2e",
  "55350": "1w",
  "56207": "1w",
  "56518": "1w",
  "56265": "1w",
  "56442": "1w",
  "56050": "1w",
  "55370": "1w",
  "55432": "1w",
  "55395": "1w",
  "55795": "1w",
  "52064": "2w",
  "50130": "2w",
  "51063": "2w",
  "51455": "2w",
  "50590": "1w",
  "51651": "2w",
  "52056": "2w",
  "51015": "2w",
  "50040": "2w",
  "50227": "2w",
  "52701": "2w",
  "52595": "2w",
  "51537": "2w",
  "50660": "2w",
  "50002": "2w",
  "51454": "2w",
  "50049": "2w",
  "50158": "2w",
  "52237": "2w",
  "52075": "2w",
  "50579": "2w",
  "50162": "2w",
  "52251": "2w",
  "52140": "1w",
  "52060": "2w",
  "50273": "2w",
  "50565": "2w",
  "52563": "2w",
  "50123": "2w",
  "52213": "2w",
  "51573": "2w",
  "50613": "2w",
  "50680": "2w",
  "51056": "2w",
  "50222": "2w",
  "52332": "2w",
  "50601": "2w",
  "50515": "1w",
  "52221": "2w",
  "50519": "1w",
  "51062": "2w",
  "51654": "2w",
  "50529": "2w",
  "52659": "2w",
  "50516": "2w",
  "52536": "2w",
  "51035": "2w",
  "52647": "2w",
  "52338": "2w",
  "52003": "2w",
  "50161": "2w",
  "50023": "2w",
  "50201": "2w",
  "50238": "2w",
  "51534": "2w",
  "52047": "1w",
  "52072": "1w",
  "52079": "2w",
  "50840": "2w",
  "52586": "2w",
  "50650": "2w",
  "50128": "2w",
  "50556": "1w",
  "50170": "2w",
  "50046": "2w",
  "50703": "2w",
  "50312": "2w",
  "50843": "2w",
  "51243": "1w",
  "50124": "2w",
  "52535": "2w",
  "07066": "2e",
  "07608": "2e",
  "08723": "2e",
  "08088": "2e",
  "08008": "2e",
  "07748": "2e",
  "08036": "2e",
  "07760": "2e",
  "07753": "2e",
  "07764": "2e",
  "07751": "2e",
  "07722": "2e",
  "07755": "2e",
  "08720": "2e",
  "07702": "2e",
  "08240": "2e",
  "07747": "2e",
  "07102": "2e",
  "08558": "2e",
  "08540": "2e",
  "07920": "2e",
  "95407": "7",
  "94928": "7",
  "94924": "7",
  "94599": "7",
  "94930": "7",
  "94956": "7",
  "91302": "6",
  "91604": "6",
  "91356": "6",
  "94945": "7",
  "94507": "7",
  "91745": "6",
  "91767": "6",
  "91789": "6",
  "91792": "6",
  "94517": "7",
  "91723": "6",
  "94526": "7",
  "94960": "7",
  "90094": "6",
  "94704": "7",
  "91201": "6",
  "91204": "6",
  "91016": "6",
  "91006": "6",
  "91007": "6",
  "94539": "7",
  "95124": "7",
  "95116": "7",
  "95110": "7",
  "95122": "7",
  "95138": "7",
  "95129": "7",
  "95054": "7",
  "94022": "7",
  "94028": "7",
  "92612": "6",
  "94129": "7",
  "92706": "6",
  "92627": "6",
  "90703": "6",
  "94080": "7",
  "90840": "6",
  "94063": "7",
  "94065": "7",
  "94020": "7",
  "94027": "7",
  "94038": "7",
  "93534": "6",
  "92222": "6",
  "91042": "6",
  "91354": "6",
  "91040": "6",
  "95982": "7",
  "95431": "7",
  "92647": "6",
  "91364": "6",
  "94940": "7",
  "94582": "7",
  "94597": "7",
  "94605": "7",
  "91744": "6",
  "94547": "7",
  "94506": "7",
  "94513": "7",
  "91706": "6",
  "91330": "6",
  "94556": "7",
  "94609": "7",
  "91501": "6",
  "91502": "6",
  "91208": "6",
  "91205": "6",
  "91011": "6",
  "94502": "7",
  "95112": "7",
  "94550": "7",
  "94566": "7",
  "90603": "6",
  "95136": "7",
  "95121": "7",
  "95111": "7",
  "95135": "7",
  "95120": "7",
  "95070": "7",
  "11709": "2e",
  "12922": "1e",
  "13333": "2e",
  "13488": "2e",
  "12064": "2e",
  "13861": "2e",
  "13148": "1e",
  "12758": "2e",
  "12740": "2e",
  "12175": "2e",
  "14869": "2e",
  "14804": "2e",
  "12458": "2e",
  "14779": "2e",
  "13620": "1e",
  "14557": "1e",
  "14013": "1e",
  "12409": "2e",
  "12915": "1e",
  "14536": "2e",
  "14735": "2e",
  "12723": "2e",
  "12789": "2e",
  "14521": "2e",
  "12983": "1e",
  "12790": "2e",
  "14707": "2e",
  "12410": "2e",
  "12139": "1e",
  "12736": "2e",
  "12767": "2e",
  "12435": "2e",
  "12404": "2e",
  "12464": "2e",
  "12719": "2e",
  "12792": "2e",
  "12745": "2e",
  "12777": "2e",
  "12411": "2e",
  "14011": "1e",
  "12781": "2e",
  "12750": "2e",
  "13815": "2e",
  "12993": "1e",
  "12932": "1e",
  "14741": "2e",
  "14039": "1e",
  "12974": "1e",
  "13788": "2e",
  "12946": "1e",
  "14550": "2e",
  "13782": "2e",
  "14082": "2e",
  "12474": "2e",
  "12459": "2e",
  "10530": "2e",
  "10167": "2e",
  "10169": "2e",
  "14830": "2e",
  "11752": "2e",
  "10911": "2e",
  "10994": "2e",
  "12721": "2e",
  "10103": "2e",
  "10112": "2e",
  "10993": "2e",
  "10984": "2e",
  "14218": "1e",
  "13329": "1e",
  "11569": "2e",
  "13057": "1e",
  "13088": "1e",
  "12785": "2e",
  "06085": "2e",
  "06790": "2e",
  "06482": "2e",
  "06470": "2e",
  "06763": "2e",
  "06750": "2e",
  "06478": "2e",
  "06477": "2e",
  "06450": "2e",
  "06810": "2e",
  "06455": "2e",
  "06481": "2e",
  "06106": "2e",
  "06088": "2e",
  "06114": "2e",
  "06082": "2e",
  "06831": "2e",
  "06403": "2e",
  "06035": "2e",
  "06795": "2e",
  "06870": "2e",
  "06456": "2e",
  "61614": "2e",
  "60556": "2e",
  "61523": "2e",
  "61526": "2e",
  "61565": "2e",
  "62615": "2e",
  "61552": "2e",
  "62536": "2e",
  "62689": "2e",
  "60402": "2e",
  "62532": "2e",
  "61732": "2e",
  "61073": "2e",
  "62037": "2w",
  "61455": "2e",
  "62280": "3e",
  "60901": "2e",
  "61831": "2e",
  "60919": "2e",
  "60468": "2e",
  "60632": "2e",
  "61844": "2e",
  "61816": "2e",
  "61459": "2e",
  "61883": "2e",
  "60033": "2e",
  "61434": "2e",
  "61416": "2e",
  "62812": "3e",
  "61747": "2e",
  "62921": "3e",
  "61025": "2e",
  "62441": "2e",
  "61059": "2e",
  "60630": "2e",
  "61733": "2e",
  "61771": "2e",
  "61062": "2e",
  "61570": "2e",
  "60201": "2e",
  "61233": "2e",
  "61412": "2e",
  "61442": "2w",
  "62860": "3e",
  "60642": "2e",
  "60661": "2e",
  "61525": "2e",
  "62692": "2e",
  "61115": "2e",
  "61088": "2e",
  "61536": "2e",
  "61728": "2e",
  "61726": "2e",
  "61753": "2e",
  "61616": "2e",
  "62712": "2e",
  "62661": "2e",
  "61079": "2e",
  "61559": "2e",
  "61607": "2e",
  "62063": "2e",
  "60960": "2e",
  "61729": "2e",
  "61723": "2e",
  "61475": "2e",
  "60935": "2e",
  "62365": "2e",
  "60914": "2e",
  "61840": "2e",
  "61012": "2e",
  "61571": "2e",
  "61568": "2e",
  "61759": "2e",
  "61611": "2e",
  "61239": "2e",
  "61534": "2e",
  "62257": "2e",
  "62933": "3e",
  "61870": "2e",
  "62896": "3e",
  "61278": "2e",
  "61452": "2e",
  "62974": "3e",
  "62935": "3e",
  "61053": "2e",
  "60622": "2e",
  "61259": "2e",
  "61241": "2e",
  "61254": "2e",
  "61274": "2e",
  "62883": "2e",
  "61413": "2e",
  "62894": "2e",
  "62836": "2e",
  "62801": "2e",
  "62856": "3e",
  "62851": "2e",
  "60624": "2e",
  "60187": "2e",
  "62442": "2e",
  "62046": "2e",
  "62001": "2e",
  "62275": "2e",
  "62067": "2e",
  "62243": "2e",
  "21087": "2e",
  "21162": "2e",
  "21078": "2e",
  "21821": "3e",
  "20770": "2e",
  "21645": "2e",
  "20866": "2e",
  "21113": "2e",
  "20676": "3e",
  "20722": "2e",
  "20602": "2e",
  "20632": "3e",
  "21669": "3e",
  "21152": "2e",
  "21661": "2e",
  "21715": "2e",
  "21023": "2e",
  "21031": "2e",
  "21219": "2e",
  "20906": "2e",
  "20714": "2e",
  "20711": "2e",
  "20882": "2e",
  "20733": "2e",
  "20607": "2e",
  "21204": "2e",
  "20841": "2e",
  "20735": "2e",
  "21042": "2e",
  "21794": "2e",
  "21723": "2e",
  "21790": "2e",
  "20764": "2e",
  "20746": "2e",
  "20601": "2e",
  "20618": "3e",
  "20629": "3e",
  "21617": "2e",
  "21114": "2e",
  "20609": "3e",
  "21610": "2e",
  "20759": "2e",
  "21053": "2e",
  "21542": "2e",
  "21130": "2e",
  "21762": "2e",
  "20603": "2e",
  "21644": "2e",
  "20742": "2e",
  "21863": "3e",
  "21634": "3e",
  "21648": "3e",
  "21660": "2e",
  "20658": "3e",
  "21624": "2e",
  "21659": "3e",
  "21612": "2e",
  "21740": "2e",
  "21822": "3e",
  "21767": "2e",
  "21911": "2e",
  "21234": "2e",
  "21830": "3e",
  "21810": "3e",
  "21780": "2e",
  "21030": "2e",
  "21117": "2e",
  "21133": "2e",
  "21082": "2e",
  "21227": "2e",
  "21237": "2e",
  "21903": "2e",
  "20740": "2e",
  "21838": "3e",
  "20619": "3e",
  "20737": "2e",
  "20912": "2e",
  "21037": "2e",
  "21727": "2e",
  "21787": "2e",
  "21778": "2e",
  "20781": "2e",
  "21620": "2e",
  "21651": "2e",
  "21240": "2e",
  "20842": "2e",
  "21052": "2e",
  "20751": "2e",
  "21703": "2e",
  "21286": "2e",
  "20776": "2e",
  "21716": "2e",
  "21012": "2e",
  "21043": "2e",
  "21401": "2e",
  "20634": "3e",
  "21046": "2e",
  "27565": "3e",
  "27831": "3e",
  "28751": "3e",
  "28102": "4",
  "27985": "3e",
  "27917": "3e",
  "28431": "3e",
  "28604": "3e",
  "28009": "3e",
  "28653": "3e",
  "27892": "3e",
  "28676": "3e",
  "28438": "3e",
  "28463": "4",
  "28774": "3e",
  "28587": "3e",
  "28779": "3e",
  "27551": "3e",
  "28556": "3e",
  "27553": "3e",
  "27986": "3e",
  "28554": "3e",
  "27983": "3e",
  "27306": "3e",
  "28357": "3e",
  "28747": "3e",
  "28533": "3e",
  "28019": "3e",
  "27509": "3e",
  "28516": "3e",
  "27948": "3e",
  "27938": "3e",
  "27920": "3e",
  "27841": "3e",
  "28775": "4",
  "27709": "3e",
  "77547": "4",
  "78666": "6",
  "78140": "6",
  "77011": "4",
  "77023": "4",
  "77520": "4",
  "77085": "4",
  "77336": "4",
  "77536": "4",
  "77055": "4",
  "77006": "4",
  "77598": "4",
  "77051": "4",
  "77014": "4",
  "77334": "3w",
  "78338": "4",
  "75103": "3w",
  "75780": "3w",
  "75779": "3w",
  "79325": "2w",
  "76549": "6",
  "76569": "6",
  "76571": "6",
  "77625": "4",
  "75454": "3w",
  "78704": "6",
  "79034": "2w",
  "76443": "6",
  "78125": "6",
  "75437": "3w",
  "75074": "3w",
  "78652": "6",
  "78738": "6",
  "78664": "6",
  "78753": "6",
  "78728": "6",
  "75167": "3w",
  "76651": "3w",
  "76626": "3w",
  "76108": "3w",
  "64453": "2w",
  "65625": "3w",
  "65032": "2w",
  "63748": "3w",
  "64646": "2w",
  "64776": "2w",
  "65692": "3w",
  "64759": "2w",
  "63443": "2w",
  "63822": "3w",
  "65775": "3w",
  "65779": "2w",
  "64461": "2w",
  "65333": "2w",
  "65662": "2w",
  "65608": "3w",
  "65348": "2w",
  "64637": "2w",
  "65559": "2w",
  "65462": "2w",
  "63379": "2w",
  "64744": "2w",
  "63387": "2w",
  "65529": "2w",
  "63662": "3w",
  "65449": "2w",
  "63060": "2w",
  "63091": "2w",
  "65734": "3w",
  "63860": "3w",
  "65247": "2w",
  "65543": "2w",
  "64874": "3w",
  "64832": "2w",
  "64720": "2w",
  "64867": "3w",
  "64861": "3w",
  "64089": "2w",
  "63138": "2e",
  "63033": "2w",
  "63126": "2w",
  "65109": "2w",
  "64117": "2w",
  "64075": "2w",
  "64746": "2w",
  "64494": "2w",
  "63113": "2w",
  "63011": "2w",
  "63040": "2w",
  "63005": "2w",
  "64106": "2w",
  "64730": "2w",
  "65630": "3w",
  "64842": "3w",
  "64067": "2w",
  "64422": "2w",
  "65631": "3w",
  "65339": "2w",
  "65059": "2w",
  "64723": "2w",
  "64836": "2w",
  "64734": "2w",
  "64166": "2w",
  "64083": "2w",
  "65745": "3w",
  "64801": "2w",
  "64126": "2w",
  "64078": "2w",
  "64834": "2w",
  "64865": "3w",
  "64151": "2w",
  "02379": "2e",
  "02673": "2e",
  "02540": "2e",
  "02543": "2e",
  "01236": "2e",
  "01079": "2e",
  "01245": "2e",
  "01270": "2e",
  "01343": "2e",
  "01026": "2e",
  "02357": "2e",
  "01590": "2e",
  "01066": "2e",
  "01053": "2e",
  "01851": "2e",
  "01845": "2e",
  "01834": "2e",
  "02026": "2e",
  "02056": "2e",
  "02368": "2e",
  "01719": "2e",
  "02476": "2e",
  "02462": "2e",
  "02464": "2e",
  "01778": "2e",
  "01742": "2e",
  "55782": "1w",
  "55718": "1w",
  "56323": "1w",
  "56710": "1w",
  "55796": "1w",
  "56114": "1w",
  "56281": "1w",
  "55036": "1w",
  "55450": "1w",
  "56153": "1w",
  "56375": "1w",
  "56686": "1w",
  "56623": "1w",
  "56128": "1w",
  "56332": "1w",
  "55112": "1w",
  "56572": "1w",
  "55051": "1w",
  "56025": "1w",
  "56661": "1w",
  "56628": "1w",
  "56082": "1w",
  "56481": "1w",
  "56244": "1w",
  "50140": "2w",
  "52155": "1w",
  "50576": "2w",
  "50624": "2w",
  "50642": "2w",
  "50247": "2w",
  "52548": "2w",
  "52220": "2w",
  "51401": "2w",
  "51005": "2w",
  "50070": "2w",
  "51531": "2w",
  "50457": "1w",
  "51451": "2w",
  "52307": "2w",
  "50621": "2w",
  "52159": "1w",
  "50609": "2w",
  "51031": "2w",
  "08046": "2e",
  "08562": "2e",
  "07762": "2e",
  "08701": "2e",
  "08514": "2e",
  "08742": "2e",
  "08005": "2e",
  "07732": "2e",
  "08732": "2e",
  "08736": "2e",
  "08555": "2e",
  "08205": "2e",
  "08034": "2e",
  "08009": "2e",
  "08340": "2e",
  "01952": "2e",
  "01826": "2e",
  "01985": "2e",
  "01469": "2e",
  "02090": "2e",
  "02052": "2e",
  "01746": "2e",
  "02030": "2e",
  "02466": "2e",
  "02420": "2e",
  "02421": "2e",
  "01821": "2e",
  "01890": "2e",
  "02451": "2e",
  "01867": "2e",
  "01862": "2e",
  "01463": "2e",
  "01827": "2e",
  "01225": "2e",
  "02738": "2e",
  "02780": "2e",
  "02492": "2e",
  "02066": "2e",
  "02366": "2e",
  "02350": "2e",
  "02199": "2e",
  "02445": "2e",
  "02670": "2e",
  "02118": "2e",
  "02110": "2e",
  "02128": "2e",
  "02744": "2e",
  "02125": "2e",
  "01338": "2e",
  "01330": "2e",
  "02124": "2e",
  "02126": "2e",
  "01367": "2e",
  "02745": "2e",
  "01905": "2e",
  "01907": "2e",
  "01949": "2e",
  "02568": "2e",
  "01930": "2e",
  "01604": "2e",
  "01564": "2e",
  "01542": "2e",
  "02791": "2e",
  "02719": "2e",
  "01453": "2e",
  "01118": "2e",
  "01581": "2e",
  "01536": "2e",
  "01434": "2e",
  "01028": "2e",
  "01570": "2e",
  "01201": "2e",
  "01077": "2e",
  "01056": "2e",
  "01235": "2e",
  "01255": "2e",
  "17007": "2e",
  "16438": "2e",
  "15931": "2e",
  "17540": "2e",
  "15927": "2e",
  "17065": "2e",
  "16624": "2e",
  "19560": "2e",
  "15958": "2e",
  "19522": "2e",
  "15925": "2e",
  "17516": "2e",
  "18056": "2e",
  "15921": "2e",
  "17582": "2e",
  "18091": "2e",
  "19144": "2e",
  "17408": "2e",
  "17301": "2e",
  "18210": "2e",
  "15928": "2e",
  "17365": "2e",
  "17103": "2e",
  "15520": "2e",
  "17323": "2e",
  "15532": "2e",
  "15530": "2e",
  "15542": "2e",
  "17370": "2e",
  "17345": "2e",
  "17109": "2e",
  "17311": "2e",
  "17329": "2e",
  "19053": "2e",
  "18507": "2e",
  "18930": "2e",
  "18976": "2e",
  "15232": "2e",
  "18932": "2e",
  "18081": "2e",
  "17243": "2e",
  "16033": "2e",
  "16061": "2e",
  "15363": "2e",
  "19106": "2e",
  "16505": "2e",
  "18237": "2e",
  "16105": "2e",
  "18214": "2e",
  "18252": "2e",
  "18245": "2e",
  "17983": "2e",
  "17941": "2e",
  "73041": "3w",
  "74536": "3w",
  "74574": "3w",
  "74543": "3w",
  "74859": "3w",
  "73446": "3w",
  "74734": "3w",
  "73020": "3w",
  "74948": "3w",
  "84317": "5",
  "84790": "5",
  "84765": "5",
  "84780": "5",
  "84311": "5",
  "84763": "5",
  "84537": "5",
  "84657": "5",
  "84701": "5",
  "84662": "5",
  "84773": "5",
  "84634": "5",
  "61770": "2e",
  "61843": "2e",
  "61754": "2e",
  "61420": "2e",
  "62052": "2e",
  "62338": "2e",
  "61470": "2e",
  "62666": "2e",
  "62274": "2e",
  "61858": "2e",
  "62347": "2e",
  "62975": "3e",
  "61038": "2e",
  "60949": "2e",
  "60969": "2e",
  "62950": "3w",
  "61815": "2e",
  "62901": "3e",
  "61810": "2e",
  "61411": "2e",
  "61851": "2e",
  "60964": "2e",
  "62959": "3e",
  "60623": "2e",
  "61744": "2e",
  "61438": "2e",
  "61745": "2e",
  "61737": "2e",
  "62320": "2e",
  "62324": "2e",
  "62924": "3e",
  "61848": "2e",
  "60135": "2e",
  "60941": "2e",
  "60609": "2e",
  "61859": "2e",
  "61846": "2e",
  "61880": "2e",
  "60416": "2e",
  "61277": "2e",
  "61938": "2e",
  "61378": "2e",
  "61704": "2e",
  "61701": "2e",
  "62573": "2e",
  "62551": "2e",
  "60548": "2e",
  "60634": "2e",
  "61772": "2e",
  "60638": "2e",
  "61625": "2e",
  "61882": "2e",
  "62670": "2e",
  "62684": "2e",
  "62613": "2e",
  "61111": "2e",
  "62545": "2e",
  "61024": "2e",
  "60942": "2e",
  "61853": "2e",
  "61877": "2e",
  "61857": "2e",
  "60640": "2e",
  "61550": "2e",
  "61036": "2e",
  "62374": "2e",
  "61001": "2e",
  "61275": "2e",
  "61089": "2e",
  "61048": "2e",
  "62915": "3e",
  "61419": "2e",
  "60505": "2e",
  "62967": "3e",
  "61074": "2e",
  "62682": "2e",
  "60521": "2e",
  "61232": "2e",
  "60409": "2e",
  "61361": "2e",
  "60302": "2e",
  "62891": "3e",
  "62872": "2e",
  "62859": "3e",
  "62423": "2e",
  "61943": "2e",
  "62478": "2e",
  "60649": "2e",
  "60617": "2e",
  "62090": "2e",
  "62449": "2e",
  "62034": "2e",
  "62258": "2e",
  "62208": "2e",
  "96110": "5",
  "95983": "5",
  "90270": "6",
  "90402": "6",
  "96050": "7",
  "95350": "7",
  "95526": "7",
  "90504": "6",
  "90210": "6",
  "92328": "5",
  "92384": "5",
  "93527": "6",
  "91784": "6",
  "93022": "7",
  "95341": "7",
  "95960": "6",
  "96090": "7",
  "95333": "6",
  "90631": "6",
  "93622": "7",
  "93274": "6",
  "93460": "7",
  "95969": "6",
  "93737": "6",
  "93635": "7",
  "92115": "6",
  "95319": "7",
  "95958": "7",
  "93266": "6",
  "95383": "6",
  "91737": "6",
  "95335": "6",
  "93030": "6",
  "95307": "7",
  "91945": "6",
  "95210": "7",
  "95974": "7",
  "93741": "6",
  "93219": "6",
  "92410": "6",
  "95832": "7",
  "93222": "6",
  "95831": "7",
  "95968": "6",
  "95305": "6",
  "95632": "7",
  "95686": "7",
  "95258": "7",
  "92136": "6",
  "92405": "6",
  "90260": "6",
  "90401": "6",
  "96014": "7",
  "38873": "3e",
  "39272": "4",
  "39145": "4",
  "39094": "4",
  "39071": "4",
  "39561": "4",
  "39337": "4",
  "39110": "4",
  "39572": "4",
  "39529": "4",
  "39439": "4",
  "38952": "3e",
  "38944": "3e",
  "39355": "4",
  "38618": "3e",
  "38626": "3e",
  "39645": "4",
  "38953": "3e",
  "38849": "3e",
  "39665": "4",
  "38668": "3e",
  "38878": "4",
  "38929": "4",
  "38870": "4",
  "39096": "4",
  "38821": "4",
  "39363": "4",
  "38856": "3e",
  "39668": "4",
  "39362": "4",
  "38957": "3e",
  "38761": "4",
  "38726": "3e",
  "38620": "3e",
  "38949": "3e",
  "39162": "4",
  "38859": "3e",
  "38863": "3e",
  "39367": "4",
  "39767": "4",
  "38771": "3e",
  "39744": "4",
  "39769": "4",
  "38614": "3e",
  "38659": "3e",
  "38925": "4",
  "39601": "4",
  "38834": "3e",
  "39459": "4",
  "39464": "4",
  "39466": "4",
  "33711": "4",
  "33174": "4",
  "33101": "4",
  "35951": "4",
  "30627": "4",
  "30741": "4",
  "31303": "4",
  "31098": "4",
  "30739": "4",
  "31805": "4",
  "30101": "4",
  "31326": "4",
  "30034": "4",
  "30002": "4",
  "31005": "4",
  "36089": "4",
  "35085": "4",
  "35045": "4",
  "36314": "4",
  "36919": "4",
  "36028": "4",
  "36255": "4",
  "35082": "4",
  "36267": "4",
  "30322": "4",
  "31031": "4",
  "33993": "4",
  "33441": "4",
  "33064": "4",
  "34291": "4",
  "33131": "4",
  "35040": "4",
  "35185": "4",
  "30738": "4",
  "30288": "4",
  "30707": "4",
  "31091": "4",
  "30446": "4",
  "30021": "4",
  "30035": "4",
  "36460": "4",
  "36445": "4",
  "36053": "4",
  "30752": "4",
  "33414": "4",
  "33432": "4",
  "33434": "4",
  "34135": "4",
  "33175": "4",
  "33498": "4",
  "33433": "4",
  "33493": "4",
  "36916": "4",
  "36446": "4",
  "36545": "4",
  "36910": "4",
  "30260": "4",
  "30273": "4",
  "30106": "4",
  "30534": "4",
  "30111": "4",
  "30726": "4",
  "30122": "4",
  "33055": "4",
  "33476": "4",
  "32806": "4",
  "36782": "4",
  "28509": "3e",
  "27209": "3e",
  "28350": "3e",
  "28378": "3e",
  "27507": "3e",
  "27846": "3e",
  "28708": "3e",
  "28649": "3e",
  "28362": "4",
  "28763": "3e",
  "28615": "3e",
  "28385": "3e",
  "28579": "3e",
  "28076": "3e",
  "28511": "3e",
  "28575": "3e",
  "28666": "3e",
  "27537": "3e",
  "27262": "3e",
  "27012": "3e",
  "28117": "3e",
  "28660": "3e",
  "28636": "3e",
  "27516": "3e",
  "28628": "3e",
  "27320": "3e",
  "28075": "3e",
  "27214": "3e",
  "27604": "3e",
  "27101": "3e",
  "27858": "3e",
  "28280": "3e",
  "28584": "3e",
  "27530": "3e",
  "28555": "3e",
  "27851": "3e",
  "27104": "3e",
  "27896": "3e",
  "27707": "3e",
  "28303": "3e",
  "27703": "3e",
  "27884": "3e",
  "27852": "3e",
  "28805": "3e",
  "27524": "3e",
  "27712": "3e",
  "28209": "3e",
  "28384": "3e",
  "28277": "3e",
  "27023": "3e",
  "28613": "3e",
  "27401": "3e",
  "27501": "3e",
  "27504": "3e",
  "27046": "3e",
  "27546": "3e",
  "27332": "3e",
  "28080": "3e",
  "27526": "3e",
  "27592": "3e",
  "27330": "3e",
  "28690": "3e",
  "27256": "3e",
  "28630": "3e",
  "28108": "3e",
  "28120": "3e",
  "28411": "3e",
  "27301": "3e",
  "27283": "3e",
  "28605": "3e",
  "28056": "3e",
  "27316": "3e",
  "28036": "3e",
  "28624": "3e",
  "28146": "3e",
  "27576": "3e",
  "27593": "3e",
  "28039": "3e",
  "27573": "3e",
  "27832": "3e",
  "28421": "3e",
  "28435": "3e",
  "28679": "3e",
  "43103": "2e",
  "45773": "2e",
  "43566": "2e",
  "43341": "2e",
  "45875": "2e",
  "43547": "2e",
  "45864": "2e",
  "43462": "2e",
  "44040": "2e",
  "44250": "2e",
  "45328": "2e",
  "43523": "2e",
  "43961": "2e",
  "45876": "2e",
  "45051": "2e",
  "44049": "2e",
  "29720": "4",
  "29906": "4",
  "29506": "4",
  "29418": "4",
  "29054": "4",
  "29851": "4",
  "29842": "4",
  "29424": "4",
  "29834": "4",
  "29941": "4",
  "29346": "4",
  "29555": "4",
  "29365": "4",
  "29038": "4",
  "29039": "4",
  "29207": "4",
  "29672": "4",
  "29325": "4",
  "29355": "4",
  "29732": "3e",
  "29102": "4",
  "29590": "4",
  "29563": "4",
  "29493": "4",
  "29510": "4",
  "29475": "4",
  "29486": "4",
  "29425": "4",
  "29117": "4",
  "29899": "4",
  "29323": "3e",
  "29334": "4",
  "29385": "4",
  "29376": "4",
  "29831": "4",
  "29449": "4",
  "29206": "4",
  "29059": "4",
  "29706": "4",
  "29829": "4",
  "29453": "4",
  "29468": "4",
  "29306": "4",
  "29712": "4",
  "29714": "4",
  "29690": "3e",
  "29609": "4",
  "29406": "4",
  "29485": "4",
  "29697": "4",
  "29129": "4",
  "29661": "3e",
  "29902": "4",
  "29631": "4",
  "29063": "4",
  "29689": "4",
  "29581": "4",
  "29062": "4",
  "29078": "4",
  "29541": "4",
  "29168": "4",
  "29209": "4",
  "29146": "4",
  "29915": "4",
  "24280": "3e",
  "24020": "3e",
  "24601": "3e",
  "22548": "3e",
  "23455": "3e",
  "24226": "3e",
  "24283": "3e",
  "23454": "3e",
  "23452": "3e",
  "22654": "2e",
  "22472": "3e",
  "24382": "3e",
  "22602": "2e",
  "22637": "2e",
  "23690": "3e",
  "24523": "3e",
  "24131": "3e",
  "24121": "3e",
  "24018": "3e",
  "24614": "3e",
  "22520": "3e",
  "22134": "3e",
  "24557": "3e",
  "23666": "3e",
  "23222": "3e",
  "24590": "3e",
  "24541": "3e",
  "22932": "3e",
  "22959": "3e",
  "24646": "3e",
  "24639": "3e",
  "24168": "3e",
  "23651": "3e",
  "24069": "3e",
  "22850": "3e",
  "22938": "3e",
  "25211": "3e",
  "26818": "2e",
  "26222": "3e",
  "26847": "2e",
  "26810": "2e",
  "26631": "3e",
  "25514": "3e",
  "25862": "3e",
  "26041": "2e",
  "25057": "3e",
  "26039": "2e",
  "25109": "3e",
  "25011": "3e",
  "25703": "3e",
  "25301": "3e",
  "24910": "3e",
  "25813": "3e",
  "24736": "3e",
  "25908": "3e",
  "25820": "3e",
  "25843": "3e",
  "25989": "3e",
  "25977": "3e",
  "25827": "3e",
  "25932": "3e",
  "25174": "3e",
  "25810": "3e",
  "26036": "2e",
  "26055": "2e",
  "25025": "3e",
  "25132": "3e",
  "25102": "3e",
  "25162": "3e",
  "25177": "3e",
  "25060": "3e",
  "25048": "3e",
  "25044": "3e",
  "25832": "3e",
  "25007": "3e",
  "25304": "3e",
  "25976": "3e",
  "25985": "3e",
  "25878": "3e",
  "24918": "3e",
  "24874": "3e",
  "26852": "2e",
  "26719": "2e",
  "24880": "3e",
  "24726": "3e",
  "26374": "2e",
  "26542": "2e",
  "26275": "2e",
  "26238": "2e",
  "26405": "2e",
  "26267": "2e",
  "26257": "2e",
  "26452": "2e",
  "26372": "2e",
  "26161": "2e",
  "25244": "2e",
  "25245": "3e",
  "26269": "2e",
  "26714": "2e",
  "25264": "2e",
  "26327": "2e",
  "26280": "3e",
  "26435": "2e",
  "26638": "2e",
  "25261": "2e",
  "26448": "2e",
  "25443": "2e",
  "24991": "3e",
  "26037": "2e",
  "26408": "2e",
  "26261": "3e",
  "24993": "3e",
  "25962": "3e",
  "26591": "2e",
  "26463": "2e",
  "26203": "3e",
  "24931": "3e",
  "26679": "3e",
  "24974": "3e",
  "25501": "3e",
  "24957": "3e",
  "25651": "3e",
  "25130": "3e",
  "24855": "3e",
  "25142": "3e",
  "25606": "3e",
  "24808": "3e",
  "25523": "3e",
  "25544": "3e",
  "25670": "3e",
  "24826": "3e",
  "24872": "3e",
  "24878": "3e",
  "44070": "2e",
  "44120": "2e",
  "44017": "2e",
  "44102": "2e",
  "43830": "2e",
  "44423": "2e",
  "43732": "2e",
  "44306": "2e",
  "44302": "2e",
  "45331": "2e",
  "45342": "2e",
  "44128": "2e",
  "44666": "2e",
  "43105": "2e",
  "44640": "2e",
  "44236": "2e",
  "44285": "2e",
  "44630": "2e",
  "44103": "2e",
  "44052": "2e",
  "44507": "2e",
  "44511": "2e",
  "44837": "2e",
  "44857": "2e",
  "44485": "2e",
  "44417": "2e",
  "45320": "2e",
  "45344": "2e",
  "44253": "2e",
  "44251": "2e",
  "44609": "2e",
  "44430": "2e",
  "44855": "2e",
  "44446": "2e",
  "45660": "2e",
  "45431": "2e",
  "45638": "3e",
  "43432": "2e",
  "43553": "2e",
  "45819": "2e",
  "44235": "2e",
  "45369": "2e",
  "45216": "2e",
  "45315": "2e",
  "43154": "2e",
  "44626": "2e",
  "44503": "2e",
  "45692": "2e",
  "45685": "2e",
  "44441": "2e",
  "43520": "2e",
  "45642": "2e",
  "44853": "2e",
  "43319": "2e",
  "43060": "2e",
  "45354": "2e",
  "44140": "2e",
  "43802": "2e",
  "20006": "2e",
  "20052": "2e",
  "20317": "2e",
  "20007": "2e",
  "20260": "2e",
  "20020": "2e",
  "20019": "2e",
  "20018": "2e",
  "20240": "2e",
  "20408": "2e",
  "20560": "2e",
  "59315": "1w",
  "59424": "5",
  "59064": "5",
  "59759": "5",
  "59714": "5",
  "59466": "5",
  "59937": "5",
  "59718": "5",
  "59412": "5",
  "32707": "4",
  "33716": "4",
  "33786": "4",
  "34689": "4",
  "34688": "4",
  "33767": "4",
  "34681": "4",
  "32714": "4",
  "31062": "4",
  "34639": "4",
  "32163": "4",
  "33947": "4",
  "34769": "4",
  "34606": "4",
  "32063": "4",
  "34602": "4",
  "34773": "4",
  "32046": "4",
  "32955": "4",
  "32905": "4",
  "32137": "4",
  "32970": "4",
  "34607": "4",
  "33965": "4",
  "32904": "4",
  "32903": "4",
  "33322": "4",
  "33325": "4",
  "32899": "4",
  "32775": "4",
  "32763": "4",
  "33388": "4",
  "33022": "4",
  "36201": "4",
  "35904": "4",
  "32502": "4",
  "33469": "4",
  "32667": "4",
  "36206": "4",
  "36106": "4",
  "30635": "4",
  "36607": "4",
  "31405": "4",
  "32601": "4",
  "35805": "3e",
  "30506": "4",
  "30901": "4",
  "35622": "4",
  "36575": "4",
  "36611": "4",
  "36069": "4",
  "36525": "4",
  "32407": "4",
  "32609": "4",
  "32044": "4",
  "31707": "4",
  "34994": "4",
  "33930": "4",
  "33610": "4",
  "34491": "4",
  "33901": "4",
  "33147": "4",
  "32202": "4",
  "34472": "4",
  "34201": "4",
  "34232": "4",
  "33602": "4",
  "32702": "4",
  "30303": "4",
  "30124": "4",
  "75568": "3w",
  "75457": "3w",
  "78872": "6",
  "79040": "2w",
  "79511": "6",
  "79257": "3w",
  "78070": "6",
  "79512": "6",
  "79087": "2w",
  "78879": "6",
  "75450": "3w",
  "78385": "4",
  "79057": "2w",
  "76531": "6",
  "79312": "6",
  "75788": "3w",
  "75603": "3w",
  "75856": "3w",
  "78058": "6",
  "78635": "6",
  "75228": "3w",
  "77036": "4",
  "76309": "3w",
  "78597": "4",
  "79602": "6",
  "75217": "3w",
  "77494": "4",
  "77356": "3w",
  "77498": "4",
  "77318": "4",
  "77650": "4",
  "77306": "4",
  "77380": "4",
  "77302": "4",
  "77482": "4",
  "77489": "4",
  "77082": "4",
  "77578": "4",
  "77465": "4",
  "77456": "4",
  "79027": "2w",
  "79506": "6",
  "75972": "4",
  "78026": "6",
  "79781": "6",
  "79556": "6",
  "79331": "6",
  "76433": "3w",
  "76519": "6",
  "75446": "3w",
  "76856": "6",
  "77426": "3w",
  "79730": "6",
  "79549": "6",
  "79059": "2w",
  "78951": "6",
  "76431": "3w",
  "76448": "6",
  "79070": "2w",
  "76841": "6",
  "78145": "6",
  "78119": "6",
  "79848": "6",
  "78022": "6",
  "79738": "6",
  "75487": "3w",
  "75572": "3w",
  "79370": "6",
  "79845": "6",
  "78618": "6",
  "78663": "6",
  "78358": "4",
  "79068": "2w",
  "78361": "6",
  "75668": "3w",
  "78873": "6",
  "75560": "3w",
  "78669": "6",
  "76849": "6",
  "79783": "6",
  "76453": "3w",
  "75672": "3w",
  "75554": "3w",
  "78017": "6",
  "76857": "6",
  "79098": "2w",
  "79742": "6",
  "75566": "3w",
  "78142": "6",
  "75426": "3w",
  "75847": "3w",
  "76866": "6",
  "79832": "6",
  "76634": "3w",
  "79533": "6",
  "75077": "3w",
  "78560": "4",
  "79541": "6",
  "52168": "1w",
  "52737": "2w",
  "50110": "2w",
  "50152": "2w",
  "50649": "2w",
  "51630": "2w",
  "50218": "2w",
  "52232": "2w",
  "51026": "2w",
  "52136": "1w",
  "52301": "2w",
  "51577": "2w",
  "50078": "2w",
  "56236": "1w",
  "55130": "1w",
  "56111": "1w",
  "56101": "1w",
  "55604": "1w",
  "55606": "1w",
  "55612": "1w",
  "56058": "1w",
  "55030": "1w",
  "55124": "1w",
  "56339": "1w",
  "55019": "1w",
  "55720": "1w",
  "56678": "1w",
  "55306": "1w",
  "55088": "1w",
  "56672": "1w",
  "56576": "1w",
  "56085": "1w",
  "56519": "1w",
  "56252": "1w",
  "55971": "1w",
  "56571": "1w",
  "56316": "1w",
  "56537": "1w",
  "55954": "1w",
  "56588": "1w",
  "56466": "1w",
  "55976": "1w",
  "56282": "1w",
  "55939": "1w",
  "56473": "1w",
  "56338": "1w",
  "55063": "1w",
  "56225": "1w",
  "56289": "1w",
  "55354": "1w",
  "55924": "1w",
  "55448": "1w",
  "56566": "1w",
  "56240": "1w",
  "55985": "1w",
  "56336": "1w",
  "56347": "1w",
  "55955": "1w",
  "56447": "1w",
  "55366": "1w",
  "55386": "1w",
  "55338": "1w",
  "55360": "1w",
  "55056": "1w",
  "55339": "1w",
  "56448": "1w",
  "55735": "1w",
  "55405": "1w",
  "55401": "1w",
  "55054": "1w",
  "55411": "1w",
  "55964": "1w",
  "55987": "1w",
  "56660": "1w",
  "56629": "1w",
  "58533": "1w",
  "58544": "1w",
  "57638": "1w",
  "58765": "1w",
  "58744": "1w",
  "58581": "1w",
  "58422": "1w",
  "58074": "1w",
  "58701": "1w",
  "58521": "1w",
  "58781": "1w",
  "58105": "1w",
  "58733": "1w",
  "58256": "1w",
  "58235": "1w",
  "58524": "1w",
  "58204": "1w",
  "58479": "1w",
  "58467": "1w",
  "58488": "1w",
  "58549": "1w",
  "58476": "1w",
  "57641": "1w",
  "58741": "1w",
  "58385": "1w",
  "58844": "1w",
  "58769": "1w",
  "59275": "1w",
  "58343": "1w",
  "58490": "1w",
  "58454": "1w",
  "57430": "1w",
  "58442": "1w",
  "57255": "1w",
  "58345": "1w",
  "58443": "1w",
  "58224": "1w",
  "58353": "1w",
  "58052": "1w",
  "58363": "1w",
  "58057": "1w",
  "58018": "1w",
  "58276": "1w",
  "58077": "1w",
  "58051": "1w",
  "58831": "1w",
  "58540": "1w",
  "58580": "1w",
  "58576": "1w",
  "58530": "1w",
  "58545": "1w",
  "58563": "1w",
  "58763": "1w",
  "58723": "1w",
  "58384": "1w",
  "58721": "1w",
  "58356": "1w",
  "58346": "1w",
  "58351": "1w",
  "58255": "1w",
  "58102": "1w",
  "58504": "1w",
  "58570": "1w",
  "58251": "1w",
  "58756": "1w",
  "58477": "1w",
  "58573": "1w",
  "58475": "1w",
  "58062": "1w",
  "58788": "1w",
  "58770": "1w",
  "58032": "1w",
  "58458": "1w",
  "58441": "1w",
  "58017": "1w",
  "58067": "1w",
  "58330": "1w",
  "58229": "1w",
  "38472": "3e",
  "37345": "3e",
  "37321": "3e",
  "38258": "3e",
  "37692": "3e",
  "42223": "3e",
  "37743": "3e",
  "37890": "3e",
  "37354": "3e",
  "37097": "3e",
  "38425": "3e",
  "38357": "3e",
  "38372": "3e",
  "38370": "3e",
  "37029": "3e",
  "37708": "3e",
  "37175": "3e",
  "37872": "3e",
  "37851": "3e",
  "38231": "3e",
  "37325": "3e",
  "37732": "3e",
  "38321": "3e",
  "38568": "3e",
  "38254": "3e",
  "38375": "3e",
  "38339": "3e",
  "37034": "3e",
  "37316": "4",
  "38541": "3e",
  "70056": "4",
  "70002": "4",
  "71359": "4",
  "70117": "4",
  "70802": "4",
  "71108": "3w",
  "70310": "4",
  "71343": "4",
  "71334": "4",
  "70591": "4",
  "71411": "4",
  "70124": "4",
  "71316": "4",
  "71375": "4",
  "71434": "4",
  "70806": "4",
  "70129": "4",
  "70714": "4",
  "70816": "4",
  "70706": "4",
  "70744": "4",
  "70785": "4",
  "70051": "4",
  "70654": "4",
  "70082": "4",
  "70662": "4",
  "98503": "7",
  "99357": "5",
  "99212": "5",
  "99018": "5",
  "99016": "5",
  "99037": "5",
  "98026": "5",
  "98683": "7",
  "98042": "5",
  "98296": "5",
  "98024": "5",
  "08217": "2e",
  "07458": "2e",
  "07870": "2e",
  "08071": "2e",
  "08028": "2e",
  "07442": "2e",
  "07424": "2e",
  "07822": "2e",
  "08043": "2e",
  "08014": "2e",
  "08035": "2e",
  "08505": "2e",
  "08091": "2e",
  "08224": "2e",
  "08731": "2e",
  "07734": "2e",
  "07730": "2e",
  "07738": "2e",
  "07712": "2e",
  "07711": "2e",
  "07731": "2e",
  "08902": "2e",
  "07666": "2e",
  "07069": "2e",
  "08530": "2e",
  "07018": "2e",
  "08867": "2e",
  "08809": "2e",
  "08889": "2e",
  "12429": "2e",
  "12471": "2e",
  "13065": "1e",
  "12743": "2e",
  "14810": "2e",
  "13739": "2e",
  "13806": "2e",
  "14823": "2e",
  "12928": "1e",
  "13751": "2e",
  "12453": "2e",
  "14807": "2e",
  "14727": "2e",
  "13368": "1e",
  "12969": "1e",
  "12765": "2e",
  "12167": "2e",
  "12076": "2e",
  "13655": "1e",
  "14772": "2e",
  "14783": "2e",
  "12926": "1e",
  "12759": "2e",
  "14065": "2e",
  "14744": "2e",
  "14860": "2e",
  "11955": "2e",
  "14842": "2e",
  "11548": "2e",
  "11556": "2e",
  "12927": "1e",
  "13660": "1e",
  "12965": "1e",
  "13694": "1e",
  "11558": "2e",
  "11753": "2e",
  "12973": "1e",
  "12986": "1e",
  "13683": "1e",
  "12847": "1e",
  "14803": "2e",
  "12449": "2e",
  "12433": "2e",
  "12724": "2e",
  "12483": "2e",
  "12465": "2e",
  "13404": "1e",
  "12446": "2e",
  "12941": "1e",
  "12752": "2e",
  "12486": "2e",
  "12472": "2e",
  "12987": "1e",
  "14809": "2e",
  "14826": "2e",
  "14171": "2e",
  "12997": "1e",
  "13757": "2e",
  "12117": "1e",
  "13832": "2e",
  "14855": "2e",
  "14839": "2e",
  "14731": "2e",
  "12858": "1e",
  "98908": "5",
  "99163": "5",
  "98563": "7",
  "98199": "5",
  "98564": "7",
  "98585": "7",
  "98944": "5",
  "98404": "7",
  "98276": "5",
  "98177": "5",
  "99109": "5",
  "99148": "5",
  "98582": "7",
  "98937": "5",
  "98826": "5",
  "98405": "7",
  "99326": "5",
  "98178": "5",
  "98168": "5",
  "98188": "5",
  "98146": "5",
  "98072": "5",
  "98903": "5",
  "99344": "5",
  "98648": "5",
  "98577": "7",
  "98621": "7",
  "98279": "5",
  "98547": "7",
  "98674": "7",
  "98315": "7",
  "99034": "5",
  "98951": "5",
  "98860": "5",
  "98310": "7",
  "98359": "7",
  "98332": "7",
  "98297": "5",
  "98853": "5",
  "99329": "5",
  "98240": "5",
  "99152": "5",
  "98394": "7",
  "98333": "7",
  "98544": "7",
  "98539": "7",
  "98533": "7",
  "98643": "7",
  "99324": "5",
  "98558": "7",
  "99140": "5",
  "98587": "7",
  "98631": "7",
  "99014": "5",
  "98811": "5",
  "98562": "7",
  "98408": "7",
  "98201": "5",
  "99320": "5",
  "99346": "5",
  "98613": "5",
  "98466": "7",
  "98092": "5",
  "98294": "5",
  "98045": "5",
  "98323": "5",
  "98275": "5",
  "98607": "7",
  "40810": "3e",
  "42350": "3e",
  "40108": "3e",
  "40740": "3e",
  "41254": "3e",
  "41651": "3e",
  "40803": "3e",
  "41778": "3e",
  "41052": "2e",
  "41745": "3e",
  "40358": "3e",
  "41727": "3e",
  "40161": "3e",
  "40816": "3e",
  "41366": "3e",
  "41560": "3e",
  "41540": "3e",
  "40946": "3e",
  "40941": "3e",
  "42516": "3e",
  "42638": "3e",
  "40843": "3e",
  "40109": "3e",
  "42104": "3e",
  "40391": "3e",
  "41017": "2e",
  "41051": "2e",
  "41011": "2e",
  "40383": "3e",
  "41141": "3e",
  "42103": "3e",
  "41819": "3e",
  "41503": "3e",
  "40953": "3e",
  "41519": "3e",
  "42151": "3e",
  "41226": "3e",
  "40870": "3e",
  "41268": "3e",
  "42759": "3e",
  "41386": "3e",
  "40357": "3e",
  "40104": "3e",
  "42741": "3e",
  "42410": "3e",
  "41739": "3e",
  "40847": "3e",
  "40231": "3e",
  "41642": "3e",
  "41132": "3e",
  "41822": "3e",
  "40170": "3e",
  "41844": "3e",
  "47837": "2e",
  "47108": "2e",
  "46565": "2e",
  "47012": "2e",
  "47030": "2e",
  "46540": "2e",
  "46702": "2e",
  "46940": "2e",
  "46148": "2e",
  "47932": "2e",
  "46164": "2e",
  "46988": "2e",
  "46110": "2e",
  "46142": "2e",
  "47581": "2e",
  "46917": "2e",
  "47997": "2e",
  "46135": "2e",
  "46105": "2e",
  "46128": "2e",
  "47933": "2e",
  "47958": "2e",
  "47465": "2e",
  "46172": "2e",
  "47990": "2e",
  "46524": "2e",
  "47949": "2e",
  "47848": "2e",
  "46390": "2e",
  "46055": "2e",
  "46069": "2e",
  "47111": "2e",
  "47354": "2e",
  "46065": "2e",
  "47579": "3e",
  "47515": "3e",
  "47854": "2e",
  "47847": "2e",
  "47966": "2e",
  "46323": "2e",
  "46072": "2e",
  "46914": "2e",
  "46950": "2e",
  "51555": "2w",
  "52730": "2w",
  "52637": "2w",
  "51556": "2w",
  "50047": "2w",
  "50071": "2w",
  "52037": "2w",
  "50001": "2w",
  "50848": "2w",
  "51338": "1w",
  "50652": "2w",
  "50057": "2w",
  "50421": "2w",
  "50459": "1w",
  "51631": "2w",
  "50551": "2w",
  "51364": "1w",
  "51347": "1w",
  "50101": "2w",
  "52252": "2w",
  "52631": "2w",
  "50623": "2w",
  "50137": "2w",
  "52166": "1w",
  "50573": "2w",
  "56151": "1w",
  "56594": "1w",
  "55332": "1w",
  "55406": "1w",
  "56024": "1w",
  "55045": "1w",
  "55066": "1w",
  "55334": "1w",
  "55313": "1w",
  "55396": "1w",
  "55414": "1w",
  "55301": "1w",
  "56757": "1w",
  "55363": "1w",
  "56543": "1w",
  "55906": "1w",
  "55753": "1w",
  "55155": "1w",
  "56277": "1w",
  "56684": "1w",
  "56654": "1w",
  "55957": "1w",
  "56169": "1w",
  "56273": "1w",
  "56373": "1w",
  "55349": "1w",
  "55963": "1w",
  "55756": "1w",
  "56276": "1w",
  "56362": "1w",
  "55413": "1w",
  "55723": "1w",
  "56621": "1w",
  "56716": "1w",
  "56440": "1w",
  "56224": "1w",
  "56149": "1w",
  "55443": "1w",
  "55455": "1w",
  "56009": "1w",
  "55391": "1w",
  "56330": "1w",
  "56646": "1w",
  "56089": "1w",
  "55311": "1w",
  "56568": "1w",
  "56020": "1w",
  "56525": "1w",
  "55929": "1w",
  "55960": "1w",
  "78702": "6",
  "75859": "3w",
  "75486": "3w",
  "75462": "3w",
  "76250": "3w",
  "77859": "3w",
  "79904": "6",
  "76656": "6",
  "76711": "3w",
  "76630": "6",
  "77707": "4",
  "77706": "4",
  "76693": "3w",
  "78408": "4",
  "75848": "3w",
  "79406": "6",
  "75838": "3w",
  "78159": "6",
  "75204": "3w",
  "77994": "6",
  "77702": "4",
  "77977": "6",
  "78415": "4",
  "76258": "3w",
  "75704": "3w",
  "76861": "6",
  "75212": "3w",
  "75790": "3w",
  "78044": "6",
  "78550": "4",
  "78742": "6",
  "79382": "6",
  "75570": "3w",
  "78633": "6",
  "79534": "6",
  "79240": "2w",
  "75431": "3w",
  "78076": "6",
  "78612": "6",
  "76596": "6",
  "76388": "3w",
  "75759": "3w",
  "78836": "6",
  "75438": "3w",
  "75565": "3w",
  "75682": "3w",
  "76852": "6",
  "76402": "6",
  "75849": "3w",
  "79369": "6",
  "16840": "2e",
  "16860": "2e",
  "16837": "2e",
  "15840": "2e",
  "19344": "2e",
  "19083": "2e",
  "19087": "2e",
  "19342": "2e",
  "19319": "2e",
  "15044": "2e",
  "53080": "1e",
  "53004": "1e",
  "53571": "1e",
  "53075": "1e",
  "53911": "1e",
  "54512": "1e",
  "54420": "1e",
  "54526": "1e",
  "54462": "1e",
  "53533": "1e",
  "54216": "1e",
  "53574": "2e",
  "54626": "1e",
  "54119": "1e",
  "54443": "1e",
  "54645": "1e",
  "54006": "1e",
  "54966": "1e",
  "54418": "1e",
  "53954": "1e",
  "53956": "1e",
  "54157": "1e",
  "54889": "1e",
  "53086": "1e",
  "54548": "1e",
  "54926": "1e",
  "54421": "1e",
  "53920": "1e",
  "54856": "1e",
  "54652": "1e",
  "53078": "1e",
  "54893": "1e",
  "54701": "1e",
  "54720": "1e",
  "54742": "1e",
  "54601": "1e",
  "53034": "1e",
  "54963": "1e",
  "53140": "2e",
  "53706": "1e",
  "54902": "1e",
  "53406": "2e",
  "53713": "1e",
  "54904": "1e",
  "54964": "1e",
  "54417": "1e",
  "53714": "1e",
  "53181": "2e",
  "53031": "1e",
  "54948": "1e",
  "54935": "1e",
  "54107": "1e",
  "54838": "1e",
  "54126": "1e",
  "54738": "1e",
  "54450": "1e",
  "54977": "1e",
  "54960": "1e",
  "54138": "1e",
  "54862": "1e",
  "54983": "1e",
  "53038": "1e",
  "28667": "3e",
  "27562": "3e",
  "27502": "3e",
  "28436": "3e",
  "27310": "3e",
  "27409": "3e",
  "27233": "3e",
  "27263": "3e",
  "28012": "3e",
  "28606": "3e",
  "28052": "3e",
  "27605": "3e",
  "27054": "3e",
  "27606": "3e",
  "27408": "3e",
  "28452": "4",
  "27574": "3e",
  "28562": "3e",
  "28733": "3e",
  "28684": "3e",
  "28464": "3e",
  "27927": "3e",
  "27923": "3e",
  "27966": "3e",
  "28119": "4",
  "27875": "3e",
  "28791": "3e",
  "27932": "3e",
  "28646": "3e",
  "27890": "3e",
  "28777": "3e",
  "28616": "3e",
  "28327": "3e",
  "28909": "4",
  "27924": "3e",
  "28668": "3e",
  "28740": "3e",
  "28073": "3e",
  "27925": "3e",
  "27967": "3e",
  "28712": "3e",
  "28746": "3e",
  "27872": "3e",
  "28364": "3e",
  "28749": "3e",
  "27281": "3e",
  "28755": "3e",
  "28358": "3e",
  "28772": "3e",
  "28328": "3e",
  "28762": "3e",
  "28553": "3e",
  "28577": "3e",
  "28640": "3e",
  "28557": "3e",
  "27981": "3e",
  "27936": "3e",
  "27587": "3e",
  "27508": "3e",
  "28125": "3e",
  "28422": "3e",
  "28451": "3e",
  "27517": "3e",
  "34947": "4",
  "32680": "4",
  "33037": "4",
  "32427": "4",
  "33040": "4",
  "33036": "4",
  "33050": "4",
  "33051": "4",
  "32669": "4",
  "32643": "4",
  "33146": "4",
  "33126": "4",
  "33413": "4",
  "32442": "4",
  "33122": "4",
  "33592": "4",
  "33076": "4",
  "32438": "4",
  "32259": "4",
  "32043": "4",
  "33597": "4",
  "33024": "4",
  "32141": "4",
  "32759": "4",
  "32960": "4",
  "32440": "4",
  "33330": "4",
  "32091": "4",
  "32134": "4",
  "33870": "4",
  "95419": "7",
  "91505": "6",
  "95405": "7",
  "90071": "6",
  "94947": "7",
  "94519": "7",
  "94518": "7",
  "91765": "6",
  "94611": "7",
  "91724": "6",
  "94572": "7",
  "94613": "7",
  "94618": "7",
  "94563": "7",
  "94551": "7",
  "94606": "7",
  "95017": "7",
  "92866": "6",
  "90248": "6",
  "91214": "6",
  "91711": "6",
  "96076": "7",
  "93308": "6",
  "95646": "5",
  "93653": "6",
  "93626": "6",
  "94134": "7",
  "96054": "5",
  "91763": "6",
  "91803": "6",
  "91104": "6",
  "95984": "5",
  "21733": "2e",
  "21205": "2e",
  "21223": "2e",
  "20878": "2e",
  "21239": "2e",
  "21531": "2e",
  "21861": "3e",
  "21128": "2e",
  "21014": "2e",
  "21208": "2e",
  "21084": "2e",
  "21013": "2e",
  "21918": "2e",
  "20653": "3e",
  "20782": "2e",
  "21678": "2e",
  "21122": "2e",
  "21140": "2e",
  "20814": "2e",
  "21061": "2e",
  "21108": "2e",
  "20852": "2e",
  "20850": "2e",
  "21788": "2e",
  "21704": "2e",
  "20624": "3e",
  "21626": "3e",
  "20886": "2e",
  "20754": "2e",
  "20744": "2e",
  "20763": "2e",
  "21048": "2e",
  "20779": "2e",
  "21755": "2e",
  "20762": "2e",
  "21851": "3e",
  "21635": "2e",
  "20689": "2e",
  "20736": "2e",
  "21623": "2e",
  "20680": "3e",
  "21650": "2e",
  "20769": "2e",
  "20660": "3e",
  "21105": "2e",
  "20868": "2e",
  "21641": "2e",
  "21673": "2e",
  "21632": "2e",
  "21872": "3e",
  "21654": "2e",
  "21653": "2e",
  "21502": "2e",
  "21224": "2e",
  "21520": "2e",
  "21231": "2e",
  "21783": "2e",
  "21562": "2e",
  "21719": "2e",
  "21202": "2e",
  "21015": "2e",
  "21009": "2e",
  "21536": "2e",
  "21211": "2e",
  "21758": "2e",
  "21865": "3e",
  "21530": "2e",
  "21154": "2e",
  "21050": "2e",
  "21010": "2e",
  "21163": "2e",
  "21902": "2e",
  "21901": "2e",
  "21817": "3e",
  "20743": "2e",
  "20904": "2e",
  "21757": "2e",
  "20710": "2e",
  "20664": "3e",
  "21622": "3e",
  "20902": "2e",
  "20661": "3e",
  "21158": "2e",
  "21157": "2e",
  "01266": "2e",
  "01534": "2e",
  "01073": "2e",
  "01075": "2e",
  "59645": "5",
  "59467": "5",
  "59013": "5",
  "59469": "5",
  "59419": "5",
  "59644": "5",
  "59745": "5",
  "59873": "5",
  "59727": "5",
  "59542": "5",
  "59422": "5",
  "59343": "1w",
  "59452": "5",
  "59354": "1w",
  "59083": "5",
  "59259": "1w",
  "59029": "5",
  "59401": "5",
  "59262": "1w",
  "59038": "5",
  "59443": "5",
  "59323": "5",
  "59068": "5",
  "59929": "5",
  "59520": "5",
  "59842": "5",
  "59864": "5",
  "59076": "5",
  "59434": "5",
  "59801": "5",
  "59803": "5",
  "59826": "5",
  "59088": "5",
  "59411": "5",
  "59414": "5",
  "59063": "5",
  "59006": "5",
  "59451": "5",
  "59489": "5",
  "59471": "5",
  "59930": "5",
  "59050": "5",
  "59081": "5",
  "59252": "1w",
  "59067": "5",
  "59054": "5",
  "59318": "5",
  "59337": "1w",
  "59523": "5",
  "59339": "1w",
  "59214": "1w",
  "59347": "5",
  "59427": "5",
  "59843": "5",
  "59547": "5",
  "59713": "5",
  "59053": "5",
  "59044": "5",
  "59333": "5",
  "59101": "5",
  "59024": "5",
  "59643": "5",
  "59711": "5",
  "59934": "5",
  "59931": "5",
  "59020": "5",
  "59828": "5",
  "59741": "5",
  "59860": "5",
  "59914": "5",
  "59417": "5",
  "59823": "5",
  "59834": "5",
  "59920": "5",
  "59865": "5",
  "59230": "1w",
  "59750": "5",
  "59812": "5",
  "59760": "5",
  "59710": "5",
  "59226": "1w",
  "59211": "1w",
  "59841": "5",
  "59031": "5",
  "59933": "5",
  "59625": "5",
  "59089": "5",
  "59453": "5",
  "59923": "5",
  "59078": "5",
  "59327": "5",
  "59870": "5",
  "59349": "1w",
  "59405": "5",
  "59345": "1w",
  "59416": "5",
  "59019": "5",
  "59336": "1w",
  "59526": "5",
  "59085": "5",
  "59716": "5",
  "59474": "5",
  "59635": "5",
  "59724": "5",
  "59752": "5",
  "59912": "5",
  "59012": "5",
  "59855": "5",
  "59631": "5",
  "59634": "5",
  "59106": "5",
  "59524": "5",
  "59821": "5",
  "59522": "5",
  "59465": "5",
  "59273": "1w",
  "59319": "1w",
  "59201": "1w",
  "59530": "5",
  "59255": "1w",
  "59071": "5",
  "59007": "5",
  "59247": "1w",
  "34949": "4",
  "32455": "4",
  "32464": "4",
  "34984": "4",
  "32359": "4",
  "32439": "4",
  "33875": "4",
  "32626": "4",
  "32320": "4",
  "32322": "4",
  "32640": "4",
  "33913": "4",
  "33004": "4",
  "32724": "4",
  "32738": "4",
  "32344": "4",
  "32448": "4",
  "33331": "4",
  "32059": "4",
  "32124": "4",
  "32744": "4",
  "32083": "4",
  "32162": "4",
  "33865": "4",
  "34445": "4",
  "32361": "4",
  "32435": "4",
  "33513": "4",
  "34950": "4",
  "32193": "4",
  "32139": "4",
  "33872": "4",
  "32064": "4",
  "32628": "4",
  "32621": "4",
  "33042": "4",
  "32358": "4",
  "33143": "4",
  "32413": "4",
  "33178": "4",
  "33614": "4",
  "28107": "3e",
  "28027": "3e",
  "27613": "3e",
  "27513": "3e",
  "27055": "3e",
  "27601": "3e",
  "27358": "3e",
  "27893": "3e",
  "27704": "3e",
  "27863": "3e",
  "28547": "3e",
  "28551": "3e",
  "28542": "3e",
  "27803": "3e",
  "28212": "3e",
  "27503": "3e",
  "27807": "3e",
  "28348": "3e",
  "27051": "3e",
  "28226": "3e",
  "28701": "3e",
  "28770": "3e",
  "28214": "3e",
  "28278": "3e",
  "28078": "3e",
  "27856": "3e",
  "28580": "3e",
  "28037": "3e",
  "28412": "3e",
  "27053": "3e",
  "27521": "3e",
  "28398": "3e",
  "28368": "3e",
  "27506": "3e",
  "27239": "3e",
  "28086": "3e",
  "28645": "3e",
  "28612": "3e",
  "28420": "3e",
  "27407": "3e",
  "28449": "3e",
  "28480": "3e",
  "27529": "3e",
  "28147": "3e",
  "27048": "3e",
  "27568": "3e",
  "28041": "3e",
  "27268": "3e",
  "28716": "3e",
  "28443": "3e",
  "28585": "3e",
  "27291": "3e",
  "28743": "3e",
  "27941": "3e",
  "27897": "3e",
  "28739": "3e",
  "27806": "3e",
  "28472": "3e",
  "27212": "3e",
  "27379": "3e",
  "28906": "3e",
  "28109": "3e",
  "27839": "3e",
  "27817": "3e",
  "28621": "3e",
  "28766": "3e",
  "28623": "3e",
  "28705": "3e",
  "66757": "2w",
  "67451": "2w",
  "66941": "2w",
  "66417": "2w",
  "66401": "2w",
  "67458": "2w",
  "67438": "2w",
  "66439": "2w",
  "67073": "2w",
  "66013": "2w",
  "68978": "2w",
  "67340": "2w",
  "67733": "2w",
  "67560": "2w",
  "67839": "2w",
  "66776": "2w",
  "67645": "2w",
  "67868": "2w",
  "66869": "2w",
  "66845": "2w",
  "66713": "2w",
  "66725": "2w",
  "66724": "2w",
  "66860": "2w",
  "67105": "2w",
  "67859": "2w",
  "67361": "2w",
  "67559": "2w",
  "67070": "2w",
  "67028": "2w",
  "67831": "2w",
  "67554": "2w",
  "67449": "2w",
  "66839": "2w",
  "67524": "2w",
  "66937": "2w",
  "67563": "2w",
  "67840": "2w",
  "67573": "2w",
  "67061": "2w",
  "67515": "2w",
  "66006": "2w",
  "66873": "2w",
  "66834": "2w",
  "67570": "2w",
  "67851": "2w",
  "66048": "2w",
  "66865": "2w",
  "66045": "2w",
  "66441": "2w",
  "66411": "2w",
  "66546": "2w",
  "67209": "2w",
  "67235": "2w",
  "67016": "2w",
  "66073": "2w",
  "66070": "2w",
  "66206": "2w",
  "67227": "2w",
  "66528": "2w",
  "67230": "2w",
  "66532": "2w",
  "67114": "2w",
  "66223": "2w",
  "67401": "2w",
  "66449": "2w",
  "66402": "2w",
  "66614": "2w",
  "66409": "2w",
  "66603": "2w",
  "67205": "2w",
  "66413": "2w",
  "66523": "2w",
  "66212": "2w",
  "66618": "2w",
  "66512": "2w",
  "66202": "2w",
  "66025": "2w",
  "66209": "2w",
  "66062": "2w",
  "67219": "2w",
  "66548": "2w",
  "66052": "2w",
  "66044": "2w",
  "67543": "2w",
  "67067": "2w",
  "66510": "2w",
  "67001": "2w",
  "66407": "2w",
  "67456": "2w",
  "66534": "2w",
  "67753": "2w",
  "67351": "2w",
  "67730": "2w",
  "66963": "2w",
  "67734": "2w",
  "66010": "2w",
  "67441": "2w",
  "66942": "2w",
  "66064": "2w",
  "66020": "2w",
  "66522": "2w",
  "66858": "2w",
  "67675": "2w",
  "67871": "2w",
  "67584": "2w",
  "66067": "2w",
  "67654": "2w",
  "66739": "2w",
  "67878": "2w",
  "67862": "2w",
  "67346": "2w",
  "67352": "2w",
  "67221": "2w",
  "67102": "2w",
  "67879": "2w",
  "67882": "2w",
  "67054": "2w",
  "67565": "2w",
  "66856": "2w",
  "67574": "2w",
  "67334": "2w",
  "67841": "2w",
  "66944": "2w",
  "66968": "2w",
  "67134": "2w",
  "45358": "2e",
  "45721": "2e",
  "45321": "2e",
  "44080": "2e",
  "43027": "2e",
  "44065": "2e",
  "45368": "2e",
  "43023": "2e",
  "43025": "2e",
  "43013": "2e",
  "44121": "2e",
  "44145": "2e",
  "44134": "2e",
  "43735": "2e",
  "45227": "2e",
  "45152": "2e",
  "43044": "2e",
  "43468": "2e",
  "45121": "2e",
  "45887": "2e",
  "16825": "2e",
  "16839": "2e",
  "17527": "2e",
  "19365": "2e",
  "19382": "2e",
  "15226": "2e",
  "15234": "2e",
  "19086": "2e",
  "15084": "2e",
  "19029": "2e",
  "19076": "2e",
  "19079": "2e",
  "19043": "2e",
  "18419": "2e",
  "18618": "2e",
  "15209": "2e",
  "16749": "2e",
  "16745": "2e",
  "15051": "2e",
  "15126": "2e",
  "15108": "2e",
  "15075": "2e",
  "16347": "2e",
  "19096": "2e",
  "16046": "2e",
  "15210": "2e",
  "15123": "2e",
  "15050": "2e",
  "15009": "2e",
  "15059": "2e",
  "15074": "2e",
  "15290": "2e",
  "15323": "2e",
  "15656": "2e",
  "15417": "2e",
  "16341": "2e",
  "15322": "2e",
  "15313": "2e",
  "15368": "2e",
  "15642": "2e",
  "15340": "2e",
  "15689": "2e",
  "15683": "2e",
  "15620": "2e",
  "15678": "2e",
  "15054": "2e",
  "15640": "2e",
  "15617": "2e",
  "19604": "2e",
  "17403": "2e",
  "18109": "2e",
  "17602": "2e",
  "17401": "2e",
  "17935": "2e",
  "15906": "2e",
  "17921": "2e",
  "19146": "2e",
  "16510": "2e",
  "17078": "2e",
  "46901": "2e",
  "46068": "2e",
  "47904": "2e",
  "47304": "2e",
  "46506": "2e",
  "47803": "2e",
  "46619": "2e",
  "46765": "2e",
  "46218": "2e",
  "47464": "2e",
  "46204": "2e",
  "46614": "2e",
  "47884": "2e",
  "46785": "2e",
  "46504": "2e",
  "46356": "2e",
  "47025": "2e",
  "46835": "2e",
  "47032": "2e",
  "46763": "2e",
  "46797": "2e",
  "47573": "2e",
  "47366": "2e",
  "46971": "2e",
  "46302": "2e",
  "46701": "2e",
  "46784": "2e",
  "47225": "2e",
  "46922": "2e",
  "47306": "2e",
  "47880": "2e",
  "47542": "3e",
  "47460": "2e",
  "46168": "2e",
  "46240": "2e",
  "46290": "2e",
  "47963": "2e",
  "46250": "2e",
  "46278": "2e",
  "46158": "2e",
  "46260": "2e",
  "47943": "2e",
  "46222": "2e",
  "47403": "2e",
  "47527": "2e",
  "46777": "2e",
  "46781": "2e",
  "47359": "2e",
  "47368": "2e",
  "47394": "2e",
  "47390": "2e",
  "47452": "2e",
  "46960": "2e",
  "47024": "2e",
  "47041": "2e",
  "47167": "2e",
  "47220": "2e",
  "46776": "2e",
  "40176": "3e",
  "40070": "3e",
  "41547": "3e",
  "40145": "3e",
  "40868": "3e",
  "40058": "3e",
  "40808": "3e",
  "41558": "3e",
  "41360": "3e",
  "42060": "3e",
  "41650": "3e",
  "42333": "3e",
  "41616": "3e",
  "40464": "3e",
  "41631": "3e",
  "42533": "3e",
  "41231": "3e",
  "41149": "3e",
  "40824": "3e",
  "03224": "1e",
  "03771": "1e",
  "03785": "1e",
  "03874": "2e",
  "03260": "1e",
  "03824": "2e",
  "03823": "2e",
  "03873": "2e",
  "03861": "2e",
  "03858": "2e",
  "03279": "1e",
  "03860": "1e",
  "03882": "1e",
  "03871": "2e",
  "03225": "1e",
  "03452": "2e",
  "03752": "1e",
  "03086": "2e",
  "03082": "2e",
  "03801": "2e",
  "03244": "1e",
  "14214": "1e",
  "12526": "2e",
  "11385": "2e",
  "14613": "1e",
  "11232": "2e",
  "13210": "1e",
  "13045": "2e",
  "10003": "2e",
  "14623": "1e",
  "14201": "1e",
  "10016": "2e",
  "10801": "2e",
  "10580": "2e",
  "14226": "1e",
  "14604": "1e",
  "14612": "1e",
  "14261": "1e",
  "14260": "1e",
  "11718": "2e",
  "10152": "2e",
  "13811": "2e",
  "13041": "1e",
  "10595": "2e",
  "10516": "2e",
  "10923": "2e",
  "10537": "2e",
  "20176": "2e",
  "20105": "2e",
  "22125": "3e",
  "22192": "3e",
  "23891": "3e",
  "20136": "2e",
  "20109": "2e",
  "22025": "3e",
  "23875": "3e",
  "23876": "3e",
  "20130": "2e",
  "22719": "3e",
  "22973": "3e",
  "23937": "3e",
  "23974": "3e",
  "20115": "2e",
  "24072": "3e",
  "22732": "3e",
  "24473": "3e",
  "24150": "3e",
  "24279": "3e",
  "23919": "3e",
  "24093": "3e",
  "20106": "3e",
  "22734": "3e",
  "24086": "3e",
  "23845": "3e",
  "22627": "3e",
  "24465": "3e",
  "23502": "3e",
  "23066": "3e",
  "23175": "3e",
  "23021": "3e",
  "23119": "3e",
  "24221": "3e",
  "24016": "3e",
  "24641": "3e",
  "24210": "3e",
  "24270": "3e",
  "23323": "3e",
  "24501": "3e",
  "24602": "3e",
  "23513": "3e",
  "24271": "3e",
  "24179": "3e",
  "23604": "3e",
  "23605": "3e",
  "22749": "3e",
  "24282": "3e",
  "24536": "3e",
  "20204": "2e",
  "20319": "2e",
  "20530": "2e",
  "20245": "2e",
  "20009": "2e",
  "20015": "2e",
  "20004": "2e",
  "20250": "2e",
  "20388": "2e",
  "20064": "2e",
  "20008": "2e",
  "20005": "2e",
  "20032": "2e",
  "20037": "2e",
  "20551": "2e",
  "20036": "2e",
  "20515": "2e",
  "20591": "2e",
  "20520": "2e",
  "20017": "2e",
  "20373": "2e",
  "20566": "2e",
  "20010": "2e",
  "20059": "2e",
  "20542": "2e",
  "20422": "2e",
  "20565": "2e",
  "20535": "2e",
  "32223": "4",
  "32836": "4",
  "32768": "4",
  "32831": "4",
  "34695": "4",
  "31079": "4",
  "30546": "4",
  "39854": "4",
  "30547": "4",
  "31556": "4",
  "30429": "4",
  "30467": "4",
  "30276": "4",
  "39885": "4",
  "30205": "4",
  "30290": "4",
  "30269": "4",
  "31058": "4",
  "30428": "4",
  "30412": "4",
  "32809": "4",
  "33573": "4",
  "32751": "4",
  "31024": "4",
  "30442": "4",
  "30454": "4",
  "30241": "4",
  "32084": "4",
  "32324": "4",
  "32234": "4",
  "32757": "4",
  "31551": "4",
  "30477": "4",
  "31626": "4",
  "39815": "4",
  "31051": "4",
  "33709": "4",
  "30576": "4",
  "33773": "4",
  "32095": "4",
  "32082": "4",
  "30137": "4",
  "32330": "4",
  "32541": "4",
  "30218": "4",
  "32736": "4",
  "34698": "4",
  "34684": "4",
  "32073": "4",
  "31599": "4",
  "31756": "4",
  "34652": "4",
  "34715": "4",
  "33541": "4",
  "33946": "4",
  "34737": "4",
  "32967": "4",
  "33311": "4",
  "34771": "4",
  "33301": "4",
  "34746": "4",
  "32040": "4",
  "32337": "4",
  "34487": "4",
  "36652": "4",
  "34729": "4",
  "32512": "4",
  "32723": "4",
  "35901": "4",
  "35222": "4",
  "33471": "4",
  "31057": "4",
  "33440": "4",
  "30145": "4",
  "34234": "4",
  "32308": "4",
  "35207": "4",
  "32301": "4",
  "19111": "2e",
  "17055": "2e",
  "17502": "2e",
  "19501": "2e",
  "17570": "2e",
  "15943": "2e",
  "15773": "2e",
  "16675": "2e",
  "17720": "2e",
  "17263": "2e",
  "16546": "2e",
  "17088": "2e",
  "19549": "2e",
  "18036": "2e",
  "17053": "2e",
  "17021": "2e",
  "19507": "2e",
  "16826": "2e",
  "16864": "2e",
  "17093": "2e",
  "17257": "2e",
  "16686": "2e",
  "16601": "2e",
  "17739": "2e",
  "17240": "2e",
  "17578": "2e",
  "17406": "2e",
  "17512": "2e",
  "16159": "2e",
  "17774": "2e",
  "16856": "2e",
  "17547": "2e",
  "16854": "2e",
  "15963": "2e",
  "17554": "2e",
  "17538": "2e",
  "17520": "2e",
  "16682": "2e",
  "17019": "2e",
  "15714": "2e",
  "16646": "2e",
  "16427": "2e",
  "15940": "2e",
  "17508": "2e",
  "19123": "2e",
  "45160": "2e",
  "44256": "2e",
  "44281": "2e",
  "45318": "2e",
  "44515": "2e",
  "44439": "2e",
  "43106": "2e",
  "45361": "2e",
  "44270": "2e",
  "45684": "3e",
  "44512": "2e",
  "45679": "2e",
  "44028": "2e",
  "45414": "2e",
  "45404": "2e",
  "45416": "2e",
  "44280": "2e",
  "45351": "2e",
  "45236": "2e",
  "44215": "2e",
  "44880": "2e",
  "45054": "2e",
  "45657": "2e",
  "45656": "2e",
  "45334": "2e",
  "43570": "2e",
  "43152": "2e",
  "43920": "2e",
  "45133": "2e",
  "43536": "2e",
  "44445": "2e",
  "45617": "2e",
  "44807": "2e",
  "43812": "2e",
  "43811": "2e",
  "45723": "2e",
  "45621": "2e",
  "45775": "2e",
  "43407": "2e",
  "44882": "2e",
  "45827": "2e",
  "43804": "2e",
  "43843": "2e",
  "43014": "2e",
  "43006": "2e",
  "43748": "2e",
  "43783": "2e",
  "43019": "2e",
  "45760": "2e",
  "45686": "2e",
  "43149": "2e",
  "44669": "2e",
  "44905": "2e",
  "44907": "2e",
  "45420": "2e",
  "43554": "2e",
  "43215": "2e",
  "43310": "2e",
  "45663": "2e",
  "44221": "2e",
  "44056": "2e",
  "44067": "2e",
  "43340": "2e",
  "43028": "2e",
  "45213": "2e",
  "45332": "2e",
  "43227": "2e",
  "45814": "2e",
  "43348": "2e",
  "43224": "2e",
  "43210": "2e",
  "44817": "2e",
  "45237": "2e",
  "45226": "2e",
  "43532": "2e",
  "43962": "2e",
  "45419": "2e",
  "43555": "2e",
  "45232": "2e",
  "45630": "3e",
  "43560": "2e",
  "45211": "2e",
  "43082": "2e",
  "43719": "2e",
  "45053": "2e",
  "45768": "2e",
  "35062": "4",
  "35477": "4",
  "35460": "4",
  "35647": "3e",
  "35503": "4",
  "36353": "4",
  "36027": "4",
  "35130": "4",
  "36016": "4",
  "34238": "4",
  "35747": "4",
  "35216": "4",
  "36703": "4",
  "35004": "4",
  "36783": "4",
  "36766": "4",
  "35957": "4",
  "36301": "4",
  "35987": "4",
  "36742": "4",
  "36720": "4",
  "35013": "4",
  "36370": "4",
  "36874": "4",
  "36849": "4",
  "35178": "4",
  "32408": "4",
  "33140": "4",
  "34286": "4",
  "33486": "4",
  "32509": "4",
  "33431": "4",
  "30750": "4",
  "31088": "4",
  "30345": "4",
  "30809": "4",
  "30030": "4",
  "36444": "4",
  "36863": "4",
  "36871": "4",
  "36723": "4",
  "36786": "4",
  "36343": "4",
  "36784": "4",
  "31421": "4",
  "33616": "4",
  "31216": "4",
  "32514": "4",
  "32535": "4",
  "32577": "4",
  "33707": "4",
  "36869": "4",
  "36093": "4",
  "35176": "4",
  "30294": "4",
  "31025": "4",
  "36435": "4",
  "30079": "4",
  "31008": "4",
  "36082": "4",
  "35740": "3e",
  "36048": "4",
  "35966": "4",
  "35771": "4",
  "35744": "4",
  "36088": "4",
  "36401": "4",
  "35984": "4",
  "35447": "4",
  "36865": "4",
  "36740": "4",
  "35097": "4",
  "36569": "4",
  "36584": "4",
  "36474": "4",
  "36071": "4",
  "36251": "4",
  "35983": "4",
  "74425": "3w",
  "74522": "3w",
  "73028": "2w",
  "74637": "2w",
  "74650": "2w",
  "73032": "3w",
  "73947": "2w",
  "73939": "2w",
  "74636": "2w",
  "73758": "2w",
  "73764": "2w",
  "73726": "2w",
  "73760": "2w",
  "73719": "2w",
  "73835": "2w",
  "73642": "2w",
  "73024": "3w",
  "73043": "2w",
  "73533": "3w",
  "73004": "3w",
  "73753": "2w",
  "73079": "3w",
  "74421": "3w",
  "74445": "3w",
  "73481": "3w",
  "73442": "3w",
  "74047": "3w",
  "73521": "3w",
  "74023": "3w",
  "74601": "2w",
  "73092": "3w",
  "74652": "2w",
  "73743": "2w",
  "73664": "3w",
  "74059": "3w",
  "73622": "3w",
  "73488": "3w",
  "74721": "3w",
  "73668": "2w",
  "73624": "3w",
  "74931": "3w",
  "73448": "3w",
  "74766": "3w",
  "73463": "3w",
  "73099": "3w",
  "73049": "3w",
  "73117": "3w",
  "73569": "3w",
  "73132": "3w",
  "73162": "3w",
  "73130": "3w",
  "74042": "2w",
  "74021": "3w",
  "73528": "3w",
  "73048": "3w",
  "73538": "3w",
  "73128": "3w",
  "73548": "3w",
  "74557": "3w",
  "74871": "3w",
  "74954": "3w",
  "74071": "3w",
  "74114": "3w",
  "74338": "3w",
  "74011": "3w",
  "74470": "3w",
  "73557": "3w",
  "74937": "3w",
  "74027": "2w",
  "74346": "3w",
  "74364": "3w",
  "73047": "3w",
  "73065": "3w",
  "74365": "3w",
  "74016": "3w",
  "74549": "3w",
  "74941": "3w",
  "73553": "3w",
  "73441": "3w",
  "74352": "3w",
  "73552": "3w",
  "61603": "2e",
  "61436": "2e",
  "61474": "2e",
  "60619": "2e",
  "60151": "2e",
  "61103": "2e",
  "61756": "2e",
  "61749": "2e",
  "61818": "2e",
  "61830": "2e",
  "62561": "2e",
  "61920": "2e",
  "60407": "2e",
  "61021": "2e",
  "60450": "2e",
  "60530": "2e",
  "62629": "2e",
  "60076": "2e",
  "61748": "2e",
  "61072": "2e",
  "61739": "2e",
  "61774": "2e",
  "62927": "3e",
  "62012": "2e",
  "61008": "2e",
  "62351": "2e",
  "62907": "3e",
  "60963": "2e",
  "61736": "2e",
  "60954": "2e",
  "60148": "2e",
  "62031": "2e",
  "62326": "2e",
  "62028": "2w",
  "62903": "3e",
  "62920": "3e",
  "62940": "3e",
  "61884": "2e",
  "61265": "2e",
  "61535": "2e",
  "61546": "2e",
  "62958": "3e",
  "61085": "2e",
  "62917": "3e",
  "61610": "2e",
  "60643": "2e",
  "61262": "2e",
  "60644": "2e",
  "62831": "2e",
  "61472": "2e",
  "62830": "2e",
  "61933": "2e",
  "61917": "2e",
  "60181": "2e",
  "60126": "2e",
  "62095": "2e",
  "62216": "2e",
  "62060": "2e",
  "62413": "2e",
  "62294": "2e",
  "62236": "2e",
  "62244": "2e",
  "60015": "2e",
  "60465": "2e",
  "60501": "2e",
  "60165": "2e",
  "60466": "2e",
  "60555": "2e",
  "60119": "2e",
  "60539": "2e",
  "60177": "2e",
  "60090": "2e",
  "60070": "2e",
  "60077": "2e",
  "60018": "2e",
  "60120": "2e",
  "60029": "2e",
  "60208": "2e",
  "60546": "2e",
  "60827": "2e",
  "62239": "2e",
  "60480": "2e",
  "60534": "2e",
  "60141": "2e",
  "60155": "2e",
  "60471": "2e",
  "60428": "2e",
  "60189": "2e",
  "60563": "2e",
  "60185": "2e",
  "60142": "2e",
  "60540": "2e",
  "60561": "2e",
  "60048": "2e",
  "11971": "2e",
  "11939": "2e",
  "11733": "2e",
  "11934": "2e",
  "14878": "2e",
  "11959": "2e",
  "12967": "1e",
  "13669": "1e",
  "13672": "1e",
  "11932": "2e",
  "13699": "1e",
  "13810": "2e",
  "12116": "2e",
  "13337": "2e",
  "11732": "2e",
  "12149": "2e",
  "12036": "2e",
  "11797": "2e",
  "12980": "1e",
  "13747": "2e",
  "12416": "2e",
  "13433": "1e",
  "12966": "1e",
  "14129": "2e",
  "14020": "1e",
  "12747": "2e",
  "12432": "2e",
  "12779": "2e",
  "13489": "1e",
  "12763": "2e",
  "12443": "2e",
  "14715": "2e",
  "14770": "2e",
  "14143": "1e",
  "12775": "2e",
  "10002": "2e",
  "14867": "2e",
  "12567": "2e",
  "10005": "2e",
  "10006": "2e",
  "13469": "1e",
  "13044": "1e",
  "14008": "1e",
  "14568": "1e",
  "14006": "2e",
  "11566": "2e",
  "13078": "1e",
  "13215": "1e",
  "14206": "1e",
  "14047": "2e",
  "13108": "1e",
  "14048": "2e",
  "14138": "2e",
  "14769": "2e",
  "11413": "2e",
  "13052": "2e",
  "13310": "1e",
  "10466": "2e",
  "14435": "2e",
  "38359": "3e",
  "37187": "3e",
  "37178": "3e",
  "37733": "3e",
  "37892": "3e",
  "37348": "3e",
  "38351": "3e",
  "38563": "3e",
  "38578": "3e",
  "37847": "3e",
  "37813": "3e",
  "37818": "3e",
  "37616": "3e",
  "37821": "3e",
  "38559": "3e",
  "37391": "3e",
  "38543": "3e",
  "37333": "3e",
  "37713": "3e",
  "38455": "3e",
  "37059": "3e",
  "37082": "3e",
  "37861": "3e",
  "37887": "3e",
  "37058": "3e",
  "40965": "3e",
  "37723": "3e",
  "38547": "3e",
  "37765": "3e",
  "38240": "3e",
  "38260": "3e",
  "38030": "3e",
  "38320": "3e",
  "38450": "3e",
  "37361": "3e",
  "37819": "3e",
  "78536": "6",
  "79039": "2w",
  "79342": "6",
  "75480": "3w",
  "79519": "6",
  "79061": "2w",
  "79353": "6",
  "79407": "6",
  "76522": "6",
  "75415": "3w",
  "79255": "3w",
  "79097": "2w",
  "76859": "6",
  "79024": "2w",
  "75656": "3w",
  "75642": "3w",
  "75935": "3w",
  "76904": "6",
  "79010": "2w",
  "75778": "3w",
  "77656": "4",
  "78745": "6",
  "77663": "4",
  "76365": "3w",
  "79504": "6",
  "75093": "3w",
  "75023": "3w",
  "77664": "4",
  "78727": "6",
  "77585": "4",
  "75173": "3w",
  "78749": "6",
  "78758": "6",
  "75104": "3w",
  "75158": "3w",
  "76140": "3w",
  "76028": "3w",
  "76040": "3w",
  "76060": "3w",
  "76177": "3w",
  "76092": "3w",
  "76005": "3w",
  "76021": "3w",
  "75051": "3w",
  "78220": "6",
  "78108": "6",
  "76058": "3w",
  "76061": "3w",
  "76035": "3w",
  "76073": "3w",
  "76023": "3w",
  "78233": "6",
  "76270": "3w",
  "78232": "6",
  "78253": "6",
  "76267": "3w",
  "78242": "6",
  "78252": "6",
  "78238": "6",
  "77363": "3w",
  "77876": "3w",
  "75960": "4",
  "77335": "4",
  "77568": "4",
  "77377": "4",
  "77358": "3w",
  "79843": "6",
  "77488": "4",
  "77518": "4",
  "77565": "4",
  "77546": "4",
  "79518": "6",
  "79529": "3w",
  "78624": "6",
  "75455": "3w",
  "75763": "3w",
  "79359": "6",
  "78832": "6",
  "79252": "3w",
  "79743": "6",
  "78880": "6",
  "76932": "6",
  "50631": "2w",
  "50269": "2w",
  "52344": "2w",
  "52619": "2w",
  "52657": "2w",
  "51341": "1w",
  "52562": "2w",
  "50593": "2w",
  "52553": "2w",
  "50213": "2w",
  "50164": "2w",
  "50528": "1w",
  "50020": "2w",
  "52057": "2w",
  "52330": "2w",
  "51453": "2w",
  "51436": "2w",
  "50665": "2w",
  "51530": "2w",
  "51235": "1w",
  "52229": "2w",
  "52208": "2w",
  "50858": "2w",
  "51055": "2w",
  "50581": "2w",
  "50837": "2w",
  "52531": "2w",
  "50599": "2w",
  "50847": "2w",
  "50568": "2w",
  "52316": "2w",
  "50578": "1w",
  "50479": "1w",
  "51452": "2w",
  "51565": "2w",
  "52249": "2w",
  "51448": "2w",
  "50060": "2w",
  "51442": "2w",
  "51334": "1w",
  "52043": "2w",
  "50630": "1w",
  "50217": "2w",
  "51365": "1w",
  "50008": "2w",
  "51439": "2w",
  "50207": "2w",
  "50216": "2w",
  "52747": "2w",
  "50169": "2w",
  "51571": "2w",
  "50602": "2w",
  "50522": "1w",
  "50854": "2w",
  "52561": "2w",
  "52035": "2w",
  "50634": "2w",
  "50666": "2w",
  "52556": "2w",
  "51458": "2w",
  "50662": "2w",
  "51029": "2w",
  "51014": "2w",
  "51053": "2w",
  "52242": "2w",
  "50272": "2w",
  "50839": "2w",
  "52584": "2w",
  "52551": "2w",
  "50480": "1w",
  "51003": "1w",
  "52773": "2w",
  "50244": "2w",
  "50068": "2w",
  "50632": "2w",
  "52625": "2w",
  "50518": "2w",
  "51036": "1w",
  "51501": "2w",
  "50214": "2w",
  "50475": "2w",
  "50616": "1w",
  "50435": "1w",
  "50166": "2w",
  "50139": "2w",
  "50125": "2w",
  "51526": "2w",
  "51564": "2w",
  "51346": "1w",
  "51542": "2w",
  "52254": "2w",
  "48188": "2e",
  "48131": "2e",
  "48049": "1e",
  "48040": "1e",
  "48079": "1e",
  "48097": "1e",
  "48843": "2e",
  "49709": "1e",
  "48182": "2e",
  "49646": "1e",
  "48467": "1e",
  "49028": "2e",
  "49743": "1e",
  "49228": "2e",
  "49959": "1e",
  "48139": "2e",
  "49780": "1e",
  "49795": "1e",
  "54540": "1e",
  "49120": "2e",
  "49958": "1e",
  "49916": "1e",
  "48505": "1e",
  "48622": "1e",
  "48619": "1e",
  "48054": "1e",
  "48064": "1e",
  "48855": "2e",
  "49270": "2e",
  "49276": "2e",
  "49801": "1e",
  "49853": "1e",
  "49892": "1e",
  "48177": "2e",
  "49947": "1e",
  "49676": "1e",
  "49402": "1e",
  "49765": "1e",
  "48759": "1e",
  "49793": "1e",
  "49802": "1e",
  "49738": "1e",
  "49449": "1e",
  "48878": "1e",
  "48617": "1e",
  "49340": "1e",
  "48746": "1e",
  "49004": "2e",
  "49017": "2e",
  "48874": "1e",
  "48067": "2e",
  "48889": "1e",
  "49757": "1e",
  "49305": "1e",
  "49873": "1e",
  "48475": "1e",
  "48735": "1e",
  "17776": "2e",
  "16057": "2e",
  "17219": "2e",
  "85633": "6",
  "85350": "6",
  "86334": "6",
  "85638": "6",
  "85609": "6",
  "85620": "6",
  "85605": "6",
  "86020": "5",
  "86036": "5",
  "86436": "6",
  "86404": "6",
  "85139": "6",
  "86413": "6",
  "85643": "6",
  "85935": "6",
  "85551": "6",
  "86022": "5",
  "85616": "6",
  "85607": "6",
  "86301": "6",
  "85641": "6",
  "85645": "6",
  "85735": "6",
  "85332": "6",
  "85739": "6",
  "85716": "6",
  "85650": "6",
  "85618": "6",
  "85623": "6",
  "86331": "6",
  "85354": "6",
  "85387": "6",
  "85328": "6",
  "86314": "6",
  "85322": "6",
  "85361": "6",
  "85145": "6",
  "85320": "6",
  "85707": "6",
  "86018": "5",
  "85540": "6",
  "85925": "6",
  "85936": "6",
  "85734": "6",
  "85282": "6",
  "85345": "6",
  "85255": "6",
  "85268": "6",
  "85022": "6",
  "85308": "6",
  "85203": "6",
  "85286": "6",
  "85226": "6",
  "85142": "6",
  "85333": "6",
  "85120": "6",
  "85215": "6",
  "85258": "6",
  "85015": "6",
  "85212": "6",
  "85634": "6",
  "87328": "5",
  "86054": "5",
  "85344": "6",
  "86535": "5",
  "85234": "6",
  "85533": "6",
  "85306": "6",
  "85016": "6",
  "85172": "6",
  "86433": "6",
  "80219": "5",
  "80113": "5",
  "80228": "5",
  "80401": "5",
  "80215": "5",
  "80212": "5",
  "80929": "5",
  "80913": "5",
  "80207": "5",
  "80483": "5",
  "80482": "5",
  "81049": "2w",
  "80643": "5",
  "81637": "5",
  "80463": "5",
  "80603": "5",
  "80602": "5",
  "80260": "5",
  "80640": "5",
  "81047": "2w",
  "81631": "5",
  "81501": "5",
  "80642": "5",
  "80733": "5",
  "82063": "5",
  "80516": "5",
  "80103": "5",
  "80136": "5",
  "55793": "1w",
  "56209": "1w",
  "56361": "1w",
  "55616": "1w",
  "55602": "1w",
  "55003": "1w",
  "56647": "1w",
  "55609": "1w",
  "56034": "1w",
  "56760": "1w",
  "56443": "1w",
  "55329": "1w",
  "56180": "1w",
  "56256": "1w",
  "55454": "1w",
  "55734": "1w",
  "56293": "1w",
  "56303": "1w",
  "55750": "1w",
  "55724": "1w",
  "56176": "1w",
  "56292": "1w",
  "55708": "1w",
  "55710": "1w",
  "55792": "1w",
  "55717": "1w",
  "56280": "1w",
  "55428": "1w",
  "55812": "1w",
  "55802": "1e",
  "50261": "2w",
  "50033": "2w",
  "51450": "2w",
  "52591": "2w",
  "50833": "2w",
  "50009": "2w",
  "51111": "2w",
  "52726": "2e",
  "52405": "2w",
  "51004": "2w",
  "50702": "2w",
  "50836": "2w",
  "50148": "2w",
  "50168": "2w",
  "50629": "2w",
  "50707": "2w",
  "51039": "2w",
  "51044": "2w",
  "50664": "2w",
  "52627": "2w",
  "50625": "2w",
  "51245": "1w",
  "52758": "2w",
  "50641": "2w",
  "52202": "2w",
  "50523": "2w",
  "50239": "2w",
  "50135": "2w",
  "50119": "2w",
  "50423": "1w",
  "51355": "1w",
  "50438": "1w",
  "50436": "1w",
  "52601": "2w",
  "45424": "2e",
  "44064": "2e",
  "44026": "2e",
  "45304": "2e",
  "45373": "2e",
  "44675": "2e",
  "43031": "2e",
  "44149": "2e",
  "44133": "2e",
  "44130": "2e",
  "44131": "2e",
  "44109": "2e",
  "43701": "2e",
  "44634": "2e",
  "45142": "2e",
  "44493": "2e",
  "44311": "2e",
  "45325": "2e",
  "44125": "2e",
  "44119": "2e",
  "44641": "2e",
  "44708": "2e",
  "44709": "2e",
  "45337": "2e",
  "44491": "2e",
  "44146": "2e",
  "44104": "2e",
  "44689": "2e",
  "44440": "2e",
  "44481": "2e",
  "43521": "2e",
  "43502": "2e",
  "45869": "2e",
  "45885": "2e",
  "45003": "2e",
  "45311": "2e",
  "43128": "2e",
  "44846": "2e",
  "45678": "2e",
  "43016": "2e",
  "44023": "2e",
  "44077": "2e",
  "44095": "2e",
  "45432": "2e",
  "44060": "2e",
  "43040": "2e",
  "43449": "2e",
  "43017": "2e",
  "45434": "2e",
  "44074": "2e",
  "43515": "2e",
  "45426": "2e",
  "44254": "2e",
  "45846": "2e",
  "45122": "2e",
  "44089": "2e",
  "45044": "2e",
  "43558": "2e",
  "43102": "2e",
  "45005": "2e",
  "44661": "2e",
  "43950": "2e",
  "44660": "2e",
  "44224": "2e",
  "44003": "2e",
  "43209": "2e",
  "44902": "2e",
  "44618": "2e",
  "45219": "2e",
  "44438": "2e",
  "43211": "2e",
  "43326": "2e",
  "45810": "2e",
  "45403": "2e",
  "44286": "2e",
  "43952": "2e",
  "43207": "2e",
  "44610": "2e",
  "43837": "2e",
  "43360": "2e",
  "43357": "2e",
  "43229": "2e",
  "45856": "2e",
  "43221": "2e",
  "43614": "2e",
  "45214": "2e",
  "45428": "2e",
  "44262": "2e",
  "44437": "2e",
  "45209": "2e",
  "32819": "4",
  "33856": "4",
  "31539": "4",
  "31001": "4",
  "30833": "4",
  "31516": "4",
  "31816": "4",
  "33980": "4",
  "33068": "4",
  "32332": "4",
  "32837": "4",
  "34614": "4",
  "33756": "4",
  "33764": "4",
  "30217": "4",
  "31510": "4",
  "30240": "4",
  "31090": "4",
  "31003": "4",
  "30667": "4",
  "30401": "4",
  "39817": "4",
  "31768": "4",
  "32569": "4",
  "33760": "4",
  "30552": "4",
  "30581": "4",
  "33744": "4",
  "33759": "4",
  "34677": "4",
  "32065": "4",
  "30807": "4",
  "33542": "4",
  "33576": "4",
  "33545": "4",
  "34772": "4",
  "32176": "4",
  "33924": "4",
  "32726": "4",
  "30449": "4",
  "30222": "4",
  "34610": "4",
  "34691": "4",
  "32778": "4",
  "33967": "4",
  "32087": "4",
  "33305": "4",
  "34758": "4",
  "33306": "4",
  "32953": "4",
  "32927": "4",
  "33326": "4",
  "32959": "4",
  "32136": "4",
  "33323": "4",
  "33351": "4",
  "31727": "4",
  "36278": "4",
  "35212": "4",
  "35217": "4",
  "35234": "4",
  "32501": "4",
  "30103": "4",
  "31030": "4",
  "32208": "4",
  "34205": "4",
  "30512": "4",
  "31415": "4",
  "36604": "4",
  "31068": "4",
  "36277": "4",
  "35204": "4",
  "30501": "4",
  "30535": "4",
  "32113": "4",
  "47420": "2e",
  "46157": "2e",
  "46184": "2e",
  "47451": "2e",
  "47270": "2e",
  "46787": "2e",
  "46929": "2e",
  "47516": "2e",
  "47528": "2e",
  "40334": "3e",
  "41364": "3e",
  "40536": "3e",
  "42321": "3e",
  "41735": "3e",
  "42356": "3e",
  "40280": "3e",
  "40404": "3e",
  "42758": "3e",
  "42163": "3e",
  "41566": "3e",
  "41397": "3e",
  "42022": "3e",
  "41421": "3e",
  "41257": "3e",
  "41772": "3e",
  "40481": "3e",
  "41859": "3e",
  "42452": "3e",
  "40370": "3e",
  "40019": "3e",
  "41071": "2e",
  "42045": "3e",
  "40223": "3e",
  "40403": "3e",
  "40205": "3e",
  "40214": "3e",
  "40046": "3e",
  "42406": "3e",
  "41080": "2e",
  "41048": "2e",
  "41074": "2e",
  "42040": "3e",
  "42058": "3e",
  "42210": "3e",
  "40442": "3e",
  "41097": "3e",
  "42567": "3e",
  "42376": "3e",
  "40209": "3e",
  "41183": "3e",
  "41653": "3e",
  "41039": "3e",
  "40461": "3e",
  "42348": "3e",
  "42039": "3e",
  "40339": "3e",
  "41645": "3e",
  "42328": "3e",
  "40330": "3e",
  "41189": "3e",
  "42501": "3e",
  "41045": "2e",
  "40342": "3e",
  "42544": "3e",
  "42259": "3e",
  "41749": "3e",
  "41821": "3e",
  "41731": "3e",
  "42345": "3e",
  "40409": "3e",
  "41004": "2e",
  "42456": "3e",
  "41274": "3e",
  "41663": "3e",
  "40845": "3e",
  "42757": "3e",
  "41250": "3e",
  "42635": "3e",
  "40729": "3e",
  "42361": "3e",
  "47036": "2e",
  "47929": "2e",
  "47861": "2e",
  "46345": "2e",
  "47639": "3e",
  "46403": "2e",
  "46818": "2e",
  "47968": "2e",
  "46038": "2e",
  "47104": "3e",
  "47977": "2e",
  "47615": "3e",
  "47537": "3e",
  "70543": "4",
  "71279": "4",
  "70607": "4",
  "70570": "4",
  "70512": "4",
  "70660": "4",
  "71435": "4",
  "70560": "4",
  "70003": "4",
  "70006": "4",
  "71350": "4",
  "70563": "4",
  "71202": "4",
  "70115": "4",
  "35544": "4",
  "35580": "4",
  "31606": "4",
  "32204": "4",
  "32506": "4",
  "31624": "4",
  "31650": "4",
  "35578": "4",
  "35128": "4",
  "36744": "4",
  "36856": "4",
  "35049": "4",
  "35112": "4",
  "35950": "4",
  "36804": "4",
  "36765": "4",
  "35135": "4",
  "33470": "4",
  "35143": "4",
  "35755": "4",
  "31093": "4",
  "30728": "4",
  "30340": "4",
  "30341": "4",
  "31312": "4",
  "31033": "4",
  "30094": "4",
  "31787": "4",
  "31764": "4",
  "36035": "4",
  "36005": "4",
  "36850": "4",
  "36752": "4",
  "36040": "4",
  "35979": "4",
  "36482": "4",
  "36031": "4",
  "36340": "4",
  "31733": "4",
  "32805": "4",
  "31709": "4",
  "30816": "4",
  "39827": "4",
  "31083": "4",
  "31544": "4",
  "33184": "4",
  "32225": "4",
  "31564": "4",
  "30013": "4",
  "35548": "4",
  "35540": "4",
  "35572": "4",
  "31082": "4",
  "30052": "4",
  "30011": "4",
  "33549": "4",
  "33613": "4",
  "34114": "4",
  "31783": "4",
  "39841": "4",
  "31630": "4",
  "36736": "4",
  "30516": "4",
  "30452": "4",
  "31730": "4",
  "30135": "4",
  "30134": "4",
  "30187": "4",
  "33805": "4",
  "30539": "4",
  "33615": "4",
  "30216": "4",
  "33811": "4",
  "30116": "4",
  "31812": "4",
  "31803": "4",
  "34139": "4",
  "30251": "4",
  "31012": "4",
  "31832": "4",
  "32826": "4",
  "32825": "4",
  "31775": "4",
  "32233": "4",
  "31560": "4",
  "32792": "4",
  "33841": "4",
  "33843": "4",
  "34734": "4",
  "32703": "4",
  "30121": "4",
  "39870": "4",
  "31793": "4",
  "31827": "4",
  "33321": "4",
  "32798": "4",
  "32824": "4",
  "32830": "4",
  "34613": "4",
  "33971": "4",
  "31757": "4",
  "39834": "4",
  "31545": "4",
  "31627": "4",
  "31042": "4",
  "66224": "2w",
  "66611": "2w",
  "66414": "2w",
  "66842": "2w",
  "67151": "2w",
  "67601": "2w",
  "67062": "2w",
  "57103": "1w",
  "57436": "1w",
  "57258": "1w",
  "57473": "1w",
  "57429": "1w",
  "57279": "1w",
  "57010": "1w",
  "57750": "2w",
  "57780": "1w",
  "57051": "1w",
  "57027": "1w",
  "57014": "1w",
  "57792": "1w",
  "36503": "4",
  "30272": "4",
  "35491": "4",
  "30414": "4",
  "36280": "4",
  "36258": "4",
  "36274": "4",
  "35235": "4",
  "36617": "4",
  "35954": "4",
  "30624": "4",
  "34237": "4",
  "31522": "4",
  "30510": "4",
  "32206": "4",
  "36610": "4",
  "35749": "3e",
  "31904": "4",
  "33181": "4",
  "36113": "4",
  "33935": "4",
  "36605": "4",
  "30315": "4",
  "35064": "4",
  "35218": "4",
  "35640": "4",
  "36013": "4",
  "35650": "4",
  "36663": "4",
  "32664": "4",
  "32505": "4",
  "30605": "4",
  "32307": "4",
  "32133": "4",
  "33136": "4",
  "34476": "4",
  "30316": "4",
  "31406": "4",
  "30519": "4",
  "32612": "4",
  "33165": "4",
  "33145": "4",
  "47406": "2e",
  "47720": "3e",
  "46845": "2e",
  "46036": "2e",
  "47341": "2e",
  "46788": "2e",
  "47334": "2e",
  "46076": "2e",
  "46203": "2e",
  "47429": "2e",
  "46530": "2e",
  "46216": "2e",
  "46553": "2e",
  "46115": "2e",
  "47907": "2e",
  "46738": "2e",
  "46347": "2e",
  "47971": "2e",
  "46051": "2e",
  "46778": "2e",
  "46945": "2e",
  "47335": "2e",
  "47387": "2e",
  "47348": "2e",
  "47964": "2e",
  "47580": "3e",
  "47654": "3e",
  "47576": "3e",
  "47434": "2e",
  "47983": "2e",
  "47809": "2e",
  "47567": "2e",
  "47325": "2e",
  "47562": "2e",
  "46122": "2e",
  "41531": "3e",
  "40107": "3e",
  "41408": "3e",
  "42129": "3e",
  "41056": "3e",
  "40119": "3e",
  "42749": "3e",
  "40484": "3e",
  "41605": "3e",
  "42343": "3e",
  "40144": "3e",
  "41722": "3e",
  "41826": "3e",
  "40460": "3e",
  "42044": "3e",
  "42455": "3e",
  "41222": "3e",
  "40823": "3e",
  "41828": "3e",
  "40741": "3e",
  "41255": "3e",
  "41465": "3e",
  "40312": "3e",
  "40033": "3e",
  "40328": "3e",
  "40155": "3e",
  "42541": "3e",
  "40152": "3e",
  "42634": "3e",
  "42713": "3e",
  "40997": "3e",
  "42764": "3e",
  "40982": "3e",
  "40903": "3e",
  "42762": "3e",
  "40827": "3e",
  "41317": "3e",
  "40448": "3e",
  "40995": "3e",
  "40979": "3e",
  "42565": "3e",
  "42431": "3e",
  "40060": "3e",
  "40815": "3e",
  "42032": "3w",
  "40526": "3e",
  "40829": "3e",
  "41762": "3e",
  "41564": "3e",
  "41512": "3e",
  "78075": "6",
  "79720": "6",
  "76570": "6",
  "75555": "3w",
  "77437": "6",
  "78828": "6",
  "79735": "6",
  "79322": "6",
  "77367": "3w",
  "77458": "4",
  "77560": "4",
  "79360": "6",
  "76374": "3w",
  "79058": "2w",
  "79259": "3w",
  "75469": "3w",
  "75494": "3w",
  "75644": "3w",
  "76671": "3w",
  "76890": "6",
  "79003": "2w",
  "75127": "3w",
  "77971": "4",
  "79364": "6",
  "76471": "6",
  "77964": "6",
  "79528": "6",
  "76844": "6",
  "76665": "6",
  "76460": "3w",
  "76539": "6",
  "79085": "2w",
  "76690": "3w",
  "77970": "4",
  "78838": "6",
  "78650": "6",
  "79371": "6",
  "79095": "3w",
  "78884": "6",
  "75410": "3w",
  "75980": "4",
  "79351": "6",
  "79748": "6",
  "76538": "6",
  "75493": "3w",
  "76463": "6",
  "79324": "6",
  "79013": "2w",
  "78620": "6",
  "78504": "4",
  "78541": "4",
  "75034": "3w",
  "75078": "3w",
  "78750": "6",
  "78730": "6",
  "75025": "3w",
  "76228": "3w",
  "75495": "3w",
  "78734": "6",
  "75248": "3w",
  "75048": "3w",
  "75032": "3w",
  "78724": "6",
  "75119": "3w",
  "78654": "6",
  "78733": "6",
  "76064": "3w",
  "76050": "3w",
  "41260": "3e",
  "42742": "3e",
  "40355": "2e",
  "42440": "3e",
  "42285": "3e",
  "41526": "3e",
  "41517": "3e",
  "40219": "3e",
  "42274": "3e",
  "40216": "3e",
  "40258": "3e",
  "41144": "3e",
  "40356": "3e",
  "42027": "3e",
  "40175": "3e",
  "40217": "3e",
  "40218": "3e",
  "40010": "3e",
  "41030": "2e",
  "41094": "2e",
  "41059": "2e",
  "41018": "2e",
  "40508": "3e",
  "40505": "3e",
  "42724": "3e",
  "42025": "3e",
  "42083": "3e",
  "41007": "2e",
  "42740": "3e",
  "42776": "3e",
  "42349": "3e",
  "40437": "3e",
  "42368": "3e",
  "41035": "2e",
  "42085": "3e",
  "40507": "3e",
  "42076": "3e",
  "40121": "3e",
  "40242": "3e",
  "42461": "3e",
  "42712": "3e",
  "41666": "3e",
  "42320": "3e",
  "41636": "3e",
  "41501": "3e",
  "41216": "3e",
  "42553": "3e",
  "41555": "3e",
  "42256": "3e",
  "41472": "3e",
  "40983": "3e",
  "41514": "3e",
  "41544": "3e",
  "41219": "3e",
  "42055": "3e",
  "42141": "3e",
  "42123": "3e",
  "42642": "3e",
  "42130": "3e",
  "42217": "3e",
  "42215": "3e",
  "42232": "3e",
  "41602": "3e",
  "41537": "3e",
  "47568": "2e",
  "47553": "2e",
  "47462": "2e",
  "46392": "2e",
  "46310": "2e",
  "46205": "2e",
  "46234": "2e",
  "46032": "2e",
  "46103": "2e",
  "47513": "3e",
  "47541": "3e",
  "47532": "3e",
  "46360": "2e",
  "46342": "2e",
  "46554": "2e",
  "46733": "2e",
  "47846": "2e",
  "47840": "2e",
  "46319": "2e",
  "46410": "2e",
  "47872": "2e",
  "47612": "3e",
  "46947": "2e",
  "47118": "3e",
  "47455": "2e",
  "47125": "2e",
  "46795": "2e",
  "47037": "2e",
  "46304": "2e",
  "47386": "2e",
  "47360": "2e",
  "47272": "2e",
  "46173": "2e",
  "46991": "2e",
  "46562": "2e",
  "47003": "2e",
  "47043": "2e",
  "47017": "2e",
  "47858": "2e",
  "47446": "2e",
  "46176": "2e",
  "46124": "2e",
  "46166": "2e",
  "46259": "2e",
  "47223": "2e",
  "47960": "2e",
  "47373": "2e",
  "46160": "2e",
  "46162": "2e",
  "81643": "5",
  "80451": "5",
  "81635": "5",
  "80863": "5",
  "80106": "5",
  "81228": "5",
  "81046": "5",
  "80939": "5",
  "80013": "5",
  "80024": "5",
  "80425": "5",
  "80453": "5",
  "80302": "5",
  "80427": "5",
  "80419": "5",
  "80108": "5",
  "80310": "5",
  "80510": "5",
  "80444": "5",
  "80436": "5",
  "80802": "2w",
  "80862": "2w",
  "81136": "5",
  "80118": "5",
  "81210": "5",
  "80755": "2w",
  "80758": "2w",
  "80828": "5",
  "80461": "5",
  "81239": "5",
  "81248": "5",
  "80824": "2w",
  "81121": "5",
  "80821": "5",
  "80826": "5",
  "81425": "5",
  "80101": "5",
  "81057": "2w",
  "81087": "2w",
  "81133": "5",
  "81301": "5",
  "81433": "5",
  "81240": "5",
  "17701": "2e",
  "16101": "2e",
  "19107": "2e",
  "17603": "2e",
  "17948": "2e",
  "15448": "2e",
  "15370": "2e",
  "15379": "2e",
  "89410": "5",
  "89509": "5",
  "89701": "5",
  "89084": "5",
  "89025": "5",
  "89074": "5",
  "89191": "5",
  "89406": "5",
  "89815": "5",
  "89020": "5",
  "89403": "5",
  "89825": "5",
  "89519": "5",
  "89822": "5",
  "89119": "5",
  "89433": "5",
  "89444": "5",
  "89434": "5",
  "89144": "5",
  "89143": "5",
  "89405": "5",
  "89085": "5",
  "89054": "5",
  "89419": "5",
  "89045": "5",
  "89049": "5",
  "89835": "5",
  "89834": "5",
  "89022": "5",
  "89830": "5",
  "89408": "5",
  "89048": "5",
  "89061": "5",
  "89017": "5",
  "89826": "5",
  "89311": "5",
  "89318": "5",
  "84034": "5",
  "82052": "5",
  "82450": "5",
  "82944": "5",
  "82943": "5",
  "82324": "5",
  "83110": "5",
  "83126": "5",
  "83119": "5",
  "82718": "5",
  "82716": "5",
  "82725": "5",
  "82060": "5",
  "82061": "5",
  "82516": "5",
  "82005": "5",
  "82720": "5",
  "82223": "5",
  "82229": "5",
  "82714": "5",
  "82242": "5",
  "82434": "5",
  "82072": "5",
  "82431": "5",
  "82414": "5",
  "82442": "5",
  "57233": "1w",
  "57758": "1w",
  "57385": "1w",
  "57551": "2w",
  "57770": "5",
  "57772": "2w",
  "57566": "2w",
  "57560": "2w",
  "57547": "2w",
  "57024": "1w",
  "56164": "1w",
  "57065": "1w",
  "57762": "1w",
  "57045": "1w",
  "57046": "1w",
  "57564": "1w",
  "57522": "1w",
  "57311": "1w",
  "57375": "1w",
  "57073": "1w",
  "57433": "1w",
  "57441": "1w",
  "57232": "1w",
  "57259": "1w",
  "57246": "1w",
  "57223": "1w",
  "56257": "1w",
  "57221": "1w",
  "57568": "1w",
  "57340": "1w",
  "57104": "1w",
  "57018": "1w",
  "57322": "1w",
  "57442": "1w",
  "57301": "1w",
  "57725": "1w",
  "57745": "5",
  "57342": "1w",
  "82727": "5",
  "82833": "5",
  "82310": "5",
  "82435": "5",
  "82646": "5",
  "82638": "5",
  "82053": "5",
  "82523": "5",
  "82832": "5",
  "82836": "5",
  "82620": "5",
  "82644": "5",
  "82838": "5",
  "82635": "5",
  "82842": "5",
  "82711": "5",
  "82637": "5",
  "82219": "5",
  "82217": "5",
  "83011": "5",
  "82190": "5",
  "82410": "5",
  "82411": "5",
  "82083": "5",
  "82430": "5",
  "82942": "5",
  "82335": "5",
  "83124": "5",
  "83121": "5",
  "83122": "5",
  "83111": "5",
  "82609": "5",
  "82601": "5",
  "82732": "5",
  "82054": "5",
  "82839": "5",
  "82844": "5",
  "82227": "5",
  "83014": "5",
  "82058": "5",
  "82325": "5",
  "82327": "5",
  "82334": "5",
  "82084": "5",
  "82935": "5",
  "82922": "5",
  "82640": "5",
  "83025": "5",
  "82432": "5",
  "82426": "5",
  "82323": "5",
  "82930": "5",
  "82933": "5",
  "83114": "5",
  "83116": "5",
  "82938": "5",
  "82801": "5",
  "83113": "5",
  "82001": "5",
  "82925": "5",
  "82604": "5",
  "82630": "5",
  "82059": "5",
  "82081": "5",
  "82639": "5",
  "82642": "5",
  "82649": "5",
  "82648": "5",
  "82221": "5",
  "82730": "5",
  "82721": "5",
  "82212": "5",
  "82214": "5",
  "82218": "5",
  "83012": "5",
  "82428": "5",
  "82441": "5",
  "82440": "5",
  "82433": "5",
  "82443": "5",
  "82329": "5",
  "82051": "5",
  "82936": "5",
  "82945": "5",
  "83123": "5",
  "82501": "5",
  "82512": "5",
  "82240": "5",
  "82710": "5",
  "82729": "5",
  "82633": "5",
  "82834": "5",
  "82201": "5",
  "82213": "5",
  "82222": "5",
  "82225": "5",
  "82301": "5",
  "82331": "5",
  "82055": "5",
  "82073": "5",
  "82321": "5",
  "82937": "5",
  "82932": "5",
  "82934": "5",
  "82835": "5",
  "82520": "5",
  "82513": "5",
  "82845": "5",
  "82941": "5",
  "82923": "5",
  "82070": "5",
  "82009": "5",
  "82514": "5",
  "82636": "5",
  "45851": "2e",
  "43111": "2e",
  "43144": "2e",
  "43356": "2e",
  "44840": "2e",
  "43754": "2e",
  "44849": "2e",
  "43942": "2e",
  "43780": "2e",
  "43717": "2e",
  "45744": "2e",
  "43725": "2e",
  "44633": "2e",
  "44691": "2e",
  "44838": "2e",
  "44874": "2e",
  "43983": "2e",
  "44843": "2e",
  "44670": "2e",
  "43201": "2e",
  "44047": "2e",
  "44667": "2e",
  "45505": "2e",
  "44403": "2e",
  "44041": "2e",
  "44659": "2e",
  "44084": "2e",
  "45694": "3e",
  "44420": "2e",
  "43953": "2e",
  "43206": "2e",
  "44087": "2e",
  "43610": "2e",
  "45841": "2e",
  "43938": "2e",
  "43331": "2e",
  "45658": "2e",
  "45890": "2e",
  "45230": "2e",
  "45208": "2e",
  "45858": "2e",
  "45349": "2e",
  "43037": "2e",
  "45833": "2e",
  "43074": "2e",
  "43402": "2e",
  "43137": "2e",
  "45224": "2e",
  "43933": "2e",
  "43912": "2e",
  "45033": "2e",
  "45246": "2e",
  "43451": "2e",
  "43971": "2e",
  "45111": "2e",
  "43217": "2e",
  "43109": "2e",
  "43540": "2e",
  "43116": "2e",
  "44619": "2e",
  "43047": "2e",
  "45267": "2e",
  "07088": "2e",
  "08865": "2e",
  "07646": "2e",
  "07514": "2e",
  "07840": "2e",
  "07830": "2e",
  "07052": "2e",
  "07050": "2e",
  "07410": "2e",
  "07032": "2e",
  "07107": "2e",
  "08401": "2e",
  "08837": "2e",
  "08225": "2e",
  "07078": "2e",
  "07110": "2e",
  "07648": "2e",
  "07856": "2e",
  "07082": "2e",
  "07446": "2e",
  "07463": "2e",
  "07662": "2e",
  "08260": "2e",
  "07004": "2e",
  "07112": "2e",
  "07077": "2e",
  "07034": "2e",
  "08067": "2e",
  "08816": "2e",
  "07849": "2e",
  "07310": "2e",
  "07457": "2e",
  "07878": "2e",
  "07644": "2e",
  "07823": "2e",
  "07961": "2e",
  "97499": "7",
  "97435": "7",
  "97011": "7",
  "97335": "7",
  "97144": "7",
  "97125": "7",
  "97862": "5",
  "97442": "7",
  "97496": "7",
  "97039": "5",
  "97886": "5",
  "97341": "7",
  "97856": "5",
  "97830": "5",
  "97380": "7",
  "97875": "5",
  "97394": "7",
  "97751": "5",
  "97138": "7",
  "97543": "7",
  "97914": "5",
  "97824": "5",
  "97638": "5",
  "97711": "5",
  "97817": "5",
  "97141": "7",
  "97758": "5",
  "97637": "5",
  "97844": "5",
  "97054": "7",
  "97112": "7",
  "97489": "7",
  "97217": "7",
  "97411": "7",
  "97204": "7",
  "97423": "7",
  "97324": "7",
  "97535": "7",
  "89123": "5",
  "89183": "5",
  "89139": "5",
  "89508": "5",
  "89402": "5",
  "89002": "5",
  "89046": "5",
  "89070": "5",
  "89008": "5",
  "89047": "5",
  "89823": "5",
  "89319": "5",
  "89427": "5",
  "89420": "5",
  "89428": "5",
  "89413": "5",
  "89121": "5",
  "89511": "5",
  "89705": "5",
  "89110": "5",
  "89439": "5",
  "89120": "5",
  "89147": "5",
  "89134": "5",
  "89436": "5",
  "89145": "5",
  "89510": "5",
  "89081": "5",
  "23486": "3e",
  "20111": "2e",
  "23879": "3e",
  "23413": "3e",
  "24136": "3e",
  "24558": "3e",
  "22989": "3e",
  "24162": "3e",
  "20198": "2e",
  "22731": "3e",
  "22725": "3e",
  "24555": "3e",
  "29940": "4",
  "29163": "4",
  "29544": "4",
  "29718": "4",
  "29127": "4",
  "29727": "4",
  "29709": "4",
  "29003": "4",
  "29335": "4",
  "29708": "3e",
  "29715": "3e",
  "29579": "4",
  "29525": "4",
  "29743": "3e",
  "29923": "4",
  "29840": "4",
  "29225": "4",
  "29373": "4",
  "29912": "4",
  "29446": "4",
  "29452": "4",
  "29070": "4",
  "29307": "4",
  "29455": "4",
  "29611": "4",
  "29466": "4",
  "29492": "4",
  "29431": "4",
  "29483": "4",
  "29511": "4",
  "29115": "4",
  "29526": "4",
  "29601": "4",
  "29152": "4",
  "29051": "4",
  "23947": "3e",
  "20169": "2e",
  "23962": "3e",
  "20143": "2e",
  "23952": "3e",
  "22712": "3e",
  "22718": "3e",
  "24539": "3e",
  "23927": "3e",
  "22729": "3e",
  "24293": "3e",
  "24273": "3e",
  "22747": "3e",
  "22949": "3e",
  "23106": "3e",
  "23508": "3e",
  "24248": "3e",
  "22560": "3e",
  "24281": "3e",
  "22406": "3e",
  "23503": "3e",
  "23109": "3e",
  "65723": "3w",
  "65337": "2w",
  "64763": "2w",
  "65603": "2w",
  "65685": "2w",
  "65635": "2w",
  "65332": "2w",
  "63563": "2w",
  "64635": "2w",
  "63775": "3w",
  "63830": "3w",
  "63739": "3w",
  "63785": "3w",
  "63781": "3w",
  "64624": "2w",
  "64681": "2w",
  "65571": "3w",
  "64620": "2w",
  "65335": "2w",
  "65457": "2w",
  "63544": "2w",
  "64740": "2w",
  "64750": "2w",
  "65323": "2w",
  "63760": "3w",
  "63940": "3w",
  "63601": "2w",
  "63937": "3w",
  "64741": "2w",
  "64466": "2w",
  "63012": "2w",
  "64856": "3w",
  "65647": "3w",
  "63116": "2w",
  "64116": "2w",
  "64119": "2w",
  "63136": "2w",
  "63123": "2w",
  "63127": "2w",
  "64111": "2w",
  "65262": "2w",
  "63134": "2w",
  "63135": "2w",
  "63146": "2w",
  "63131": "2w",
  "63852": "3w",
  "65063": "2w",
  "65738": "2w",
  "64060": "2w",
  "65730": "3w",
  "64066": "2w",
  "64105": "2w",
  "64056": "2w",
  "64146": "2w",
  "64123": "2w",
  "65803": "2w",
  "65804": "3w",
  "64125": "2w",
  "64505": "2w",
  "65757": "2w",
  "65781": "2w",
  "64485": "2w",
  "64054": "2w",
  "64053": "2w",
  "64436": "2w",
  "65617": "2w",
  "63132": "2w",
  "63821": "3w",
  "65046": "2w",
  "65586": "2w",
  "65446": "2w",
  "65456": "2w",
  "63030": "2w",
  "04491": "1e",
  "70770": "4",
  "70712": "4",
  "71245": "3w",
  "71247": "4",
  "71410": "4",
  "71227": "4",
  "71001": "3w",
  "71465": "4",
  "71270": "4",
  "71238": "4",
  "70549": "4",
  "70030": "4",
  "70358": "4",
  "70067": "4",
  "71405": "4",
  "70116": "4",
  "71203": "4",
  "71023": "3w",
  "70123": "4",
  "71368": "4",
  "71354": "4",
  "71373": "4",
  "71450": "4",
  "71212": "4",
  "71468": "4",
  "71447": "4",
  "70611": "4",
  "70815": "4",
  "70813": "4",
  "70427": "4",
  "70393": "4",
  "70341": "4",
  "48893": "1e",
  "48912": "2e",
  "49503": "1e",
  "49127": "2e",
  "49015": "2e",
  "49720": "1e",
  "48030": "2e",
  "49007": "2e",
  "48811": "1e",
  "49001": "2e",
  "48748": "1e",
  "49130": "2e",
  "48879": "1e",
  "48073": "2e",
  "48750": "1e",
  "49871": "1e",
  "49921": "1e",
  "48420": "1e",
  "49255": "2e",
  "48726": "1e",
  "49755": "1e",
  "49665": "1e",
  "49337": "1e",
  "49642": "1e",
  "49716": "1e",
  "49817": "1e",
  "49349": "1e",
  "49674": "1e",
  "48738": "1e",
  "49621": "1e",
  "48471": "1e",
  "49910": "1e",
  "49654": "1e",
  "48410": "1e",
  "49457": "1e",
  "49715": "1e",
  "49728": "1e",
  "48450": "1e",
  "49329": "1e",
  "49339": "1e",
  "49343": "1e",
  "48809": "1e",
  "48819": "2e",
  "49097": "2e",
  "49087": "2e",
  "49038": "2e",
  "49319": "1e",
  "49027": "2e",
  "49284": "2e",
  "49055": "2e",
  "49341": "1e",
  "48724": "1e",
  "49825": "1e",
  "49423": "2e",
  "49093": "2e",
  "49507": "1e",
  "49024": "2e",
  "49102": "2e",
  "49448": "1e",
  "48876": "2e",
  "49403": "1e",
  "49323": "2e",
  "48730": "1e",
  "49546": "1e",
  "48460": "1e",
  "48457": "1e",
  "48816": "2e",
  "48441": "1e",
  "49719": "1e",
  "49411": "1e",
  "49410": "1e",
  "49660": "1e",
  "48761": "1e",
  "48754": "1e",
  "49252": "2e",
  "49756": "1e",
  "49712": "1e",
  "49885": "1e",
  "49504": "1e",
  "48503": "1e",
  "48847": "1e",
  "49061": "2e",
  "49095": "2e",
  "48871": "1e",
  "48624": "1e",
  "48734": "1e",
  "49766": "1e",
  "49965": "1e",
  "49634": "1e",
  "49833": "1e",
  "48610": "1e",
  "32610": "4",
  "30828": "4",
  "30204": "4",
  "35961": "4",
  "35444": "4",
  "35474": "4",
  "35456": "4",
  "35476": "4",
  "35473": "4",
  "35555": "4",
  "35022": "4",
  "33908": "4",
  "32360": "4",
  "32603": "4",
  "32404": "4",
  "32784": "4",
  "33407": "4",
  "33127": "4",
  "34997": "4",
  "35802": "4",
  "35903": "4",
  "35254": "4",
  "30104": "4",
  "31527": "4",
  "33176": "4",
  "34471": "4",
  "33156": "4",
  "32182": "4",
  "33056": "4",
  "34221": "4",
  "34470": "4",
  "32312": "4",
  "32653": "4",
  "33134": "4",
  "36619": "4",
  "35042": "4",
  "35221": "4",
  "36041": "4",
  "36560": "4",
  "35034": "4",
  "30206": "4",
  "31519": "4",
  "34480": "4",
  "35020": "4",
  "36346": "4",
  "36034": "4",
  "36521": "4",
  "35761": "3e",
  "35632": "3e",
  "36615": "4",
  "36523": "4",
  "36512": "4",
  "31092": "4",
  "31313": "4",
  "34250": "4",
  "64109": "2w",
  "65656": "3w",
  "64071": "2w",
  "63385": "2w",
  "63863": "3w",
  "63368": "2w",
  "65327": "2w",
  "64152": "2w",
  "65201": "2w",
  "64058": "2w",
  "64016": "2w",
  "64859": "2w",
  "64082": "2w",
  "65344": "2w",
  "64072": "2w",
  "64506": "2w",
  "64496": "2w",
  "64467": "2w",
  "65280": "2w",
  "63466": "2w",
  "63961": "3w",
  "65771": "3w",
  "65722": "2w",
  "64726": "2w",
  "64050": "2w",
  "65809": "3w",
  "64830": "2w",
  "65216": "2w",
  "64483": "2w",
  "64480": "2w",
  "64134": "2w",
  "64139": "2w",
  "63130": "2w",
  "63155": "2w",
  "65018": "2w",
  "65535": "2w",
  "63020": "2w",
  "63071": "2w",
  "65466": "3w",
  "63771": "3w",
  "63648": "2w",
  "63548": "2w",
  "65261": "2w",
  "64676": "2w",
  "65634": "2w",
  "65668": "2w",
  "63656": "3w",
  "64657": "2w",
  "63746": "3w",
  "65236": "2w",
  "63960": "3w",
  "65760": "3w",
  "63561": "2w",
  "65755": "3w",
  "63560": "2w",
  "64482": "2w",
  "63751": "3w",
  "64765": "2w",
  "65232": "2w",
  "27536": "3e",
  "28392": "3e",
  "28340": "4",
  "28160": "3e",
  "28074": "3e",
  "28651": "3e",
  "28089": "3e",
  "27949": "3e",
  "28581": "3e",
  "28693": "3e",
  "28359": "3e",
  "28512": "3e",
  "28617": "3e",
  "27953": "3e",
  "28330": "3e",
  "27555": "3e",
  "27510": "3e",
  "27412": "3e",
  "27377": "3e",
  "27520": "3e",
  "28081": "3e",
  "27527": "3e",
  "28159": "3e",
  "28681": "3e",
  "28083": "3e",
  "28072": "3e",
  "28465": "3e",
  "27213": "3e",
  "28721": "3e",
  "28425": "3e",
  "27866": "3e",
  "27862": "3e",
  "28698": "3e",
  "28007": "3e",
  "28458": "3e",
  "27916": "3e",
  "28466": "3e",
  "28786": "3e",
  "27960": "3e",
  "27845": "3e",
  "27877": "3e",
  "27947": "3e",
  "28756": "3e",
  "27973": "3e",
  "28448": "3e",
  "28444": "3e",
  "27850": "3e",
  "28901": "3e",
  "28423": "3e",
  "27865": "3e",
  "28450": "3e",
  "27315": "3e",
  "27962": "3e",
  "28735": "3e",
  "27616": "3e",
  "27351": "3e",
  "28902": "4",
  "27047": "3e",
  "28439": "4",
  "28664": "3e",
  "28387": "3e",
  "28374": "3e",
  "28042": "3e",
  "28663": "3e",
  "28510": "3e",
  "28136": "3e",
  "28741": "3e",
  "27594": "3e",
  "28114": "3e",
  "27849": "3e",
  "28659": "3e",
  "28527": "3e",
  "27229": "3e",
  "28332": "3e",
  "28720": "3e",
  "27979": "3e",
  "28347": "3e",
  "28697": "3e",
  "28338": "3e",
  "27926": "3e",
  "27937": "3e",
  "28531": "3e",
  "28524": "3e",
  "27825": "3e",
  "27972": "3e",
  "28672": "3e",
  "33477": "4",
  "33905": "4",
  "32179": "4",
  "32503": "4",
  "32641": "4",
  "30564": "4",
  "32304": "4",
  "32403": "4",
  "33166": "4",
  "33405": "4",
  "32607": "4",
  "36111": "4",
  "36250": "4",
  "30311": "4",
  "30313": "4",
  "31419": "4",
  "33173": "4",
  "33157": "4",
  "33444": "4",
  "31543": "4",
  "31566": "4",
  "30332": "4",
  "32306": "4",
  "34240": "4",
  "33606": "4",
  "33912": "4",
  "32305": "4",
  "33137": "4",
  "36579": "4",
  "35546": "4",
  "36792": "4",
  "35115": "4",
  "36046": "4",
  "35188": "4",
  "35630": "3e",
  "36036": "4",
  "36010": "4",
  "36509": "4",
  "36528": "4",
  "30753": "4",
  "30747": "4",
  "31554": "4",
  "30650": "4",
  "30292": "4",
  "30549": "4",
  "30558": "4",
  "31333": "4",
  "31085": "4",
  "30224": "4",
  "30711": "4",
  "30110": "4",
  "30339": "4",
  "30906": "4",
  "34473": "4",
  "30305": "4",
  "31558": "4",
  "36551": "4",
  "36322": "4",
  "35633": "3e",
  "33317": "4",
  "32072": "4",
  "32935": "4",
  "32951": "4",
  "32780": "4",
  "32963": "4",
  "32909": "4",
  "32968": "4",
  "32958": "4",
  "32132": "4",
  "32169": "4",
  "32119": "4",
  "32117": "4",
  "36764": "4",
  "36851": "4",
  "30639": "4",
  "35206": "4",
  "36130": "4",
  "36054": "4",
  "36264": "4",
  "35806": "3e",
  "30601": "4",
  "30904": "4",
  "30306": "4",
  "30662": "4",
  "30161": "4",
  "45681": "2e",
  "45115": "2e",
  "44030": "2e",
  "44804": "2e",
  "45812": "2e",
  "43535": "2e",
  "43343": "2e",
  "43347": "2e",
  "45229": "2e",
  "45674": "2e",
  "43026": "2e",
  "45872": "2e",
  "45816": "2e",
  "43123": "2e",
  "43615": "2e",
  "43004": "2e",
  "43617": "2e",
  "43005": "2e",
  "43035": "2e",
  "45251": "2e",
  "43939": "2e",
  "43935": "2e",
  "44653": "2e",
  "43571": "2e",
  "43943": "2e",
  "43066": "2e",
  "45174": "2e",
  "45243": "2e",
  "45389": "2e",
  "43342": "2e",
  "43972": "2e",
  "45032": "2e",
  "45001": "2e",
  "43126": "2e",
  "43565": "2e",
  "45218": "2e",
  "61541": "2e",
  "62985": "3e",
  "62319": "2e",
  "61469": "2w",
  "61480": "2e",
  "61454": "2e",
  "61951": "2e",
  "62428": "2e",
  "62984": "3e",
  "62027": "2e",
  "60479": "2e",
  "61310": "2e",
  "61283": "2e",
  "60112": "2e",
  "61243": "2e",
  "60444": "2e",
  "62701": "2e",
  "60474": "2e",
  "62707": "2e",
  "62703": "2e",
  "61489": "2e",
  "60641": "2e",
  "62207": "2e",
  "61925": "2e",
  "62554": "2e",
  "60531": "2e",
  "61752": "2e",
  "62867": "3e",
  "60470": "2e",
  "61364": "2e",
  "60929": "2e",
  "61049": "2e",
  "61068": "2e",
  "61537": "2e",
  "61051": "2e",
  "61014": "2e",
  "61061": "2e",
  "61362": "2e",
  "61332": "2e",
  "62839": "2e",
  "61735": "2e",
  "60955": "2e",
  "62261": "2w",
  "62885": "2e",
  "62292": "2e",
  "61491": "2e",
  "62858": "2e",
  "62878": "2e",
  "62823": "2e",
  "62512": "2e",
  "62853": "2e",
  "61479": "2e",
  "62824": "2e",
  "61910": "2e",
  "62352": "2e",
  "61477": "2e",
  "62094": "2e",
  "62015": "2e",
  "62992": "3e",
  "61433": "2e",
  "62811": "2e",
  "62626": "2e",
  "61957": "2e",
  "62465": "2e",
  "62444": "2e",
  "61316": "2e",
  "62879": "2e",
  "62996": "3e",
  "62976": "3e",
  "62943": "3e",
  "61418": "2e",
  "61437": "2e",
  "61425": "2e",
  "62375": "2e",
  "62432": "2e",
  "62475": "2e",
  "62425": "2e",
  "61067": "2e",
  "61324": "2e",
  "61439": "2e",
  "61071": "2e",
  "60178": "2e",
  "62702": "2e",
  "61821": "2e",
  "62305": "2e",
  "62918": "3e",
  "60553": "2e",
  "60518": "2e",
  "61342": "2e",
  "61705": "2e",
  "61448": "2e",
  "61874": "2e",
  "61544": "2e",
  "59825": "5",
  "59932": "5",
  "59075": "5",
  "59762": "5",
  "59736": "5",
  "59722": "5",
  "59418": "5",
  "59642": "5",
  "59720": "5",
  "59739": "5",
  "59018": "5",
  "59728": "5",
  "59468": "5",
  "59430": "5",
  "59916": "5",
  "59010": "5",
  "59501": "5",
  "59052": "5",
  "59640": "5",
  "59487": "5",
  "59928": "5",
  "59866": "5",
  "59421": "5",
  "59875": "5",
  "59747": "5",
  "59027": "5",
  "59043": "5",
  "59456": "5",
  "59632": "5",
  "59845": "5",
  "59028": "5",
  "59871": "5",
  "59829": "5",
  "59002": "5",
  "59824": "5",
  "59079": "5",
  "59442": "5",
  "59440": "5",
  "59066": "5",
  "59457": "5",
  "59276": "1w",
  "59253": "1w",
  "59527": "5",
  "59544": "1w",
  "59241": "1w",
  "59244": "1w",
  "59260": "1w",
  "59212": "1w",
  "59537": "5",
  "59910": "5",
  "59432": "5",
  "59485": "5",
  "59257": "1w",
  "59911": "5",
  "59034": "5",
  "59433": "5",
  "59868": "5",
  "59648": "5",
  "59436": "5",
  "59003": "5",
  "59464": "5",
  "59435": "5",
  "59936": "5",
  "59639": "5",
  "59701": "5",
  "59808": "5",
  "59082": "5",
  "59647": "5",
  "59751": "5",
  "59444": "5",
  "59730": "5",
  "59922": "5",
  "59030": "5",
  "59872": "5",
  "59102": "5",
  "59521": "5",
  "59831": "5",
  "59540": "5",
  "59531": "5",
  "59460": "5",
  "59213": "1w",
  "59755": "5",
  "59461": "5",
  "59448": "5",
  "59447": "5",
  "72841": "3w",
  "71749": "3w",
  "71631": "3w",
  "72802": "3w",
  "71758": "3w",
  "72826": "3w",
  "72847": "3w",
  "72585": "3w",
  "71958": "3w",
  "71999": "3w",
  "71969": "3w",
  "72540": "3w",
  "72405": "3w",
  "72437": "3w",
  "71659": "3w",
  "72210": "3w",
  "72073": "3w",
  "72053": "3w",
  "72135": "3w",
  "72183": "3w",
  "72945": "3w",
  "72941": "3w",
  "72727": "3w",
  "72717": "3w",
  "72330": "3w",
  "72956": "3w",
  "71854": "3w",
  "72386": "3w",
  "72751": "3w",
  "72007": "3w",
  "72745": "3w",
  "71839": "3w",
  "71837": "3w",
  "71923": "3w",
  "72084": "3w",
  "71836": "3w",
  "72364": "3w",
  "72325": "3w",
  "71846": "3w",
  "72332": "3w",
  "71842": "3w",
  "72137": "3w",
  "72742": "3w",
  "72854": "3w",
  "71676": "3w",
  "71722": "3w",
  "72153": "3w",
  "72532": "3w",
  "72013": "3w",
  "72581": "3w",
  "72017": "3w",
  "71825": "3w",
  "72005": "3w",
  "72352": "3w",
  "72021": "3w",
  "72130": "3w",
  "72014": "3w",
  "03240": "1e",
  "03243": "1e",
  "03227": "1e",
  "03818": "1e",
  "03867": "1e",
  "03449": "2e",
  "03878": "1e",
  "03256": "1e",
  "03253": "1e",
  "03258": "1e",
  "03586": "1e",
  "03079": "2e",
  "03774": "1e",
  "03832": "1e",
  "03840": "2e",
  "03814": "1e",
  "03609": "1e",
  "03451": "2e",
  "03782": "1e",
  "03048": "2e",
  "03064": "2e",
  "03838": "1e",
  "03813": "1e",
  "03087": "2e",
  "03816": "1e",
  "03576": "1e",
  "03106": "2e",
  "03741": "1e",
  "03595": "1e",
  "03872": "1e",
  "03259": "1e",
  "03045": "2e",
  "03042": "2e",
  "03226": "1e",
  "03574": "1e",
  "03890": "1e",
  "03285": "1e",
  "03836": "1e",
  "03046": "1e",
  "03743": "1e",
  "03456": "1e",
  "03773": "1e",
  "03837": "1e",
  "03745": "1e",
  "03444": "2e",
  "03062": "2e",
  "03057": "2e",
  "03033": "2e",
  "03266": "1e",
  "03245": "1e",
  "33544": "4",
  "31542": "4",
  "31054": "4",
  "30455": "4",
  "34753": "4",
  "33319": "4",
  "34608": "4",
  "33308": "4",
  "33334": "4",
  "34604": "4",
  "32937": "4",
  "32931": "4",
  "32952": "4",
  "32009": "4",
  "33922": "4",
  "32922": "4",
  "32962": "4",
  "32164": "4",
  "32908": "4",
  "32127": "4",
  "32013": "4",
  "36207": "4",
  "36263": "4",
  "35811": "3e",
  "36110": "4",
  "36603": "4",
  "35810": "3e",
  "36107": "4",
  "36276": "4",
  "30563": "4",
  "32686": "4",
  "33612": "4",
  "34236": "4",
  "30543": "4",
  "31906": "4",
  "34103": "4",
  "30720": "4",
  "33154": "4",
  "35214": "4",
  "31404": "4",
  "30572": "4",
  "31041": "4",
  "35208": "4",
  "33868": "4",
  "33566": "4",
  "32803": "4",
  "33016": "4",
  "32212": "4",
  "31772": "4",
  "33849": "4",
  "31779": "4",
  "33839": "4",
  "32258": "4",
  "32246": "4",
  "32839": "4",
  "30248": "4",
  "30252": "4",
  "30044": "4",
  "30019": "4",
  "30223": "4",
  "31823": "4",
  "31648": "4",
  "30457": "4",
  "31815": "4",
  "36763": "4",
  "30458": "4",
  "30114": "4",
  "39845": "4",
  "30115": "4",
  "30018": "4",
  "30189": "4",
  "34120": "4",
  "31087": "4",
  "34760": "4",
  "32827": "4",
  "32828": "4",
  "33304": "4",
  "33765": "4",
  "31643": "4",
  "31634": "4",
  "31638": "4",
  "31625": "4",
  "31788": "4",
  "30630": "4",
  "30597": "4",
  "32773": "4",
  "32746": "4",
  "31070": "4",
  "32779": "4",
  "33854": "4",
  "33835": "4",
  "32548": "4",
  "31637": "4",
  "30648": "4",
  "31792": "4",
  "55434": "1w",
  "56278": "1w",
  "56115": "1w",
  "55927": "1w",
  "56520": "1w",
  "56001": "1w",
  "55409": "1w",
  "55387": "1w",
  "55074": "1e",
  "55042": "1w",
  "55315": "1w",
  "55321": "1w",
  "56732": "1w",
  "55092": "1w",
  "55079": "1w",
  "55382": "1w",
  "55910": "1w",
  "56221": "1w",
  "56116": "1w",
  "55959": "1w",
  "56649": "1w",
  "55367": "1w",
  "56134": "1w",
  "55341": "1w",
  "55373": "1w",
  "56201": "1w",
  "56288": "1w",
  "56228": "1w",
  "55069": "1w",
  "56748": "1w",
  "56007": "1w",
  "56368": "1w",
  "55772": "1w",
  "55941": "1w",
  "55760": "1w",
  "56216": "1w",
  "56263": "1w",
  "56214": "1w",
  "56387": "1w",
  "55719": "1w",
  "55423": "1w",
  "56546": "1w",
  "55902": "1w",
  "55901": "1w",
  "55806": "1e",
  "56165": "1w",
  "55356": "1w",
  "50635": "2w",
  "50219": "2w",
  "52312": "2w",
  "51231": "1w",
  "50032": "2w",
  "52323": "2w",
  "50054": "2w",
  "52066": "2w",
  "51540": "2w",
  "51503": "2w",
  "50441": "2w",
  "50431": "2w",
  "50449": "1w",
  "50265": "2w",
  "50447": "1w",
  "51544": "2w",
  "51351": "1w",
  "51559": "2w",
  "52219": "2w",
  "51548": "2w",
  "51510": "2w",
  "52660": "2w",
  "52757": "2w",
  "51646": "2w",
  "51445": "2w",
  "51025": "2w",
  "52135": "1w",
  "52557": "2w",
  "50461": "1w",
  "50454": "1w",
  "52640": "2w",
  "52581": "2w",
  "52639": "2w",
  "50608": "2w",
  "51460": "2w",
  "05001": "1e",
  "05776": "1e",
  "05340": "1e",
  "05152": "1e",
  "05352": "2e",
  "05350": "2e",
  "05358": "2e",
  "05441": "1e",
  "05830": "1e",
  "05845": "1e",
  "05822": "1e",
  "05875": "1e",
  "05457": "1e",
  "05461": "1e",
  "05445": "1e",
  "05902": "1e",
  "05820": "1e",
  "05833": "1e",
  "05868": "1e",
  "05654": "1e",
  "05043": "1e",
  "05473": "1e",
  "05033": "1e",
  "05647": "1e",
  "23427": "3e",
  "23436": "3e",
  "23359": "3e",
  "24448": "3e",
  "23337": "3e",
  "22205": "2e",
  "22923": "3e",
  "23081": "3e",
  "22214": "2e",
  "23229": "3e",
  "23238": "3e",
  "24317": "3e",
  "23059": "3e",
  "23060": "3e",
  "23878": "3e",
  "23231": "3e",
  "23702": "3e",
  "23703": "3e",
  "22304": "2e",
  "24132": "3e",
  "23030": "3e",
  "22306": "2e",
  "22315": "2e",
  "23487": "3e",
  "22015": "2e",
  "22153": "2e",
  "22182": "2e",
  "22151": "2e",
  "23872": "3e",
  "23833": "3e",
  "23124": "3e",
  "23011": "3e",
  "22193": "3e",
  "23867": "3e",
  "23839": "3e",
  "20155": "2e",
  "23843": "3e",
  "23950": "3e",
  "22737": "3e",
  "22722": "3e",
  "24416": "3e",
  "23923": "3e",
  "22948": "3e",
  "22730": "3e",
  "24149": "3e",
  "23040": "3e",
  "22738": "3e",
  "22716": "3e",
  "24483": "3e",
  "23004": "3e",
  "24134": "3e",
  "23917": "3e",
  "22746": "3e",
  "23887": "3e",
  "24580": "3e",
  "24277": "3e",
  "22922": "3e",
  "23009": "3e",
  "24464": "3e",
  "22974": "3e",
  "23518": "3e",
  "22454": "3e",
  "23148": "3e",
  "22509": "3e",
  "22476": "3e",
  "22401": "3e",
  "24151": "3e",
  "85259": "6",
  "85264": "6",
  "86544": "5",
  "86538": "5",
  "85941": "6",
  "85530": "6",
  "85296": "6",
  "85532": "6",
  "85378": "6",
  "85051": "6",
  "85029": "6",
  "85008": "6",
  "86506": "5",
  "86045": "5",
  "86401": "6",
  "85138": "6",
  "86409": "5",
  "86429": "6",
  "86431": "5",
  "85928": "6",
  "85705": "6",
  "85364": "6",
  "85614": "6",
  "85743": "6",
  "85755": "6",
  "85132": "6",
  "85736": "6",
  "85342": "6",
  "86343": "6",
  "85192": "6",
  "86052": "5",
  "85334": "6",
  "85610": "6",
  "86046": "5",
  "85355": "6",
  "85730": "6",
  "85363": "6",
  "86015": "5",
  "85608": "6",
  "85926": "6",
  "85233": "6",
  "85382": "6",
  "85201": "6",
  "80033": "5",
  "80907": "5",
  "80238": "5",
  "80817": "5",
  "80910": "5",
  "80925": "5",
  "80246": "5",
  "80233": "5",
  "81052": "2w",
  "80211": "5",
  "80202": "5",
  "80651": "5",
  "80498": "5",
  "81091": "5",
  "80432": "5",
  "80528": "5",
  "81027": "5",
  "80532": "5",
  "80908": "5",
  "80120": "5",
  "81092": "2w",
  "80423": "5",
  "81081": "5",
  "80467": "5",
  "81654": "5",
  "81526": "5",
  "81655": "5",
  "80475": "5",
  "81646": "5",
  "81019": "5",
  "80840": "5",
  "80860": "5",
  "80439": "5",
  "07060": "2e",
  "07663": "2e",
  "08232": "2e",
  "07407": "2e",
  "08829": "2e",
  "07003": "2e",
  "07208": "2e",
  "07502": "2e",
  "07024": "2e",
  "08244": "2e",
  "07828": "2e",
  "07043": "2e",
  "07928": "2e",
  "07070": "2e",
  "08403": "2e",
  "08620": "2e",
  "07801": "2e",
  "08901": "2e",
  "08230": "2e",
  "08098": "2e",
  "08861": "2e",
  "08512": "2e",
  "07603": "2e",
  "07946": "2e",
  "07105": "2e",
  "08850": "2e",
  "08349": "2e",
  "07021": "2e",
  "08323": "2e",
  "07444": "2e",
  "07452": "2e",
  "07440": "2e",
  "07857": "2e",
  "07863": "2e",
  "07874": "2e",
  "08329": "2e",
  "08887": "2e",
  "08310": "2e",
  "08320": "2e",
  "08110": "2e",
  "08102": "2e",
  "08085": "2e",
  "07842": "2e",
  "07512": "2e",
  "08312": "2e",
  "08322": "2e",
  "07422": "2e",
  "07827": "2e",
  "08096": "2e",
  "07881": "2e",
  "56160": "1w",
  "56011": "1w",
  "55352": "1w",
  "55358": "1w",
  "55070": "1w",
  "55372": "1w",
  "55417": "1w",
  "55956": "1w",
  "55744": "1w",
  "55932": "1w",
  "55764": "1w",
  "55767": "1w",
  "55324": "1w",
  "55947": "1w",
  "55325": "1w",
  "56326": "1w",
  "55607": "1w",
  "56118": "1w",
  "04683": "1e",
  "04287": "1e",
  "04544": "1e",
  "04571": "1e",
  "04605": "1e",
  "04472": "1e",
  "04674": "1e",
  "04979": "1e",
  "04443": "1e",
  "04732": "1e",
  "04786": "1e",
  "04694": "1e",
  "04739": "1e",
  "04493": "1e",
  "04284": "1e",
  "04355": "1e",
  "04093": "1e",
  "04413": "1e",
  "04643": "1e",
  "04657": "1e",
  "04642": "1e",
  "04268": "1e",
  "04285": "1e",
  "04224": "1e",
  "04558": "1e",
  "04449": "1e",
  "04030": "1e",
  "04939": "1e",
  "04435": "1e",
  "04076": "1e",
  "04001": "1e",
  "04079": "1e",
  "04932": "1e",
  "04097": "1e",
  "04345": "1e",
  "04110": "1e",
  "04072": "1e",
  "04765": "1e",
  "04781": "1e",
  "04270": "1e",
  "04985": "1e",
  "04635": "1e",
  "04773": "1e",
  "04762": "1e",
  "04961": "1e",
  "03579": "1e",
  "04427": "1e",
  "06062": "2e",
  "06782": "2e",
  "06092": "2e",
  "10030": "2e",
  "10312": "2e",
  "11434": "2e",
  "13403": "1e",
  "11433": "2e",
  "14546": "1e",
  "10460": "2e",
  "13483": "1e",
  "11801": "2e",
  "13114": "1e",
  "13363": "1e",
  "12833": "1e",
  "13637": "1e",
  "13632": "1e",
  "12151": "1e",
  "12827": "1e",
  "12436": "2e",
  "12431": "2e",
  "12058": "2e",
  "12508": "2e",
  "12192": "2e",
  "12418": "2e",
  "12862": "1e",
  "12166": "2e",
  "12124": "2e",
  "12470": "2e",
  "12452": "2e",
  "12843": "1e",
  "12450": "2e",
  "11691": "2e",
  "12816": "1e",
  "13428": "1e",
  "12962": "1e",
  "12903": "1e",
  "12959": "1e",
  "12935": "1e",
  "12934": "1e",
  "12955": "1e",
  "11239": "2e",
  "12929": "1e",
  "11768": "2e",
  "13410": "1e",
  "11749": "2e",
  "11788": "2e",
  "11725": "2e",
  "12854": "1e",
  "11724": "2e",
  "59258": "1w",
  "59250": "1w",
  "59240": "1w",
  "59748": "5",
  "59623": "5",
  "59069": "5",
  "59011": "5",
  "16263": "2e",
  "15730": "2e",
  "18417": "2e",
  "15832": "2e",
  "15863": "2e",
  "15732": "2e",
  "17004": "2e",
  "15701": "2e",
  "17054": "2e",
  "15344": "2e",
  "15752": "2e",
  "15731": "2e",
  "16405": "2e",
  "15346": "2e",
  "15315": "2e",
  "15260": "2e",
  "19438": "2e",
  "18704": "2e",
  "18702": "2e",
  "17068": "2e",
  "18622": "2e",
  "17829": "2e",
  "19034": "2e",
  "16323": "2e",
  "18434": "2e",
  "18222": "2e",
  "18660": "2e",
  "18634": "2e",
  "17751": "2e",
  "18347": "2e",
  "18344": "2e",
  "18330": "2e",
  "18355": "2e",
  "16328": "2e",
  "16111": "2e",
  "17353": "2e",
  "18929": "2e",
  "18950": "2e",
  "18708": "2e",
  "18644": "2e",
  "18630": "2e",
  "17748": "2e",
  "17040": "2e",
  "15425": "2e",
  "15456": "2e",
  "16311": "2e",
  "17018": "2e",
  "16440": "2e",
  "17340": "2e",
  "17030": "2e",
  "17023": "2e",
  "17006": "2e",
  "16220": "2e",
  "19375": "2e",
  "16656": "2e",
  "15440": "2e",
  "15442": "2e",
  "18816": "2e",
  "17306": "2e",
  "37369": "3e",
  "38076": "3e",
  "37687": "3e",
  "38066": "3e",
  "37852": "3e",
  "38567": "3e",
  "37730": "3e",
  "38555": "3e",
  "37342": "3e",
  "38345": "3e",
  "37755": "3e",
  "37756": "3e",
  "38390": "3e",
  "38565": "3e",
  "38341": "3e",
  "37403": "3e",
  "37916": "3e",
  "38505": "3e",
  "38392": "3e",
  "38366": "3e",
  "38313": "3e",
  "38355": "3e",
  "38380": "3e",
  "38550": "3e",
  "37909": "3e",
  "38126": "3w",
  "37931": "3e",
  "37871": "3e",
  "37189": "3e",
  "38476": "3e",
  "37772": "3e",
  "37830": "3e",
  "37379": "3e",
  "37804": "3e",
  "37709": "3e",
  "37323": "3e",
  "37351": "3e",
  "37865": "3e",
  "37878": "3e",
  "37210": "3e",
  "37213": "3e",
  "37212": "3e",
  "38135": "3e",
  "38004": "3e",
  "37705": "3e",
  "38011": "3e",
  "37087": "3e",
  "38116": "3e",
  "38019": "3e",
  "37888": "3e",
  "37866": "3e",
  "37375": "3e",
  "37604": "3e",
  "37052": "3e",
  "37752": "3e",
  "38315": "3e",
  "38462": "3e",
  "38225": "3e",
  "38242": "3e",
  "38368": "3e",
  "38311": "3e",
  "37366": "3e",
  "38317": "3e",
  "37640": "3e",
  "37033": "3e",
  "37376": "3e",
  "38371": "3e",
  "38551": "3e",
  "37876": "3e",
  "37043": "3e",
  "37141": "3e",
  "37885": "3e",
  "42602": "3e",
  "38310": "3e",
  "37098": "3e",
  "38573": "3e",
  "22504": "3e",
  "24503": "3e",
  "24517": "3e",
  "23180": "3e",
  "22408": "3e",
  "29404": "4",
  "29133": "4",
  "29118": "4",
  "29935": "4",
  "29401": "4",
  "29420": "4",
  "29920": "4",
  "29448": "4",
  "29540": "4",
  "29437": "4",
  "29388": "4",
  "29333": "4",
  "29137": "4",
  "29439": "4",
  "29061": "4",
  "29338": "3e",
  "29545": "4",
  "29044": "4",
  "29353": "4",
  "29691": "4",
  "29693": "4",
  "29584": "4",
  "29015": "4",
  "29332": "4",
  "29843": "4",
  "17317": "2e",
  "17355": "2e",
  "18960": "2e",
  "18944": "2e",
  "18510": "2e",
  "19030": "2e",
  "19047": "2e",
  "17056": "2e",
  "18914": "2e",
  "19006": "2e",
  "17841": "2e",
  "17812": "2e",
  "17086": "2e",
  "17862": "2e",
  "17861": "2e",
  "15779": "2e",
  "15658": "2e",
  "15628": "2e",
  "16066": "2e",
  "16038": "2e",
  "16001": "2e",
  "15665": "2e",
  "17044": "2e",
  "16373": "2e",
  "16050": "2e",
  "18425": "2e",
  "15823": "2e",
  "16048": "2e",
  "15636": "2e",
  "16029": "2e",
  "16027": "2e",
  "18830": "2e",
  "16240": "2e",
  "16259": "2e",
  "16922": "2e",
  "16912": "2e",
  "16611": "2e",
  "16262": "2e",
  "16923": "2e",
  "17052": "2e",
  "17002": "2e",
  "16224": "2e",
  "18626": "2e",
  "17260": "2e",
  "15715": "2e",
  "18325": "2e",
  "17215": "2e",
  "16664": "2e",
  "15778": "2e",
  "16911": "2e",
  "18833": "2e",
  "17264": "2e",
  "53942": "1e",
  "53143": "2e",
  "53108": "2e",
  "53185": "2e",
  "54985": "1e",
  "53020": "1e",
  "54489": "1e",
  "53295": "1e",
  "54646": "1e",
  "53094": "1e",
  "54111": "1e",
  "53222": "1e",
  "54618": "1e",
  "53929": "1e",
  "53523": "1e",
  "54747": "1e",
  "53572": "1e",
  "54234": "1e",
  "53146": "1e",
  "53045": "1e",
  "53122": "1e",
  "53228": "1e",
  "53051": "1e",
  "53529": "1e",
  "54915": "1e",
  "53190": "2e",
  "54022": "1e",
  "53129": "2e",
  "53202": "2e",
  "53968": "1e",
  "54013": "1e",
  "54625": "1e",
  "53209": "1e",
  "54005": "1e",
  "54536": "1e",
  "54153": "1e",
  "54023": "1e",
  "53508": "1e",
  "54832": "1e",
  "53802": "2e",
  "53059": "1e",
  "54537": "1e",
  "53541": "2e",
  "53717": "1e",
  "53120": "2e",
  "54644": "1e",
  "54861": "1e",
  "53540": "1e",
  "53142": "2e",
  "53715": "1e",
  "53184": "2e",
  "53501": "2e",
  "53147": "2e",
  "54412": "1e",
  "53195": "2e",
  "53126": "2e",
  "53125": "2e",
  "54927": "1e",
  "54227": "1e",
  "54614": "1e",
  "54410": "1e",
  "54732": "1e",
  "54748": "1e",
  "54760": "1e",
  "54946": "1e",
  "54824": "1e",
  "54658": "1e",
  "54750": "1e",
  "53584": "1e",
  "54525": "1e",
  "54120": "1e",
  "54931": "1e",
  "53947": "1e",
  "54427": "1e",
  "74761": "3w",
  "74455": "3w",
  "74070": "3w",
  "74078": "2w",
  "74844": "3w",
  "74852": "3w",
  "74867": "3w",
  "73019": "3w",
  "74368": "3w",
  "74570": "3w",
  "74354": "2w",
  "74576": "3w",
  "74339": "2w",
  "74845": "3w",
  "73433": "3w",
  "74826": "3w",
  "74358": "2w",
  "74002": "2w",
  "73450": "3w",
  "73016": "3w",
  "73443": "3w",
  "73801": "2w",
  "74730": "3w",
  "74401": "3w",
  "73529": "3w",
  "74029": "2w",
  "74403": "3w",
  "73507": "3w",
  "73017": "3w",
  "73505": "3w",
  "74422": "3w",
  "74431": "3w",
  "74055": "3w",
  "73503": "3w",
  "73639": "2w",
  "74727": "3w",
  "73096": "3w",
  "73651": "3w",
  "73539": "3w",
  "74451": "3w",
  "73537": "3w",
  "74567": "3w",
  "74764": "3w",
  "73459": "3w",
  "74735": "3w",
  "73439": "3w",
  "73106": "3w",
  "73013": "3w",
  "73150": "3w",
  "74940": "3w",
  "73159": "3w",
  "73127": "3w",
  "74964": "3w",
  "73036": "3w",
  "74833": "3w",
  "73078": "3w",
  "74963": "3w",
  "73068": "3w",
  "73115": "3w",
  "73141": "3w",
  "73009": "3w",
  "74132": "3w",
  "73565": "3w",
  "74942": "3w",
  "74452": "3w",
  "74945": "3w",
  "74044": "3w",
  "74041": "3w",
  "73066": "3w",
  "74842": "3w",
  "74477": "3w",
  "74521": "3w",
  "74146": "3w",
  "74651": "2w",
  "73077": "2w",
  "74001": "2w",
  "73742": "2w",
  "74020": "3w",
  "73556": "3w",
  "74437": "3w",
  "73067": "3w",
  "73011": "3w",
  "74647": "2w",
  "73491": "3w",
  "73573": "3w",
  "74456": "3w",
  "74115": "3w",
  "74079": "3w",
  "73601": "2w",
  "74875": "3w",
  "73937": "2w",
  "73759": "2w",
  "25148": "3e",
  "25049": "3e",
  "25193": "3e",
  "25082": "3e",
  "25205": "3e",
  "25547": "3e",
  "25637": "3e",
  "25667": "3e",
  "25260": "2e",
  "25088": "3e",
  "26288": "3e",
  "26707": "2e",
  "25427": "2e",
  "25404": "2e",
  "25411": "2e",
  "26815": "3e",
  "26615": "2e",
  "26215": "3e",
  "26038": "2e",
  "25555": "3e",
  "26586": "2e",
  "25879": "3e",
  "25085": "3e",
  "25904": "3e",
  "25507": "3e",
  "25966": "3e",
  "25969": "3e",
  "25701": "3e",
  "25008": "3e",
  "25841": "3e",
  "25857": "3e",
  "25140": "3e",
  "25873": "3e",
  "24712": "3e",
  "25920": "3e",
  "24737": "3e",
  "25811": "3e",
  "25839": "3e",
  "25705": "3e",
  "25313": "3e",
  "24845": "3e",
  "24851": "3e",
  "24870": "3e",
  "24860": "3e",
  "26505": "2e",
  "25504": "3e",
  "24801": "3e",
  "25909": "3e",
  "25143": "3e",
  "25876": "3e",
  "25559": "3e",
  "25506": "3e",
  "25882": "3e",
  "25943": "3e",
  "24834": "3e",
  "25320": "3e",
  "25160": "3e",
  "26541": "2e",
  "25520": "2e",
  "26717": "2e",
  "26180": "2e",
  "25075": "3e",
  "25315": "3e",
  "26554": "2e",
  "26521": "2e",
  "26575": "2e",
  "26421": "2e",
  "26170": "2e",
  "26134": "2e",
  "25231": "3e",
  "25437": "2e",
  "26146": "2e",
  "26141": "2e",
  "26151": "2e",
  "26330": "2e",
  "26254": "2e",
  "26228": "3e",
  "25268": "2e",
  "25234": "2e",
  "25430": "2e",
  "25442": "2e",
  "26422": "2e",
  "26058": "2e",
  "26660": "3e",
  "26348": "2e",
  "26691": "3e",
  "26656": "3e",
  "26617": "3e",
  "26680": "3e",
  "26034": "2e",
  "26587": "2e",
  "26047": "2e",
  "24915": "3e",
  "26149": "2e",
  "24879": "3e",
  "25635": "3e",
  "25047": "3e",
  "25650": "3e",
  "25652": "3e",
  "25183": "3e",
  "25678": "3e",
  "24943": "3e",
  "25503": "3e",
  "25515": "2e",
  "25632": "3e",
  "25646": "3e",
  "25567": "3e",
  "25674": "3e",
  "25685": "3e",
  "15697": "2e",
  "15638": "2e",
  "15905": "2e",
  "17934": "2e",
  "19109": "2e",
  "18052": "2e",
  "17946": "2e",
  "17944": "2e",
  "17041": "2e",
  "19148": "2e",
  "17087": "2e",
  "19104": "2e",
  "15212": "2e",
  "16720": "2e",
  "15275": "2e",
  "15146": "2e",
  "15104": "2e",
  "15037": "2e",
  "15112": "2e",
  "15018": "2e",
  "16141": "2e",
  "15019": "2e",
  "15043": "2e",
  "15042": "2e",
  "15312": "2e",
  "16037": "2e",
  "15360": "2e",
  "15828": "2e",
  "15333": "2e",
  "16322": "2e",
  "16217": "2e",
  "15629": "2e",
  "15055": "2e",
  "15696": "2e",
  "30582": "4",
  "30312": "4",
  "36606": "4",
  "36112": "4",
  "31520": "4",
  "34203": "4",
  "33944": "4",
  "32399": "4",
  "36117": "4",
  "36116": "4",
  "36612": "4",
  "36029": "4",
  "35087": "4",
  "36109": "4",
  "35223": "4",
  "36115": "4",
  "36114": "4",
  "35068": "4",
  "36265": "4",
  "33435": "4",
  "32207": "4",
  "32605": "4",
  "33013": "4",
  "33408": "4",
  "33460": "4",
  "33404": "4",
  "34243": "4",
  "32209": "4",
  "33128": "4",
  "35803": "4",
  "36613": "4",
  "35905": "4",
  "31401": "4",
  "30448": "4",
  "31546": "4",
  "32730": "4",
  "31722": "4",
  "34683": "4",
  "32735": "4",
  "32579": "4",
  "31034": "4",
  "34669": "4",
  "34748": "4",
  "34637": "4",
  "34705": "4",
  "33069": "4",
  "34756": "4",
  "32079": "4",
  "34762": "4",
  "32003": "4",
  "45854": "2e",
  "43926": "2e",
  "43944": "2e",
  "45784": "2e",
  "44678": "2e",
  "45899": "2e",
  "43322": "2e",
  "43112": "2e",
  "44629": "2e",
  "45052": "2e",
  "43467": "2e",
  "45239": "2e",
  "43529": "2e",
  "43007": "2e",
  "44424": "2e",
  "43070": "2e",
  "43156": "2e",
  "45147": "2e",
  "44607": "2e",
  "45314": "2e",
  "44072": "2e",
  "43153": "2e",
  "43055": "2e",
  "43056": "2e",
  "43071": "2e",
  "43777": "2e",
  "43746": "2e",
  "43760": "2e",
  "43738": "2e",
  "43517": "2e",
  "44460": "2e",
  "44427": "2e",
  "45107": "2e",
  "44303": "2e",
  "44308": "2e",
  "44305": "2e",
  "45381": "2e",
  "44106": "2e",
  "45402": "2e",
  "44718": "2e",
  "07302": "2e",
  "07735": "2e",
  "08828": "2e",
  "07670": "2e",
  "08801": "2e",
  "08822": "2e",
  "07002": "2e",
  "08886": "2e",
  "07430": "2e",
  "07083": "2e",
  "07035": "2e",
  "07882": "2e",
  "08827": "2e",
  "08854": "2e",
  "07202": "2e",
  "07086": "2e",
  "07042": "2e",
  "07632": "2e",
  "08629": "2e",
  "07647": "2e",
  "08846": "2e",
  "07677": "2e",
  "07011": "2e",
  "07073": "2e",
  "07001": "2e",
  "07876": "2e",
  "07660": "2e",
  "07865": "2e",
  "07924": "2e",
  "07977": "2e",
  "07076": "2e",
  "07866": "2e",
  "07435": "2e",
  "07960": "2e",
  "07950": "2e",
  "08836": "2e",
  "07675": "2e",
  "07014": "2e",
  "08648": "2e",
  "07054": "2e",
  "07601": "2e",
  "07640": "2e",
  "07838": "2e",
  "08242": "2e",
  "07423": "2e",
  "07432": "2e",
  "60554": "2e",
  "60565": "2e",
  "60085": "2e",
  "60044": "2e",
  "60152": "2e",
  "60538": "2e",
  "60543": "2e",
  "60403": "2e",
  "61447": "2e",
  "62433": "2e",
  "61417": "2e",
  "62837": "2e",
  "60021": "2e",
  "60435": "2e",
  "60431": "2e",
  "60436": "2e",
  "60447": "2e",
  "60912": "2e",
  "62998": "3e",
  "62253": "2e",
  "62266": "2e",
  "62250": "2e",
  "60537": "2e",
  "60967": "2e",
  "60918": "2e",
  "62233": "2e",
  "62288": "2e",
  "62355": "2e",
  "62045": "2w",
  "62892": "2e",
  "60926": "2e",
  "62621": "2e",
  "61426": "2e",
  "61734": "2e",
  "60922": "2e",
  "61282": "2e",
  "60614": "2e",
  "60657": "2e",
  "61075": "2e",
  "62949": "3e",
  "60506": "2e",
  "62635": "2e",
  "60625": "2e",
  "62922": "3e",
  "61443": "2e",
  "61490": "2e",
  "61041": "2e",
  "61238": "2e",
  "61279": "2e",
  "61516": "2e",
  "61760": "2e",
  "62238": "2e",
  "62268": "2e",
  "60655": "2e",
  "62897": "2e",
  "62822": "3e",
  "62865": "3e",
  "62816": "2e",
  "60613": "2e",
  "62846": "2e",
  "60612": "2e",
  "60610": "2e",
  "60654": "2e",
  "62474": "2e",
  "62025": "2e",
  "62021": "2e",
  "62298": "2e",
  "62061": "2e",
  "62282": "2e",
  "60068": "2e",
  "60043": "2e",
  "60192": "2e",
  "60067": "2e",
  "60803": "2e",
  "60459": "2e",
  "60805": "2e",
  "60154": "2e",
  "60527": "2e",
  "60456": "2e",
  "40854": "3e",
  "41774": "3e",
  "40873": "3e",
  "42442": "3e",
  "41746": "3e",
  "42131": "3e",
  "40865": "3e",
  "42715": "3e",
  "42338": "3e",
  "42037": "3e",
  "40316": "3e",
  "41643": "3e",
  "40171": "3e",
  "40363": "3e",
  "42323": "3e",
  "41760": "3e",
  "40062": "3e",
  "40049": "3e",
  "42066": "3e",
  "42420": "3e",
  "42082": "3e",
  "41015": "2e",
  "40601": "3e",
  "41175": "3e",
  "40299": "3e",
  "42458": "3e",
  "40213": "3e",
  "40067": "3e",
  "40361": "3e",
  "41102": "3e",
  "42028": "3e",
  "42047": "3e",
  "41091": "2e",
  "40204": "3e",
  "40059": "3e",
  "41143": "3e",
  "40347": "3e",
  "41073": "2e",
  "41042": "2e",
  "42048": "3e",
  "40203": "3e",
  "40489": "3e",
  "42445": "3e",
  "42366": "3e",
  "41041": "3e",
  "41776": "3e",
  "40229": "3e",
  "41014": "2e",
  "42159": "3e",
  "40023": "3e",
  "41563": "3e",
  "41562": "3e",
  "47060": "2e",
  "46365": "2e",
  "46747": "2e",
  "46150": "2e",
  "46182": "2e",
  "47273": "2e",
  "46567": "2e",
  "46163": "2e",
  "47437": "2e",
  "46978": "2e",
  "46923": "2e",
  "47040": "2e",
  "47020": "2e",
  "46913": "2e",
  "46555": "2e",
  "47967": "2e",
  "47457": "2e",
  "47130": "3e",
  "46340": "2e",
  "47850": "2e",
  "47981": "2e",
  "46031": "2e",
  "46074": "2e",
  "47124": "3e",
  "47150": "3e",
  "47112": "3e",
  "47683": "3e",
  "47137": "3e",
  "47637": "3e",
  "47586": "3e",
  "47531": "3e",
  "47928": "2e",
  "46526": "2e",
  "47408": "2e",
  "46628": "2e",
  "47401": "2e",
  "77863": "6",
  "77431": "4",
  "78578": "4",
  "78559": "4",
  "78583": "4",
  "77057": "4",
  "77471": "4",
  "77469": "4",
  "77316": "4",
  "77083": "4",
  "77355": "4",
  "77384": "4",
  "75238": "3w",
  "78626": "6",
  "77632": "4",
  "76209": "3w",
  "78503": "4",
  "77845": "3w",
  "77808": "3w",
  "79703": "6",
  "76449": "3w",
  "77640": "4",
  "75491": "3w",
  "75229": "3w",
  "75007": "3w",
  "75182": "3w",
  "75042": "3w",
  "77901": "6",
  "76655": "3w",
  "77853": "6",
  "78040": "6",
  "79423": "6",
  "75708": "3w",
  "77801": "3w",
  "78886": "6",
  "76712": "3w",
  "77905": "6",
  "79707": "6",
  "77904": "6",
  "75076": "3w",
  "75235": "3w",
  "78701": "6",
  "79915": "6",
  "79412": "6",
  "79402": "6",
  "76272": "3w",
  "78401": "4",
  "76653": "3w",
  "76664": "3w",
  "77973": "6",
  "75703": "3w",
  "76643": "3w",
  "75771": "3w",
  "75218": "3w",
  "79424": "6",
  "78045": "6",
  "76939": "6",
  "75489": "3w",
  "79928": "6",
  "76902": "6",
  "78725": "6",
  "78616": "6",
  "75224": "3w",
  "78418": "4",
  "78373": "4",
  "78419": "4",
  "79758": "6",
  "79329": "6",
  "79821": "6",
  "79911": "6",
  "76599": "6",
  "78535": "4",
  "76598": "6",
  "54529": "1e",
  "54464": "1e",
  "54488": "1e",
  "53933": "1e",
  "53806": "2w",
  "53035": "1e",
  "53557": "1e",
  "54623": "1e",
  "15728": "2e",
  "15554": "2e",
  "16694": "2e",
  "15723": "2e",
  "15739": "2e",
  "15710": "2e",
  "15682": "2e",
  "15320": "2e",
  "17859": "2e",
  "16344": "2e",
  "19437": "2e",
  "18447": "2e",
  "17760": "2e",
  "18370": "2e",
  "18349": "2e",
  "17020": "2e",
  "08007": "2e",
  "08039": "2e",
  "08059": "2e",
  "08086": "2e",
  "08554": "2e",
  "08011": "2e",
  "08641": "2e",
  "08750": "2e",
  "08095": "2e",
  "07716": "2e",
  "08048": "2e",
  "08734": "2e",
  "07746": "2e",
  "07739": "2e",
  "08535": "2e",
  "07720": "2e",
  "98581": "7",
  "99330": "5",
  "98040": "5",
  "99343": "5",
  "07480": "2e",
  "08033": "2e",
  "99169": "5",
  "99137": "5",
  "99401": "5",
  "98402": "7",
  "99361": "5",
  "98328": "5",
  "98555": "7",
  "98383": "7",
  "98444": "7",
  "98360": "5",
  "99352": "5",
  "98345": "7",
  "98403": "7",
  "99146": "5",
  "98948": "5",
  "98952": "5",
  "98443": "7",
  "98850": "5",
  "98647": "7",
  "98858": "5",
  "98843": "5",
  "99258": "5",
  "98505": "7",
  "98025": "5",
  "98623": "5",
  "98409": "7",
  "98601": "7",
  "98921": "5",
  "98350": "7",
  "98154": "5",
  "99011": "5",
  "98576": "7",
  "35618": "3e",
  "35070": "4",
  "30420": "4",
  "30470": "4",
  "32224": "4",
  "31503": "4",
  "31077": "4",
  "39846": "4",
  "32804": "4",
  "33823": "4",
  "33567": "4",
  "33182": "4",
  "32216": "4",
  "30046": "4",
  "30078": "4",
  "30234": "4",
  "31050": "4",
  "32566": "4",
  "33190": "4",
  "30425": "4",
  "32256": "4",
  "33511": "4",
  "33596": "4",
  "31781": "4",
  "32214": "4",
  "31563": "4",
  "32081": "4",
  "30436": "4",
  "31639": "4",
  "31017": "4",
  "30177": "4",
  "31331": "4",
  "30655": "4",
  "30016": "4",
  "33187": "4",
  "39842": "4",
  "30461": "4",
  "31324": "4",
  "36543": "4",
  "31308": "4",
  "31716": "4",
  "31744": "4",
  "39832": "4",
  "30040": "4",
  "30220": "4",
  "30277": "4",
  "30170": "4",
  "30411": "4",
  "30289": "4",
  "32222": "4",
  "32217": "4",
  "31555": "4",
  "33851": "4",
  "30451": "4",
  "31018": "4",
  "33185": "4",
  "33572": "4",
  "32257": "4",
  "30643": "4",
  "31836": "4",
  "30818": "4",
  "30171": "4",
  "31049": "4",
  "31075": "4",
  "31067": "4",
  "33952": "4",
  "32333": "4",
  "17581": "2e",
  "19545": "2e",
  "18014": "2e",
  "17535": "2e",
  "17551": "2e",
  "17563": "2e",
  "17518": "2e",
  "15935": "2e",
  "18077": "2e",
  "17101": "2e",
  "17339": "2e",
  "18216": "2e",
  "15552": "2e",
  "15558": "2e",
  "15538": "2e",
  "19127": "2e",
  "17356": "2e",
  "18505": "2e",
  "18969": "2e",
  "18508": "2e",
  "18974": "2e",
  "19021": "2e",
  "17827": "2e",
  "17062": "2e",
  "18940": "2e",
  "16056": "2e",
  "18848": "2e",
  "18850": "2e",
  "16669": "2e",
  "18829": "2e",
  "18328": "2e",
  "15847": "2e",
  "15762": "2e",
  "16563": "2e",
  "15724": "2e",
  "16865": "2e",
  "19523": "2e",
  "19512": "2e",
  "17237": "2e",
  "15722": "2e",
  "17555": "2e",
  "17241": "2e",
  "19130": "2e",
  "19464": "2e",
  "19525": "2e",
  "17214": "2e",
  "15737": "2e",
  "19510": "2e",
  "17576": "2e",
  "17307": "2e",
  "17504": "2e",
  "18085": "2e",
  "18038": "2e",
  "18072": "2e",
  "17536": "2e",
  "17362": "2e",
  "15541": "2e",
  "17509": "2e",
  "15555": "2e",
  "18035": "2e",
  "18255": "2e",
  "18254": "2e",
  "15424": "2e",
  "15534": "2e",
  "17112": "2e",
  "17314": "2e",
  "63447": "2w",
  "65049": "2w",
  "63051": "2w",
  "11238": "2e",
  "11216": "2e",
  "11373": "2e",
  "13054": "1e",
  "13461": "1e",
  "10463": "2e",
  "11378": "2e",
  "11561": "2e",
  "11530": "2e",
  "14555": "1e",
  "11553": "2e",
  "10035": "2e",
  "14859": "2e",
  "13156": "1e",
  "10304": "2e",
  "13118": "2e",
  "13334": "1e",
  "14481": "1e",
  "14103": "1e",
  "13140": "1e",
  "14720": "2e",
  "13402": "1e",
  "10040": "2e",
  "11435": "2e",
  "12514": "2e",
  "12303": "2e",
  "12936": "1e",
  "14529": "2e",
  "13087": "2e",
  "14778": "2e",
  "12078": "1e",
  "13846": "2e",
  "14827": "2e",
  "12434": "2e",
  "13755": "2e",
  "13784": "2e",
  "14130": "2e",
  "10171": "2e",
  "12206": "2e",
  "85019": "6",
  "86035": "5",
  "86540": "5",
  "86411": "5",
  "86025": "5",
  "85603": "6",
  "85122": "6",
  "86017": "5",
  "85714": "6",
  "85742": "6",
  "85388": "6",
  "86322": "6",
  "85737": "6",
  "85601": "6",
  "85336": "6",
  "85325": "6",
  "85173": "6",
  "85375": "6",
  "85602": "6",
  "85701": "6",
  "85630": "6",
  "86321": "6",
  "80521": "5",
  "81024": "5",
  "80620": "5",
  "80442": "5",
  "80517": "5",
  "81212": "5",
  "81222": "5",
  "81030": "5",
  "81232": "5",
  "81124": "5",
  "80542": "5",
  "80634": "5",
  "80513": "5",
  "80545": "5",
  "80205": "5",
  "80832": "5",
  "81041": "2w",
  "81612": "5",
  "81649": "5",
  "80536": "5",
  "80915": "5",
  "80918": "5",
  "80121": "5",
  "80923": "5",
  "80520": "5",
  "80203": "5",
  "80951": "5",
  "81332": "5",
  "81325": "5",
  "80652": "5",
  "80018": "5",
  "80218": "5",
  "80017": "5",
  "80014": "5",
  "81522": "5",
  "81525": "5",
  "81520": "5",
  "80645": "5",
  "80226": "5",
  "80623": "5",
  "80919": "5",
  "81023": "5",
  "80293": "5",
  "80290": "5",
  "80235": "5",
  "80030": "5",
  "80466": "5",
  "80135": "5",
  "80481": "5",
  "80020": "5",
  "80452": "5",
  "80109": "5",
  "80015": "5",
  "80759": "2w",
  "81101": "5",
  "80473": "5",
  "81328": "5",
  "80727": "2w",
  "81428": "5",
  "81090": "2w",
  "81073": "2w",
  "81220": "5",
  "81243": "5",
  "81422": "5",
  "81432": "5",
  "80830": "5",
  "81335": "5",
  "81076": "5",
  "53598": "1e",
  "54637": "1e",
  "54724": "1e",
  "54475": "1e",
  "53952": "1e",
  "54456": "1e",
  "54965": "1e",
  "54631": "1e",
  "54655": "1e",
  "54622": "1e",
  "54847": "1e",
  "54428": "1e",
  "54982": "1e",
  "54102": "1e",
  "54205": "1e",
  "54442": "1e",
  "54891": "1e",
  "54433": "1e",
  "54768": "1e",
  "01063": "2e",
  "01747": "2e",
  "01922": "2e",
  "01938": "2e",
  "01843": "2e",
  "01929": "2e",
  "01913": "2e",
  "01721": "2e",
  "02081": "2e",
  "01702": "2e",
  "02189": "2e",
  "02054": "2e",
  "02032": "2e",
  "02474": "2e",
  "01720": "2e",
  "01754": "2e",
  "02452": "2e",
  "01801": "2e",
  "01752": "2e",
  "01864": "2e",
  "01226": "2e",
  "01084": "2e",
  "01242": "2e",
  "02739": "2e",
  "03103": "2e",
  "03063": "2e",
  "03049": "2e",
  "03223": "1e",
  "03593": "1e",
  "03054": "2e",
  "03031": "2e",
  "03281": "1e",
  "03894": "1e",
  "03825": "1e",
  "03884": "1e",
  "03870": "2e",
  "03307": "1e",
  "44012": "2e",
  "43107": "2e",
  "43408": "2e",
  "45317": "2e",
  "44613": "2e",
  "45651": "2e",
  "45646": "2e",
  "43506": "2e",
  "43526": "2e",
  "43556": "2e",
  "45167": "2e",
  "45131": "2e",
  "44455": "2e",
  "45601": "2e",
  "43115": "2e",
  "44415": "2e",
  "43164": "2e",
  "45776": "2e",
  "44867": "2e",
  "43410": "2e",
  "44830": "2e",
  "43844": "2e",
  "44818": "2e",
  "44844": "2e",
  "45735": "2e",
  "44802": "2e",
  "45873": "2e",
  "45861": "2e",
  "44841": "2e",
  "45673": "2e",
  "45653": "2e",
  "45770": "2e",
  "45732": "2e",
  "45741": "2e",
  "45164": "2e",
  "44904": "2e",
  "43321": "2e",
  "45761": "2e",
  "45701": "2e",
  "45883": "2e",
  "45882": "2e",
  "45353": "2e",
  "44887": "2e",
  "43772": "2e",
  "43778": "2e",
  "43722": "2e",
  "43768": "2e",
  "45739": "2e",
  "44878": "2e",
  "43607": "2e",
  "43203": "2e",
  "45207": "2e",
  "45629": "3e",
  "45225": "2e",
  "43311": "2e",
  "44473": "2e",
  "43543": "2e",
  "43345": "2e",
  "45319": "2e",
  "44822": "2e",
  "43534": "2e",
  "57481": "1w",
  "57523": "1w",
  "57063": "1w",
  "57066": "1w",
  "57501": "1w",
  "57070": "1w",
  "57345": "1w",
  "57319": "1w",
  "57625": "1w",
  "57216": "1w",
  "57227": "1w",
  "57235": "1w",
  "57261": "1w",
  "57661": "1w",
  "57652": "1w",
  "57622": "1w",
  "57243": "1w",
  "57272": "1w",
  "57278": "1w",
  "57472": "1w",
  "57747": "5",
  "57374": "1w",
  "57763": "5",
  "57108": "1w",
  "57041": "1w",
  "57110": "1w",
  "57434": "1w",
  "57039": "1w",
  "57117": "1w",
  "57048": "1w",
  "57015": "1w",
  "57005": "1w",
  "57001": "1w",
  "57528": "1w",
  "57790": "1w",
  "57751": "5",
  "57769": "1w",
  "57793": "1w",
  "57730": "5",
  "57767": "1w",
  "57572": "2w",
  "57531": "1w",
  "57330": "1w",
  "57657": "1w",
  "57379": "1w",
  "57071": "1w",
  "57276": "1w",
  "57028": "1w",
  "57050": "1w",
  "57076": "1w",
  "57248": "1w",
  "57366": "1w",
  "57571": "2w",
  "57759": "5",
  "57724": "1w",
  "57650": "1w",
  "57332": "1w",
  "57446": "1w",
  "57454": "1w",
  "57271": "1w",
  "57631": "1w",
  "57337": "1w",
  "57782": "5",
  "57013": "1w",
  "57350": "1w",
  "57033": "1w",
  "57450": "1w",
  "57477": "1w",
  "57107": "1w",
  "57055": "1w",
  "57701": "1w",
  "57020": "1w",
  "71110": "3w",
  "71301": "4",
  "70126": "4",
  "71291": "4",
  "70647": "4",
  "71292": "4",
  "71051": "3w",
  "70605": "4",
  "70364": "4",
  "71201": "4",
  "71282": "4",
  "71070": "4",
  "71065": "4",
  "70629": "4",
  "71414": "4",
  "71286": "4",
  "71237": "4",
  "71242": "4",
  "70650": "4",
  "71439": "4",
  "71415": "4",
  "71066": "4",
  "71497": "4",
  "70353": "4",
  "70128": "4",
  "70508": "4",
  "70558": "4",
  "70397": "4",
  "70808": "4",
  "70807": "4",
  "70812": "4",
  "70661": "4",
  "70803": "4",
  "70810": "4",
  "70426": "4",
  "71250": "4",
  "71219": "4",
  "71030": "3w",
  "70049": "4",
  "70346": "4",
  "71029": "3w",
  "71009": "3w",
  "71052": "3w",
  "71378": "4",
  "71068": "3w",
  "71277": "3w",
  "71034": "3w",
  "71353": "4",
  "70655": "4",
  "70719": "4",
  "71404": "4",
  "70764": "4",
  "71325": "4",
  "71322": "4",
  "70447": "4",
  "70752": "4",
  "70436": "4",
  "70083": "4",
  "70087": "4",
  "70047": "4",
  "71078": "3w",
  "71474": "4",
  "71079": "3w",
  "70651": "4",
  "70091": "4",
  "70050": "4",
  "70391": "4",
  "71475": "4",
  "71082": "3w",
  "71043": "3w",
  "71061": "3w",
  "70121": "4",
  "71119": "3w",
  "71362": "4",
  "70747": "4",
  "70761": "4",
  "70722": "4",
  "71302": "4",
  "71454": "4",
  "70139": "4",
  "70762": "4",
  "71280": "4",
  "70791": "4",
  "71225": "4",
  "70819": "4",
  "71028": "3w",
  "05649": "1e",
  "05675": "1e",
  "05832": "1e",
  "05747": "1e",
  "05651": "1e",
  "05652": "1e",
  "05492": "1e",
  "05149": "1e",
  "05257": "1e",
  "05746": "1e",
  "05768": "1e",
  "05731": "1e",
  "05735": "1e",
  "05343": "1e",
  "28629": "3e",
  "27539": "3e",
  "27525": "3e",
  "27591": "3e",
  "27589": "3e",
  "27614": "3e",
  "28166": "3e",
  "27557": "3e",
  "28115": "3e",
  "28461": "3e",
  "27207": "3e",
  "51550": "2w",
  "50223": "2w",
  "50830": "2w",
  "50156": "2w",
  "52650": "2w",
  "51006": "2w",
  "50432": "1w",
  "50163": "2w",
  "52038": "2w",
  "52653": "2w",
  "50206": "2w",
  "52772": "2w",
  "50426": "1w",
  "52030": "2w",
  "51340": "1w",
  "50255": "2w",
  "50041": "2w",
  "51656": "2w",
  "51447": "2w",
  "51446": "2w",
  "52501": "2w",
  "50651": "2w",
  "50065": "2w",
  "51443": "2w",
  "51521": "2w",
  "52101": "1w",
  "52223": "2w",
  "52161": "1w",
  "52074": "2w",
  "50401": "1w",
  "51240": "1w",
  "52078": "2w",
  "50586": "2w",
  "52070": "2w",
  "50539": "1w",
  "50846": "2w",
  "51552": "2w",
  "56666": "1w",
  "56285": "1w",
  "55026": "1e",
  "55757": "1w",
  "56091": "1w",
  "56075": "1w",
  "55029": "1w",
  "08327": "2e",
  "08316": "2e",
  "08857": "2e",
  "07945": "2e",
  "08873": "2e",
  "08037": "2e",
  "07604": "2e",
  "08825": "2e",
  "07033": "2e",
  "07081": "2e",
  "07206": "2e",
  "07204": "2e",
  "07853": "2e",
  "07093": "2e",
  "08817": "2e",
  "07403": "2e",
  "08610": "2e",
  "07005": "2e",
  "07932": "2e",
  "08904": "2e",
  "08691": "2e",
  "07008": "2e",
  "07058": "2e",
  "08869": "2e",
  "07847": "2e",
  "07114": "2e",
  "08069": "2e",
  "07026": "2e",
  "07039": "2e",
  "08520": "2e",
  "07933": "2e",
  "08318": "2e",
  "08001": "2e",
  "49902": "1e",
  "49548": "1e",
  "49129": "2e",
  "49331": "1e",
  "49406": "2e",
  "48382": "2e",
  "49434": "2e",
  "48870": "1e",
  "48340": "2e",
  "48092": "2e",
  "48095": "1e",
  "48346": "2e",
  "48146": "2e",
  "48322": "2e",
  "48034": "2e",
  "48038": "2e",
  "48045": "2e",
  "48218": "2e",
  "48111": "2e",
  "48640": "1e",
  "48631": "1e",
  "48634": "1e",
  "49618": "1e",
  "48637": "1e",
  "48048": "2e",
  "49689": "1e",
  "49683": "1e",
  "48858": "1e",
  "48662": "1e",
  "48461": "1e",
  "48412": "1e",
  "48193": "2e",
  "48221": "2e",
  "48208": "2e",
  "48212": "2e",
  "48101": "2e",
  "48185": "2e",
  "48116": "2e",
  "62260": "2e",
  "62264": "2e",
  "62255": "2e",
  "62205": "2e",
  "60062": "2e",
  "60026": "2e",
  "60091": "2e",
  "62278": "2e",
  "60007": "2e",
  "60008": "2e",
  "60010": "2e",
  "60453": "2e",
  "60452": "2e",
  "60477": "2e",
  "60425": "2e",
  "60445": "2e",
  "60106": "2e",
  "60502": "2e",
  "62084": "2e",
  "60608": "2e",
  "60605": "2e",
  "60603": "2e",
  "62221": "2e",
  "62265": "2e",
  "62289": "2e",
  "60706": "2e",
  "62256": "2e",
  "60193": "2e",
  "60714": "2e",
  "60133": "2e",
  "60439": "2e",
  "60457": "2e",
  "60558": "2e",
  "60418": "2e",
  "60461": "2e",
  "60473": "2e",
  "60419": "2e",
  "60123": "2e",
  "60102": "2e",
  "60047": "2e",
  "60046": "2e",
  "60096": "2e",
  "60098": "2e",
  "60031": "2e",
  "62946": "3e",
  "62882": "2e",
  "60097": "2e",
  "60071": "2e",
  "60075": "2e",
  "60970": "2e",
  "62926": "3e",
  "62957": "3e",
  "62231": "2e",
  "62218": "2e",
  "62245": "2e",
  "62215": "2e",
  "60924": "2e",
  "62262": "2e",
  "62297": "2e",
  "62880": "2e",
  "62612": "2e",
  "62284": "2e",
  "62077": "2e",
  "61345": "2e",
  "60939": "2e",
  "62850": "2e",
  "61913": "2e",
  "62362": "2e",
  "62357": "2e",
  "61553": "2e",
  "62358": "2e",
  "62863": "2e",
  "62410": "2e",
  "61334": "2e",
  "62627": "2e",
  "62664": "2e",
  "62085": "2e",
  "62023": "2e",
  "62091": "2e",
  "62869": "3e",
  "62438": "2e",
  "62570": "2e",
  "62089": "2e",
  "62477": "2e",
  "62058": "2e",
  "43077": "2e",
  "24986": "3e",
  "26568": "2e",
  "26075": "2e",
  "24901": "3e",
  "26167": "2e",
  "26690": "3e",
  "24941": "3e",
  "25059": "3e",
  "26162": "2e",
  "25565": "3e",
  "26209": "3e",
  "24934": "3e",
  "26208": "3e",
  "24892": "3e",
  "25253": "2e",
  "25524": "3e",
  "25529": "3e",
  "25625": "3e",
  "26678": "3e",
  "25203": "3e",
  "13164": "1e",
  "13031": "1e",
  "13744": "2e",
  "13813": "2e",
  "10504": "2e",
  "10988": "2e",
  "11236": "2e",
  "10992": "2e",
  "11212": "2e",
  "11249": "2e",
  "10913": "2e",
  "10590": "2e",
  "12077": "2e",
  "14139": "2e",
  "10922": "2e",
  "14624": "1e",
  "10545": "2e",
  "12161": "2e",
  "14464": "1e",
  "14033": "2e",
  "14428": "1e",
  "12023": "2e",
  "12122": "2e",
  "10589": "2e",
  "11743": "2e",
  "11356": "2e",
  "10910": "2e",
  "12803": "1e",
  "12570": "2e",
  "13661": "1e",
  "14057": "2e",
  "14037": "1e",
  "13141": "2e",
  "11021": "2e",
  "14302": "1e",
  "11565": "2e",
  "13441": "1e",
  "14542": "1e",
  "13123": "1e",
  "12578": "2e",
  "10475": "2e",
  "11371": "2e",
  "14166": "2e",
  "14058": "1e",
  "13071": "2e",
  "14532": "1e",
  "14585": "1e",
  "14537": "1e",
  "13607": "1e",
  "12033": "2e",
  "25314": "3e",
  "24839": "3e",
  "26710": "2e",
  "26105": "2e",
  "26726": "2e",
  "25870": "3e",
  "25928": "3e",
  "24898": "3e",
  "25039": "3e",
  "25110": "3e",
  "26750": "2e",
  "25156": "3e",
  "05060": "1e",
  "05641": "1e",
  "05873": "1e",
  "05042": "1e",
  "05039": "1e",
  "05871": "1e",
  "05851": "1e",
  "05650": "1e",
  "05681": "1e",
  "05766": "1e",
  "05041": "1e",
  "05072": "1e",
  "05676": "1e",
  "05454": "1e",
  "05408": "1e",
  "05901": "1e",
  "05874": "1e",
  "05857": "1e",
  "05859": "1e",
  "05839": "1e",
  "05485": "1e",
  "05447": "1e",
  "05482": "1e",
  "05673": "1e",
  "05036": "1e",
  "05058": "1e",
  "05075": "1e",
  "05301": "2e",
  "05743": "1e",
  "05009": "1e",
  "05751": "1e",
  "05056": "1e",
  "05360": "2e",
  "05158": "1e",
  "05253": "1e",
  "05732": "1e",
  "05071": "1e",
  "05363": "2e",
  "05153": "1e",
  "05062": "1e",
  "05772": "1e",
  "05262": "2e",
  "05084": "1e",
  "05031": "1e",
  "05055": "1e",
  "05465": "1e",
  "05489": "1e",
  "05488": "1e",
  "05468": "1e",
  "05824": "1e",
  "05842": "1e",
  "05655": "1e",
  "12574": "2e",
  "14527": "2e",
  "14478": "2e",
  "11794": "2e",
  "13652": "1e",
  "13621": "1e",
  "13654": "1e",
  "13687": "1e",
  "13348": "2e",
  "13326": "2e",
  "11791": "2e",
  "11804": "2e",
  "13323": "1e",
  "13425": "1e",
  "13480": "1e",
  "10307": "2e",
  "10314": "2e",
  "10306": "2e",
  "14533": "1e",
  "14482": "1e",
  "13421": "1e",
  "13308": "1e",
  "14028": "1e",
  "10032": "2e",
  "10302": "2e",
  "13042": "1e",
  "14519": "1e",
  "13431": "1e",
  "14132": "1e",
  "14204": "1e",
  "14025": "2e",
  "10024": "2e",
  "11420": "2e",
  "14069": "2e",
  "14136": "2e",
  "14757": "2e",
  "14781": "2e",
  "11369": "2e",
  "14740": "2e",
  "14782": "2e",
  "14738": "2e",
  "13034": "1e",
  "11411": "2e",
  "13111": "1e",
  "14530": "2e",
  "14716": "2e",
  "45783": "2e",
  "44815": "2e",
  "43150": "2e",
  "43766": "2e",
  "45113": "2e",
  "45620": "2e",
  "43787": "2e",
  "45711": "2e",
  "44866": "2e",
  "45832": "2e",
  "43747": "2e",
  "43773": "2e",
  "44693": "2e",
  "45360": "2e",
  "43910": "2e",
  "43786": "2e",
  "45826": "2e",
  "45716": "2e",
  "45894": "2e",
  "44842": "2e",
  "44864": "2e",
  "45306": "2e",
  "43733": "2e",
  "43230": "2e",
  "43736": "2e",
  "44101": "2e",
  "45013": "2e",
  "44217": "2e",
  "44085": "2e",
  "45011": "2e",
  "44004": "2e",
  "43516": "2e",
  "43611": "2e",
  "43620": "2e",
  "43524": "2e",
  "45867": "2e",
  "45346": "2e",
  "45203": "2e",
  "43323": "2e",
  "43359": "2e",
  "45409": "2e",
  "43228": "2e",
  "43537": "2e",
  "43231": "2e",
  "43078": "2e",
  "45714": "2e",
  "45067": "2e",
  "45247": "2e",
  "43906": "2e",
  "43940": "2e",
  "43713": "2e",
  "44663": "2e",
  "45062": "2e",
  "44671": "2e",
  "45014": "2e",
  "43522": "2e",
  "45853": "2e",
  "45830": "2e",
  "39193": "4",
  "39564": "4",
  "39581": "4",
  "38671": "3e",
  "38637": "3e",
  "38943": "4",
  "38737": "3e",
  "38922": "3e",
  "38632": "3e",
  "39421": "4",
  "38920": "3e",
  "38765": "4",
  "39664": "4",
  "38619": "3e",
  "38639": "3e",
  "38940": "3e",
  "38641": "3e",
  "38680": "3e",
  "39474": "4",
  "38642": "3e",
  "39360": "4",
  "38762": "3e",
  "38923": "4",
  "39656": "4",
  "39082": "4",
  "38966": "3e",
  "38916": "4",
  "38772": "3w",
  "38850": "4",
  "39350": "4",
  "39648": "4",
  "39059": "4",
  "39425": "4",
  "39183": "4",
  "39354": "4",
  "38915": "3e",
  "39666": "4",
  "39452": "4",
  "39745": "4",
  "38732": "3e",
  "39443": "4",
  "39040": "4",
  "38826": "3e",
  "39478": "4",
  "39740": "4",
  "38703": "3e",
  "39702": "4",
  "39269": "4",
  "39342": "4",
  "38663": "3e",
  "30560": "4",
  "30710": "4",
  "33160": "4",
  "36203": "4",
  "33161": "4",
  "33458": "4",
  "35211": "4",
  "35619": "4",
  "36609": "4",
  "36052": "4",
  "35175": "4",
  "35019": "4",
  "35016": "4",
  "35249": "4",
  "33179": "4",
  "34479": "4",
  "30740": "4",
  "30609": "4",
  "33135": "4",
  "34228": "4",
  "32401": "4",
  "36279": "4",
  "30566": "4",
  "30308": "4",
  "30344": "4",
  "33150": "4",
  "33430": "4",
  "33133": "4",
  "33155": "4",
  "32310": "4",
  "34215": "4",
  "36323": "4",
  "36793": "4",
  "36550": "4",
  "30113": "4",
  "31537": "4",
  "31548": "4",
  "30663": "4",
  "30631": "4",
  "30669": "4",
  "30025": "4",
  "31801": "4",
  "30810": "4",
  "30678": "4",
  "30803": "4",
  "30336": "4",
  "30326": "4",
  "95010": "7",
  "94973": "7",
  "91343": "6",
  "94963": "7",
  "91601": "6",
  "92630": "6",
  "95619": "6",
  "92505": "6",
  "92571": "6",
  "92656": "6",
  "92629": "6",
  "92521": "6",
  "92582": "6",
  "90039": "6",
  "90027": "6",
  "94535": "7",
  "94923": "7",
  "90095": "6",
  "95404": "7",
  "94972": "7",
  "94938": "7",
  "94521": "7",
  "94621": "7",
  "94612": "7",
  "94531": "7",
  "94806": "7",
  "91791": "6",
  "94805": "7",
  "94549": "7",
  "94710": "7",
  "92865": "6",
  "92802": "6",
  "92844": "6",
  "94804": "7",
  "94516": "7",
  "91020": "6",
  "94706": "7",
  "91506": "6",
  "90056": "6",
  "94545": "7",
  "95128": "7",
  "95125": "7",
  "95118": "7",
  "91755": "6",
  "91108": "6",
  "93526": "5",
  "95811": "7",
  "96115": "5",
  "93202": "6",
  "95934": "5",
  "93701": "6",
  "93905": "7",
  "96085": "7",
  "95595": "7",
  "95224": "6",
  "93305": "6",
  "90404": "6",
  "95524": "7",
  "95043": "7",
  "93930": "7",
  "96038": "7",
  "95568": "7",
  "93530": "6",
  "96161": "5",
  "91701": "6",
  "93227": "6",
  "95564": "7",
  "83203": "5",
  "83825": "5",
  "83348": "5",
  "87551": "5",
  "88201": "6",
  "87102": "5",
  "88008": "6",
  "87420": "5",
  "87313": "5",
  "88124": "2w",
  "88126": "6",
  "88012": "6",
  "88230": "6",
  "88435": "5",
  "87830": "6",
  "88029": "6",
  "87025": "5",
  "87326": "5",
  "88340": "6",
  "87018": "5",
  "88345": "6",
  "87046": "5",
  "87518": "5",
  "87111": "5",
  "88417": "5",
  "87742": "5",
  "87529": "5",
  "87743": "5",
  "87410": "5",
  "88265": "6",
  "87083": "5",
  "88325": "6",
  "87323": "5",
  "87357": "5",
  "87733": "5",
  "87007": "5",
  "87421": "5",
  "87556": "5",
  "87710": "5",
  "87514": "5",
  "87513": "5",
  "88324": "6",
  "87557": "5",
  "87512": "5",
  "88354": "6",
  "87723": "5",
  "88268": "6",
  "88255": "6",
  "88055": "6",
  "15202": "2e",
  "15046": "2e",
  "15005": "2e",
  "16730": "2e",
  "15056": "2e",
  "15142": "2e",
  "15870": "2e",
  "15122": "2e",
  "15236": "2e",
  "15139": "2e",
  "15332": "2e",
  "15034": "2e",
  "15140": "2e",
  "16117": "2e",
  "15345": "2e",
  "28619": "3e",
  "27559": "3e",
  "27881": "3e",
  "27843": "3e",
  "27244": "3e",
  "27203": "3e",
  "27298": "3e",
  "27235": "3e",
  "28054": "3e",
  "28611": "3e",
  "27208": "3e",
  "28098": "3e",
  "27249": "3e",
  "27609": "3e",
  "28135": "3e",
  "28447": "3e",
  "27820": "3e",
  "28771": "3e",
  "27939": "3e",
  "28349": "3e",
  "28453": "3e",
  "27885": "3e",
  "28745": "3e",
  "27860": "3e",
  "27919": "3e",
  "27946": "3e",
  "27853": "3e",
  "27956": "3e",
  "28742": "3e",
  "27870": "3e",
  "27024": "3e",
  "28758": "3e",
  "28129": "3e",
  "27522": "3e",
  "27017": "3e",
  "28128": "3e",
  "28726": "3e",
  "28719": "3e",
  "28789": "3e",
  "28455": "4",
  "28683": "3e",
  "27970": "3e",
  "10462": "2e",
  "10309": "2e",
  "14305": "1e",
  "11509": "2e",
  "13486": "1e",
  "13032": "1e",
  "14701": "2e",
  "10503": "2e",
  "11738": "2e",
  "13406": "1e",
  "14450": "1e",
  "10965": "2e",
  "13420": "1e",
  "13331": "1e",
  "11572": "2e",
  "13060": "1e",
  "10506": "2e",
  "11730": "2e",
  "13783": "2e",
  "12189": "2e",
  "10562": "2e",
  "10520": "2e",
  "10511": "2e",
  "13211": "1e",
  "10566": "2e",
  "10069": "2e",
  "12469": "2e",
  "10987": "2e",
  "10540": "2e",
  "11702": "2e",
  "11030": "2e",
  "11714": "2e",
  "13115": "1e",
  "14112": "2e",
  "13121": "1e",
  "14109": "1e",
  "14539": "1e",
  "14512": "2e",
  "12144": "2e",
  "12057": "1e",
  "13484": "1e",
  "13147": "2e",
  "12524": "2e",
  "13640": "1e",
  "12140": "2e",
  "13622": "1e",
  "13624": "1e",
  "13605": "1e",
  "12024": "2e",
  "12022": "2e",
  "12527": "2e",
  "12601": "2e",
  "13615": "1e",
  "12820": "1e",
  "12814": "1e",
  "12856": "1e",
  "12871": "1e",
  "13603": "1e",
  "12874": "1e",
  "12809": "1e",
  "12463": "2e",
  "12837": "1e",
  "11796": "2e",
  "12581": "2e",
  "11727": "2e",
  "12734": "2e",
  "14847": "2e",
  "12448": "2e",
  "13473": "1e",
  "12787": "2e",
  "14815": "2e",
  "12945": "1e",
  "14711": "2e",
  "14708": "2e",
  "13353": "1e",
  "12108": "1e",
  "14802": "2e",
  "12428": "2e",
  "12726": "2e",
  "12762": "2e",
  "12751": "2e",
  "12975": "1e",
  "14101": "2e",
  "13040": "2e",
  "13860": "2e",
  "14066": "2e",
  "14113": "2e",
  "12421": "2e",
  "11109": "2e",
  "12513": "2e",
  "12173": "2e",
  "12195": "2e",
  "11776": "2e",
  "11933": "2e",
  "11935": "2e",
  "11973": "2e",
  "11756": "2e",
  "11937": "2e",
  "11024": "2e",
  "11568": "2e",
  "11942": "2e",
  "13664": "1e",
  "13666": "1e",
  "13697": "1e",
  "13658": "1e",
  "13670": "1e",
  "13678": "1e",
  "13639": "1e",
  "13690": "1e",
  "13695": "1e",
  "13315": "2e",
  "13820": "2e",
  "11771": "2e",
  "11542": "2e",
  "13808": "2e",
  "12043": "2e",
  "13775": "2e",
  "13411": "2e",
  "02720": "2e",
  "01119": "2e",
  "01475": "2e",
  "02554": "2e",
  "01254": "2e",
  "01036": "2e",
  "01071": "2e",
  "01237": "2e",
  "01030": "2e",
  "01258": "2e",
  "01238": "2e",
  "06096": "2e",
  "06438": "2e",
  "06084": "2e",
  "06783": "2e",
  "06468": "2e",
  "06516": "2e",
  "06483": "2e",
  "06519": "2e",
  "06855": "2e",
  "06850": "2e",
  "06417": "2e",
  "06409": "2e",
  "06883": "2e",
  "06796": "2e",
  "06068": "2e",
  "06231": "2e",
  "06607": "2e",
  "06784": "2e",
  "06793": "2e",
  "06469": "2e",
  "06353": "2e",
  "06377": "2e",
  "06340": "2e",
  "06237": "2e",
  "06242": "2e",
  "06241": "2e",
  "06243": "2e",
  "06010": "2e",
  "06058": "2e",
  "06441": "2e",
  "06419": "2e",
  "06461": "2e",
  "06473": "2e",
  "06759": "2e",
  "06511": "2e",
  "06524": "2e",
  "06702": "2e",
  "06071": "2e",
  "06804": "2e",
  "06716": "2e",
  "06897": "2e",
  "06851": "2e",
  "06854": "2e",
  "06479": "2e",
  "06903": "2e",
  "06755": "2e",
  "06525": "2e",
  "06877": "2e",
  "06112": "2e",
  "06069": "2e",
  "06098": "2e",
  "06033": "2e",
  "06117": "2e",
  "06119": "2e",
  "06081": "2e",
  "06026": "2e",
  "06777": "2e",
  "06255": "2e",
  "06334": "2e",
  "06278": "2e",
  "06239": "2e",
  "06262": "2e",
  "06263": "2e",
  "06410": "2e",
  "06019": "2e",
  "08056": "2e",
  "08041": "2e",
  "08518": "2e",
  "08064": "2e",
  "08097": "2e",
  "08722": "2e",
  "08073": "2e",
  "98003": "5",
  "98074": "5",
  "98685": "7",
  "98385": "5",
  "98447": "7",
  "98102": "5",
  "99347": "5",
  "99139": "5",
  "98363": "7",
  "98381": "7",
  "98591": "7",
  "98819": "5",
  "98862": "5",
  "98930": "5",
  "98938": "5",
  "99032": "5",
  "98542": "7",
  "98108": "5",
  "98261": "5",
  "99008": "5",
  "98260": "5",
  "98649": "7",
  "98947": "5",
  "98155": "5",
  "98056": "5",
  "98524": "7",
  "98058": "5",
  "98267": "5",
  "99328": "5",
  "99103": "5",
  "99029": "5",
  "58638": "1w",
  "59270": "1w",
  "58367": "1w",
  "58849": "1w",
  "58254": "1w",
  "58421": "1w",
  "58361": "1w",
  "58382": "1w",
  "58362": "1w",
  "58225": "1w",
  "58484": "1w",
  "58266": "1w",
  "58505": "1w",
  "58790": "1w",
  "58267": "1w",
  "58558": "1w",
  "58035": "1w",
  "58639": "1w",
  "58049": "1w",
  "58492": "1w",
  "58425": "1w",
  "58063": "1w",
  "58529": "1w",
  "58429": "1w",
  "58542": "1w",
  "58496": "1w",
  "58420": "1w",
  "57645": "1w",
  "58776": "1w",
  "58474": "1w",
  "58440": "1w",
  "58472": "1w",
  "58377": "1w",
  "58042": "1w",
  "58005": "1w",
  "58047": "1w",
  "58002": "1w",
  "58029": "1w",
  "58068": "1w",
  "58277": "1w",
  "58222": "1w",
  "58323": "1w",
  "58015": "1w",
  "58405": "1w",
  "58355": "1w",
  "58219": "1w",
  "58575": "1w",
  "58716": "1w",
  "58652": "1w",
  "58757": "1w",
  "58329": "1w",
  "58795": "1w",
  "58463": "1w",
  "58301": "1w",
  "58270": "1w",
  "58386": "1w",
  "58272": "1w",
  "58579": "1w",
  "58313": "1w",
  "58503": "1w",
  "58566": "1w",
  "58532": "1w",
  "58520": "1w",
  "58031": "1w",
  "58416": "1w",
  "58448": "1w",
  "58327": "1w",
  "58210": "1w",
  "58601": "1w",
  "58642": "1w",
  "58838": "1w",
  "58634": "1w",
  "58835": "1w",
  "58621": "1w",
  "58654": "1w",
  "58631": "1w",
  "58775": "1w",
  "59221": "1w",
  "58366": "1w",
  "58316": "1w",
  "58843": "1w",
  "58752": "1w",
  "58755": "1w",
  "58782": "1w",
  "58341": "1w",
  "58736": "1w",
  "58710": "1w",
  "58273": "1w",
  "58321": "1w",
  "58237": "1w",
  "58344": "1w",
  "58559": "1w",
  "58201": "1w",
  "58703": "1w",
  "58704": "1w",
  "58731": "1w",
  "58078": "1w",
  "58244": "1w",
  "58258": "1w",
  "58228": "1w",
  "58046": "1w",
  "70721": "4",
  "71473": "4",
  "70725": "4",
  "71003": "3w",
  "71243": "4",
  "70119": "4",
  "71449": "4",
  "70113": "4",
  "71209": "4",
  "71456": "4",
  "70814": "4",
  "70592": "4",
  "70529": "4",
  "70356": "4",
  "70555": "4",
  "70817": "4",
  "70471": "4",
  "70754": "4",
  "71040": "3w",
  "71446": "4",
  "71367": "4",
  "70656": "4",
  "70638": "4",
  "70068": "4",
  "70084": "4",
  "71235": "3w",
  "70080": "4",
  "70031": "4",
  "70464": "4",
  "70514": "4",
  "70726": "4",
  "71069": "3w",
  "71063": "4",
  "70589": "4",
  "70524": "4",
  "71356": "4",
  "70775": "4",
  "70777": "4",
  "70659": "4",
  "71064": "3w",
  "71328": "4",
  "71433": "4",
  "70342": "4",
  "70522": "4",
  "70550": "4",
  "70778": "4",
  "70085": "4",
  "70580": "4",
  "71259": "4",
  "71045": "3w",
  "71342": "4",
  "70516": "4",
  "70645": "4",
  "71226": "4",
  "70584": "4",
  "70525": "4",
  "70541": "4",
  "70301": "4",
  "71106": "3w",
  "70519": "4",
  "70355": "4",
  "70065": "4",
  "70036": "4",
  "55407": "1w",
  "55603": "1w",
  "56354": "1w",
  "56313": "1w",
  "56453": "1w",
  "56750": "1w",
  "55378": "1w",
  "56762": "1w",
  "55749": "1w",
  "56548": "1w",
  "56046": "1w",
  "56226": "1w",
  "56081": "1w",
  "56579": "1w",
  "56044": "1w",
  "55314": "1w",
  "55416": "1w",
  "56701": "1w",
  "55013": "1w",
  "55302": "1w",
  "55016": "1w",
  "55001": "1w",
  "56378": "1w",
  "55005": "1w",
  "55109": "1w",
  "55312": "1w",
  "56231": "1w",
  "55385": "1w",
  "56425": "1w",
  "55310": "1w",
  "55368": "1w",
  "55041": "1w",
  "56639": "1w",
  "56156": "1w",
  "56173": "1w",
  "55969": "1w",
  "55769": "1w",
  "55736": "1w",
  "55389": "1w",
  "55731": "1w",
  "56676": "1w",
  "56315": "1w",
  "56175": "1w",
  "55328": "1w",
  "56239": "1w",
  "56759": "1w",
  "56713": "1w",
  "56357": "1w",
  "56350": "1w",
  "56729": "1w",
  "55379": "1w",
  "56142": "1w",
  "56037": "1w",
  "55765": "1w",
  "55706": "1w",
  "55422": "1w",
  "55343": "1w",
  "55439": "1w",
  "55113": "1w",
  "56279": "1w",
  "56320": "1w",
  "56671": "1w",
  "56575": "1w",
  "56369": "1w",
  "56110": "1w",
  "56178": "1w",
  "55787": "1w",
  "55424": "1w",
  "56715": "1w",
  "56367": "1w",
  "55982": "1w",
  "55779": "1w",
  "56331": "1w",
  "56166": "1w",
  "55375": "1w",
  "56185": "1w",
  "55442": "1w",
  "56033": "1w",
  "56253": "1w",
  "56437": "1w",
  "51103": "2w",
  "52306": "2w",
  "52207": "2w",
  "52073": "2w",
  "52039": "2w",
  "52745": "2w",
  "52235": "2w",
  "52246": "2w",
  "50319": "2w",
  "51234": "1w",
  "54909": "1e",
  "54454": "1e",
  "54632": "1e",
  "53522": "2e",
  "54467": "1e",
  "53932": "1e",
  "53969": "1e",
  "53935": "1e",
  "53940": "1e",
  "54541": "1e",
  "53934": "1e",
  "54546": "1e",
  "54446": "1e",
  "53544": "1e",
  "53553": "1e",
  "54703": "1e",
  "54737": "1e",
  "53121": "2e",
  "53404": "2e",
  "53224": "1e",
  "53548": "2e",
  "54307": "1e",
  "53711": "1e",
  "53959": "1e",
  "54603": "1e",
  "53579": "1e",
  "54826": "1e",
  "53115": "2e",
  "53144": "2e",
  "53402": "2e",
  "54650": "1e",
  "53218": "1e",
  "53703": "1e",
  "54159": "1e",
  "54406": "1e",
  "54480": "1e",
  "54021": "1w",
  "53810": "2w",
  "54566": "1e",
  "53816": "1e",
  "54401": "1e",
  "54220": "1e",
  "53704": "1e",
  "53961": "1e",
  "54805": "1e",
  "53158": "2e",
  "53191": "2e",
  "53536": "2e",
  "53716": "1e",
  "53576": "2e",
  "54228": "1e",
  "54214": "1e",
  "54669": "1e",
  "54113": "1e",
  "53559": "1e",
  "54160": "1e",
  "54666": "1e",
  "54971": "1e",
  "53950": "1e",
  "54981": "1e",
  "53551": "1e",
  "54630": "1e",
  "54929": "1e",
  "54638": "1e",
  "54162": "1e",
  "53207": "2e",
  "54880": "1e",
  "54313": "1e",
  "53208": "1e",
  "54130": "1e",
  "54830": "1e",
  "54174": "1e",
  "53010": "1e",
  "54864": "1e",
  "54015": "1e",
  "53178": "1e",
  "53007": "1e",
  "53521": "2e",
  "54311": "1e",
  "54842": "1e",
  "53517": "1e",
  "54027": "1e",
  "54755": "1e",
  "53211": "1e",
  "53212": "1e",
  "54112": "1e",
  "53012": "1e",
  "53092": "1e",
  "53022": "1e",
  "53527": "1e",
  "54495": "1e",
  "53093": "1e",
  "54026": "1e",
  "53534": "2e",
  "54561": "1e",
  "53809": "1e",
  "54639": "1e",
  "54466": "1e",
  "53964": "1e",
  "54411": "1e",
  "54827": "1e",
  "53805": "1e",
  "54895": "1e",
  "53953": "1e",
  "53217": "1e",
  "53221": "2e",
  "17970": "2e",
  "17965": "2e",
  "17028": "2e",
  "16102": "2e",
  "19139": "2e",
  "18059": "2e",
  "19611": "2e",
  "19607": "2e",
  "19529": "2e",
  "18218": "2e",
  "17073": "2e",
  "19610": "2e",
  "18079": "2e",
  "17979": "2e",
  "17016": "2e",
  "18087": "2e",
  "19539": "2e",
  "16841": "2e",
  "17244": "2e",
  "16415": "2e",
  "16829": "2e",
  "17011": "2e",
  "18020": "2e",
  "19541": "2e",
  "17265": "2e",
  "17724": "2e",
  "16823": "2e",
  "17762": "2e",
  "16677": "2e",
  "17758": "2e",
  "17254": "2e",
  "19544": "2e",
  "17261": "2e",
  "16635": "2e",
  "17550": "2e",
  "16665": "2e",
  "17702": "2e",
  "16673": "2e",
  "17752": "2e",
  "17015": "2e",
  "17027": "2e",
  "17013": "2e",
  "07450": "2e",
  "07661": "2e",
  "07111": "2e",
  "07047": "2e",
  "07074": "2e",
  "07606": "2e",
  "08802": "2e",
  "07504": "2e",
  "07631": "2e",
  "07067": "2e",
  "08611": "2e",
  "08638": "2e",
  "07306": "2e",
  "07836": "2e",
  "07063": "2e",
  "07040": "2e",
  "07620": "2e",
  "07304": "2e",
  "08360": "2e",
  "07936": "2e",
  "07885": "2e",
  "07850": "2e",
  "08344": "2e",
  "08070": "2e",
  "08210": "2e",
  "08226": "2e",
  "08248": "2e",
  "08023": "2e",
  "08882": "2e",
  "08560": "2e",
  "08223": "2e",
  "08872": "2e",
  "07930": "2e",
  "07311": "2e",
  "08826": "2e",
  "08311": "2e",
  "08852": "2e",
  "07064": "2e",
  "08212": "2e",
  "08810": "2e",
  "08561": "2e",
  "07726": "2e",
  "08109": "2e",
  "07508": "2e",
  "99180": "5",
  "98632": "7",
  "99208": "5",
  "98331": "7",
  "29487": "4",
  "29161": "4",
  "29205": "4",
  "29687": "4",
  "29550": "4",
  "29673": "4",
  "29928": "4",
  "29461": "4",
  "29169": "4",
  "29172": "4",
  "29841": "4",
  "29644": "4",
  "29681": "4",
  "29662": "4",
  "29201": "4",
  "29607": "4",
  "29671": "4",
  "29479": "4",
  "29657": "4",
  "29505": "4",
  "23233": "3e",
  "23803": "3e",
  "23707": "3e",
  "24301": "3e",
  "24084": "3e",
  "24058": "3e",
  "23063": "3e",
  "23116": "3e",
  "23662": "3e",
  "22032": "2e",
  "22031": "2e",
  "22041": "2e",
  "23047": "3e",
  "22039": "2e",
  "22102": "2e",
  "22124": "2e",
  "23841": "3e",
  "20129": "2e",
  "23881": "3e",
  "20110": "2e",
  "23350": "3e",
  "24589": "3e",
  "23889": "3e",
  "23027": "3e",
  "23002": "3e",
  "23921": "3e",
  "23884": "3e",
  "22727": "3e",
  "24599": "3e",
  "23405": "3e",
  "24577": "3e",
  "22715": "3e",
  "24079": "3e",
  "23083": "3e",
  "22711": "3e",
  "24487": "3e",
  "23924": "3e",
  "23398": "3e",
  "22723": "3e",
  "24415": "3e",
  "23307": "3e",
  "20186": "3e",
  "24124": "3e",
  "24147": "3e",
  "24569": "3e",
  "24520": "3e",
  "22642": "2e",
  "24219": "3e",
  "24263": "3e",
  "24244": "3e",
  "23071": "3e",
  "23176": "3e",
  "23138": "3e",
  "23025": "3e",
  "24502": "3e",
  "24651": "3e",
  "23320": "3e",
  "23110": "3e",
  "24311": "3e",
  "22963": "3e",
  "24137": "3e",
  "24065": "3e",
  "24588": "3e",
  "22553": "3e",
  "24088": "3e",
  "24551": "3e",
  "24184": "3e",
  "24014": "3e",
  "24059": "3e",
  "23507": "3e",
  "24245": "3e",
  "22407": "3e",
  "23893": "3e",
  "23857": "3e",
  "20181": "3e",
  "22743": "3e",
  "22740": "3e",
  "24450": "3e",
  "23123": "3e",
  "20144": "2e",
  "23354": "3e",
  "24091": "3e",
  "23938": "3e",
  "23942": "3e",
  "24138": "3e",
  "23934": "3e",
  "22643": "2e",
  "24598": "3e",
  "22967": "3e",
  "22720": "3e",
  "22964": "3e",
  "23056": "3e",
  "23079": "3e",
  "23169": "3e",
  "23043": "3e",
  "22436": "3e",
  "23505": "3e",
  "24017": "3e",
  "24634": "3e",
  "24087": "3e",
  "24550": "3e",
  "22610": "2e",
  "23510": "3e",
  "24290": "3e",
  "23606": "3e",
  "24013": "3e",
  "24171": "3e",
  "22576": "3e",
  "22427": "3e",
  "22650": "3e",
  "24139": "3e",
  "24161": "3e",
  "23462": "3e",
  "77453": "4",
  "76457": "6",
  "76853": "6",
  "75657": "3w",
  "79714": "6",
  "77342": "3w",
  "77419": "4",
  "75975": "3w",
  "78355": "6",
  "75472": "3w",
  "79323": "6",
  "78860": "6",
  "79705": "6",
  "75766": "3w",
  "79527": "6",
  "71333": "4",
  "71369": "4",
  "70513": "4",
  "70340": "4",
  "70576": "4",
  "70639": "4",
  "70787": "4",
  "71480": "4",
  "70632": "4",
  "70559": "4",
  "70518": "4",
  "70373": "4",
  "70354": "4",
  "71105": "3w",
  "70375": "4",
  "71351": "4",
  "71303": "4",
  "71360": "4",
  "70125": "4",
  "71115": "3w",
  "70601": "4",
  "70805": "4",
  "71254": "4",
  "71462": "4",
  "70648": "4",
  "70546": "4",
  "70581": "4",
  "71276": "4",
  "70395": "4",
  "70130": "4",
  "70363": "4",
  "70615": "4",
  "71427": "4",
  "70352": "4",
  "70811": "4",
  "70668": "4",
  "70435": "4",
  "70452": "4",
  "70437": "4",
  "70041": "4",
  "71046": "3w",
  "70079": "4",
  "70076": "4",
  "70090": "4",
  "71044": "3w",
  "71118": "3w",
  "71047": "3w",
  "71007": "3w",
  "71032": "3w",
  "70575": "4",
  "71422": "4",
  "71483": "4",
  "71358": "4",
  "71336": "4",
  "70453": "4",
  "70730": "4",
  "70782": "4",
  "71346": "4",
  "71323": "4",
  "71430": "4",
  "71467": "4",
  "71330": "4",
  "70086": "4",
  "70732": "4",
  "70401": "4",
  "70446": "4",
  "94528": "7",
  "94523": "7",
  "90293": "6",
  "90732": "6",
  "94801": "7",
  "94707": "7",
  "91210": "6",
  "91008": "6",
  "91024": "6",
  "90660": "6",
  "90670": "6",
  "91125": "6",
  "95053": "7",
  "95037": "7",
  "94304": "7",
  "95139": "7",
  "94306": "7",
  "92617": "6",
  "92603": "6",
  "92618": "6",
  "92637": "6",
  "94044": "7",
  "94030": "7",
  "94074": "7",
  "91387": "6",
  "93591": "6",
  "90290": "6",
  "90263": "6",
  "93544": "6",
  "90211": "6",
  "91355": "6",
  "91741": "6",
  "91608": "6",
  "95671": "6",
  "95659": "7",
  "95439": "7",
  "95060": "7",
  "90720": "6",
  "90623": "6",
  "90620": "6",
  "91340": "6",
  "90680": "6",
  "95005": "7",
  "95007": "7",
  "90089": "6",
  "90043": "6",
  "90003": "6",
  "96059": "7",
  "95453": "7",
  "95912": "7",
  "95602": "6",
  "93721": "6",
  "95361": "7",
  "93244": "6",
  "93065": "6",
  "91307": "6",
  "93063": "6",
  "92109": "6",
  "93651": "6",
  "92374": "6",
  "92408": "6",
  "95660": "7",
  "92106": "6",
  "95837": "7",
  "90265": "6",
  "92350": "6",
  "95630": "6",
  "95610": "6",
  "92037": "6",
  "92114": "6",
  "92358": "6",
  "95328": "7",
  "95313": "7",
  "95917": "7",
  "93726": "6",
  "95304": "7",
  "15780": "2e",
  "16926": "2e",
  "18832": "2e",
  "15747": "2e",
  "15736": "2e",
  "15536": "2e",
  "16313": "2e",
  "18424": "2e",
  "15727": "2e",
  "18444": "2e",
  "16352": "2e",
  "16211": "2e",
  "15539": "2e",
  "16434": "2e",
  "16420": "2e",
  "19115": "2e",
  "19383": "2e",
  "16235": "2e",
  "18701": "2e",
  "16258": "2e",
  "16145": "2e",
  "18249": "2e",
  "17860": "2e",
  "19004": "2e",
  "18471": "2e",
  "18452": "2e",
  "19090": "2e",
  "16374": "2e",
  "17764": "2e",
  "18331": "2e",
  "17061": "2e",
  "73005": "3w",
  "73108": "3w",
  "73129": "3w",
  "73014": "3w",
  "74347": "3w",
  "74359": "3w",
  "74966": "3w",
  "74943": "3w",
  "73090": "3w",
  "73040": "3w",
  "74361": "3w",
  "73105": "3w",
  "74949": "3w",
  "74080": "2w",
  "74472": "3w",
  "73151": "3w",
  "73527": "3w",
  "74435": "3w",
  "74446": "3w",
  "74085": "3w",
  "74103": "3w",
  "73705": "2w",
  "74632": "2w",
  "74646": "2w",
  "74126": "3w",
  "74120": "3w",
  "74105": "3w",
  "74463": "3w",
  "74641": "2w",
  "74130": "3w",
  "73942": "2w",
  "73945": "2w",
  "73173": "3w",
  "74560": "3w",
  "74873": "3w",
  "74525": "3w",
  "74546": "3w",
  "73098": "3w",
  "74849": "3w",
  "74827": "3w",
  "77443": "6",
  "77454": "6",
  "76882": "6",
  "77460": "6",
  "78024": "6",
  "79344": "6",
  "79380": "6",
  "78585": "6",
  "76483": "3w",
  "79343": "6",
  "78384": "6",
  "79065": "2w",
  "76943": "6",
  "78563": "4",
  "75844": "3w",
  "78636": "6",
  "75683": "3w",
  "75440": "3w",
  "79226": "2w",
  "79084": "2w",
  "75930": "4",
  "75451": "3w",
  "76363": "3w",
  "75140": "3w",
  "75803": "3w",
  "75974": "3w",
  "75550": "3w",
  "79706": "6",
  "79014": "2w",
  "76933": "6",
  "75965": "3w",
  "78671": "6",
  "78675": "6",
  "76454": "6",
  "75643": "3w",
  "75441": "3w",
  "79314": "6",
  "75977": "4",
  "79326": "6",
  "79080": "2w",
  "79256": "6",
  "75964": "3w",
  "79367": "6",
  "79235": "6",
  "79854": "6",
  "79376": "6",
  "76865": "6",
  "76872": "6",
  "76823": "6",
  "76380": "3w",
  "75070": "3w",
  "75884": "3w",
  "02802": "2e",
  "02824": "2e",
  "02885": "2e",
  "02806": "2e",
  "02874": "2e",
  "02804": "2e",
  "02915": "2e",
  "02916": "2e",
  "02912": "2e",
  "02830": "2e",
  "02917": "2e",
  "02829": "2e",
  "02839": "2e",
  "02886": "2e",
  "02818": "2e",
  "02879": "2e",
  "02835": "2e",
  "02918": "2e",
  "02865": "2e",
  "02920": "2e",
  "02814": "2e",
  "02861": "2e",
  "02858": "2e",
  "02871": "2e",
  "02878": "2e",
  "02807": "2e",
  "02832": "2e",
  "02873": "2e",
  "02841": "2e",
  "02911": "2e",
  "02904": "2e",
  "02860": "2e",
  "02828": "2e",
  "02859": "2e",
  "02895": "2e",
  "02889": "2e",
  "02888": "2e",
  "02809": "2e",
  "02893": "2e",
  "02808": "2e",
  "02822": "2e",
  "02813": "2e",
  "02833": "2e",
  "02875": "2e",
  "08003": "2e",
  "08083": "2e",
  "08106": "2e",
  "08029": "2e",
  "08107": "2e",
  "08074": "2e",
  "08049": "2e",
  "08066": "2e",
  "08054": "2e",
  "08060": "2e",
  "08053": "2e",
  "08092": "2e",
  "07724": "2e",
  "07719": "2e",
  "08884": "2e",
  "08203": "2e",
  "07848": "2e",
  "07826": "2e",
  "08844": "2e",
  "07501": "2e",
  "07055": "2e",
  "07059": "2e",
  "08876": "2e",
  "07901": "2e",
  "08804": "2e",
  "07065": "2e",
  "07027": "2e",
  "07016": "2e",
  "07028": "2e",
  "08830": "2e",
  "08840": "2e",
  "08820": "2e",
  "07106": "2e",
  "07203": "2e",
  "07013": "2e",
  "44721": "2e",
  "43018": "2e",
  "43046": "2e",
  "44201": "2e",
  "44272": "2e",
  "44234": "2e",
  "43147": "2e",
  "44111": "2e",
  "44105": "2e",
  "44110": "2e",
  "44001": "2e",
  "44404": "2e",
  "45102": "2e",
  "45157": "2e",
  "45106": "2e",
  "45347": "2e",
  "45383": "2e",
  "44275": "2e",
  "44483": "2e",
  "45244": "2e",
  "45150": "2e",
  "45659": "2e",
  "44865": "2e",
  "43439": "2e",
  "45669": "3e",
  "44850": "2e",
  "45645": "2e",
  "43458": "2e",
  "45806": "2e",
  "45215": "2e",
  "45065": "2e",
  "45696": "2e",
  "45242": "2e",
  "45212": "2e",
  "43015": "2e",
  "43464": "2e",
  "43157": "2e",
  "43437": "2e",
  "45699": "2e",
  "43436": "2e",
  "43330": "2e",
  "43434": "2e",
  "43136": "2e",
  "45041": "2e",
  "45888": "2e",
  "45348": "2e",
  "45301": "2e",
  "45356": "2e",
  "43963": "2e",
  "45307": "2e",
  "44021": "2e",
  "45169": "2e",
  "45316": "2e",
  "43903": "2e",
  "43945": "2e",
  "44651": "2e",
  "44639": "2e",
  "43011": "2e",
  "43988": "2e",
  "44122": "2e",
  "68127": "2w",
  "68640": "2w",
  "68419": "2w",
  "68008": "2w",
  "68002": "2w",
  "68818": "2w",
  "69168": "2w",
  "68816": "2w",
  "69128": "5",
  "69366": "2w",
  "69148": "2w",
  "68350": "2w",
  "68741": "2w",
  "68413": "2w",
  "68647": "2w",
  "68318": "2w",
  "68313": "2w",
  "68405": "2w",
  "68044": "2w",
  "68020": "2w",
  "68370": "2w",
  "68784": "2w",
  "69030": "2w",
  "69027": "2w",
  "68452": "2w",
  "68422": "2w",
  "68833": "2w",
  "68623": "2w",
  "68460": "2w",
  "68791": "2w",
  "68433": "2w",
  "68003": "2w",
  "68033": "2w",
  "68305": "2w",
  "68860": "2w",
  "68815": "2w",
  "68813": "2w",
  "68827": "2w",
  "68726": "2w",
  "68665": "2w",
  "68767": "2w",
  "68346": "2w",
  "68454": "2w",
  "68407": "2w",
  "68774": "2w",
  "68724": "2w",
  "68789": "2w",
  "68112": "2w",
  "69146": "2w",
  "80534": "5",
  "80537": "5",
  "80906": "5",
  "80612": "5",
  "80809": "5",
  "80222": "5",
  "80904": "5",
  "80549": "5",
  "80002": "5",
  "83440": "5",
  "83530": "5",
  "83234": "5",
  "83713": "5",
  "83541": "5",
  "83524": "5",
  "83406": "5",
  "83672": "5",
  "83335": "5",
  "83428": "5",
  "83714": "5",
  "83645": "5",
  "83631": "5",
  "83627": "5",
  "83841": "5",
  "83286": "5",
  "83217": "5",
  "83725": "5",
  "83328": "5",
  "83246": "5",
  "83350": "5",
  "83438": "5",
  "83311": "5",
  "83455": "5",
  "83802": "5",
  "83812": "5",
  "99128": "5",
  "83840": "5",
  "83287": "5",
  "83323": "5",
  "83686": "5",
  "83866": "5",
  "83342": "5",
  "83254": "5",
  "83655": "5",
  "83501": "5",
  "83226": "5",
  "83712": "5",
  "83703": "5",
  "83221": "5",
  "83839": "5",
  "83709": "5",
  "83842": "5",
  "83677": "5",
  "83467": "5",
  "83535": "5",
  "83628": "5",
  "83632": "5",
  "83615": "5",
  "83445": "5",
  "83540": "5",
  "83334": "5",
  "83218": "5",
  "83629": "5",
  "83210": "5",
  "83657": "5",
  "83228": "5",
  "83444": "5",
  "83421": "5",
  "83252": "5",
  "83525": "5",
  "83223": "5",
  "83808": "5",
  "83656": "5",
  "59847": "5",
  "83236": "5",
  "83347": "5",
  "83846": "5",
  "83716": "5",
  "83648": "5",
  "83702": "5",
  "15222": "2e",
  "15953": "2e",
  "18229": "2e",
  "15564": "2e",
  "19007": "2e",
  "17059": "2e",
  "19440": "2e",
  "17870": "2e",
  "17082": "2e",
  "17014": "2e",
  "16002": "2e",
  "18428": "2e",
  "18457": "2e",
  "18854": "2e",
  "15692": "2e",
  "50605": "2w",
  "52141": "1w",
  "50151": "2w",
  "52358": "2w",
  "50154": "2w",
  "50316": "2w",
  "50567": "2w",
  "51018": "2w",
  "52576": "2w",
  "51101": "2w",
  "52543": "2w",
  "50606": "2w",
  "52570": "2w",
  "52362": "2w",
  "50451": "1w",
  "51520": "2w",
  "52053": "2w",
  "50540": "2w",
  "52241": "2w",
  "50228": "2w",
  "51549": "2w",
  "50484": "1w",
  "51535": "2w",
  "50853": "2w",
  "50126": "2w",
  "52342": "2w",
  "51579": "2w",
  "51360": "1w",
  "52732": "2w",
  "52328": "2w",
  "50633": "2w",
  "50044": "2w",
  "51354": "1w",
  "50420": "2w",
  "52750": "2w",
  "52638": "2w",
  "50052": "2w",
  "52164": "2w",
  "50456": "1w",
  "50476": "1w",
  "50455": "1w",
  "50460": "1w",
  "50469": "1w",
  "52549": "2w",
  "50157": "2w",
  "50122": "2w",
  "50465": "1w",
  "52216": "2w",
  "50464": "1w",
  "52337": "2w",
  "52329": "2w",
  "50552": "2w",
  "50013": "2w",
  "51636": "2w",
  "50012": "2w",
  "51533": "2w",
  "51033": "1w",
  "50536": "1w",
  "50048": "2w",
  "50597": "1w",
  "50644": "2w",
  "88346": "6",
  "87582": "5",
  "87560": "5",
  "88039": "6",
  "87015": "5",
  "88431": "5",
  "87553": "5",
  "87051": "5",
  "87063": "5",
  "87829": "6",
  "87105": "5",
  "87109": "5",
  "87113": "5",
  "87059": "5",
  "88048": "6",
  "88410": "2w",
  "87578": "5",
  "87531": "5",
  "87412": "5",
  "88003": "6",
  "87517": "5",
  "87732": "5",
  "87031": "5",
  "87941": "6",
  "87736": "5",
  "88024": "6",
  "88439": "5",
  "87735": "5",
  "88065": "6",
  "87006": "6",
  "87116": "5",
  "87823": "6",
  "88009": "6",
  "16625": "2e",
  "17225": "2e",
  "16442": "2e",
  "15738": "2e",
  "16868": "2e",
  "17606": "2e",
  "15760": "2e",
  "17506": "2e",
  "15938": "2e",
  "15962": "2e",
  "17507": "2e",
  "19562": "2e",
  "19534": "2e",
  "17560": "2e",
  "17529": "2e",
  "15952": "2e",
  "15561": "2e",
  "15937": "2e",
  "15544": "2e",
  "18244": "2e",
  "18343": "2e",
  "15926": "2e",
  "15622": "2e",
  "15540": "2e",
  "18212": "2e",
  "17104": "2e",
  "17347": "2e",
  "18058": "2e",
  "17584": "2e",
  "17534": "2e",
  "17565": "2e",
  "18083": "2e",
  "15934": "2e",
  "19511": "2e",
  "15930": "2e",
  "19564": "2e",
  "18235": "2e",
  "17315": "2e",
  "15546": "2e",
  "15936": "2e",
  "17316": "2e",
  "97446": "7",
  "97709": "5",
  "97212": "7",
  "97437": "7",
  "97266": "7",
  "97403": "7",
  "97712": "5",
  "97701": "5",
  "97490": "7",
  "97222": "7",
  "97434": "7",
  "97524": "7",
  "97463": "7",
  "97306": "7",
  "97536": "7",
  "97218": "7",
  "97497": "7",
  "97208": "7",
  "97133": "7",
  "97258": "7",
  "97352": "7",
  "97071": "7",
  "97347": "7",
  "97441": "7",
  "97115": "7",
  "97023": "7",
  "65786": "2w",
  "63050": "2w",
  "63023": "2w",
  "63627": "2w",
  "65658": "3w",
  "63878": "3w",
  "63384": "2w",
  "64132": "2w",
  "63952": "3w",
  "63956": "3w",
  "65711": "3w",
  "63069": "2w",
  "64601": "2w",
  "65689": "3w",
  "65590": "2w",
  "63026": "2w",
  "65257": "2w",
  "65014": "2w",
  "65679": "3w",
  "65672": "3w",
  "65739": "3w",
  "63655": "3w",
  "65640": "2w",
  "65641": "3w",
  "63446": "2w",
  "64402": "2w",
  "64755": "2w",
  "65061": "2w",
  "64473": "2w",
  "65250": "2w",
  "63558": "2w",
  "63557": "2w",
  "64638": "2w",
  "65567": "2w",
  "64438": "2w",
  "64068": "2w",
  "64484": "2w",
  "64163": "2w",
  "64012": "2w",
  "63031": "2w",
  "63104": "2w",
  "63118": "2w",
  "64158": "2w",
  "64133": "2w",
  "65721": "3w",
  "64150": "2w",
  "63121": "2w",
  "63133": "2w",
  "63108": "2w",
  "64114": "2w",
  "64128": "2w",
  "65681": "3w",
  "65053": "2w",
  "64779": "2w",
  "63074": "2w",
  "63376": "2w",
  "63122": "2w",
  "63017": "2w",
  "65754": "3w",
  "65074": "2w",
  "65349": "2w",
  "64097": "2w",
  "65330": "2w",
  "65790": "3w",
  "65347": "2w",
  "64077": "2w",
  "64090": "2w",
  "64492": "2w",
  "64084": "2w",
  "65611": "3w",
  "64029": "2w",
  "64070": "2w",
  "64870": "2w",
  "65772": "3w",
  "64770": "2w",
  "64788": "2w",
  "64124": "2w",
  "65215": "2w",
  "64401": "2w",
  "64063": "2w",
  "64440": "2w",
  "64449": "2w",
  "64057": "2w",
  "65725": "2w",
  "63626": "2w",
  "63630": "2w",
  "63434": "2w",
  "65713": "2w",
  "65707": "2w",
  "63459": "2w",
  "64640": "2w",
  "63787": "3w",
  "65483": "3w",
  "65731": "3w",
  "65648": "2w",
  "65704": "3w",
  "64653": "2w",
  "65048": "2w",
  "65759": "3w",
  "65627": "3w",
  "63967": "3w",
  "63468": "2w",
  "64429": "2w",
  "64667": "2w",
  "63534": "2w",
  "65401": "2w",
  "64855": "2w",
  "64479": "2w",
  "65752": "2w",
  "65438": "3w",
  "65542": "2w",
  "65705": "3w",
  "65583": "2w",
  "65769": "3w",
  "65011": "2w",
  "65084": "2w",
  "64457": "2w",
  "65584": "2w",
  "63703": "3w",
  "64491": "2w",
  "64644": "2w",
  "63740": "3w",
  "65726": "3w",
  "64432": "2w",
  "64783": "2w",
  "64767": "2w",
  "64671": "2w",
  "63942": "3w",
  "63743": "3w",
  "64493": "2w",
  "65066": "2w",
  "64062": "2w",
  "63450": "2w",
  "64477": "2w",
  "64762": "2w",
  "63845": "3w",
  "63621": "3w",
  "65260": "2w",
  "64444": "2w",
  "63042": "2w",
  "63139": "2w",
  "64844": "3w",
  "64130": "2w",
  "64138": "2w",
  "64843": "3w",
  "63101": "2e",
  "64085": "2w",
  "64036": "2w",
  "64022": "2w",
  "71234": "4",
  "71055": "3w",
  "71073": "3w",
  "71039": "3w",
  "71339": "4",
  "70739": "4",
  "70825": "4",
  "71269": "4",
  "70535": "4",
  "70586": "4",
  "71441": "4",
  "70520": "4",
  "70556": "4",
  "70531": "4",
  "70582": "4",
  "71103": "3w",
  "70062": "4",
  "70357": "4",
  "70552": "4",
  "71112": "3w",
  "71111": "3w",
  "70663": "4",
  "70122": "4",
  "70127": "4",
  "70377": "4",
  "71031": "4",
  "71406": "4",
  "71019": "4",
  "71429": "4",
  "70583": "4",
  "71452": "4",
  "70517": "4",
  "70433": "4",
  "70420": "4",
  "70431": "4",
  "70037": "4",
  "70038": "4",
  "70658": "4",
  "71223": "4",
  "70057": "4",
  "70637": "4",
  "71048": "3w",
  "70448": "4",
  "70445": "4",
  "71438": "4",
  "70422": "4",
  "70443": "4",
  "70441": "4",
  "71264": "4",
  "71229": "4",
  "70783": "4",
  "70753": "4",
  "70748": "4",
  "70710": "4",
  "70729": "4",
  "70801": "4",
  "70163": "4",
  "70523": "4",
  "70723": "4",
  "70743": "4",
  "70755": "4",
  "70454": "4",
  "70736": "4",
  "71233": "4",
  "71072": "3w",
  "70711": "4",
  "88262": "6",
  "87101": "5",
  "87712": "5",
  "88121": "5",
  "88038": "6",
  "87831": "6",
  "87801": "6",
  "87062": "6",
  "87042": "5",
  "87151": "5",
  "88426": "2w",
  "87036": "6",
  "87061": "5",
  "88043": "6",
  "88130": "6",
  "88001": "6",
  "88030": "6",
  "80457": "5",
  "80501": "5",
  "80104": "5",
  "80743": "2w",
  "81036": "2w",
  "80810": "2w",
  "80434": "5",
  "81147": "5",
  "81321": "5",
  "81230": "5",
  "80735": "2w",
  "80805": "2w",
  "80836": "2w",
  "80861": "2w",
  "80117": "5",
  "81434": "5",
  "80720": "2w",
  "80801": "2w",
  "80822": "2w",
  "80107": "5",
  "80751": "5",
  "81429": "5",
  "81411": "5",
  "81423": "5",
  "81430": "5",
  "80747": "5",
  "81424": "5",
  "81058": "5",
  "81149": "5",
  "81148": "5",
  "72520": "3w",
  "72392": "3w",
  "71658": "3w",
  "71953": "3w",
  "72560": "3w",
  "72721": "3w",
  "72632": "3w",
  "72454": "3w",
  "72379": "3w",
  "38769": "3e",
  "72834": "3w",
  "72583": "3w",
  "72578": "3w",
  "72538": "3w",
  "72531": "3w",
  "72687": "3w",
  "72951": "3w",
  "72564": "3w",
  "72165": "3w",
  "72821": "3w",
  "72827": "3w",
  "72658": "3w",
  "71654": "3w",
  "72838": "3w",
  "72853": "3w",
  "71944": "3w",
  "72544": "3w",
  "72460": "3w",
  "72686": "3w",
  "71940": "3w",
  "72634": "3w",
  "72444": "3w",
  "72322": "3w",
  "72661": "3w",
  "72168": "3w",
  "72916": "3w",
  "72150": "3w",
  "72447": "3w",
  "72438": "3w",
  "72923": "3w",
  "72072": "3w",
  "72223": "3w",
  "72199": "3w",
  "71835": "3w",
  "72119": "3w",
  "72354": "3w",
  "71933": "3w",
  "72955": "3w",
  "72932": "3w",
  "71949": "3w",
  "72739": "3w",
  "72736": "3w",
  "71838": "3w",
  "72768": "3w",
  "72034": "3w",
  "72061": "3w",
  "72131": "3w",
  "71822": "3w",
  "72111": "3w",
  "71638": "3w",
  "71858": "3w",
  "72081": "3w",
  "72852": "3w",
  "72139": "3w",
  "72568": "3w",
  "71661": "3w",
  "72685": "3w",
  "71864": "3w",
  "72458": "3w",
  "72128": "3w",
  "72459": "3w",
  "05682": "1e",
  "05051": "1e",
  "05443": "1e",
  "05050": "1e",
  "05648": "1e",
  "05667": "1e",
  "05666": "1e",
  "05079": "1e",
  "05442": "1e",
  "05065": "1e",
  "05068": "1e",
  "05730": "1e",
  "05762": "1e",
  "05737": "1e",
  "05761": "1e",
  "05143": "1e",
  "05030": "1e",
  "05252": "1e",
  "05251": "1e",
  "05059": "1e",
  "05361": "2e",
  "05770": "1e",
  "05354": "2e",
  "05154": "1e",
  "05455": "1e",
  "05846": "1e",
  "05840": "1e",
  "05837": "1e",
  "05853": "1e",
  "05401": "1e",
  "05462": "1e",
  "05458": "1e",
  "05486": "1e",
  "05440": "1e",
  "05444": "1e",
  "05656": "1e",
  "05680": "1e",
  "05452": "1e",
  "05664": "1e",
  "05046": "1e",
  "05821": "1e",
  "05602": "1e",
  "05076": "1e",
  "05679": "1e",
  "05081": "1e",
  "05828": "1e",
  "05767": "1e",
  "05045": "1e",
  "05773": "1e",
  "05778": "1e",
  "05764": "1e",
  "05774": "1e",
  "05052": "1e",
  "05155": "1e",
  "05736": "1e",
  "05495": "1e",
  "05478": "1e",
  "05448": "1e",
  "05872": "1e",
  "05906": "1e",
  "05450": "1e",
  "05905": "1e",
  "05860": "1e",
  "05907": "1e",
  "05471": "1e",
  "05404": "1e",
  "05674": "1e",
  "05836": "1e",
  "05843": "1e",
  "05661": "1e",
  "04671": "1e",
  "04057": "1e",
  "04360": "1e",
  "04066": "1e",
  "04843": "1e",
  "04568": "1e",
  "04539": "1e",
  "04046": "1e",
  "04481": "1e",
  "04945": "1e",
  "04257": "1e",
  "04275": "1e",
  "04406": "1e",
  "04492": "1e",
  "04736": "1e",
  "04441": "1e",
  "04490": "1e",
  "04330": "1e",
  "04085": "1e",
  "04658": "1e",
  "04950": "1e",
  "04535": "1e",
  "04982": "1e",
  "04757": "1e",
  "04572": "1e",
  "04735": "1e",
  "04760": "1e",
  "04853": "1e",
  "04984": "1e",
  "04047": "1e",
  "04352": "1e",
  "04056": "1e",
  "04461": "1e",
  "04021": "1e",
  "04474": "1e",
  "04346": "1e",
  "04043": "1e",
  "04607": "1e",
  "04448": "1e",
  "04274": "1e",
  "04430": "1e",
  "04422": "1e",
  "04019": "1e",
  "04271": "1e",
  "04613": "1e",
  "04669": "1e",
  "04662": "1e",
  "04410": "1e",
  "04944": "1e",
  "04861": "1e",
  "04675": "1e",
  "04222": "1e",
  "07628": "2e",
  "08534": "2e",
  "08832": "2e",
  "08848": "2e",
  "08202": "2e",
  "07068": "2e",
  "08536": "2e",
  "08824": "2e",
  "07460": "2e",
  "08038": "2e",
  "08559": "2e",
  "07921": "2e",
  "08350": "2e",
  "07503": "2e",
  "08528": "2e",
  "07721": "2e",
  "08002": "2e",
  "08751": "2e",
  "07505": "2e",
  "08245": "2e",
  "07970": "2e",
  "08062": "2e",
  "08012": "2e",
  "08081": "2e",
  "07871": "2e",
  "08108": "2e",
  "08078": "2e",
  "08026": "2e",
  "55340": "1w",
  "56042": "1w",
  "56032": "1w",
  "55435": "1w",
  "55359": "1w",
  "55384": "1w",
  "55961": "1w",
  "55973": "1w",
  "56652": "1w",
  "56529": "1w",
  "55446": "1w",
  "55974": "1w",
  "56035": "1w",
  "56736": "1w",
  "55808": "1e",
  "56340": "1w",
  "97357": "7",
  "97752": "5",
  "97365": "7",
  "97131": "7",
  "97369": "7",
  "97865": "5",
  "97842": "5",
  "97145": "7",
  "97147": "7",
  "97639": "5",
  "97135": "7",
  "72901": "3w",
  "71601": "3w",
  "72207": "3w",
  "72417": "3w",
  "72421": "3w",
  "72117": "3w",
  "72211": "3w",
  "72201": "3w",
  "72116": "3w",
  "72180": "3w",
  "72002": "3w",
  "72016": "3w",
  "72764": "3w",
  "71968": "3w",
  "71913": "3w",
  "72087": "3w",
  "72442": "3w",
  "72729": "3w",
  "72959": "3w",
  "72351": "3w",
  "72329": "3w",
  "72167": "3w",
  "72732": "3w",
  "71941": "3w",
  "71834": "3w",
  "72032": "3w",
  "72181": "3w",
  "72339": "3w",
  "71764": "3w",
  "72012": "3w",
  "72082": "3w",
  "72068": "3w",
  "72601": "3w",
  "71752": "3w",
  "72629": "3w",
  "72433": "3w",
  "72521": "3w",
  "72469": "3w",
  "72542": "3w",
  "72572": "3w",
  "72569": "3w",
  "72064": "3w",
  "72030": "3w",
  "72355": "3w",
  "72067": "3w",
  "72440": "3w",
  "72434": "3w",
  "72445": "3w",
  "72028": "3w",
  "72443": "3w",
  "72534": "3w",
  "72530": "3w",
  "72170": "3w",
  "72366": "3w",
  "72347": "3w",
  "72432": "3w",
  "72365": "3w",
  "12040": "2e",
  "12468": "2e",
  "12482": "2e",
  "12042": "2e",
  "12569": "2e",
  "12815": "1e",
  "12886": "1e",
  "12424": "2e",
  "12473": "2e",
  "10510": "2e",
  "13797": "2e",
  "13833": "2e",
  "11366": "2e",
  "12553": "2e",
  "10308": "2e",
  "14506": "1e",
  "10964": "2e",
  "14559": "1e",
  "12009": "2e",
  "10969": "2e",
  "14031": "1e",
  "10527": "2e",
  "10505": "2e",
  "12460": "2e",
  "11747": "2e",
  "10975": "2e",
  "13144": "1e",
  "14145": "2e",
  "13120": "1e",
  "11758": "2e",
  "14126": "1e",
  "11559": "2e",
  "14485": "1e",
  "11424": "2e",
  "12538": "2e",
  "13163": "1e",
  "14592": "1e",
  "14486": "1e",
  "12150": "1e",
  "12138": "2e",
  "11210": "2e",
  "13113": "1e",
  "13656": "1e",
  "12153": "2e",
  "12061": "2e",
  "13634": "1e",
  "13641": "1e",
  "13601": "1e",
  "13685": "1e",
  "13642": "1e",
  "13682": "1e",
  "13659": "1e",
  "12020": "1e",
  "12170": "1e",
  "12863": "1e",
  "12804": "1e",
  "12603": "2e",
  "12413": "2e",
  "12051": "2e",
  "12860": "1e",
  "12808": "1e",
  "12817": "1e",
  "12480": "2e",
  "12836": "1e",
  "12439": "2e",
  "12485": "2e",
  "12070": "1e",
  "12985": "1e",
  "12944": "1e",
  "12933": "1e",
  "11754": "2e",
  "38869": "3e",
  "39156": "4",
  "38827": "3e",
  "39737": "4",
  "38673": "3e",
  "39111": "4",
  "39647": "4",
  "38781": "3e",
  "39097": "4",
  "39339": "4",
  "39739": "4",
  "38633": "3e",
  "39633": "4",
  "39755": "4",
  "39741": "4",
  "39771": "4",
  "38801": "4",
  "39762": "4",
  "39730": "4",
  "38862": "4",
  "38858": "4",
  "39211": "4",
  "39305": "4",
  "39216": "4",
  "39530": "4",
  "39213": "4",
  "39507": "4",
  "39210": "4",
  "39335": "4",
  "39051": "4",
  "39629": "4",
  "39455": "4",
  "39074": "4",
  "39556": "4",
  "39046": "4",
  "39328": "4",
  "39160": "4",
  "39332": "4",
  "38829": "3e",
  "38740": "3e",
  "39751": "4",
  "38623": "3e",
  "38924": "4",
  "38643": "3e",
  "38629": "3e",
  "39177": "4",
  "38768": "3e",
  "39641": "4",
  "38644": "3e",
  "39088": "4",
  "38941": "4",
  "39356": "4",
  "39461": "4",
  "39347": "4",
  "38778": "3e",
  "39427": "4",
  "38914": "4",
  "24076": "3e",
  "22535": "3e",
  "22807": "3e",
  "24657": "3e",
  "24554": "3e",
  "22473": "3e",
  "22539": "3e",
  "24176": "3e",
  "23092": "3e",
  "22511": "3e",
  "22835": "3e",
  "23551": "3e",
  "22529": "3e",
  "24570": "3e",
  "23220": "3e",
  "24153": "3e",
  "22641": "2e",
  "24313": "3e",
  "24343": "3e",
  "22624": "2e",
  "22546": "3e",
  "24656": "3e",
  "24531": "3e",
  "24549": "3e",
  "23664": "3e",
  "22801": "3e",
  "22846": "3e",
  "22831": "3e",
  "24201": "3e",
  "24605": "3e",
  "24613": "3e",
  "24479": "3e",
  "24333": "3e",
  "24426": "3e",
  "22630": "2e",
  "23235": "3e",
  "23434": "3e",
  "24292": "3e",
  "23061": "3e",
  "23831": "3e",
  "23409": "3e",
  "23417": "3e",
  "23414": "3e",
  "23306": "3e",
  "23838": "3e",
  "23866": "3e",
  "22302": "2e",
  "22311": "2e",
  "24129": "3e",
  "22079": "3e",
  "23117": "3e",
  "22003": "2e",
  "23315": "3e",
  "20170": "2e",
  "22044": "2e",
  "23805": "3e",
  "23860": "3e",
  "23840": "3e",
  "23850": "3e",
  "20132": "2e",
  "20158": "2e",
  "23181": "3e",
  "23897": "3e",
  "23830": "3e",
  "23901": "3e",
  "20119": "3e",
  "23970": "3e",
  "22830": "3e",
  "22901": "3e",
  "22811": "2e",
  "22902": "3e",
  "22840": "3e",
  "24361": "3e",
  "24102": "3e",
  "24635": "3e",
  "23667": "3e",
  "24477": "3e",
  "24148": "3e",
  "23663": "3e",
  "24326": "3e",
  "24128": "3e",
  "24070": "3e",
  "23464": "3e",
  "24431": "3e",
  "24439": "3e",
  "24422": "3e",
  "23395": "3e",
  "23421": "3e",
  "23301": "3e",
  "23423": "3e",
  "23442": "3e",
  "23432": "3e",
  "23303": "3e",
  "24445": "3e",
  "23113": "3e",
  "23488": "3e",
  "23128": "3e",
  "23120": "3e",
  "22204": "2e",
  "22209": "2e",
  "23844": "3e",
  "22312": "2e",
  "23847": "3e",
  "23888": "3e",
  "22305": "2e",
  "23314": "3e",
  "23102": "3e",
  "23039": "3e",
  "23304": "3e",
  "22150": "2e",
  "23015": "3e",
  "20124": "2e",
  "20151": "2e",
  "20194": "2e",
  "22043": "2e",
  "22035": "2e",
  "22027": "2e",
  "23885": "3e",
  "23824": "3e",
  "20147": "2e",
  "20117": "2e",
  "23160": "3e",
  "20184": "2e",
  "23883": "3e",
  "24534": "3e",
  "23944": "3e",
  "65624": "3w",
  "64497": "2w",
  "63141": "2w",
  "63125": "2w",
  "65669": "3w",
  "63341": "2w",
  "63303": "2w",
  "64074": "2w",
  "64742": "2w",
  "64017": "2w",
  "63388": "2w",
  "64034": "2w",
  "64088": "2w",
  "64632": "2w",
  "63535": "2w",
  "64649": "2w",
  "63850": "3w",
  "63472": "2w",
  "63663": "3w",
  "65237": "2w",
  "51640": "2w",
  "52626": "2w",
  "65052": "2w",
  "65322": "2w",
  "64686": "2w",
  "64738": "2w",
  "65016": "2w",
  "65690": "3w",
  "65710": "2w",
  "65501": "3w",
  "63053": "2w",
  "63333": "2w",
  "64660": "2w",
  "65026": "2w",
  "63452": "2w",
  "63457": "2w",
  "65047": "2w",
  "65083": "2w",
  "65486": "2w",
  "63068": "2w",
  "63049": "2w",
  "63037": "2w",
  "65614": "3w",
  "65570": "3w",
  "64674": "2w",
  "64631": "2w",
  "63537": "2w",
  "65248": "2w",
  "63629": "3w",
  "64061": "2w",
  "64456": "2w",
  "63530": "2w",
  "64470": "2w",
  "65041": "2w",
  "65674": "2w",
  "63462": "2w",
  "63935": "3w",
  "65360": "2w",
  "65746": "3w",
  "65351": "2w",
  "65646": "2w",
  "65605": "3w",
  "65650": "2w",
  "65534": "2w",
  "65712": "2w",
  "65054": "2w",
  "63783": "3w",
  "65580": "2w",
  "65550": "2w",
  "65461": "2w",
  "63349": "2w",
  "63474": "2w",
  "65897": "2w",
  "64028": "2w",
  "63747": "3w",
  "64465": "2w",
  "64490": "2w",
  "65258": "2w",
  "63828": "3w",
  "64474": "2w",
  "65256": "2w",
  "63109": "2w",
  "63112": "2w",
  "63106": "2w",
  "80922": "5",
  "80236": "5",
  "81639": "5",
  "81324": "5",
  "80653": "5",
  "80469": "5",
  "80550": "5",
  "80530": "5",
  "80456": "5",
  "81615": "5",
  "81657": "5",
  "80010": "5",
  "81623": "5",
  "81089": "5",
  "80535": "5",
  "80016": "5",
  "80924": "5",
  "80005": "5",
  "81610": "5",
  "81656": "5",
  "80732": "5",
  "80622": "5",
  "80127": "5",
  "80433": "5",
  "80125": "5",
  "80021": "5",
  "80116": "5",
  "83844": "5",
  "83120": "5",
  "83404": "5",
  "83704": "5",
  "83314": "5",
  "83233": "5",
  "83549": "5",
  "83855": "5",
  "83801": "5",
  "83536": "5",
  "83443": "5",
  "83547": "5",
  "83402": "5",
  "83344": "5",
  "83285": "5",
  "83320": "5",
  "83848": "5",
  "89832": "5",
  "83436": "5",
  "83523": "5",
  "83450": "5",
  "83633": "5",
  "83858": "5",
  "83548": "5",
  "99033": "5",
  "83720": "5",
  "83874": "5",
  "97913": "5",
  "83423": "5",
  "83830": "5",
  "83429": "5",
  "83355": "5",
  "83463": "5",
  "83340": "5",
  "83814": "5",
  "83605": "5",
  "83316": "5",
  "83639": "5",
  "83539": "5",
  "83868": "5",
  "83843": "5",
  "83642": "5",
  "83833": "5",
  "83262": "5",
  "83545": "5",
  "83845": "5",
  "83469": "5",
  "83464": "5",
  "83824": "5",
  "83624": "5",
  "83610": "5",
  "83261": "5",
  "83806": "5",
  "83644": "5",
  "83237": "5",
  "83435": "5",
  "83452": "5",
  "83424": "5",
  "83520": "5",
  "83650": "5",
  "83274": "5",
  "83654": "5",
  "83870": "5",
  "97910": "5",
  "83873": "5",
  "83338": "5",
  "83209": "5",
  "83854": "5",
  "83312": "5",
  "83238": "5",
  "83313": "5",
  "87940": "6",
  "88052": "6",
  "87034": "5",
  "87305": "5",
  "87004": "5",
  "87120": "5",
  "87026": "5",
  "88051": "6",
  "88025": "6",
  "88330": "6",
  "88063": "6",
  "87024": "5",
  "88353": "5",
  "87021": "5",
  "87901": "6",
  "87520": "5",
  "74026": "3w",
  "74344": "3w",
  "74884": "3w",
  "74868": "3w",
  "74553": "3w",
  "74363": "2w",
  "74528": "3w",
  "73075": "3w",
  "74854": "3w",
  "73086": "3w",
  "74748": "3w",
  "73432": "3w",
  "73437": "3w",
  "73438": "3w",
  "74058": "2w",
  "74644": "2w",
  "73750": "2w",
  "73729": "2w",
  "73755": "2w",
  "73859": "2w",
  "73667": "2w",
  "73744": "2w",
  "74034": "3w",
  "73010": "3w",
  "74022": "2w",
  "74106": "3w",
  "74460": "3w",
  "74604": "2w",
  "73650": "2w",
  "73559": "3w",
  "73641": "3w",
  "73526": "3w",
  "73628": "2w",
  "74824": "3w",
  "73022": "3w",
  "73001": "3w",
  "73532": "3w",
  "74471": "3w",
  "74960": "3w",
  "73662": "2w",
  "74855": "3w",
  "73074": "3w",
  "74028": "3w",
  "74032": "2w",
  "74062": "3w",
  "73053": "3w",
  "74131": "3w",
  "74962": "3w",
  "74349": "3w",
  "73644": "2w",
  "74865": "3w",
  "74843": "3w",
  "73627": "3w",
  "74145": "3w",
  "74367": "3w",
  "73540": "3w",
  "73572": "3w",
  "74423": "3w",
  "73056": "2w",
  "73453": "3w",
  "74561": "3w",
  "74801": "3w",
  "74804": "3w",
  "74534": "3w",
  "74459": "3w",
  "74554": "3w",
  "74432": "3w",
  "73044": "3w",
  "74555": "3w",
  "74056": "2w",
  "74856": "3w",
  "73562": "3w",
  "74729": "3w",
  "73931": "2w",
  "73834": "2w",
  "74731": "3w",
  "74726": "3w",
  "74723": "3w",
  "73949": "2w",
  "74753": "3w",
  "73944": "2w",
  "73766": "2w",
  "73841": "2w",
  "73860": "2w",
  "73716": "2w",
  "73853": "2w",
  "73724": "2w",
  "74832": "3w",
  "73082": "3w",
  "74447": "3w",
  "74110": "3w",
  "74075": "2w",
  "74469": "3w",
  "74428": "3w",
  "74630": "2w",
  "73626": "2w",
  "74743": "3w",
  "74759": "3w",
  "73550": "3w",
  "73654": "2w",
  "73070": "3w",
  "29605": "4",
  "29180": "4",
  "29626": "4",
  "29107": "4",
  "29450": "4",
  "29405": "4",
  "29642": "4",
  "29067": "4",
  "29805": "4",
  "29809": "4",
  "29621": "4",
  "29018": "4",
  "29223": "4",
  "29014": "4",
  "29624": "4",
  "29104": "4",
  "29654": "4",
  "29212": "4",
  "29154": "4",
  "29945": "4",
  "29229": "4",
  "29458": "4",
  "29685": "4",
  "29583": "4",
  "29125": "4",
  "29412": "4",
  "29635": "3e",
  "29048": "4",
  "29643": "4",
  "29683": "3e",
  "29379": "4",
  "29052": "4",
  "29696": "4",
  "29704": "4",
  "29546": "4",
  "29574": "4",
  "29936": "4",
  "29592": "4",
  "29020": "4",
  "29817": "4",
  "29547": "4",
  "29481": "4",
  "29848": "4",
  "29364": "4",
  "29932": "4",
  "29516": "4",
  "29845": "4",
  "29527": "4",
  "29922": "4",
  "29145": "4",
  "29904": "4",
  "29303": "4",
  "29803": "4",
  "29324": "4",
  "29477": "4",
  "29464": "4",
  "29210": "4",
  "29434": "4",
  "29407": "4",
  "29680": "4",
  "29033": "4",
  "29047": "4",
  "29142": "4",
  "29501": "4",
  "29001": "4",
  "29615": "4",
  "29079": "4",
  "29069": "4",
  "29432": "4",
  "29055": "4",
  "29482": "4",
  "24556": "3e",
  "24122": "3e",
  "23517": "3e",
  "23459": "3e",
  "76623": "3w",
  "76105": "3w",
  "75157": "3w",
  "78215": "6",
  "76036": "3w",
  "75054": "3w",
  "76015": "3w",
  "76016": "3w",
  "76131": "3w",
  "78247": "6",
  "78216": "6",
  "76006": "3w",
  "76082": "3w",
  "78202": "6",
  "76059": "3w",
  "78154": "6",
  "78150": "6",
  "78263": "6",
  "78112": "6",
  "78264": "6",
  "76259": "3w",
  "78245": "6",
  "78229": "6",
  "78052": "6",
  "78039": "6",
  "77009": "4",
  "77360": "3w",
  "78231": "6",
  "75934": "4",
  "77345": "4",
  "77015": "4",
  "77093": "4",
  "78121": "6",
  "78123": "6",
  "77012": "4",
  "77587": "4",
  "77096": "4",
  "77007": "4",
  "77094": "4",
  "77586": "4",
  "77486": "4",
  "77444": "4",
  "77446": "3w",
  "75492": "3w",
  "75559": "3w",
  "76252": "3w",
  "76251": "3w",
  "76821": "6",
  "75801": "3w",
  "79002": "2w",
  "77979": "4",
  "78393": "6",
  "79053": "2w",
  "77660": "4",
  "75148": "3w",
  "78548": "6",
  "79041": "6",
  "75861": "3w",
  "78376": "6",
  "79842": "6",
  "79239": "3w",
  "75650": "3w",
  "79111": "2w",
  "75137": "3w",
  "75253": "3w",
  "75172": "3w",
  "78957": "6",
  "79377": "6",
  "79718": "6",
  "77615": "4",
  "78953": "6",
  "75423": "3w",
  "95935": "6",
  "92592": "6",
  "92587": "6",
  "92548": "6",
  "92653": "6",
  "92241": "6",
  "94558": "7",
  "90031": "6",
  "90065": "6",
  "95497": "7",
  "95448": "7",
  "90049": "6",
  "95222": "6",
  "95228": "6",
  "95303": "7",
  "95567": "7",
  "90814": "6",
  "91405": "6",
  "95388": "7",
  "96122": "5",
  "90601": "6",
  "95004": "7",
  "90022": "6",
  "91607": "6",
  "93618": "6",
  "95956": "5",
  "90019": "6",
  "90044": "6",
  "90059": "6",
  "90061": "6",
  "90280": "6",
  "95645": "7",
  "93242": "6",
  "92110": "6",
  "95531": "7",
  "96063": "7",
  "95689": "6",
  "93265": "6",
  "95493": "7",
  "90023": "6",
  "95926": "7",
  "90723": "6",
  "96133": "5",
  "90291": "6",
  "90212": "6",
  "94112": "7",
  "90222": "6",
  "90025": "6",
  "93292": "6",
  "93602": "6",
  "91105": "6",
  "96105": "5",
  "95357": "7",
  "96094": "7",
  "96074": "7",
  "95389": "6",
  "94607": "7",
  "95552": "7",
  "95232": "6",
  "96046": "7",
  "93103": "7",
  "95233": "6",
  "95422": "7",
  "95443": "7",
  "93549": "6",
  "93235": "6",
  "93306": "6",
  "96078": "7",
  "95457": "7",
  "93003": "6",
  "95461": "7",
  "92108": "6",
  "93908": "7",
  "95817": "7",
  "93013": "7",
  "93455": "7",
  "93436": "7",
  "93722": "6",
  "92105": "6",
  "95916": "6",
  "92335": "6",
  "95941": "6",
  "95215": "7",
  "94024": "7",
  "95132": "7",
  "95134": "7",
  "94303": "7",
  "94301": "7",
  "92614": "6",
  "92782": "6",
  "92703": "6",
  "94015": "7",
  "90715": "6",
  "90240": "6",
  "94062": "7",
  "94404": "7",
  "93552": "6",
  "91390": "6",
  "93543": "6",
  "93553": "6",
  "91351": "6",
  "91321": "6",
  "93246": "6",
  "90073": "6",
  "91436": "6",
  "95674": "6",
  "95953": "7",
  "92518": "6",
  "92845": "6",
  "94903": "7",
  "93408": "7",
  "92648": "6",
  "90743": "6",
  "94925": "7",
  "91344": "6",
  "91324": "6",
  "90638": "6",
  "94939": "7",
  "90011": "6",
  "90006": "6",
  "95950": "7",
  "93514": "5",
  "95987": "7",
  "91770": "6",
  "90004": "6",
  "93204": "7",
  "95666": "6",
  "93212": "6",
  "90712": "6",
  "93105": "7",
  "90744": "6",
  "90810": "6",
  "08348": "2e",
  "08858": "2e",
  "08757": "2e",
  "08104": "2e",
  "08341": "2e",
  "08343": "2e",
  "08246": "2e",
  "07833": "2e",
  "08759": "2e",
  "08741": "2e",
  "56356": "1w",
  "55702": "1w",
  "56325": "1w",
  "55933": "1w",
  "56039": "1w",
  "55726": "1w",
  "55111": "1w",
  "56237": "1w",
  "55742": "1w",
  "55968": "1w",
  "55950": "1w",
  "55905": "1w",
  "55967": "1w",
  "56556": "1w",
  "56155": "1w",
  "55327": "1w",
  "55447": "1w",
  "56371": "1w",
  "56143": "1w",
  "55119": "1w",
  "55126": "1w",
  "55309": "1w",
  "55103": "1w",
  "55398": "1w",
  "55114": "1w",
  "55108": "1w",
  "56544": "1w",
  "56385": "1w",
  "56552": "1w",
  "56229": "1w",
  "56258": "1w",
  "56157": "1w",
  "56051": "1w",
  "56150": "1w",
  "55613": "1w",
  "56477": "1w",
  "56685": "1w",
  "55057": "1w",
  "55047": "1w",
  "55044": "1w",
  "56311": "1w",
  "56093": "1w",
  "55128": "1w",
  "55121": "1w",
  "55123": "1w",
  "55031": "1w",
  "55025": "1w",
  "56565": "1w",
  "56208": "1w",
  "56587": "1w",
  "55060": "1w",
  "56517": "1w",
  "56249": "1w",
  "56472": "1w",
  "56527": "1w",
  "56062": "1w",
  "56515": "1w",
  "21045": "2e",
  "20861": "2e",
  "20721": "2e",
  "20640": "3e",
  "21075": "2e",
  "20667": "3e",
  "21251": "2e",
  "21056": "2e",
  "20606": "3e",
  "21890": "3e",
  "21841": "3e",
  "21675": "3e",
  "20677": "3e",
  "21627": "3e",
  "20645": "3e",
  "21541": "2e",
  "21804": "3e",
  "21713": "2e",
  "98247": "5",
  "99021": "5",
  "99353": "5",
  "99119": "5",
  "99150": "5",
  "98277": "5",
  "99153": "5",
  "99118": "5",
  "98812": "5",
  "99130": "5",
  "98112": "5",
  "98326": "7",
  "98501": "7",
  "98844": "5",
  "98248": "5",
  "98815": "5",
  "98538": "7",
  "98953": "5",
  "98382": "7",
  "98264": "5",
  "98253": "5",
  "98034": "5",
  "98526": "7",
  "21795": "2e",
  "21539": "2e",
  "21915": "2e",
  "21206": "2e",
  "21538": "2e",
  "21750": "2e",
  "21913": "2e",
  "21532": "2e",
  "21756": "2e",
  "21837": "3e",
  "21545": "2e",
  "21228": "2e",
  "21236": "2e",
  "21904": "2e",
  "21914": "2e",
  "21779": "2e",
  "20705": "2e",
  "20706": "2e",
  "21667": "2e",
  "21104": "2e",
  "21093": "2e",
  "21144": "2e",
  "21076": "2e",
  "21146": "2e",
  "20903": "2e",
  "20613": "2e",
  "21710": "2e",
  "21754": "2e",
  "20657": "3e",
  "21668": "2e",
  "21829": "3e",
  "21811": "3e",
  "21285": "2e",
  "20892": "2e",
  "20833": "2e",
  "20895": "2e",
  "20910": "2e",
  "20745": "2e",
  "21791": "2e",
  "21797": "2e",
  "20839": "2e",
  "21409": "2e",
  "20838": "2e",
  "21402": "2e",
  "21824": "3e",
  "21044": "2e",
  "20784": "2e",
  "20616": "2e",
  "20877": "2e",
  "21718": "2e",
  "21077": "2e",
  "21250": "2e",
  "20765": "2e",
  "20615": "3e",
  "21664": "2e",
  "21742": "2e",
  "21561": "2e",
  "21550": "2e",
  "13681": "1e",
  "13633": "1e",
  "13647": "1e",
  "11545": "2e",
  "12197": "2e",
  "13807": "2e",
  "13750": "2e",
  "12930": "1e",
  "13436": "1e",
  "13360": "1e",
  "12937": "1e",
  "14211": "1e",
  "12210": "2e",
  "14150": "1e",
  "12583": "2e",
  "14817": "2e",
  "13736": "2e",
  "11230": "2e",
  "12202": "2e",
  "11218": "2e",
  "10305": "2e",
  "12523": "2e",
  "11798": "2e",
  "10550": "2e",
  "11220": "2e",
  "10707": "2e",
  "11208": "2e",
  "10012": "2e",
  "11354": "2e",
  "10010": "2e",
  "10278": "2e",
  "10543": "2e",
  "14217": "1e",
  "14228": "1e",
  "10601": "2e",
  "14068": "1e",
  "10606": "2e",
  "10706": "2e",
  "11701": "2e",
  "13407": "1e",
  "14614": "1e",
  "14824": "2e",
  "10607": "2e",
  "24895": "3e",
  "26814": "3e",
  "26833": "2e",
  "26807": "3e",
  "25421": "2e",
  "25401": "2e",
  "25413": "2e",
  "20135": "2e",
  "25422": "2e",
  "26802": "3e",
  "26621": "3e",
  "25511": "3e",
  "25837": "3e",
  "25942": "3e",
  "25139": "3e",
  "25168": "3e",
  "25033": "3e",
  "25866": "3e",
  "25040": "3e",
  "25936": "3e",
  "25002": "3e",
  "26572": "2e",
  "25855": "3e",
  "26003": "2e",
  "25302": "3e",
  "25979": "3e",
  "24740": "3e",
  "25880": "3e",
  "25836": "3e",
  "25825": "3e",
  "25702": "3e",
  "26104": "2e",
  "25387": "3e",
  "25871": "3e",
  "24701": "3e",
  "43612": "2e",
  "44264": "2e",
  "43613": "2e",
  "45889": "2e",
  "44677": "2e",
  "43222": "2e",
  "44276": "2e",
  "43220": "2e",
  "43235": "2e",
  "43223": "2e",
  "45835": "2e",
  "45372": "2e",
  "45341": "2e",
  "43531": "2e",
  "43505": "2e",
  "43050": "2e",
  "43528": "2e",
  "43084": "2e",
  "44011": "2e",
  "44656": "2e",
  "43985": "2e",
  "43125": "2e",
  "43460": "2e",
  "45248": "2e",
  "43465": "2e",
  "48098": "2e",
  "48015": "2e",
  "48323": "2e",
  "48336": "2e",
  "48335": "2e",
  "48009": "2e",
  "48081": "2e",
  "48628": "1e",
  "48883": "1e",
  "48051": "2e",
  "48044": "2e",
  "48317": "2e",
  "49638": "1e",
  "48444": "1e",
  "48192": "2e",
  "48190": "2e",
  "48710": "1e",
  "48189": "2e",
  "49684": "1e",
  "48371": "1e",
  "48168": "2e",
  "48014": "1e",
  "48134": "2e",
  "48154": "2e",
  "48215": "2e",
  "48226": "2e",
  "48173": "2e",
  "48138": "2e",
  "48028": "2e",
  "49267": "2e",
  "49870": "1e",
  "49759": "1e",
  "48144": "2e",
  "49309": "1e",
  "48143": "2e",
  "49938": "1e",
  "48720": "1e",
  "49881": "1e",
  "18413": "2e",
  "17885": "2e",
  "17343": "2e",
  "19075": "2e",
  "15467": "2e",
  "15428": "2e",
  "18641": "2e",
  "18602": "2e",
  "15431": "2e",
  "15470": "2e",
  "18322": "2e",
  "15489": "2e",
  "19054": "2e",
  "19020": "2e",
  "17822": "2e",
  "19369": "2e",
  "17080": "2e",
  "17344": "2e",
  "15465": "2e",
  "19425": "2e",
  "16054": "2e",
  "18327": "2e",
  "18842": "2e",
  "18820": "2e",
  "17750": "2e",
  "18239": "2e",
  "15464": "2e",
  "60946": "2e",
  "60952": "2e",
  "61356": "2e",
  "61348": "2e",
  "61374": "2e",
  "61325": "2e",
  "61373": "2e",
  "61337": "2e",
  "60933": "2e",
  "62919": "3e",
  "62610": "2e",
  "62663": "2e",
  "62081": "2e",
  "11705": "2e",
  "11363": "2e",
  "11782": "2e",
  "12832": "1e",
  "11740": "2e",
  "11931": "2e",
  "11944": "2e",
  "12068": "1e",
  "12918": "1e",
  "12919": "1e",
  "12972": "1e",
  "12911": "1e",
  "11692": "2e",
  "11359": "2e",
  "11739": "2e",
  "12887": "1e",
  "11755": "2e",
  "11766": "2e",
  "11786": "2e",
  "11941": "2e",
  "43001": "2e",
  "43986": "2e",
  "44142": "2e",
  "43771": "2e",
  "44601": "2e",
  "44657": "2e",
  "44310": "2e",
  "44307": "2e",
  "45380": "2e",
  "45345": "2e",
  "44123": "2e",
  "45406": "2e",
  "43068": "2e",
  "43033": "2e",
  "44705": "2e",
  "44702": "2e",
  "44090": "2e",
  "45377": "2e",
  "44053": "2e",
  "43160": "2e",
  "45255": "2e",
  "45895": "2e",
  "45040": "2e",
  "45039": "2e",
  "45249": "2e",
  "44273": "2e",
  "44212": "2e",
  "45308": "2e",
  "44490": "2e",
  "43767": "2e",
  "44401": "2e",
  "45120": "2e",
  "43452": "2e",
  "43064": "2e",
  "44081": "2e",
  "43440": "2e",
  "45449": "2e",
  "45616": "2e",
  "44050": "2e",
  "44115": "2e",
  "43430": "2e",
  "43412": "2e",
  "45388": "2e",
  "43533": "2e",
  "44233": "2e",
  "43433": "2e",
  "45064": "2e",
  "11751": "2e",
  "10977": "2e",
  "10970": "2e",
  "11010": "2e",
  "13470": "1e",
  "11570": "2e",
  "14580": "1e",
  "10153": "2e",
  "10963": "2e",
  "11552": "2e",
  "10915": "2e",
  "10924": "2e",
  "10901": "2e",
  "11050": "2e",
  "13472": "1e",
  "13209": "1e",
  "13862": "2e",
  "11577": "2e",
  "11550": "2e",
  "12566": "2e",
  "11501": "2e",
  "10918": "2e",
  "13730": "2e",
  "14472": "1e",
  "11364": "2e",
  "12520": "2e",
  "10020": "2e",
  "12183": "2e",
  "14052": "1e",
  "10917": "2e",
  "14086": "1e",
  "12041": "2e",
  "12067": "2e",
  "14515": "1e",
  "12087": "2e",
  "12193": "2e",
  "10914": "2e",
  "12085": "2e",
  "10598": "2e",
  "12147": "2e",
  "10501": "2e",
  "10925": "2e",
  "14514": "1e",
  "10535": "2e",
  "12540": "2e",
  "11514": "2e",
  "13077": "2e",
  "14035": "2e",
  "60476": "2e",
  "60191": "2e",
  "60143": "2e",
  "60110": "2e",
  "60118": "2e",
  "60516": "2e",
  "60512": "2e",
  "62014": "2e",
  "60404": "2e",
  "60433": "2e",
  "60448": "2e",
  "62411": "2e",
  "62906": "3e",
  "62458": "2e",
  "62467": "2e",
  "62479": "2e",
  "60911": "2e",
  "60951": "2e",
  "60928": "2e",
  "60541": "2e",
  "62803": "2e",
  "62912": "3e",
  "62848": "2e",
  "62271": "2e",
  "62461": "2e",
  "60966": "2e",
  "62838": "2e",
  "60973": "2e",
  "60953": "2e",
  "62286": "2e",
  "62242": "2e",
  "62086": "2e",
  "61449": "2e",
  "62047": "2w",
  "62006": "2w",
  "62013": "2w",
  "61856": "2e",
  "61953": "2e",
  "62695": "2e",
  "61930": "2e",
  "61929": "2e",
  "62820": "2e",
  "62667": "2e",
  "62323": "2e",
  "61560": "2e",
  "62852": "2e",
  "62546": "2e",
  "62560": "2e",
  "61368": "2e",
  "61371": "2e",
  "61322": "2e",
  "62963": "3w",
  "62344": "2e",
  "62639": "2e",
  "61471": "2e",
  "62050": "2e",
  "62954": "3e",
  "62098": "2e",
  "61931": "2e",
  "61037": "2e",
  "60111": "2e",
  "60437": "2e",
  "61319": "2e",
  "60460": "2e",
  "61043": "2e",
  "61333": "2e",
  "61301": "2e",
  "60920": "2e",
  "48469": "1e",
  "49327": "1e",
  "49818": "1e",
  "48728": "1e",
  "48621": "1e",
  "49764": "1e",
  "49717": "1e",
  "49322": "1e",
  "48910": "2e",
  "48071": "2e",
  "48825": "2e",
  "49259": "2e",
  "49098": "2e",
  "48822": "1e",
  "48895": "2e",
  "49058": "2e",
  "49013": "2e",
  "49063": "2e",
  "49345": "1e",
  "49344": "2e",
  "49420": "1e",
  "48603": "1e",
  "49088": "2e",
  "48842": "2e",
  "48458": "1e",
  "49043": "2e",
  "49060": "2e",
  "48881": "1e",
  "48875": "1e",
  "49908": "1e",
  "49879": "1e",
  "48860": "1e",
  "49096": "2e",
  "49107": "2e",
  "49426": "2e",
  "49242": "2e",
  "49915": "1e",
  "49047": "2e",
  "49934": "1e",
  "49814": "1e",
  "49051": "2e",
  "49220": "2e",
  "49064": "2e",
  "49401": "1e",
  "49512": "1e",
  "49861": "1e",
  "49232": "2e",
  "49033": "2e",
  "49808": "1e",
  "49106": "2e",
  "49613": "1e",
  "49065": "2e",
  "48722": "1e",
  "48519": "1e",
  "49116": "2e",
  "48616": "1e",
  "02113": "2e",
  "01376": "2e",
  "01093": "2e",
  "02129": "2e",
  "01301": "2e",
  "01072": "2e",
  "01331": "2e",
  "02136": "2e",
  "01344": "2e",
  "02109": "2e",
  "02108": "2e",
  "02210": "2e",
  "02203": "2e",
  "02151": "2e",
  "01940": "2e",
  "01945": "2e",
  "02539": "2e",
  "01520": "2e",
  "01543": "2e",
  "01503": "2e",
  "02743": "2e",
  "01430": "2e",
  "01074": "2e",
  "01506": "2e",
  "01468": "2e",
  "01452": "2e",
  "01451": "2e",
  "01129": "2e",
  "01092": "2e",
  "01438": "2e",
  "01057": "2e",
  "01223": "2e",
  "01080": "2e",
  "01267": "2e",
  "01244": "2e",
  "01256": "2e",
  "01756": "2e",
  "01060": "2e",
  "20617": "3e",
  "21619": "2e",
  "21029": "2e",
  "21657": "2e",
  "20880": "2e",
  "20628": "3e",
  "20872": "2e",
  "21071": "2e",
  "21543": "2e",
  "21781": "2e",
  "21930": "2e",
  "21156": "2e",
  "21036": "2e",
  "21679": "2e",
  "21867": "3e",
  "21601": "2e",
  "20693": "3e",
  "21801": "3e",
  "21826": "3e",
  "21521": "2e",
  "21213": "2e",
  "21085": "2e",
  "21201": "2e",
  "21225": "2e",
  "21917": "2e",
  "21210": "2e",
  "21840": "3e",
  "21136": "2e",
  "21047": "2e",
  "21212": "2e",
  "21871": "3e",
  "20621": "3e",
  "20650": "3e",
  "20636": "3e",
  "20783": "2e",
  "20794": "2e",
  "20815": "2e",
  "21793": "2e",
  "20608": "2e",
  "21701": "2e",
  "20685": "3e",
  "21869": "3e",
  "21813": "3e",
  "21060": "2e",
  "20896": "2e",
  "21287": "2e",
  "20771": "2e",
  "20889": "2e",
  "21017": "2e",
  "21702": "2e",
  "20723": "2e",
  "20701": "2e",
  "21784": "2e",
  "21773": "2e",
  "20874": "2e",
  "20837": "2e",
  "21403": "2e",
  "20832": "2e",
  "20637": "3e",
  "21607": "2e",
  "21853": "3e",
  "20732": "2e",
  "20712": "2e",
  "21666": "2e",
  "20818": "2e",
  "20777": "2e",
  "20686": "3e",
  "20626": "3e",
  "21155": "2e",
  "21160": "2e",
  "20899": "2e",
  "20894": "2e",
  "21714": "2e",
  "21705": "2e",
  "21835": "3e",
  "21631": "3e",
  "21864": "3e",
  "21636": "2e",
  "21639": "2e",
  "21655": "2e",
  "20662": "3e",
  "21665": "2e",
  "25612": "3e",
  "24884": "3e",
  "24946": "3e",
  "26836": "2e",
  "26801": "2e",
  "26266": "3e",
  "26273": "3e",
  "25405": "2e",
  "26296": "3e",
  "25512": "3e",
  "26040": "2e",
  "25868": "3e",
  "25070": "3e",
  "25115": "3e",
  "26563": "2e",
  "25951": "3e",
  "25978": "3e",
  "24739": "3e",
  "25311": "3e",
  "24935": "3e",
  "24981": "3e",
  "25971": "3e",
  "25921": "3e",
  "24715": "3e",
  "25755": "3e",
  "25864": "3e",
  "24823": "3e",
  "25112": "3e",
  "26187": "2e",
  "26763": "2e",
  "26508": "2e",
  "25537": "2e",
  "26767": "2e",
  "25848": "3e",
  "26501": "2e",
  "25086": "3e",
  "26543": "2e",
  "25214": "3e",
  "25309": "3e",
  "26142": "2e",
  "25136": "3e",
  "26283": "2e",
  "26419": "2e",
  "26667": "3e",
  "24977": "3e",
  "25649": "3e",
  "24954": "3e",
  "24944": "3e",
  "24813": "3e",
  "26230": "3e",
  "26347": "2e",
  "26440": "2e",
  "26378": "2e",
  "26415": "2e",
  "25286": "3e",
  "25251": "3e",
  "25164": "3e",
  "25434": "2e",
  "26761": "2e",
  "26547": "2e",
  "26525": "2e",
  "26137": "2e",
  "26236": "3e",
  "25270": "2e",
  "26384": "2e",
  "25414": "2e",
  "26404": "2e",
  "24966": "3e",
  "26205": "3e",
  "26030": "2e",
  "25123": "2e",
  "25644": "3e",
  "25692": "3e",
  "25608": "3e",
  "25165": "3e",
  "25154": "3e",
  "25502": "2e",
  "25076": "3e",
  "24871": "3e",
  "24848": "3e",
  "24862": "3e",
  "24850": "3e",
  "25573": "3e",
  "25639": "3e",
  "24924": "3e",
  "25247": "2e",
  "25628": "3e",
  "93560": "6",
  "93611": "6",
  "93505": "6",
  "93241": "6",
  "93203": "6",
  "93528": "6",
  "93536": "6",
  "95834": "7",
  "93668": "7",
  "92092": "6",
  "93558": "6",
  "95670": "7",
  "92394": "6",
  "92368": "6",
  "95742": "6",
  "95683": "6",
  "92345": "6",
  "92308": "6",
  "95690": "7",
  "95757": "7",
  "95910": "6",
  "95922": "6",
  "95417": "7",
  "92233": "6",
  "96001": "7",
  "95939": "7",
  "94109": "7",
  "95039": "7",
  "93465": "7",
  "95012": "7",
  "93432": "7",
  "92256": "6",
  "95616": "7",
  "95943": "7",
  "95547": "7",
  "92314": "6",
  "96140": "5",
  "94105": "7",
  "92365": "6",
  "92285": "6",
  "92268": "6",
  "95620": "7",
  "92304": "6",
  "93926": "7",
  "96019": "7",
  "93960": "7",
  "92363": "6",
  "93405": "7",
  "95951": "7",
  "95920": "7",
  "93924": "7",
  "93927": "7",
  "95415": "7",
  "93410": "7",
  "95571": "7",
  "92347": "6",
  "95637": "7",
  "96087": "7",
  "96051": "7",
  "94102": "7",
  "91915": "6",
  "96084": "7",
  "92225": "6",
  "91941": "6",
  "92019": "6",
  "92021": "6",
  "92083": "6",
  "92128": "6",
  "95747": "6",
  "91948": "6",
  "92003": "6",
  "92055": "6",
  "92507": "6",
  "92673": "6",
  "94132": "7",
  "94127": "7",
  "92506": "6",
  "96155": "5",
  "92570": "6",
  "92503": "6",
  "91752": "6",
  "92532": "6",
  "92596": "6",
  "94121": "7",
  "92586": "6",
  "95903": "6",
  "95919": "6",
  "92557": "6",
  "92595": "6",
  "92583": "6",
  "90042": "6",
  "95444": "7",
  "95446": "7",
  "95462": "7",
  "95492": "7",
  "90272": "6",
  "95688": "7",
  "95476": "7",
  "83255": "5",
  "50145": "2w",
  "50242": "2w",
  "52255": "2w",
  "50467": "1w",
  "52759": "2e",
  "50241": "2w",
  "52036": "2w",
  "50470": "2w",
  "56027": "1w",
  "50521": "2w",
  "52774": "2w",
  "52771": "2w",
  "51637": "2w",
  "52247": "2w",
  "50849": "2w",
  "51342": "1w",
  "50638": "2w",
  "52031": "2w",
  "50106": "2w",
  "52577": "2w",
  "51246": "1w",
  "50142": "2w",
  "50517": "1w",
  "51527": "2w",
  "51040": "2w",
  "51433": "2w",
  "50801": "2w",
  "52224": "2w",
  "51242": "1w",
  "50585": "1w",
  "51532": "2w",
  "52731": "2w",
  "52151": "1w",
  "50466": "1w",
  "50174": "2w",
  "52248": "2w",
  "52154": "1w",
  "51060": "2w",
  "50210": "2w",
  "50006": "2w",
  "51638": "2w",
  "52641": "2w",
  "51652": "2w",
  "51027": "1w",
  "52351": "2w",
  "51653": "2w",
  "52537": "2w",
  "50560": "1w",
  "51647": "2w",
  "52228": "2w",
  "50036": "2w",
  "52317": "2w",
  "52305": "2w",
  "50323": "2w",
  "52310": "2w",
  "52157": "1w",
  "51551": "2w",
  "50636": "1w",
  "50645": "1w",
  "50682": "2w",
  "52565": "2w",
  "51237": "1w",
  "50619": "2w",
  "50153": "2w",
  "51007": "2w",
  "76311": "3w",
  "75240": "3w",
  "76504": "6",
  "75219": "3w",
  "78379": "4",
  "78681": "6",
  "75061": "3w",
  "79016": "2w",
  "75065": "3w",
  "75411": "3w",
  "78066": "6",
  "77864": "3w",
  "75901": "3w",
  "78703": "6",
  "78404": "4",
  "75860": "3w",
  "79905": "6",
  "78883": "6",
  "76707": "3w",
  "75468": "3w",
  "75605": "3w",
  "78751": "6",
  "77983": "4",
  "77840": "3w",
  "77995": "6",
  "76245": "3w",
  "76264": "3w",
  "75220": "3w",
  "75706": "3w",
  "77988": "6",
  "78677": "6",
  "78147": "6",
  "75903": "3w",
  "76708": "3w",
  "76687": "3w",
  "78417": "4",
  "76266": "3w",
  "75711": "3w",
  "76271": "3w",
  "79404": "6",
  "79902": "6",
  "76909": "6",
  "75773": "3w",
  "78371": "6",
  "76958": "6",
  "77951": "6",
  "75750": "3w",
  "75705": "3w",
  "78617": "6",
  "78640": "6",
  "79916": "6",
  "76528": "6",
  "76624": "3w",
  "79935": "6",
  "75693": "3w",
  "79836": "6",
  "79849": "6",
  "78359": "4",
  "78390": "6",
  "75561": "3w",
  "77613": "4",
  "75569": "3w",
  "79121": "2w",
  "76491": "3w",
  "78237": "6",
  "78251": "6",
  "78069": "6",
  "78932": "6",
  "77872": "3w",
  "78249": "6",
  "77331": "4",
  "77371": "4",
  "78226": "6",
  "77326": "4",
  "77338": "4",
  "77039": "4",
  "76244": "3w",
  "76052": "3w",
  "78217": "6",
  "78109": "6",
  "76086": "3w",
  "76087": "3w",
  "76426": "3w",
  "78214": "6",
  "76225": "3w",
  "77880": "3w",
  "77028": "4",
  "77037": "4",
  "78133": "6",
  "77004": "4",
  "77053": "4",
  "77035": "4",
  "77024": "4",
  "77079": "4",
  "77507": "4",
  "77080": "4",
  "77048": "4",
  "77065": "4",
  "77067": "4",
  "77018": "4",
  "79766": "6",
  "78954": "6",
  "73852": "2w",
  "73737": "2w",
  "73749": "2w",
  "73746": "2w",
  "73731": "2w",
  "73659": "2w",
  "73638": "2w",
  "74530": "3w",
  "74360": "2w",
  "74035": "2w",
  "73843": "2w",
  "73932": "2w",
  "73855": "2w",
  "73851": "2w",
  "74741": "3w",
  "74054": "3w",
  "74438": "3w",
  "73449": "3w",
  "74733": "3w",
  "74720": "3w",
  "73950": "2w",
  "73951": "2w",
  "73901": "2w",
  "73734": "2w",
  "73838": "2w",
  "74108": "3w",
  "74019": "3w",
  "74857": "3w",
  "74048": "2w",
  "74965": "3w",
  "73620": "2w",
  "73647": "2w",
  "74869": "3w",
  "73571": "3w",
  "73655": "3w",
  "74737": "3w",
  "73031": "3w",
  "73436": "3w",
  "73770": "2w",
  "73544": "3w",
  "74881": "3w",
  "73045": "3w",
  "74754": "3w",
  "73456": "3w",
  "74558": "3w",
  "74825": "3w",
  "73054": "3w",
  "73107": "3w",
  "73084": "3w",
  "73042": "3w",
  "74331": "3w",
  "74831": "3w",
  "74883": "3w",
  "74860": "3w",
  "74531": "3w",
  "74330": "3w",
  "74957": "3w",
  "74736": "3w",
  "73122": "3w",
  "74337": "3w",
  "73165": "3w",
  "73093": "3w",
  "74008": "3w",
  "73430": "3w",
  "73073": "2w",
  "74467": "3w",
  "73179": "3w",
  "74052": "3w",
  "74547": "3w",
  "74872": "3w",
  "74722": "3w",
  "73547": "3w",
  "74756": "3w",
  "60957": "2e",
  "62942": "3e",
  "60621": "2e",
  "61814": "2e",
  "61065": "2e",
  "61849": "2e",
  "60958": "2e",
  "61871": "2e",
  "61440": "2e",
  "60631": "2e",
  "60646": "2e",
  "62367": "2e",
  "60104": "2e",
  "60652": "2e",
  "62938": "3e",
  "61314": "2e",
  "62817": "3e",
  "62982": "3e",
  "62972": "3e",
  "62481": "2e",
  "62016": "2e",
  "62092": "2e",
  "61467": "2e",
  "61104": "2e",
  "61820": "2e",
  "61081": "2e",
  "61367": "2e",
  "61330": "2e",
  "60961": "2e",
  "62704": "2e",
  "61430": "2e",
  "61554": "2e",
  "62522": "2e",
  "62220": "2e",
  "62201": "2e",
  "61102": "2e",
  "62539": "2e",
  "62513": "2e",
  "61604": "2e",
  "61937": "2e",
  "62550": "2e",
  "62625": "2e",
  "62558": "2e",
  "62530": "2e",
  "62537": "2e",
  "61562": "2e",
  "62515": "2e",
  "62966": "3e",
  "61738": "2e",
  "61539": "2e",
  "61731": "2e",
  "61722": "2e",
  "62675": "2e",
  "62994": "3e",
  "62325": "2e",
  "61866": "2e",
  "62376": "2w",
  "62916": "3e",
  "62030": "2e",
  "60651": "2e",
  "60659": "2e",
  "61847": "2e",
  "62688": "2e",
  "61878": "2e",
  "60915": "2e",
  "61956": "2e",
  "61864": "2e",
  "61872": "2e",
  "61852": "2e",
  "61876": "2e",
  "61850": "2e",
  "61817": "2e",
  "61114": "2e",
  "61201": "2e",
  "62884": "2e",
  "61755": "2e",
  "61932": "2e",
  "62948": "3e",
  "61721": "2e",
  "62226": "2e",
  "60656": "2e",
  "61242": "2w",
  "61257": "2e",
  "62234": "2e",
  "62062": "2e",
  "60616": "2e",
  "60653": "2e",
  "61087": "2e",
  "61548": "2e",
  "60615": "2e",
  "61240": "2e",
  "61545": "2e",
  "61235": "2e",
  "61234": "2e",
  "61237": "2e",
  "61344": "2e",
  "60707": "2e",
  "62263": "2e",
  "61281": "2e",
  "61466": "2e",
  "62999": "3e",
  "62814": "2e",
  "62877": "2e",
  "47975": "2e",
  "46111": "2e",
  "46915": "2e",
  "47918": "2e",
  "47441": "2e",
  "47926": "2e",
  "47980": "2e",
  "47670": "2e",
  "46764": "2e",
  "46373": "2e",
  "46814": "2e",
  "46348": "2e",
  "46383": "2e",
  "47849": "2e",
  "47135": "3e",
  "40801": "3e",
  "40178": "3e",
  "40037": "3e",
  "41351": "3e",
  "42252": "3e",
  "40221": "3e",
  "40061": "3e",
  "42326": "3e",
  "41721": "3e",
  "40140": "3e",
  "40020": "3e",
  "41667": "3e",
  "41135": "3e",
  "41559": "3e",
  "41862": "3e",
  "42124": "3e",
  "42322": "3e",
  "42122": "3e",
  "42086": "3e",
  "42071": "3e",
  "40208": "3e",
  "40245": "3e",
  "40007": "3e",
  "40013": "3e",
  "40014": "3e",
  "41076": "2e",
  "40385": "3e",
  "41129": "3e",
  "40041": "3e",
  "42020": "3e",
  "42788": "3e",
  "40202": "3e",
  "40419": "3e",
  "41010": "3e",
  "40353": "3e",
  "41764": "3e",
  "40514": "3e",
  "40055": "3e",
  "42462": "3e",
  "42355": "3e",
  "42069": "3e",
  "41301": "3e",
  "47162": "2e",
  "47611": "3e",
  "46967": "2e",
  "47842": "2e",
  "46324": "2e",
  "47862": "2e",
  "47635": "3e",
  "46039": "2e",
  "47714": "3e",
  "47303": "2e",
  "46016": "2e",
  "47804": "2e",
  "46805": "2e",
  "47901": "2e",
  "46528": "2e",
  "26456": "2e",
  "25252": "2e",
  "25005": "3e",
  "25271": "2e",
  "25262": "2e",
  "26711": "2e",
  "25444": "2e",
  "26537": "2e",
  "26519": "2e",
  "26425": "2e",
  "26253": "2e",
  "26424": "2e",
  "26178": "2e",
  "26148": "2e",
  "26289": "2e",
  "26376": "3e",
  "25425": "2e",
  "25438": "2e",
  "25432": "2e",
  "26301": "2e",
  "26361": "2e",
  "26369": "2e",
  "24983": "3e",
  "26070": "2e",
  "25972": "3e",
  "26160": "2e",
  "24925": "3e",
  "26662": "3e",
  "26062": "2e",
  "26437": "2e",
  "26585": "2e",
  "26574": "2e",
  "26050": "2e",
  "25508": "3e",
  "26264": "3e",
  "24811": "3e",
  "25647": "3e",
  "25611": "3e",
  "24881": "3e",
  "25187": "2e",
  "25106": "2e",
  "25206": "3e",
  "25019": "3e",
  "25114": "3e",
  "25108": "3e",
  "25149": "3e",
  "25607": "3e",
  "25617": "3e",
  "25654": "3e",
  "26684": "3e",
  "25630": "3e",
  "24815": "3e",
  "25031": "3e",
  "25312": "3e",
  "25915": "3e",
  "25902": "3e",
  "25853": "3e",
  "24963": "3e",
  "25911": "3e",
  "25704": "3e",
  "24724": "3e",
  "24962": "3e",
  "25865": "3e",
  "25180": "3e",
  "25305": "3e",
  "25062": "3e",
  "25849": "3e",
  "25173": "3e",
  "25907": "3e",
  "25541": "3e",
  "26184": "2e",
  "24827": "3e",
  "25875": "3e",
  "44452": "2e",
  "44451": "2e",
  "43145": "2e",
  "45112": "2e",
  "43344": "2e",
  "45144": "3e",
  "45430": "2e",
  "44035": "2e",
  "45680": "3e",
  "43416": "2e",
  "44039": "2e",
  "44839": "2e",
  "43162": "2e",
  "44506": "2e",
  "45070": "2e",
  "45030": "2e",
  "45241": "2e",
  "45429": "2e",
  "43155": "2e",
  "43358": "2e",
  "43067": "2e",
  "45650": "2e",
  "45871": "2e",
  "45050": "2e",
  "44688": "2e",
  "44408": "2e",
  "45710": "2e",
  "45661": "2e",
  "45647": "2e",
  "43135": "2e",
  "45698": "2e",
  "43519": "2e",
  "45613": "2e",
  "44413": "2e",
  "45644": "2e",
  "45671": "2e",
  "43530": "2e",
  "44411": "2e",
  "44288": "2e",
  "44216": "2e",
  "44444": "2e",
  "43721": "2e",
  "44144": "2e",
  "44143": "2e",
  "44137": "2e",
  "45417": "2e",
  "44632": "2e",
  "44707": "2e",
  "44241": "2e",
  "44243": "2e",
  "44662": "2e",
  "44418": "2e",
  "44450": "2e",
  "44890": "2e",
  "44402": "2e",
  "45103": "2e",
  "44870": "2e",
  "44470": "2e",
  "44811": "2e",
  "45135": "2e",
  "45619": "3e",
  "45688": "2e",
  "43734": "2e",
  "44092": "2e",
  "44044": "2e",
  "44127": "2e",
  "43061": "2e",
  "45339": "2e",
  "44509": "2e",
  "45459": "2e",
  "45458": "2e",
  "45697": "2e",
  "45002": "2e",
  "44214": "2e",
  "45217": "2e",
  "45322": "2e",
  "43113": "2e",
  "43445": "2e",
  "45378": "2e",
  "45034": "2e",
  "71230": "4",
  "71060": "3w",
  "71275": "3w",
  "71423": "4",
  "71075": "3w",
  "71071": "3w",
  "70462": "4",
  "70451": "4",
  "70759": "4",
  "70075": "4",
  "71327": "4",
  "71331": "4",
  "70450": "4",
  "70515": "4",
  "70836": "4",
  "71016": "4",
  "71232": "4",
  "71479": "4",
  "70631": "4",
  "70652": "4",
  "70634": "4",
  "71101": "3w",
  "70374": "4",
  "70380": "4",
  "70094": "4",
  "70544": "4",
  "71355": "4",
  "70053": "4",
  "70501": "4",
  "71067": "3w",
  "71340": "4",
  "71263": "4",
  "71326": "4",
  "71457": "4",
  "70640": "4",
  "70360": "4",
  "71426": "4",
  "71416": "4",
  "70507": "4",
  "70131": "4",
  "70438": "4",
  "70644": "4",
  "70390": "4",
  "70372": "4",
  "71261": "4",
  "71256": "3w",
  "71295": "4",
  "71038": "3w",
  "71222": "3w",
  "70039": "4",
  "70463": "4",
  "71004": "3w",
  "70510": "4",
  "70548": "4",
  "71461": "4",
  "71459": "4",
  "71260": "3w",
  "54139": "1e",
  "54141": "1e",
  "53563": "2e",
  "53110": "2e",
  "54534": "1e",
  "54875": "1e",
  "54511": "1e",
  "53588": "1e",
  "53153": "1e",
  "53205": "1e",
  "54201": "1e",
  "53017": "1e",
  "53081": "1e",
  "53073": "1e",
  "54437": "1e",
  "53936": "1e",
  "54568": "1e",
  "54436": "1e",
  "53565": "2e",
  "54754": "1e",
  "54848": "1e",
  "54615": "1e",
  "54473": "1e",
  "54656": "1e",
  "53922": "1e",
  "54125": "1e",
  "54011": "1e",
  "53916": "1e",
  "54611": "1e",
  "54643": "1e",
  "54610": "1e",
  "53821": "1e",
  "54725": "1e",
  "53586": "2e",
  "53901": "1e",
  "53818": "2e",
  "53937": "1e",
  "54538": "1e",
  "54513": "1e",
  "53503": "1e",
  "54152": "1e",
  "53526": "1e",
  "54613": "1e",
  "54554": "1e",
  "54943": "1e",
  "54850": "1e",
  "54422": "1e",
  "54761": "1e",
  "54733": "1e",
  "53726": "1e",
  "53943": "1e",
  "53577": "1e",
  "54471": "1e",
  "53128": "2e",
  "54484": "1e",
  "53104": "2e",
  "53167": "2e",
  "53216": "1e",
  "53114": "2e",
  "54822": "1e",
  "53015": "1e",
  "54636": "1e",
  "54245": "1e",
  "53023": "1e",
  "54140": "1e",
  "54923": "1e",
  "54968": "1e",
  "54212": "1e",
  "54773": "1e",
  "54211": "1e",
  "53189": "1e",
  "54016": "1e",
  "54017": "1e",
  "54025": "1e",
  "53213": "1e",
  "54106": "1e",
  "53226": "1e",
  "53963": "1e",
  "54612": "1e",
  "54627": "1e",
  "54820": "1e",
  "53555": "1e",
  "53946": "1e",
  "54416": "1e",
  "53154": "2e",
  "53079": "1e",
  "54499": "1e",
  "54736": "1e",
  "54550": "1e",
  "54559": "1e",
  "53183": "1e",
  "53018": "1e",
  "54246": "1e",
  "54734": "1e",
  "54942": "1e",
  "53006": "1e",
  "53931": "1e",
  "53210": "1e",
  "54414": "1e",
  "53583": "1e",
  "81129": "5",
  "80624": "5",
  "80543": "5",
  "80909": "5",
  "81022": "5",
  "80131": "5",
  "81125": "5",
  "80815": "2w",
  "80740": "5",
  "81122": "5",
  "81431": "5",
  "81427": "5",
  "81419": "5",
  "80726": "2w",
  "81410": "5",
  "80749": "2w",
  "81123": "5",
  "81151": "5",
  "81126": "5",
  "81138": "5",
  "80239": "5",
  "80241": "5",
  "80022": "5",
  "80019": "5",
  "80820": "5",
  "81505": "5",
  "81641": "5",
  "80524": "5",
  "80902": "5",
  "80220": "5",
  "80420": "5",
  "81506": "5",
  "80512": "5",
  "80864": "5",
  "80128": "5",
  "80515": "5",
  "80249": "5",
  "80111": "5",
  "81227": "5",
  "80112": "5",
  "80750": "5",
  "81630": "5",
  "81523": "5",
  "80734": "2w",
  "81054": "2w",
  "80454": "5",
  "80007": "5",
  "80126": "5",
  "80130": "5",
  "81071": "2w",
  "80757": "5",
  "80812": "2w",
  "80818": "5",
  "81241": "5",
  "81063": "5",
  "81416": "5",
  "81055": "5",
  "81401": "5",
  "81331": "5",
  "81327": "5",
  "81223": "5",
  "81233": "5",
  "81033": "5",
  "81155": "5",
  "81120": "5",
  "80650": "5",
  "80206": "5",
  "80905": "5",
  "16242": "2e",
  "16933": "2e",
  "16917": "2e",
  "18464": "2e",
  "16210": "2e",
  "18845": "2e",
  "16943": "2e",
  "15846": "2e",
  "17223": "2e",
  "17233": "2e",
  "18439": "2e",
  "17371": "2e",
  "17363": "2e",
  "17309": "2e",
  "17113": "2e",
  "17034": "2e",
  "19055": "2e",
  "17094": "2e",
  "17842": "2e",
  "18054": "2e",
  "18972": "2e",
  "18411": "2e",
  "15627": "2e",
  "15944": "2e",
  "16045": "2e",
  "16049": "2e",
  "18405": "2e",
  "16915": "2e",
  "16746": "2e",
  "15860": "2e",
  "15635": "2e",
  "16022": "2e",
  "16695": "2e",
  "18461": "2e",
  "15857": "2e",
  "15711": "2e",
  "16622": "2e",
  "16674": "2e",
  "16685": "2e",
  "15776": "2e",
  "15331": "2e",
  "15022": "2e",
  "15324": "2e",
  "15350": "2e",
  "15377": "2e",
  "15429": "2e",
  "15038": "2e",
  "15078": "2e",
  "15663": "2e",
  "15412": "2e",
  "18103": "2e",
  "18240": "2e",
  "18101": "2e",
  "18202": "2e",
  "18241": "2e",
  "16550": "2e",
  "17938": "2e",
  "17901": "2e",
  "17963": "2e",
  "17959": "2e",
  "19143": "2e",
  "17545": "2e",
  "19151": "2e",
  "18053": "2e",
  "18951": "2e",
  "15909": "2e",
  "18017": "2e",
  "17025": "2e",
  "18046": "2e",
  "16410": "2e",
  "17723": "2e",
  "17745": "2e",
  "17769": "2e",
  "17402": "2e",
  "16172": "2e",
  "17763": "2e",
  "16475": "2e",
  "17050": "2e",
  "19567": "2e",
  "16132": "2e",
  "16835": "2e",
  "19550": "2e",
  "19608": "2e",
  "16882": "2e",
  "16112": "2e",
  "16803": "2e",
  "16428": "2e",
  "17236": "2e",
  "51562": "2w",
  "52540": "2w",
  "50627": "2w",
  "52156": "1w",
  "52325": "2w",
  "52324": "2w",
  "50231": "2w",
  "52315": "2w",
  "51024": "2w",
  "52621": "2w",
  "50545": "2w",
  "51045": "2w",
  "51008": "2w",
  "51022": "1w",
  "51109": "2w",
  "50857": "2w",
  "50208": "2w",
  "52753": "2e",
  "52002": "2w",
  "56334": "1w",
  "56264": "1w",
  "56073": "1w",
  "56360": "1w",
  "56358": "1w",
  "56681": "1w",
  "56054": "1w",
  "56657": "1w",
  "56161": "1w",
  "56531": "1w",
  "55733": "1w",
  "55033": "1w",
  "56096": "1w",
  "56069": "1w",
  "56581": "1w",
  "56567": "1w",
  "56584": "1w",
  "56763": "1w",
  "56751": "1w",
  "56714": "1w",
  "55935": "1w",
  "56260": "1w",
  "55336": "1w",
  "55922": "1w",
  "55944": "1w",
  "56083": "1w",
  "56297": "1w",
  "56534": "1w",
  "56431": "1w",
  "56449": "1w",
  "56026": "1w",
  "55709": "1w",
  "55014": "1w",
  "55333": "1w",
  "55342": "1w",
  "56060": "1w",
  "55408": "1w",
  "55397": "1w",
  "55040": "1w",
  "56755": "1w",
  "56725": "1w",
  "56733": "1w",
  "55337": "1w",
  "56162": "1w",
  "56318": "1w",
  "56132": "1w",
  "56353": "1w",
  "55403": "1w",
  "56735": "1w",
  "56728": "1w",
  "56210": "1w",
  "56734": "1w",
  "55355": "1w",
  "55746": "1w",
  "56627": "1w",
  "56382": "1w",
  "55032": "1w",
  "56168": "1w",
  "55716": "1w",
  "55775": "1w",
  "55981": "1w",
  "55748": "1w",
  "56088": "1w",
  "55943": "1w",
  "56243": "1w",
  "56327": "1w",
  "56754": "1w",
  "55925": "1w",
  "56446": "1w",
  "56758": "1w",
  "56138": "1w",
  "55090": "1w",
  "55065": "1w",
  "55923": "1w",
  "56271": "1w",
  "56528": "1w",
  "56019": "1w",
  "56484": "1w",
  "56574": "1w",
  "56465": "1w",
  "55962": "1w",
  "56586": "1w",
  "55917": "1w",
  "56533": "1w",
  "56540": "1w",
  "56557": "1w",
  "56542": "1w",
  "55087": "1w",
  "56461": "1w",
  "55115": "1w",
  "56467": "1w",
  "55068": "1w",
  "56590": "1w",
  "56468": "1w",
  "56063": "1w",
  "10467": "2e",
  "14411": "1e",
  "11223": "2e",
  "14733": "2e",
  "11412": "2e",
  "14787": "2e",
  "14724": "2e",
  "13166": "1e",
  "12594": "2e",
  "11429": "2e",
  "12028": "1e",
  "14560": "2e",
  "14784": "2e",
  "14846": "2e",
  "12010": "1e",
  "12066": "2e",
  "13364": "2e",
  "11226": "2e",
  "13092": "2e",
  "12572": "2e",
  "13456": "1e",
  "10038": "2e",
  "13206": "1e",
  "10710": "2e",
  "14609": "1e",
  "13068": "2e",
  "12546": "2e",
  "11704": "2e",
  "13207": "1e",
  "14606": "1e",
  "10552": "2e",
  "14642": "1e",
  "14208": "1e",
  "11222": "2e",
  "14072": "1e",
  "14207": "1e",
  "12032": "1e",
  "12769": "2e",
  "12913": "1e",
  "12939": "1e",
  "12466": "2e",
  "12917": "1e",
  "12778": "2e",
  "12742": "2e",
  "12547": "2e",
  "12548": "2e",
  "14173": "2e",
  "14569": "2e",
  "13801": "2e",
  "13753": "2e",
  "13842": "2e",
  "14858": "2e",
  "12977": "1e",
  "14808": "2e",
  "12961": "1e",
  "13756": "2e",
  "13780": "2e",
  "13774": "2e",
  "13804": "2e",
  "12029": "2e",
  "12165": "2e",
  "12130": "2e",
  "11377": "2e",
  "13131": "1e",
  "13438": "1e",
  "75501": "3w",
  "78610": "6",
  "78413": "4",
  "78351": "6",
  "79907": "6",
  "76621": "3w",
  "79936": "6",
  "77619": "4",
  "78656": "6",
  "79237": "2w",
  "76837": "6",
  "77991": "6",
  "79539": "6",
  "75751": "3w",
  "76887": "6",
  "78662": "6",
  "76452": "6",
  "78349": "6",
  "79007": "2w",
  "78375": "6",
  "76878": "6",
  "79231": "6",
  "75925": "3w",
  "75687": "3w",
  "76827": "6",
  "76055": "3w",
  "78107": "6",
  "75401": "3w",
  "76636": "3w",
  "78639": "6",
  "75422": "3w",
  "78963": "6",
  "76679": "3w",
  "78672": "6",
  "75155": "3w",
  "76885": "6",
  "78144": "6",
  "56131": "1w",
  "55811": "1w",
  "55931": "1w",
  "55346": "1w",
  "56307": "1w",
  "56722": "1w",
  "55316": "1w",
  "55711": "1w",
  "55752": "1w",
  "55707": "1w",
  "56245": "1w",
  "56761": "1w",
  "55017": "1w",
  "55758": "1w",
  "56591": "1w",
  "56125": "1w",
  "56673": "1w",
  "55110": "1w",
  "55127": "1w",
  "55330": "1w",
  "56560": "1w",
  "56580": "1w",
  "56342": "1w",
  "56021": "1w",
  "56601": "1w",
  "56479": "1w",
  "56137": "1w",
  "56159": "1w",
  "55009": "1w",
  "56458": "1w",
  "56510": "1w",
  "56545": "1w",
  "56452": "1w",
  "55037": "1w",
  "56017": "1w",
  "56455": "1w",
  "56441": "1w",
  "55007": "1w",
  "56641": "1w",
  "56072": "1w",
  "55951": "1w",
  "55304": "1w",
  "55433": "1w",
  "56120": "1w",
  "56227": "1w",
  "55381": "1w",
  "56522": "1w",
  "55317": "1w",
  "55371": "1w",
  "55307": "1w",
  "55410": "1w",
  "55318": "1w",
  "56737": "1w",
  "55125": "1w",
  "55075": "1w",
  "56389": "1w",
  "55388": "1w",
  "56724": "1w",
  "55376": "1w",
  "55320": "1w",
  "55011": "1w",
  "56048": "1w",
  "56731": "1w",
  "55418": "1w",
  "55080": "1w",
  "55991": "1w",
  "56653": "1w",
  "56230": "1w",
  "55946": "1w",
  "56129": "1w",
  "55704": "1w",
  "51363": "1w",
  "52555": "2w",
  "50448": "1w",
  "52071": "2w",
  "50831": "2w",
  "52568": "2w",
  "24476": "3e",
  "23691": "3e",
  "24467": "3e",
  "24363": "3e",
  "23168": "3e",
  "23420": "3e",
  "23415": "3e",
  "23437": "3e",
  "24381": "3e",
  "23321": "3e",
  "24085": "3e",
  "23149": "3e",
  "22202": "2e",
  "22733": "3e",
  "23837": "3e",
  "22301": "2e",
  "29733": "3e",
  "29728": "4",
  "29944": "4",
  "29572": "4",
  "29575": "4",
  "29384": "4",
  "29717": "4",
  "22485": "3e",
  "24083": "3e",
  "24237": "3e",
  "29111": "4",
  "24220": "3e",
  "22660": "2e",
  "24019": "3e",
  "23692": "3e",
  "24350": "3e",
  "22601": "2e",
  "22443": "3e",
  "23219": "3e",
  "23607": "3e",
  "24620": "3e",
  "22936": "3e",
  "24141": "3e",
  "23669": "3e",
  "24165": "3e",
  "22820": "3e",
  "24133": "3e",
  "22821": "3e",
  "22841": "3e",
  "24370": "3e",
  "24486": "3e",
  "22834": "3e",
  "24592": "3e",
  "23325": "3e",
  "24060": "3e",
  "24459": "3e",
  "22980": "3e",
  "23435": "3e",
  "24330": "3e",
  "22939": "3e",
  "22656": "2e",
  "24348": "3e",
  "22958": "3e",
  "24352": "3e",
  "24328": "3e",
  "23237": "3e",
  "23440": "3e",
  "23357": "3e",
  "23358": "3e",
  "23418": "3e",
  "24380": "3e",
  "24457": "3e",
  "24347": "3e",
  "23389": "3e",
  "24411": "3e",
  "23050": "3e",
  "22206": "2e",
  "22542": "3e",
  "22701": "3e",
  "22433": "3e",
  "23829": "3e",
  "23430": "3e",
  "23038": "3e",
  "23005": "3e",
  "23192": "3e",
  "20120": "2e",
  "20121": "2e",
  "22033": "2e",
  "20171": "2e",
  "22181": "2e",
  "20180": "2e",
  "23701": "3e",
  "23704": "3e",
  "23828": "3e",
  "23153": "3e",
  "22310": "2e",
  "23069": "3e",
  "23146": "3e",
  "22042": "2e",
  "22046": "2e",
  "22066": "2e",
  "23024": "3e",
  "20166": "2e",
  "20175": "2e",
  "20165": "2e",
  "35541": "4",
  "30830": "4",
  "30545": "4",
  "31037": "4",
  "31055": "4",
  "31774": "4",
  "30410": "4",
  "36317": "4",
  "35033": "4",
  "31407": "4",
  "30666": "4",
  "36867": "4",
  "36092": "4",
  "36026": "4",
  "35051": "4",
  "36078": "4",
  "35653": "3e",
  "36006": "4",
  "36008": "4",
  "35441": "4",
  "36768": "4",
  "36858": "4",
  "35481": "4",
  "36738": "4",
  "36312": "4",
  "36320": "4",
  "35133": "4",
  "36753": "4",
  "31220": "4",
  "32568": "4",
  "34288": "4",
  "32526": "4",
  "33158": "4",
  "33109": "4",
  "30725": "4",
  "31329": "4",
  "30329": "4",
  "30683": "4",
  "30677": "4",
  "31032": "4",
  "31061": "4",
  "30360": "4",
  "34266": "4",
  "36081": "4",
  "36785": "4",
  "35958": "3e",
  "36439": "4",
  "36756": "4",
  "36759": "4",
  "36017": "4",
  "35462": "4",
  "36548": "4",
  "36556": "4",
  "36420": "4",
  "36861": "4",
  "36473": "4",
  "36256": "4",
  "35089": "4",
  "32631": "4",
  "30805": "4",
  "31322": "4",
  "30004": "4",
  "36912": "4",
  "35470": "4",
  "35172": "4",
  "36555": "4",
  "35032": "4",
  "35072": "4",
  "35674": "3e",
  "35646": "3e",
  "35545": "4",
  "34229": "4",
  "33480": "4",
  "30680": "4",
  "35671": "3e",
  "36091": "4",
  "35769": "4",
  "35124": "4",
  "36373": "4",
  "35573": "4",
  "35005": "4",
  "35061": "4",
  "36751": "4",
  "36722": "4",
  "36875": "4",
  "36025": "4",
  "36442": "4",
  "35031": "4",
  "35125": "4",
  "36877": "4",
  "30097": "4",
  "30024": "4",
  "33619": "4",
  "49068": "2e",
  "49461": "1e",
  "48429": "1e",
  "49418": "1e",
  "49315": "2e",
  "49509": "1e",
  "49919": "1e",
  "48729": "1e",
  "48801": "1e",
  "49891": "1e",
  "49645": "1e",
  "49744": "1e",
  "48363": "1e",
  "49052": "2e",
  "48370": "1e",
  "49616": "1e",
  "49057": "2e",
  "49428": "1e",
  "48649": "1e",
  "49839": "1e",
  "48350": "2e",
  "49262": "2e",
  "48357": "2e",
  "49409": "1e",
  "48328": "2e",
  "48088": "2e",
  "48089": "2e",
  "48026": "2e",
  "48066": "2e",
  "48062": "1e",
  "48307": "2e",
  "48302": "2e",
  "48706": "1e",
  "48324": "2e",
  "48033": "2e",
  "48108": "2e",
  "48104": "2e",
  "48198": "2e",
  "48109": "2e",
  "48421": "1e",
  "48626": "1e",
  "48650": "1e",
  "49668": "1e",
  "48446": "1e",
  "48615": "1e",
  "48180": "2e",
  "48230": "2e",
  "48003": "1e",
  "48205": "2e",
  "48423": "1e",
  "48462": "1e",
  "75116": "3w",
  "75236": "3w",
  "75412": "3w",
  "75667": "3w",
  "79233": "3w",
  "76873": "6",
  "75163": "3w",
  "75782": "3w",
  "77960": "6",
  "77852": "6",
  "78141": "6",
  "78062": "6",
  "78352": "6",
  "04969": "1e",
  "04101": "1e",
  "04103": "1e",
  "04411": "1e",
  "04069": "1e",
  "03908": "1e",
  "04783": "1e",
  "04664": "1e",
  "04756": "1e",
  "04090": "1e",
  "03907": "1e",
  "04221": "1e",
  "04263": "1e",
  "04915": "1e",
  "04261": "1e",
  "04943": "1e",
  "04238": "1e",
  "03903": "2e",
  "04253": "1e",
  "04941": "1e",
  "04027": "1e",
  "04469": "1e",
  "04646": "1e",
  "04227": "1e",
  "04475": "1e",
  "04556": "1e",
  "04267": "1e",
  "04858": "1e",
  "04234": "1e",
  "04679": "1e",
  "04924": "1e",
  "04276": "1e",
  "04464": "1e",
  "04761": "1e",
  "04747": "1e",
  "04485": "1e",
  "04462": "1e",
  "04763": "1e",
  "04455": "1e",
  "04930": "1e",
  "04091": "1e",
  "04363": "1e",
  "04622": "1e",
  "04606": "1e",
  "04681": "1e",
  "04947": "1e",
  "04538": "1e",
  "04860": "1e",
  "04555": "1e",
  "31022": "4",
  "33714": "4",
  "30253": "4",
  "30093": "4",
  "30107": "4",
  "30734": "4",
  "33813": "4",
  "30450": "4",
  "34145": "4",
  "34134": "4",
  "34101": "4",
  "33620": "4",
  "33712": "4",
  "31826": "4",
  "31831": "4",
  "31765": "4",
  "34482": "4",
  "34208": "4",
  "31705": "4",
  "33180": "4",
  "30507": "4",
  "32303": "4",
  "36266": "4",
  "34102": "4",
  "35801": "3e",
  "31076": "4",
  "33162": "4",
  "32409": "4",
  "31806": "4",
  "30310": "4",
  "35906": "4",
  "36695": "4",
  "36618": "4",
  "35228": "4",
  "35213": "4",
  "36571": "4",
  "36272": "4",
  "32617": "4",
  "31721": "4",
  "31711": "4",
  "30318": "4",
  "30149": "4",
  "31069": "4",
  "31524": "4",
  "33012": "4",
  "32195": "4",
  "33604": "4",
  "34239": "4",
  "34420": "4",
  "30504": "4",
  "30314": "4",
  "30575": "4",
  "34209": "4",
  "31909": "4",
  "30511": "4",
  "33966": "4",
  "33907": "4",
  "33125": "4",
  "32313": "4",
  "32205": "4",
  "33401": "4",
  "36582": "4",
  "36541": "4",
  "36507": "4",
  "36505": "4",
  "36587": "4",
  "35023": "4",
  "35111": "4",
  "35074": "4",
  "36079": "4",
  "36513": "4",
  "30295": "4",
  "30055": "4",
  "31064": "4",
  "31699": "4",
  "30350": "4",
  "31097": "4",
  "30623": "4",
  "31631": "4",
  "36879": "4",
  "35973": "4",
  "36032": "4",
  "35765": "4",
  "35978": "4",
  "36037": "4",
  "36701": "4",
  "55104": "1w",
  "56549": "1w",
  "56304": "1w",
  "55101": "1w",
  "55102": "1w",
  "56630": "1w",
  "56267": "1w",
  "56014": "1w",
  "52322": "2w",
  "52349": "2w",
  "50322": "2w",
  "52320": "2w",
  "50056": "2w",
  "52253": "2w",
  "52742": "2w",
  "52212": "2w",
  "50278": "2w",
  "52217": "2w",
  "50212": "2w",
  "52402": "2w",
  "50310": "2w",
  "51350": "1w",
  "52211": "2w",
  "52215": "2w",
  "51536": "2w",
  "52767": "2e",
  "52348": "2w",
  "51345": "1w",
  "50111": "2w",
  "50472": "1w",
  "50428": "1w",
  "50477": "1w",
  "50258": "2w",
  "52326": "2w",
  "50051": "2w",
  "50440": "1w",
  "50031": "2w",
  "50427": "2w",
  "52236": "2w",
  "52201": "2w",
  "50108": "2w",
  "52160": "1w",
  "52162": "1w",
  "50511": "1w",
  "50250": "2w",
  "50562": "1w",
  "50055": "2w",
  "52313": "2w",
  "52347": "2w",
  "50141": "2w",
  "50514": "1w",
  "50028": "2w",
  "52172": "1w",
  "50595": "2w",
  "52533": "2w",
  "50147": "2w",
  "51366": "1w",
  "50022": "2w",
  "50458": "1w",
  "52308": "2w",
  "48312": "2e",
  "48130": "2e",
  "49643": "1e",
  "49285": "2e",
  "48620": "1e",
  "48235": "2e",
  "48239": "2e",
  "48152": "2e",
  "48128": "2e",
  "48243": "2e",
  "48023": "2e",
  "48002": "1e",
  "48451": "1e",
  "48836": "2e",
  "48635": "1e",
  "48661": "1e",
  "49836": "1e",
  "48418": "1e",
  "48432": "1e",
  "49659": "1e",
  "49774": "1e",
  "48755": "1e",
  "49203": "2e",
  "48602": "1e",
  "49037": "2e",
  "49441": "1e",
  "49849": "1e",
  "49729": "1e",
  "48831": "1e",
  "49034": "2e",
  "48862": "1e",
  "48072": "2e",
  "49887": "1e",
  "49632": "1e",
  "49338": "1e",
  "49807": "1e",
  "49304": "1e",
  "49896": "1e",
  "49332": "1e",
  "49627": "1e",
  "49705": "1e",
  "48850": "1e",
  "49953": "1e",
  "49310": "1e",
  "48763": "1e",
  "48745": "1e",
  "49682": "1e",
  "49630": "1e",
  "49631": "1e",
  "49863": "1e",
  "49342": "1e",
  "49821": "1e",
  "49651": "1e",
  "49006": "2e",
  "48806": "1e",
  "49031": "2e",
  "48741": "1e",
  "48807": "1e",
  "49963": "1e",
  "49967": "1e",
  "49440": "1e",
  "48743": "1e",
  "48859": "1e",
  "48632": "1e",
  "48614": "1e",
  "49868": "1e",
  "49622": "1e",
  "49847": "1e",
  "49769": "1e",
  "49848": "1e",
  "48656": "1e",
  "48721": "1e",
  "49670": "1e",
  "49706": "1e",
  "49912": "1e",
  "49864": "1e",
  "13693": "1e",
  "13692": "1e",
  "12156": "2e",
  "13838": "2e",
  "12788": "2e",
  "12783": "2e",
  "12748": "2e",
  "12760": "2e",
  "14024": "2e",
  "14895": "2e",
  "12970": "1e",
  "12766": "2e",
  "12401": "2e",
  "12989": "1e",
  "12441": "2e",
  "12720": "2e",
  "14040": "1e",
  "13645": "1e",
  "13680": "1e",
  "11962": "2e",
  "13335": "2e",
  "13468": "1e",
  "11579": "2e",
  "12155": "2e",
  "13776": "2e",
  "13457": "2e",
  "12768": "2e",
  "12725": "2e",
  "12754": "2e",
  "14884": "2e",
  "14753": "2e",
  "12525": "2e",
  "12419": "2e",
  "12515": "2e",
  "12786": "2e",
  "14874": "2e",
  "14801": "2e",
  "12942": "1e",
  "12956": "1e",
  "12996": "1e",
  "13101": "2e",
  "13786": "2e",
  "14879": "2e",
  "14729": "2e",
  "14788": "2e",
  "13830": "2e",
  "14821": "2e",
  "13731": "2e",
  "14549": "2e",
  "14427": "2e",
  "13839": "2e",
  "14820": "2e",
  "14893": "2e",
  "12207": "2e",
  "12565": "2e",
  "12132": "2e",
  "14853": "2e",
  "10031": "2e",
  "14131": "1e",
  "14301": "1e",
  "14883": "2e",
  "13734": "2e",
  "11233": "2e",
  "23068": "3e",
  "22847": "3e",
  "23958": "3e",
  "24272": "3e",
  "23963": "3e",
  "23456": "3e",
  "22460": "3e",
  "23226": "3e",
  "24323": "3e",
  "22849": "3e",
  "22620": "2e",
  "22611": "2e",
  "24574": "3e",
  "24572": "3e",
  "24236": "3e",
  "24540": "3e",
  "24055": "3e",
  "24471": "3e",
  "24340": "3e",
  "22812": "3e",
  "24597": "3e",
  "24239": "3e",
  "22969": "3e",
  "22920": "3e",
  "22904": "3e",
  "22832": "3e",
  "23234": "3e",
  "24437": "3e",
  "23185": "3e",
  "23224": "3e",
  "24430": "3e",
  "22207": "2e",
  "23836": "3e",
  "24474": "3e",
  "23302": "3e",
  "23441": "3e",
  "24105": "3e",
  "23114": "3e",
  "22960": "3e",
  "22942": "3e",
  "23898": "3e",
  "22508": "3e",
  "22567": "3e",
  "22211": "2e",
  "22101": "2e",
  "22957": "3e",
  "22314": "2e",
  "23228": "3e",
  "22308": "2e",
  "22060": "2e",
  "23103": "3e",
  "23709": "3e",
  "23065": "3e",
  "23708": "3e",
  "23129": "3e",
  "22030": "2e",
  "23139": "3e",
  "20190": "2e",
  "99039": "5",
  "98620": "5",
  "98077": "5",
  "98031": "5",
  "98038": "5",
  "98019": "5",
  "98207": "5",
  "98105": "5",
  "98273": "5",
  "98257": "5",
  "98902": "5",
  "98229": "5",
  "99115": "5",
  "98849": "5",
  "98859": "5",
  "98565": "7",
  "98840": "5",
  "99158": "5",
  "98195": "5",
  "98592": "7",
  "98304": "5",
  "98052": "5",
  "98028": "5",
  "98550": "7",
  "98005": "5",
  "99117": "5",
  "98602": "5",
  "99026": "5",
  "98339": "7",
  "98535": "7",
  "98650": "5",
  "98312": "7",
  "99114": "5",
  "98559": "7",
  "98406": "7",
  "98822": "5",
  "98232": "5",
  "99170": "5",
  "98320": "7",
  "74128": "3w",
  "74468": "3w",
  "74643": "2w",
  "74340": "3w",
  "74501": "3w",
  "74538": "3w",
  "73444": "3w",
  "73461": "3w",
  "73460": "3w",
  "74084": "2w",
  "74633": "2w",
  "73458": "3w",
  "73747": "2w",
  "73741": "2w",
  "73722": "2w",
  "73110": "3w",
  "73089": "3w",
  "73501": "3w",
  "74450": "3w",
  "73059": "3w",
  "74006": "2w",
  "73736": "2w",
  "74864": "3w",
  "74880": "3w",
  "74640": "2w",
  "73632": "3w",
  "74834": "3w",
  "73669": "2w",
  "73564": "3w",
  "73549": "3w",
  "74427": "3w",
  "73015": "3w",
  "73661": "3w",
  "74562": "3w",
  "74369": "2w",
  "73038": "3w",
  "73064": "3w",
  "73762": "3w",
  "73069": "3w",
  "73080": "3w",
  "73012": "3w",
  "74063": "3w",
  "74038": "3w",
  "74750": "3w",
  "74936": "3w",
  "73673": "3w",
  "74755": "3w",
  "73063": "2w",
  "73754": "2w",
  "73735": "2w",
  "74061": "2w",
  "73149": "3w",
  "73095": "3w",
  "73006": "3w",
  "74301": "2w",
  "73057": "3w",
  "73570": "3w",
  "74366": "3w",
  "74053": "3w",
  "74017": "3w",
  "74902": "3w",
  "74901": "3w",
  "73021": "3w",
  "73551": "3w",
  "74563": "3w",
  "73541": "3w",
  "74107": "3w",
  "74540": "3w",
  "73097": "3w",
  "74837": "3w",
  "74556": "3w",
  "74430": "3w",
  "73030": "3w",
  "73058": "3w",
  "74060": "3w",
  "74836": "3w",
  "73447": "3w",
  "28124": "3e",
  "27511": "3e",
  "27542": "3e",
  "28518": "3e",
  "27534": "3e",
  "27106": "3e",
  "28544": "3e",
  "28205": "3e",
  "28530": "3e",
  "28806": "3e",
  "27813": "3e",
  "27110": "3e",
  "28213": "3e",
  "28787": "3e",
  "28709": "3e",
  "27019": "3e",
  "27052": "3e",
  "27045": "3e",
  "28311": "3e",
  "28217": "3e",
  "28778": "3e",
  "28730": "3e",
  "28262": "3e",
  "28134": "3e",
  "27514": "3e",
  "27243": "3e",
  "27231": "3e",
  "27809": "3e",
  "27403": "3e",
  "27006": "3e",
  "27540": "3e",
  "27314": "3e",
  "28424": "3e",
  "28723": "3e",
  "28515": "3e",
  "27242": "3e",
  "27942": "3e",
  "28627": "3e",
  "28441": "3e",
  "27805": "3e",
  "28635": "3e",
  "28788": "3e",
  "28519": "3e",
  "28523": "3e",
  "28169": "3e",
  "27556": "3e",
  "28752": "3e",
  "28369": "4",
  "28360": "3e",
  "28532": "3e",
  "27581": "3e",
  "28694": "3e",
  "28665": "3e",
  "28376": "3e",
  "27935": "3e",
  "28781": "3e",
  "28589": "3e",
  "28024": "3e",
  "27959": "3e",
  "27978": "3e",
  "28351": "4",
  "28396": "3e",
  "27374": "3e",
  "27815": "3e",
  "28677": "3e",
  "27107": "3e",
  "27127": "3e",
  "28689": "3e",
  "27020": "3e",
  "28079": "3e",
  "27344": "3e",
  "27217": "3e",
  "27258": "3e",
  "28657": "3e",
  "27349": "3e",
  "28227": "3e",
  "28138": "3e",
  "27560": "3e",
  "27834": "3e",
  "27701": "3e",
  "27105": "3e",
  "27705": "3e",
  "28572": "3e",
  "28460": "3e",
  "28403": "3e",
  "28208": "3e",
  "28304": "3e",
  "28365": "3e",
  "28543": "3e",
  "27822": "3e",
  "27889": "3e",
  "27888": "3e",
  "27873": "3e",
  "28318": "3e",
  "48047": "2e",
  "48708": "1e",
  "48076": "2e",
  "48082": "2e",
  "48035": "2e",
  "48170": "2e",
  "48880": "1e",
  "48611": "1e",
  "48229": "2e",
  "48228": "2e",
  "48455": "1e",
  "49686": "1e",
  "49690": "1e",
  "49625": "1e",
  "48164": "2e",
  "48612": "1e",
  "48240": "2e",
  "48463": "1e",
  "48183": "2e",
  "48238": "2e",
  "48203": "2e",
  "48214": "2e",
  "48122": "2e",
  "48186": "2e",
  "48174": "2e",
  "48161": "2e",
  "48159": "2e",
  "48039": "2e",
  "48442": "1e",
  "48063": "1e",
  "48145": "2e",
  "48133": "2e",
  "49735": "1e",
  "49089": "2e",
  "49911": "1e",
  "48654": "1e",
  "48445": "1e",
  "49680": "1e",
  "49040": "2e",
  "48157": "2e",
  "49094": "2e",
  "48892": "2e",
  "49612": "1e",
  "49751": "1e",
  "48872": "1e",
  "49745": "1e",
  "49082": "2e",
  "49781": "1e",
  "48470": "1e",
  "49112": "2e",
  "48504": "1e",
  "49855": "1e",
  "39307": "4",
  "38744": "4",
  "38731": "3w",
  "39574": "4",
  "39154": "4",
  "39482": "4",
  "39359": "4",
  "39092": "4",
  "39576": "4",
  "79021": "6",
  "78561": "4",
  "78605": "6",
  "76627": "3w",
  "78657": "6",
  "76648": "3w",
  "77882": "3w",
  "75153": "3w",
  "77651": "4",
  "79366": "6",
  "78586": "4",
  "79107": "2w",
  "79108": "2w",
  "75227": "3w",
  "78552": "4",
  "75149": "3w",
  "77476": "4",
  "77459": "4",
  "77479": "4",
  "77327": "4",
  "77365": "4",
  "77447": "4",
  "77581": "4",
  "77541": "4",
  "77531": "4",
  "75852": "3w",
  "77517": "4",
  "79538": "6",
  "75862": "3w",
  "77474": "6",
  "78072": "6",
  "76255": "3w",
  "76951": "6",
  "76520": "6",
  "79734": "6",
  "79005": "2w",
  "79045": "2w",
  "76877": "6",
  "79567": "6",
  "77415": "4",
  "77597": "4",
  "78061": "6",
  "78342": "6",
  "78834": "6",
  "78102": "6",
  "79752": "6",
  "76832": "6",
  "75979": "4",
  "78377": "6",
  "79521": "6",
  "75840": "3w",
  "78114": "6",
  "77708": "4",
  "79924": "6",
  "78046": "6",
  "75969": "3w",
  "75701": "3w",
  "75021": "3w",
  "75473": "3w",
  "78009": "6",
  "78632": "6",
  "79403": "6",
  "75421": "3w",
  "76429": "3w",
  "75208": "3w",
  "77975": "6",
  "79415": "6",
  "78948": "6",
  "79762": "6",
  "76484": "3w",
  "77982": "4",
  "76798": "3w",
  "79930": "6",
  "77705": "4",
  "78143": "6",
  "77642": "4",
  "75202": "3w",
  "75223": "3w",
  "75602": "3w",
  "76629": "3w",
  "76238": "3w",
  "75949": "4",
  "79932": "6",
  "75707": "3w",
  "75792": "3w",
  "75709": "3w",
  "75230": "3w",
  "78741": "6",
  "76940": "6",
  "77866": "3w",
  "78744": "6",
  "78412": "4",
  "75270": "3w",
  "76657": "6",
  "76633": "3w",
  "76673": "3w",
  "07104": "2e",
  "08234": "2e",
  "08330": "2e",
  "07017": "2e",
  "07436": "2e",
  "07205": "2e",
  "08812": "2e",
  "07524": "2e",
  "07087": "2e",
  "07020": "2e",
  "08402": "2e",
  "08221": "2e",
  "08609": "2e",
  "08618": "2e",
  "08619": "2e",
  "08361": "2e",
  "08807": "2e",
  "07931": "2e",
  "07401": "2e",
  "07080": "2e",
  "07031": "2e",
  "07075": "2e",
  "07023": "2e",
  "07803": "2e",
  "08270": "2e",
  "07041": "2e",
  "07980": "2e",
  "08821": "2e",
  "07044": "2e",
  "08079": "2e",
  "08542": "2e",
  "07979": "2e",
  "08628": "2e",
  "08321": "2e",
  "07071": "2e",
  "07201": "2e",
  "08201": "2e",
  "98237": "5",
  "99133": "5",
  "99185": "5",
  "98610": "5",
  "98305": "7",
  "98817": "5",
  "98055": "5",
  "98645": "7",
  "98126": "5",
  "98851": "5",
  "98311": "7",
  "98438": "7",
  "98327": "7",
  "98011": "5",
  "98221": "5",
  "98255": "5",
  "98390": "5",
  "99149": "5",
  "99135": "5",
  "98290": "5",
  "45866": "2e",
  "45727": "2e",
  "45340": "2e",
  "45310": "2e",
  "44627": "2e",
  "44628": "2e",
  "44687": "2e",
  "44652": "2e",
  "44325": "2e",
  "44010": "2e",
  "44032": "2e",
  "44082": "2e",
  "45502": "2e",
  "45652": "2e",
  "43351": "2e",
  "43609": "2e",
  "45410": "2e",
  "43501": "2e",
  "44906": "2e",
  "43214": "2e",
  "44230": "2e",
  "45836": "2e",
  "45850": "2e",
  "44048": "2e",
  "43204": "2e",
  "43605": "2e",
  "43511": "2e",
  "45896": "2e",
  "43212": "2e",
  "43022": "2e",
  "45859": "2e",
  "44093": "2e",
  "45881": "2e",
  "43213": "2e",
  "43010": "2e",
  "43081": "2e",
  "45805": "2e",
  "44680": "2e",
  "43551": "2e",
  "44622": "2e",
  "43964": "2e",
  "45056": "2e",
  "45238": "2e",
  "43902": "2e",
  "45844": "2e",
  "45231": "2e",
  "43232": "2e",
  "45205": "2e",
  "45439": "2e",
  "43463": "2e",
  "45677": "2e",
  "43218": "2e",
  "43510": "2e",
  "43466": "2e",
  "45807": "2e",
  "45233": "2e",
  "43443": "2e",
  "45423": "2e",
  "45501": "2e",
  "43336": "2e",
  "43967": "2e",
  "45162": "2e",
  "45158": "2e",
  "43446": "2e",
  "45618": "2e",
  "45335": "2e",
  "44695": "2e",
  "47924": "2e",
  "46957": "2e",
  "47370": "2e",
  "47845": "2e",
  "46796": "2e",
  "46149": "2e",
  "46755": "2e",
  "46771": "2e",
  "47855": "2e",
  "47405": "2e",
  "47367": "2e",
  "47558": "2e",
  "47598": "2e",
  "47591": "2e",
  "47459": "2e",
  "47833": "2e",
  "47357": "2e",
  "46236": "2e",
  "46231": "2e",
  "46165": "2e",
  "47944": "2e",
  "46113": "2e",
  "46180": "2e",
  "46220": "2e",
  "46280": "2e",
  "46532": "2e",
  "46939": "2e",
  "46350": "2e",
  "46772": "2e",
  "46714": "2e",
  "47630": "3e",
  "46792": "2e",
  "47610": "3e",
  "46783": "2e",
  "47454": "2e",
  "46531": "2e",
  "47340": "2e",
  "41619": "3e",
  "41604": "3e",
  "41838": "3e",
  "42463": "3e",
  "41159": "3e",
  "41528": "3e",
  "40052": "3e",
  "41390": "3e",
  "41543": "3e",
  "40142": "3e",
  "42722": "3e",
  "69101": "2w",
  "69361": "5",
  "68117": "2w",
  "68517": "2w",
  "68336": "2w",
  "68785": "2w",
  "69337": "5",
  "68666": "2w",
  "68359": "2w",
  "68652": "2w",
  "68335": "2w",
  "69028": "2w",
  "68367": "2w",
  "69129": "2w",
  "68948": "2w",
  "68982": "2w",
  "68415": "2w",
  "68949": "2w",
  "69046": "2w",
  "68062": "2w",
  "68047": "2w",
  "69131": "5",
  "68458": "2w",
  "68410": "2w",
  "68523": "2w",
  "68955": "2w",
  "69149": "2w",
  "69355": "5",
  "68457": "2w",
  "68355": "2w",
  "68428": "2w",
  "68065": "2w",
  "68017": "2w",
  "68929": "2w",
  "68309": "2w",
  "68748": "2w",
  "69335": "2w",
  "69356": "5",
  "69020": "2w",
  "68360": "2w",
  "69135": "2w",
  "51557": "2w",
  "69036": "2w",
  "68378": "2w",
  "68866": "2w",
  "68763": "2w",
  "68828": "2w",
  "68371": "2w",
  "68348": "2w",
  "68825": "2w",
  "68838": "2w",
  "68725": "2w",
  "68401": "2w",
  "68344": "2w",
  "68447": "2w",
  "68001": "2w",
  "68853": "2w",
  "68958": "2w",
  "68441": "2w",
  "68925": "2w",
  "68973": "2w",
  "68923": "2w",
  "68786": "2w",
  "68732": "2w",
  "68755": "2w",
  "68801": "2w",
  "69153": "2w",
  "68803": "2w",
  "68503": "2w",
  "68824": "2w",
  "68113": "2w",
  "68317": "2w",
  "68654": "2w",
  "68620": "2w",
  "69348": "5",
  "68436": "2w",
  "69346": "5",
  "68007": "2w",
  "68106": "2w",
  "68526": "2w",
  "69156": "5",
  "69334": "5",
  "68352": "2w",
  "68967": "2w",
  "68966": "2w",
  "68351": "2w",
  "68152": "2w",
  "68118": "2w",
  "69165": "2w",
  "69120": "2w",
  "69163": "2w",
  "68936": "2w",
  "68331": "2w",
  "68349": "2w",
  "68347": "2w",
  "68461": "2w",
  "69343": "2w",
  "69161": "2w",
  "68959": "2w",
  "68945": "2w",
  "68972": "2w",
  "68337": "2w",
  "68437": "2w",
  "68952": "2w",
  "68653": "2w",
  "80737": "2w",
  "69211": "2w",
  "69170": "2w",
  "93615": "6",
  "95329": "6",
  "91602": "6",
  "94546": "7",
  "96064": "7",
  "95640": "6",
  "91403": "6",
  "96108": "5",
  "96044": "7",
  "96118": "5",
  "95543": "7",
  "95947": "5",
  "93702": "6",
  "90241": "6",
  "95204": "7",
  "95356": "7",
  "96020": "5",
  "93040": "6",
  "90745": "6",
  "95223": "5",
  "93312": "6",
  "96113": "5",
  "92584": "6",
  "92677": "6",
  "95972": "6",
  "92536": "6",
  "92539": "6",
  "92234": "6",
  "92203": "6",
  "94534": "7",
  "90041": "6",
  "95436": "7",
  "92075": "6",
  "92007": "6",
  "92058": "6",
  "92026": "6",
  "92069": "6",
  "95677": "6",
  "92086": "6",
  "91963": "6",
  "91934": "6",
  "92155": "6",
  "94124": "7",
  "95701": "6",
  "92867": "6",
  "95633": "6",
  "96068": "5",
  "95664": "6",
  "95651": "6",
  "92504": "6",
  "92882": "6",
  "96117": "5",
  "92691": "6",
  "95682": "6",
  "95471": "7",
  "94952": "7",
  "95486": "7",
  "94508": "7",
  "94576": "7",
  "95409": "7",
  "94965": "7",
  "94971": "7",
  "90079": "6",
  "94610": "7",
  "94525": "7",
  "91746": "6",
  "91740": "6",
  "94703": "7",
  "92841": "6",
  "92840": "6",
  "94514": "7",
  "94575": "7",
  "91504": "6",
  "90302": "6",
  "91202": "6",
  "91207": "6",
  "91046": "6",
  "91010": "6",
  "94709": "7",
  "95032": "7",
  "90604": "6",
  "95014": "7",
  "95133": "7",
  "95051": "7",
  "95140": "7",
  "94086": "7",
  "95013": "7",
  "02341": "2e",
  "02370": "2e",
  "02330": "2e",
  "02668": "2e",
  "02536": "2e",
  "02667": "2e",
  "02648": "2e",
  "02635": "2e",
  "02672": "2e",
  "02647": "2e",
  "02144": "2e",
  "02111": "2e",
  "01378": "2e",
  "01340": "2e",
  "01351": "2e",
  "01349": "2e",
  "02120": "2e",
  "02131": "2e",
  "01342": "2e",
  "02148": "2e",
  "02143": "2e",
  "01902": "2e",
  "01970": "2e",
  "02152": "2e",
  "02535": "2e",
  "01908": "2e",
  "01612": "2e",
  "01602": "2e",
  "01535": "2e",
  "60606": "2e",
  "60559": "2e",
  "62087": "2e",
  "62048": "2e",
  "62097": "2e",
  "62018": "2e",
  "62295": "2w",
  "60601": "2e",
  "60602": "2e",
  "62026": "2e",
  "62240": "2e",
  "60093": "2e",
  "60176": "2e",
  "60107": "2e",
  "60195": "2e",
  "62248": "2e",
  "60455": "2e",
  "60462": "2e",
  "60153": "2e",
  "60163": "2e",
  "60458": "2e",
  "60513": "2e",
  "60467": "2e",
  "60305": "2e",
  "60430": "2e",
  "60423": "2e",
  "60137": "2e",
  "60139": "2e",
  "60175": "2e",
  "60042": "2e",
  "60020": "2e",
  "60041": "2e",
  "60064": "2e",
  "60012": "2e",
  "60013": "2e",
  "62930": "3e",
  "61473": "2e",
  "60441": "2e",
  "60035": "2e",
  "61453": "2e",
  "61478": "2e",
  "62650": "2e",
  "62421": "2e",
  "62476": "2e",
  "60586": "2e",
  "60180": "2e",
  "60442": "2e",
  "60484": "2e",
  "62952": "3e",
  "60545": "2e",
  "62422": "2e",
  "62987": "3e",
  "61530": "2e",
  "61236": "2e",
  "61944": "2e",
  "62890": "3e",
  "61742": "2e",
  "61561": "2e",
  "61468": "2e",
  "62841": "3e",
  "60130": "2e",
  "62040": "2e",
  "62237": "2e",
  "62888": "2e",
  "61272": "2w",
  "61258": "2e",
  "61465": "2e",
  "61486": "2e",
  "62874": "3e",
  "62825": "3e",
  "62898": "2e",
  "62864": "2e",
  "62810": "2e",
  "61263": "2e",
  "60611": "2e",
  "62420": "2e",
  "61955": "2e",
  "62024": "2e",
  "62088": "2e",
  "62074": "2e",
  "62249": "2e",
  "62281": "2e",
  "61942": "2e",
  "60633": "2e",
  "45415": "2e",
  "44504": "2e",
  "43151": "2e",
  "44443": "2e",
  "45654": "2e",
  "45634": "2e",
  "43545": "2e",
  "45101": "3e",
  "43932": "2e",
  "45155": "2e",
  "45628": "2e",
  "45743": "2e",
  "45769": "2e",
  "43836": "2e",
  "43749": "2e",
  "45849": "2e",
  "44654": "2e",
  "45720": "2e",
  "44809": "2e",
  "43761": "2e",
  "45146": "2e",
  "44833": "2e",
  "45813": "2e",
  "43003": "2e",
  "44813": "2e",
  "43758": "2e",
  "44859": "2e",
  "43914": "2e",
  "45745": "2e",
  "45333": "2e",
  "45860": "2e",
  "45828": "2e",
  "43973": "2e",
  "44856": "2e",
  "43779": "2e",
  "43723": "2e",
  "43755": "2e",
  "45336": "2e",
  "45504": "2e",
  "44606": "2e",
  "45202": "2e",
  "45506": "2e",
  "43606": "2e",
  "45503": "2e",
  "43205": "2e",
  "45206": "2e",
  "43604": "2e",
  "43518": "2e",
  "45223": "2e",
  "06060": "2e",
  "06785": "2e",
  "06076": "2e",
  "06351": "2e",
  "06378": "2e",
  "06249": "2e",
  "06375": "2e",
  "06350": "2e",
  "06247": "2e",
  "06281": "2e",
  "06037": "2e",
  "70772": "4",
  "70788": "4",
  "70456": "4",
  "70465": "4",
  "70749": "4",
  "70740": "4",
  "70043": "4",
  "70092": "4",
  "70032": "4",
  "70737": "4",
  "70734": "4",
  "71024": "3w",
  "71341": "4",
  "71027": "3w",
  "71472": "4",
  "71218": "4",
  "71251": "4",
  "71008": "4",
  "71371": "4",
  "70750": "4",
  "70537": "4",
  "71345": "4",
  "70534": "4",
  "70657": "4",
  "70526": "4",
  "70578": "4",
  "70630": "4",
  "70551": "4",
  "70345": "4",
  "70394": "4",
  "70072": "4",
  "70005": "4",
  "70058": "4",
  "71320": "4",
  "71037": "3w",
  "70118": "4",
  "71006": "3w",
  "71018": "3w",
  "71109": "3w",
  "70359": "4",
  "70532": "4",
  "71002": "4",
  "71366": "4",
  "71401": "4",
  "71486": "4",
  "70506": "4",
  "71425": "4",
  "13165": "1e",
  "14706": "2e",
  "12187": "2e",
  "12498": "2e",
  "12490": "2e",
  "13733": "2e",
  "12092": "2e",
  "12131": "2e",
  "13327": "1e",
  "14843": "2e",
  "12031": "2e",
  "12457": "2e",
  "13312": "1e",
  "12069": "1e",
  "12177": "1e",
  "11430": "2e",
  "13452": "1e",
  "12901": "1e",
  "13320": "2e",
  "11770": "2e",
  "12873": "1e",
  "11949": "2e",
  "11792": "2e",
  "11940": "2e",
  "11952": "2e",
  "11964": "2e",
  "11965": "2e",
  "11947": "2e",
  "14507": "2e",
  "14415": "2e",
  "11930": "2e",
  "11946": "2e",
  "11978": "2e",
  "13635": "1e",
  "13662": "1e",
  "13613": "1e",
  "11968": "2e",
  "13630": "1e",
  "11976": "2e",
  "13342": "2e",
  "13450": "2e",
  "13623": "1e",
  "13825": "2e",
  "13796": "2e",
  "13843": "2e",
  "11765": "2e",
  "13834": "2e",
  "13415": "2e",
  "13482": "2e",
  "14818": "2e",
  "12477": "2e",
  "12953": "1e",
  "12093": "2e",
  "14755": "2e",
  "14891": "2e",
  "12916": "1e",
  "13305": "1e",
  "13345": "1e",
  "13325": "1e",
  "12791": "2e",
  "12741": "2e",
  "12776": "2e",
  "12957": "1e",
  "12733": "2e",
  "12481": "2e",
  "14054": "1e",
  "12494": "2e",
  "12701": "2e",
  "12406": "2e",
  "12164": "1e",
  "14721": "2e",
  "14588": "2e",
  "12764": "2e",
  "12487": "2e",
  "57538": "1w",
  "57783": "5",
  "57754": "5",
  "57791": "1w",
  "57260": "1w",
  "56219": "1w",
  "57270": "1w",
  "57756": "2w",
  "57380": "1w",
  "57569": "1w",
  "57576": "1w",
  "57563": "1w",
  "57384": "1w",
  "57002": "1w",
  "57213": "1w",
  "57054": "1w",
  "57466": "1w",
  "57451": "1w",
  "56144": "1w",
  "57471": "1w",
  "57214": "1w",
  "57720": "1w",
  "57640": "1w",
  "57072": "1w",
  "57540": "1w",
  "57383": "1w",
  "57623": "1w",
  "57445": "1w",
  "57432": "1w",
  "57426": "1w",
  "57269": "1w",
  "57630": "1w",
  "57265": "1w",
  "57324": "1w",
  "57245": "1w",
  "56220": "1w",
  "57541": "1w",
  "57358": "1w",
  "57321": "1w",
  "57428": "1w",
  "57766": "5",
  "57437": "1w",
  "57420": "1w",
  "57003": "1w",
  "57424": "1w",
  "57469": "1w",
  "57440": "1w",
  "57455": "1w",
  "57053": "1w",
  "57775": "1w",
  "57744": "5",
  "57249": "1w",
  "57212": "1w",
  "57349": "1w",
  "57252": "1w",
  "57732": "5",
  "57224": "1w",
  "57266": "1w",
  "57634": "1w",
  "57555": "1w",
  "57339": "1w",
  "57532": "1w",
  "57639": "1w",
  "57312": "1w",
  "57234": "1w",
  "57470": "1w",
  "57435": "1w",
  "57567": "1w",
  "57007": "1w",
  "57553": "1w",
  "57359": "1w",
  "57069": "1w",
  "57373": "1w",
  "57799": "1w",
  "57036": "1w",
  "57449": "1w",
  "57427": "1w",
  "57263": "1w",
  "57242": "1w",
  "57022": "1w",
  "57064": "1w",
  "57077": "1w",
  "57474": "1w",
  "57460": "1w",
  "57760": "1w",
  "57025": "2w",
  "51001": "2w",
  "57038": "2w",
  "57741": "1w",
  "57626": "1w",
  "57062": "1w",
  "57197": "1w",
  "57262": "1w",
  "57257": "1w",
  "57356": "1w",
  "57325": "1w",
  "57656": "1w",
  "57562": "1w",
  "57752": "2w",
  "57714": "2w",
  "57737": "1w",
  "57006": "1w",
  "57075": "1w",
  "14453": "1e",
  "12123": "2e",
  "12169": "2e",
  "13608": "1e",
  "13616": "1e",
  "13636": "1e",
  "12844": "1e",
  "12839": "1e",
  "12427": "2e",
  "12015": "2e",
  "12423": "2e",
  "12885": "1e",
  "12810": "1e",
  "12444": "2e",
  "12857": "1e",
  "12870": "1e",
  "13459": "2e",
  "11360": "2e",
  "12979": "1e",
  "12981": "1e",
  "12912": "1e",
  "12958": "1e",
  "11769": "2e",
  "12861": "1e",
  "12883": "1e",
  "12823": "1e",
  "12841": "1e",
  "11731": "2e",
  "11439": "2e",
  "11764": "2e",
  "06078": "2e",
  "06457": "2e",
  "06074": "2e",
  "06040": "2e",
  "06118": "2e",
  "06042": "2e",
  "06371": "2e",
  "06787": "2e",
  "06439": "2e",
  "06080": "2e",
  "06612": "2e",
  "06840": "2e",
  "06608": "2e",
  "06021": "2e",
  "06853": "2e",
  "06426": "2e",
  "06413": "2e",
  "06890": "2e",
  "06360": "2e",
  "06370": "2e",
  "06447": "2e",
  "06807": "2e",
  "06020": "2e",
  "06022": "2e",
  "06250": "2e",
  "06268": "2e",
  "06333": "2e",
  "06330": "2e",
  "66932": "2w",
  "67363": "2w",
  "69026": "2w",
  "67669": "2w",
  "66901": "2w",
  "67466": "2w",
  "67646": "2w",
  "66711": "2w",
  "66076": "2w",
  "66032": "2w",
  "67846": "2w",
  "67855": "2w",
  "67865": "2w",
  "67842": "2w",
  "67045": "2w",
  "66863": "2w",
  "66251": "2w",
  "67860": "2w",
  "67952": "2w",
  "66031": "2w",
  "67349": "2w",
  "67511": "2w",
  "67525": "2w",
  "67450": "2w",
  "67526": "2w",
  "67552": "2w",
  "67159": "2w",
  "66850": "2w",
  "67036": "2w",
  "67029": "2w",
  "66962": "2w",
  "67665": "2w",
  "66105": "2w",
  "66033": "2w",
  "66955": "2w",
  "66930": "2w",
  "66939": "2w",
  "66966": "2w",
  "67631": "2w",
  "67853": "2w",
  "67119": "2w",
  "66849": "2w",
  "67057": "2w",
  "66964": "2w",
  "67626": "2w",
  "67634": "2w",
  "67155": "2w",
  "66746": "2w",
  "66859": "2w",
  "67512": "2w",
  "66078": "2w",
  "67644": "2w",
  "66840": "2w",
  "66854": "2w",
  "66862": "2w",
  "66218": "2w",
  "66106": "2w",
  "66736": "2w",
  "66778": "2w",
  "67502": "2w",
  "67212": "2w",
  "67052": "2w",
  "67147": "2w",
  "67030": "2w",
  "67042": "2w",
  "67074": "2w",
  "67039": "2w",
  "66101": "2w",
  "66030": "2w",
  "66609": "2w",
  "66539": "2w",
  "30125": "4",
  "30354": "4",
  "30735": "4",
  "33611": "4",
  "33129": "4",
  "31081": "4",
  "36693": "4",
  "35670": "4",
  "35224": "4",
  "36572": "4",
  "35179": "4",
  "34475": "4",
  "33410": "4",
  "30363": "4",
  "31523": "4",
  "33936": "4",
  "30602": "4",
  "30606": "4",
  "30533": "4",
  "32410": "4",
  "34488": "4",
  "34142": "4",
  "33609": "4",
  "33403": "4",
  "33167": "4",
  "32504": "4",
  "36260": "4",
  "35096": "4",
  "36271": "4",
  "36547": "4",
  "30598": "4",
  "31004": "4",
  "35601": "3e",
  "36602": "4",
  "36104": "4",
  "36108": "4",
  "36101": "4",
  "35215": "4",
  "34996": "4",
  "30523": "4",
  "30733": "4",
  "33617": "4",
  "30634": "4",
  "32634": "4",
  "30909": "4",
  "16941": "2e",
  "16223": "2e",
  "17229": "2e",
  "15742": "2e",
  "18628": "2e",
  "15861": "2e",
  "85301": "6",
  "85191": "6",
  "85338": "6",
  "85250": "6",
  "85326": "6",
  "85262": "6",
  "85321": "6",
  "85911": "6",
  "85256": "6",
  "86031": "5",
  "85371": "6",
  "86503": "5",
  "85757": "6",
  "86505": "5",
  "85040": "6",
  "85303": "6",
  "85013": "6",
  "85003": "6",
  "85018": "6",
  "86511": "5",
  "86406": "6",
  "86442": "6",
  "85193": "6",
  "86547": "5",
  "86556": "5",
  "85937": "6",
  "85194": "6",
  "85501": "6",
  "85395": "6",
  "85543": "6",
  "86327": "6",
  "85741": "6",
  "85611": "6",
  "85536": "6",
  "85658": "6",
  "85348": "6",
  "85346": "6",
  "85263": "6",
  "85377": "6",
  "85544": "6",
  "86336": "6",
  "85632": "6",
  "85750": "6",
  "85335": "6",
  "85554": "6",
  "85553": "6",
  "85340": "6",
  "86435": "5",
  "85012": "6",
  "85137": "6",
  "85637": "6",
  "85531": "6",
  "85724": "6",
  "85654": "6",
  "85248": "6",
  "85302": "6",
  "85305": "6",
  "85902": "6",
  "85205": "6",
  "85284": "6",
  "85028": "6",
  "85253": "6",
  "85053": "6",
  "85034": "6",
  "85542": "6",
  "85086": "6",
  "86042": "5",
  "85756": "6",
  "85004": "6",
  "85006": "6",
  "86512": "5",
  "80744": "2w",
  "81143": "5",
  "81141": "5",
  "65076": "2w",
  "65013": "2w",
  "65484": "3w",
  "65552": "2w",
  "65613": "2w",
  "65560": "2w",
  "63456": "2w",
  "64683": "2w",
  "63645": "3w",
  "65265": "2w",
  "63943": "3w",
  "63549": "2w",
  "65336": "2w",
  "65633": "3w",
  "63363": "2w",
  "65069": "2w",
  "65082": "2w",
  "65064": "2w",
  "65072": "2w",
  "63454": "2w",
  "65065": "2w",
  "65452": "2w",
  "65791": "3w",
  "63432": "2w",
  "63536": "2w",
  "65588": "3w",
  "64645": "2w",
  "65557": "2w",
  "64423": "2w",
  "65037": "2w",
  "63827": "3w",
  "65582": "2w",
  "63072": "2w",
  "63764": "3w",
  "64481": "2w",
  "63344": "2w",
  "63950": "3w",
  "63389": "2w",
  "63650": "3w",
  "63343": "2w",
  "63953": "3w",
  "63431": "2w",
  "64682": "2w",
  "63941": "3w",
  "65263": "2w",
  "64048": "2w",
  "64849": "2w",
  "64065": "2w",
  "63857": "3w",
  "63117": "2w",
  "63366": "2w",
  "65034": "2w",
  "65453": "2w",
  "65338": "2w",
  "63469": "2w",
  "63633": "3w",
  "65773": "3w",
  "65246": "2w",
  "65756": "2w",
  "65766": "3w",
  "64081": "2w",
  "63087": "2w",
  "65439": "3w",
  "64778": "2w",
  "64446": "2w",
  "65285": "2w",
  "64499": "2w",
  "64728": "2w",
  "63675": "3w",
  "63567": "2w",
  "63566": "2w",
  "65468": "3w",
  "63758": "3w",
  "65282": "2w",
  "63079": "2w",
  "63361": "2w",
  "63359": "2w",
  "64015": "2w",
  "63052": "2w",
  "63966": "3w",
  "65085": "2w",
  "65653": "3w",
  "65444": "3w",
  "65667": "3w",
  "64630": "2w",
  "63934": "3w",
  "63565": "2w",
  "65275": "2w",
  "63461": "2w",
  "64652": "2w",
  "63460": "2w",
  "64784": "2w",
  "63547": "2w",
  "63670": "2w",
  "64643": "2w",
  "63538": "2w",
  "64489": "2w",
  "64679": "2w",
  "63471": "2w",
  "65075": "2w",
  "65040": "2w",
  "65652": "3w",
  "95929": "7",
  "96025": "7",
  "93441": "7",
  "92831": "6",
  "93625": "6",
  "92880": "6",
  "93907": "7",
  "93616": "6",
  "92336": "6",
  "92376": "6",
  "93257": "6",
  "95363": "7",
  "93280": "6",
  "92411": "6",
  "93033": "6",
  "95327": "6",
  "92313": "6",
  "92509": "6",
  "95337": "7",
  "93012": "6",
  "93619": "6",
  "93205": "6",
  "93518": "6",
  "93519": "6",
  "95841": "7",
  "93609": "6",
  "92140": "6",
  "07030": "2e",
  "07307": "2e",
  "07095": "2e",
  "07650": "2e",
  "07046": "2e",
  "08332": "2e",
  "07940": "2e",
  "07045": "2e",
  "08805": "2e",
  "07981": "2e",
  "07927": "2e",
  "07922": "2e",
  "07976": "2e",
  "08243": "2e",
  "07621": "2e",
  "08863": "2e",
  "08690": "2e",
  "07009": "2e",
  "07072": "2e",
  "08859": "2e",
  "08345": "2e",
  "07834": "2e",
  "08241": "2e",
  "07880": "2e",
  "08326": "2e",
  "08735": "2e",
  "08317": "2e",
  "08094": "2e",
  "08324": "2e",
  "08544": "2e",
  "08353": "2e",
  "07513": "2e",
  "08072": "2e",
  "07926": "2e",
  "07939": "2e",
  "07462": "2e",
  "43623": "2e",
  "43065": "2e",
  "43119": "2e",
  "45804": "2e",
  "45863": "2e",
  "43009": "2e",
  "45874": "2e",
  "43759": "2e",
  "45069": "2e",
  "44054": "2e",
  "43917": "2e",
  "45729": "2e",
  "43240": "2e",
  "43616": "2e",
  "43948": "2e",
  "45809": "2e",
  "43913": "2e",
  "45240": "2e",
  "43117": "2e",
  "43928": "2e",
  "44682": "2e",
  "43542": "2e",
  "45820": "2e",
  "43951": "2e",
  "43934": "2e",
  "45838": "2e",
  "45330": "2e",
  "45385": "2e",
  "44057": "2e",
  "44022": "2e",
  "44099": "2e",
  "44062": "2e",
  "44615": "2e",
  "44621": "2e",
  "43822": "2e",
  "43080": "2e",
  "43062": "2e",
  "44118": "2e",
  "44129": "2e",
  "44107": "2e",
  "43720": "2e",
  "43036": "2e",
  "44471": "2e",
  "44405": "2e",
  "43456": "2e",
  "45884": "2e",
  "43029": "2e",
  "43557": "2e",
  "43146": "2e",
  "45695": "2e",
  "45612": "2e",
  "84097": "5",
  "84712": "5",
  "84108": "5",
  "84338": "5",
  "84526": "5",
  "84020": "5",
  "84111": "5",
  "84101": "5",
  "84721": "5",
  "84753": "5",
  "84756": "5",
  "84719": "5",
  "84070": "5",
  "13355": "2e",
  "14525": "1e",
  "14850": "2e",
  "11560": "2e",
  "14841": "2e",
  "13849": "2e",
  "13809": "2e",
  "14748": "2e",
  "14865": "2e",
  "14813": "2e",
  "12495": "2e",
  "14739": "2e",
  "13859": "2e",
  "12194": "2e",
  "12071": "2e",
  "12035": "2e",
  "14709": "2e",
  "14806": "2e",
  "12812": "1e",
  "14036": "1e",
  "12412": "2e",
  "12461": "2e",
  "14877": "2e",
  "12976": "1e",
  "14541": "2e",
  "12456": "2e",
  "12190": "1e",
  "14754": "2e",
  "14774": "2e",
  "14777": "2e",
  "14005": "1e",
  "14060": "2e",
  "14870": "2e",
  "12420": "2e",
  "14042": "2e",
  "12732": "2e",
  "12770": "2e",
  "14009": "2e",
  "12440": "2e",
  "12749": "2e",
  "12493": "2e",
  "13155": "2e",
  "14898": "2e",
  "14743": "2e",
  "14760": "2e",
  "12998": "1e",
  "12943": "1e",
  "14168": "2e",
  "14856": "2e",
  "12852": "1e",
  "13738": "2e",
  "13847": "2e",
  "12136": "2e",
  "12075": "2e",
  "12226": "2e",
  "12304": "2e",
  "14433": "1e",
  "10026": "2e",
  "13082": "1e",
  "13122": "1e",
  "10033": "2e",
  "13477": "1e",
  "14174": "1e",
  "11221": "2e",
  "11214": "2e",
  "10034": "2e",
  "11205": "2e",
  "10044": "2e",
  "14108": "1e",
  "13304": "1e",
  "13303": "1e",
  "13302": "1e",
  "43718": "2e",
  "45788": "2e",
  "43450": "2e",
  "43947": "2e",
  "45801": "2e",
  "43072": "2e",
  "45204": "2e",
  "45066": "2e",
  "43905": "2e",
  "45808": "2e",
  "43032": "2e",
  "43413": "2e",
  "43525": "2e",
  "45724": "2e",
  "43504": "2e",
  "45252": "2e",
  "45877": "2e",
  "45815": "2e",
  "45055": "2e",
  "43346": "2e",
  "44232": "2e",
  "45352": "2e",
  "54409": "1e",
  "54209": "1e",
  "54843": "1e",
  "54661": "1e",
  "53219": "1e",
  "53227": "1e",
  "53072": "1e",
  "53014": "1e",
  "54944": "1e",
  "53061": "1e",
  "54849": "1e",
  "53919": "1e",
  "53926": "1e",
  "54486": "1e",
  "53151": "1e",
  "54426": "1e",
  "54980": "1e",
  "54440": "1e",
  "54947": "1e",
  "53537": "2e",
  "53179": "2e",
  "54247": "1e",
  "53792": "1e",
  "53085": "1e",
  "54230": "1e",
  "53044": "1e",
  "54542": "1e",
  "54961": "1e",
  "53965": "1e",
  "53220": "1e",
  "54165": "1e",
  "54854": "1e",
  "54867": "1e",
  "54124": "1e",
  "53118": "1e",
  "53058": "1e",
  "53206": "1e",
  "53203": "1e",
  "53225": "1e",
  "54002": "1e",
  "54028": "1e",
  "54562": "1e",
  "53516": "2e",
  "54767": "1e",
  "54876": "1e",
  "54151": "1e",
  "54517": "1e",
  "53941": "1e",
  "53036": "1e",
  "53923": "1e",
  "54469": "1e",
  "53001": "1e",
  "54757": "1e",
  "53088": "1e",
  "54519": "1e",
  "54871": "1e",
  "54545": "1e",
  "54156": "1e",
  "54563": "1e",
  "54648": "1e",
  "54455": "1e",
  "54424": "1e",
  "54984": "1e",
  "54558": "1e",
  "54970": "1e",
  "54741": "1e",
  "54635": "1e",
  "54739": "1e",
  "53813": "2e",
  "54872": "1e",
  "54844": "1e",
  "54868": "1e",
  "54986": "1e",
  "54819": "1e",
  "54654": "1e",
  "54660": "1e",
  "54521": "1e",
  "54564": "1e",
  "54524": "1e",
  "53530": "2e",
  "53960": "1e",
  "54730": "1e",
  "54001": "1e",
  "53235": "2e",
  "54215": "1e",
  "54520": "1e",
  "53910": "1e",
  "54855": "1e",
  "54813": "1e",
  "54810": "1e",
  "54721": "1e",
  "53801": "1e",
  "53003": "1e",
  "54515": "1e",
  "54459": "1e",
  "53928": "1e",
  "53951": "1e",
  "53913": "1e",
  "53105": "2e",
  "53705": "1e",
  "53599": "2e",
  "54403": "1e",
  "53047": "1e",
  "54408": "1e",
  "54729": "1e",
  "54448": "1e",
  "53511": "2e",
  "54857": "1e",
  "53546": "2e",
  "54207": "1e",
  "53063": "1e",
  "54413": "1e",
  "54937": "1e",
  "54304": "1e",
  "54115": "1e",
  "54932": "1e",
  "54974": "1e",
  "53214": "1e",
  "59715": "5",
  "59853": "5",
  "59324": "1w",
  "59917": "5",
  "59638": "5",
  "59837": "5",
  "59858": "5",
  "59105": "5",
  "59820": "5",
  "59404": "5",
  "59915": "5",
  "59480": "5",
  "59532": "5",
  "59472": "5",
  "59261": "1w",
  "59256": "1w",
  "59546": "5",
  "59863": "5",
  "59867": "5",
  "59441": "5",
  "59033": "5",
  "59039": "5",
  "59330": "1w",
  "59326": "1w",
  "59833": "5",
  "59353": "1w",
  "59301": "1w",
  "59484": "5",
  "59041": "5",
  "59462": "5",
  "59072": "5",
  "59058": "5",
  "59317": "5",
  "59077": "5",
  "59322": "1w",
  "59314": "5",
  "59312": "1w",
  "59316": "1w",
  "59545": "5",
  "59633": "5",
  "59732": "5",
  "59535": "5",
  "59015": "5",
  "59740": "5",
  "59026": "5",
  "59874": "5",
  "59721": "5",
  "59901": "5",
  "59918": "5",
  "59830": "5",
  "59804": "5",
  "59538": "5",
  "59925": "5",
  "59016": "5",
  "59758": "5",
  "59057": "5",
  "59231": "1w",
  "59420": "5",
  "59222": "1w",
  "59528": "5",
  "59525": "5",
  "59477": "5",
  "59311": "1w",
  "59935": "5",
  "59756": "5",
  "59218": "1w",
  "59219": "1w",
  "59242": "1w",
  "59008": "5",
  "59217": "1w",
  "59486": "5",
  "59274": "1w",
  "59854": "5",
  "59032": "5",
  "59529": "5",
  "59074": "5",
  "64748": "2w",
  "63640": "3w",
  "63867": "3w",
  "63028": "2w",
  "63350": "2w",
  "65459": "2w",
  "64780": "2w",
  "63555": "2w",
  "63839": "3e",
  "64724": "2w",
  "65764": "2w",
  "63770": "3w",
  "65079": "2w",
  "65770": "2w",
  "65078": "2w",
  "65604": "2w",
  "63732": "3w",
  "65708": "3w",
  "63531": "2w",
  "65101": "2w",
  "63015": "2w",
  "63755": "3w",
  "65443": "2w",
  "63766": "3w",
  "65409": "2w",
  "65638": "3w",
  "65233": "2w",
  "63041": "2w",
  "65231": "2w",
  "64079": "2w",
  "65264": "2w",
  "63107": "2w",
  "63034": "2w",
  "63110": "2w",
  "63128": "2w",
  "63102": "2e",
  "64156": "2w",
  "64155": "2w",
  "65686": "3w",
  "64127": "2w",
  "64108": "2w",
  "64035": "2w",
  "65753": "3w",
  "64463": "2w",
  "11742": "2e",
  "11715": "2e",
  "13020": "1e",
  "10115": "2e",
  "13321": "1e",
  "14098": "1e",
  "13162": "1e",
  "10311": "2e",
  "11451": "2e",
  "14545": "2e",
  "14135": "2e",
  "11203": "2e",
  "14477": "1e",
  "14785": "2e",
  "14425": "1e",
  "14548": "1e",
  "14475": "1e",
  "12063": "2e",
  "12866": "1e",
  "12134": "1e",
  "13675": "1e",
  "12850": "1e",
  "12065": "1e",
  "13674": "1e",
  "13611": "1e",
  "12496": "2e",
  "12853": "1e",
  "13317": "1e",
  "13602": "1e",
  "13628": "1e",
  "12884": "1e",
  "13643": "1e",
  "14479": "1e",
  "14712": "2e",
  "14836": "2e",
  "14471": "2e",
  "13318": "1e",
  "05070": "1e",
  "05738": "1e",
  "05739": "1e",
  "05156": "1e",
  "05346": "2e",
  "05201": "2e",
  "05355": "2e",
  "05342": "2e",
  "05151": "1e",
  "05142": "1e",
  "05037": "1e",
  "05769": "1e",
  "05053": "1e",
  "05855": "1e",
  "05847": "1e",
  "05463": "1e",
  "05474": "1e",
  "05446": "1e",
  "05903": "1e",
  "05841": "1e",
  "05464": "1e",
  "05476": "1e",
  "05491": "1e",
  "05086": "1e",
  "05677": "1e",
  "05660": "1e",
  "05850": "1e",
  "05653": "1e",
  "05742": "1e",
  "05161": "1e",
  "05701": "1e",
  "05073": "1e",
  "05250": "1e",
  "05765": "1e",
  "05777": "1e",
  "05759": "1e",
  "05091": "1e",
  "05035": "1e",
  "05148": "1e",
  "05260": "2e",
  "05146": "1e",
  "05760": "1e",
  "05067": "1e",
  "05829": "1e",
  "05858": "1e",
  "05483": "1e",
  "05403": "1e",
  "05459": "1e",
  "05487": "1e",
  "05827": "1e",
  "05439": "1e",
  "05825": "1e",
  "05481": "1e",
  "05663": "1e",
  "05670": "1e",
  "05038": "1e",
  "05456": "1e",
  "05040": "1e",
  "05866": "1e",
  "05733": "1e",
  "05748": "1e",
  "05640": "1e",
  "05061": "1e",
  "05775": "1e",
  "05758": "1e",
  "05150": "1e",
  "05088": "1e",
  "05048": "1e",
  "05345": "2e",
  "05101": "1e",
  "05356": "2e",
  "05089": "1e",
  "05362": "2e",
  "05255": "1e",
  "05359": "1e",
  "05141": "1e",
  "05254": "1e",
  "05477": "1e",
  "05904": "1e",
  "05826": "1e",
  "05405": "1e",
  "05494": "1e",
  "05669": "1e",
  "05077": "1e",
  "05472": "1e",
  "02048": "2e",
  "02771": "2e",
  "02767": "2e",
  "02725": "2e",
  "02779": "2e",
  "02322": "2e",
  "02346": "2e",
  "02332": "2e",
  "02359": "2e",
  "02325": "2e",
  "02534": "2e",
  "02115": "2e",
  "02675": "2e",
  "02637": "2e",
  "02563": "2e",
  "02446": "2e",
  "02652": "2e",
  "02646": "2e",
  "01354": "2e",
  "01373": "2e",
  "02155": "2e",
  "01341": "2e",
  "02130": "2e",
  "01350": "2e",
  "01983": "2e",
  "01606": "2e",
  "02748": "2e",
  "02777": "2e",
  "02721": "2e",
  "01104": "2e",
  "01103": "2e",
  "01368": "2e",
  "01151": "2e",
  "01106": "2e",
  "01550": "2e",
  "01247": "2e",
  "01095": "2e",
  "01008": "2e",
  "01013": "2e",
  "02338": "2e",
  "02653": "2e",
  "01029": "2e",
  "01504": "2e",
  "01027": "2e",
  "01038": "2e",
  "01062": "2e",
  "01915": "2e",
  "01944": "2e",
  "01844": "2e",
  "19022": "2e",
  "15014": "2e",
  "19153": "2e",
  "18623": "2e",
  "15116": "2e",
  "15237": "2e",
  "16740": "2e",
  "16731": "2e",
  "15071": "2e",
  "16724": "2e",
  "15235": "2e",
  "15239": "2e",
  "15137": "2e",
  "15110": "2e",
  "15228": "2e",
  "15083": "2e",
  "15066": "2e",
  "15010": "2e",
  "15052": "2e",
  "15205": "2e",
  "15216": "2e",
  "15027": "2e",
  "15077": "2e",
  "15053": "2e",
  "15427": "2e",
  "15613": "2e",
  "16353": "2e",
  "15641": "2e",
  "15432": "2e",
  "15666": "2e",
  "15672": "2e",
  "15639": "2e",
  "15637": "2e",
  "15661": "2e",
  "15691": "2e",
  "16335": "2e",
  "17017": "2e",
  "19031": "2e",
  "17864": "2e",
  "16362": "2e",
  "17304": "2e",
  "19355": "2e",
  "15920": "2e",
  "15705": "2e",
  "18460": "2e",
  "15720": "2e",
  "15754": "2e",
  "15349": "2e",
  "16402": "2e",
  "17837": "2e",
  "90292": "6",
  "91030": "6",
  "93638": "6",
  "95652": "7",
  "95662": "6",
  "93608": "7",
  "92093": "6",
  "92161": "6",
  "95624": "7",
  "95830": "7",
  "95655": "7",
  "92154": "6",
  "96120": "5",
  "91942": "6",
  "92342": "6",
  "95490": "7",
  "95626": "7",
  "92227": "6",
  "95585": "7",
  "95525": "7",
  "95488": "7",
  "92179": "6",
  "92338": "6",
  "92284": "6",
  "95514": "7",
  "93450": "7",
  "95565": "7",
  "95420": "7",
  "92386": "6",
  "95560": "7",
  "95553": "7",
  "96007": "7",
  "92283": "6",
  "95697": "7",
  "91914": "6",
  "96011": "7",
  "94103": "7",
  "94107": "7",
  "94117": "7",
  "94920": "7",
  "92081": "6",
  "92084": "6",
  "95658": "6",
  "92025": "6",
  "96145": "5",
  "92064": "6",
  "94131": "7",
  "91962": "6",
  "91917": "6",
  "95681": "6",
  "92562": "6",
  "95715": "6",
  "96141": "5",
  "94116": "7",
  "92688": "6",
  "95735": "5",
  "92705": "6",
  "92883": "6",
  "95961": "7",
  "95672": "6",
  "95636": "6",
  "95709": "6",
  "85749": "6",
  "85715": "6",
  "85723": "6",
  "85709": "6",
  "84531": "5",
  "85202": "6",
  "85249": "6",
  "85206": "6",
  "85283": "6",
  "85260": "6",
  "86510": "5",
  "85337": "6",
  "85213": "6",
  "84536": "5",
  "85128": "6",
  "85147": "6",
  "86043": "5",
  "85031": "6",
  "86502": "5",
  "86004": "5",
  "86507": "5",
  "80834": "2w",
  "81224": "5",
  "80721": "2w",
  "81403": "5",
  "80728": "2w",
  "81050": "2w",
  "80746": "2w",
  "81062": "5",
  "81130": "5",
  "81140": "5",
  "81154": "5",
  "81221": "5",
  "80754": "5",
  "80210": "5",
  "81003": "5",
  "81039": "5",
  "81025": "5",
  "81067": "5",
  "81084": "2w",
  "80294": "5",
  "80646": "5",
  "80503": "5",
  "80023": "5",
  "80134": "5",
  "80471": "5",
  "80303": "5",
  "80544": "5",
  "80025": "5",
  "81146": "5",
  "81303": "5",
  "81006": "5",
  "80601": "5",
  "80004": "5",
  "81611": "5",
  "81645": "5",
  "80615": "5",
  "80110": "5",
  "80227": "5",
  "81620": "5",
  "80216": "5",
  "81504": "5",
  "80930": "5",
  "80443": "5",
  "80459": "5",
  "80546": "5",
  "81020": "5",
  "80231": "5",
  "81524": "5",
  "80247": "5",
  "80105": "5",
  "80446": "5",
  "80133": "5",
  "80448": "5",
  "80232": "5",
  "80813": "5",
  "81624": "5",
  "81638": "5",
  "80403": "5",
  "81253": "5",
  "80833": "5",
  "80835": "5",
  "80266": "5",
  "80129": "5",
  "80455": "5",
  "80474": "5",
  "80438": "5",
  "80480": "5",
  "81652": "5",
  "81021": "2w",
  "81648": "5",
  "81334": "5",
  "83318": "5",
  "83546": "5",
  "83537": "5",
  "83634": "5",
  "83239": "5",
  "83433": "5",
  "83302": "5",
  "83425": "5",
  "83451": "5",
  "83465": "5",
  "83804": "5",
  "83869": "5",
  "83705": "5",
  "83643": "5",
  "83277": "5",
  "83809": "5",
  "83602": "5",
  "83637": "5",
  "83462": "5",
  "83827": "5",
  "83850": "5",
  "83466": "5",
  "37228": "3e",
  "37220": "3e",
  "37148": "3e",
  "37716": "3e",
  "37840": "3e",
  "37066": "3e",
  "37048": "3e",
  "37769": "3e",
  "38017": "3e",
  "38028": "3e",
  "38125": "3e",
  "37846": "3e",
  "37874": "3e",
  "37184": "3e",
  "38069": "3e",
  "37663": "3e",
  "38023": "3w",
  "37686": "3e",
  "38040": "3e",
  "37051": "3e",
  "37601": "3e",
  "37731": "3e",
  "37149": "3e",
  "37711": "3e",
  "37891": "3e",
  "38233": "3e",
  "37018": "3e",
  "38226": "3e",
  "38222": "3e",
  "37357": "3e",
  "37160": "3e",
  "38570": "3e",
  "37101": "3e",
  "37324": "3e",
  "37360": "3e",
  "38337": "3e",
  "38061": "3e",
  "37144": "3e",
  "38363": "3e",
  "38113": "3w",
  "38024": "3e",
  "38387": "3e",
  "38481": "3e",
  "38503": "3e",
  "38305": "3e",
  "37920": "3e",
  "38583": "3e",
  "38582": "3e",
  "37419": "3e",
  "38006": "3e",
  "38348": "3e",
  "37923": "3e",
  "38109": "3e",
  "37336": "3e",
  "38487": "3e",
  "37701": "3e",
  "37938": "3e",
  "37311": "3e",
  "37174": "3e",
  "37853": "3e",
  "37218": "3e",
  "38128": "3e",
  "37377": "3e",
  "37882": "3e",
  "37416": "3e",
  "37221": "3e",
  "37027": "3e",
  "37186": "3e",
  "37049": "3e",
  "37828": "3e",
  "38029": "3e",
  "37660": "3e",
  "37132": "3e",
  "37656": "3e",
  "37037": "3e",
  "37118": "3e",
  "37014": "3e",
  "37811": "3e",
  "38058": "3e",
  "37825": "3e",
  "37380": "3e",
  "37642": "3e",
  "38037": "3e",
  "37181": "3e",
  "37327": "3e",
  "37659": "3e",
  "37020": "3e",
  "37881": "3e",
  "38585": "3e",
  "38068": "3e",
  "37645": "3e",
  "37690": "3e",
  "37171": "3e",
  "37183": "3e",
  "38347": "3e",
  "38358": "3e",
  "38256": "3e",
  "38224": "3e",
  "38554": "3e",
  "37140": "3e",
  "37317": "4",
  "38008": "3e",
  "38079": "3e",
  "37398": "3e",
  "37047": "3e",
  "37306": "3e",
  "37334": "3e",
  "37032": "3e",
  "37172": "3e",
  "38318": "3e",
  "38468": "3e",
  "38486": "3e",
  "37879": "3e",
  "37381": "3e",
  "37738": "3e",
  "37860": "3e",
  "37042": "3e",
  "37814": "3e",
  "37040": "3e",
  "37725": "3e",
  "37079": "3e",
  "37050": "3e",
  "38549": "3e",
  "37359": "3e",
  "25801": "3e",
  "26101": "2e",
  "25918": "3e",
  "25851": "3e",
  "25818": "3e",
  "25817": "3e",
  "25152": "3e",
  "25185": "3e",
  "24844": "3e",
  "24882": "3e",
  "24857": "3e",
  "24822": "3e",
  "26743": "2e",
  "25913": "3e",
  "25248": "3e",
  "25015": "3e",
  "25054": "3e",
  "25003": "3e",
  "26164": "2e",
  "26562": "2e",
  "25126": "3e",
  "26285": "2e",
  "26234": "3e",
  "26338": "2e",
  "72683": "3w",
  "72666": "3w",
  "72648": "3w",
  "72040": "3w",
  "72410": "3w",
  "72482": "3w",
  "71742": "3w",
  "72471": "3w",
  "71766": "3w",
  "72057": "3w",
  "71855": "3w",
  "72412": "3w",
  "72169": "3w",
  "72074": "3w",
  "71720": "3w",
  "72044": "3w",
  "71677": "3w",
  "72353": "3w",
  "72377": "3w",
  "72123": "3w",
  "72630": "3w",
  "71740": "3w",
  "72422": "3w",
  "72430": "3w",
  "71630": "3w",
  "71973": "3w",
  "72512": "3w",
  "72396": "3w",
  "72464": "3w",
  "72823": "3w",
  "72453": "3w",
  "72928": "3w",
  "72108": "3w",
  "71651": "3w",
  "71635": "3w",
  "72832": "3w",
  "72565": "3w",
  "71922": "3w",
  "71961": "3w",
  "71667": "3w",
  "71957": "3w",
  "65729": "3w",
  "72449": "3w",
  "71602": "3w",
  "72315": "3e",
  "72079": "3w",
  "72142": "3w",
  "72730": "3w",
  "72749": "3w",
  "72744": "3w",
  "72769": "3w",
  "72947": "3w",
  "72722": "3w",
  "72714": "3w",
  "72715": "3w",
  "72301": "3w",
  "72102": "3w",
  "72856": "3w",
  "71726": "3w",
  "11106": "2e",
  "11101": "2e",
  "14881": "2e",
  "14216": "1e",
  "10583": "2e",
  "13073": "2e",
  "10279": "2e",
  "10803": "2e",
  "11231": "2e",
  "13102": "2e",
  "14611": "1e",
  "12801": "1e",
  "14617": "1e",
  "10459": "2e",
  "10605": "2e",
  "10986": "2e",
  "13039": "1e",
  "10512": "2e",
  "14816": "2e",
  "11596": "2e",
  "11762": "2e",
  "14061": "2e",
  "13167": "1e",
  "14413": "1e",
  "13352": "1e",
  "13313": "1e",
  "13455": "1e",
  "14752": "2e",
  "14822": "2e",
  "14422": "1e",
  "13160": "1e",
  "13026": "2e",
  "13691": "1e",
  "12859": "1e",
  "12831": "1e",
  "12025": "1e",
  "13606": "1e",
  "12196": "2e",
  "13626": "1e",
  "12188": "2e",
  "13651": "1e",
  "13619": "1e",
  "13612": "1e",
  "12845": "1e",
  "12082": "2e",
  "12414": "2e",
  "12442": "2e",
  "12451": "2e",
  "12176": "2e",
  "13665": "1e",
  "12492": "2e",
  "12454": "2e",
  "12910": "1e",
  "12992": "1e",
  "18223": "2e",
  "15446": "2e",
  "15463": "2e",
  "16833": "2e",
  "16858": "2e",
  "16871": "2e",
  "16845": "2e",
  "16834": "2e",
  "19520": "2e",
  "19475": "2e",
  "15865": "2e",
  "19372": "2e",
  "19010": "2e",
  "19041": "2e",
  "15207": "2e",
  "19330": "2e",
  "19061": "2e",
  "19081": "2e",
  "15065": "2e",
  "19060": "2e",
  "18615": "2e",
  "18446": "2e",
  "16701": "2e",
  "15215": "2e",
  "16733": "2e",
  "16743": "2e",
  "15223": "2e",
  "15321": "2e",
  "15145": "2e",
  "15133": "2e",
  "15045": "2e",
  "15085": "2e",
  "15106": "2e",
  "15136": "2e",
  "15088": "2e",
  "15311": "2e",
  "16120": "2e",
  "15217": "2e",
  "15366": "2e",
  "15376": "2e",
  "15479": "2e",
  "15062": "2e",
  "15012": "2e",
  "15660": "2e",
  "15624": "2e",
  "15902": "2e",
  "19601": "2e",
  "17046": "2e",
  "19103": "2e",
  "16507": "2e",
  "19605": "2e",
  "18248": "2e",
  "16502": "2e",
  "16508": "2e",
  "17003": "2e",
  "17038": "2e",
  "18104": "2e",
  "18037": "2e",
  "17960": "2e",
  "19142": "2e",
  "18051": "2e",
  "18064": "2e",
  "19131": "2e",
  "17952": "2e",
  "17933": "2e",
  "18106": "2e",
  "18092": "2e",
  "39346": "4",
  "39361": "4",
  "38864": "3e",
  "38646": "3e",
  "39743": "4",
  "38767": "3e",
  "39440": "4",
  "39657": "4",
  "39039": "4",
  "39120": "4",
  "38760": "3e",
  "39301": "4",
  "38776": "3e",
  "39056": "4",
  "39201": "4",
  "39736": "4",
  "39364": "4",
  "39042": "4",
  "39047": "4",
  "39057": "4",
  "39520": "4",
  "39146": "4",
  "39045": "4",
  "39079": "4",
  "39192": "4",
  "38917": "4",
  "38963": "3e",
  "38625": "3e",
  "39179": "4",
  "38961": "3e",
  "38824": "3e",
  "38610": "3e",
  "38746": "3e",
  "38833": "3e",
  "39078": "4",
  "38954": "4",
  "39662": "4",
  "39149": "4",
  "38723": "3w",
  "38650": "3e",
  "39194": "4",
  "39341": "4",
  "39577": "4",
  "39456": "4",
  "39114": "4",
  "39638": "4",
  "39062": "4",
  "39423": "4",
  "39159": "4",
  "39176": "4",
  "39428": "4",
  "38627": "3e",
  "39180": "4",
  "39759": "4",
  "38868": "4",
  "39479": "4",
  "39144": "4",
  "38701": "3w",
  "38722": "4",
  "39705": "4",
  "39571": "4",
  "39202": "4",
  "39217": "4",
  "39540": "4",
  "39573": "4",
  "39066": "4",
  "65010": "2w",
  "65801": "2w",
  "65810": "3w",
  "64835": "2w",
  "64443": "2w",
  "65612": "2w",
  "64137": "2w",
  "64055": "2w",
  "64136": "2w",
  "65620": "3w",
  "64165": "2w",
  "63855": "3w",
  "63386": "2w",
  "65715": "3w",
  "65807": "3w",
  "65240": "2w",
  "65255": "2w",
  "68438": "2w",
  "21523": "2e",
  "21230": "2e",
  "21226": "2e",
  "21217": "2e",
  "21215": "2e",
  "21850": "3e",
  "21782": "2e",
  "21814": "3e",
  "21875": "3e",
  "21120": "2e",
  "21161": "2e",
  "21220": "2e",
  "21001": "2e",
  "78330": "6",
  "78410": "6",
  "78414": "4",
  "79925": "6",
  "78336": "4",
  "79906": "6",
  "75247": "3w",
  "75503": "3w",
  "79938": "6",
  "79699": "6",
  "76710": "3w",
  "77954": "6",
  "75201": "3w",
  "78405": "4",
  "76263": "3w",
  "79413": "6",
  "75246": "3w",
  "75762": "3w",
  "78416": "4",
  "76955": "6",
  "75647": "3w",
  "75459": "3w",
  "78019": "6",
  "79776": "6",
  "78747": "6",
  "79853": "6",
  "79104": "2w",
  "78619": "6",
  "76373": "3w",
  "79544": "6",
  "76556": "6",
  "75833": "3w",
  "75755": "3w",
  "79373": "6",
  "75850": "3w",
  "77616": "4",
  "75471": "3w",
  "79241": "3w",
  "78341": "6",
  "78067": "6",
  "78547": "6",
  "76481": "3w",
  "76227": "3w",
  "75671": "3w",
  "75180": "3w",
  "79607": "6",
  "76828": "6",
  "79261": "3w",
  "79834": "6",
  "78843": "6",
  "75962": "3w",
  "75680": "3w",
  "78877": "6",
  "75488": "3w",
  "75447": "3w",
  "79032": "2w",
  "75689": "3w",
  "78644": "6",
  "78013": "6",
  "79073": "6",
  "79733": "6",
  "78871": "6",
  "75764": "3w",
  "77993": "6",
  "78643": "6",
  "77879": "6",
  "47361": "2e",
  "47263": "2e",
  "46502": "2e",
  "47326": "2e",
  "42167": "3e",
  "41180": "3e",
  "41522": "3e",
  "40004": "3e",
  "42275": "3e",
  "40962": "3e",
  "40322": "3e",
  "42156": "3e",
  "40977": "3e",
  "40444": "3e",
  "41855": "3e",
  "41832": "3e",
  "42050": "3e",
  "41804": "3e",
  "42459": "3e",
  "41002": "2e",
  "42330": "3e",
  "40387": "3e",
  "40146": "3e",
  "41837": "3e",
  "42234": "3e",
  "41034": "2e",
  "42236": "3e",
  "42728": "3e",
  "42337": "3e",
  "40050": "3e",
  "42266": "3e",
  "40906": "3e",
  "40943": "3e",
  "41835": "3e",
  "42566": "3e",
  "41043": "2e",
  "41834": "3e",
  "41839": "3e",
  "41712": "3e",
  "42202": "3e",
  "41367": "3e",
  "40759": "3e",
  "41267": "3e",
  "41824": "3e",
  "42729": "3e",
  "41534": "3e",
  "42332": "3e",
  "42120": "3e",
  "42354": "3e",
  "41166": "3e",
  "40826": "3e",
  "42280": "3e",
  "41660": "3e",
  "42453": "3e",
  "40819": "3e",
  "40117": "3e",
  "41751": "3e",
  "41310": "3e",
  "40981": "3e",
  "40807": "3e",
  "40820": "3e",
  "41464": "3e",
  "41729": "3e",
  "40818": "3e",
  "41754": "3e",
  "40964": "3e",
  "41723": "3e",
  "41763": "3e",
  "42061": "3e",
  "41571": "3e",
  "41554": "3e",
  "41538": "3e",
  "42444": "3e",
  "40434": "3e",
  "40350": "3e",
  "04619": "1e",
  "77031": "4",
  "77099": "4",
  "77364": "3w",
  "78023": "6",
  "77013": "4",
  "78256": "6",
  "77056": "4",
  "78676": "6",
  "77571": "4",
  "77005": "4",
  "77046": "4",
  "77047": "4",
  "77066": "4",
  "77038": "4",
  "77084": "4",
  "77545": "4",
  "77629": "4",
  "77561": "4",
  "77440": "4",
  "77432": "4",
  "79545": "6",
  "78943": "6",
  "78007": "6",
  "76953": "6",
  "79118": "2w",
  "78659": "6",
  "75641": "3w",
  "77990": "6",
  "76824": "6",
  "75563": "3w",
  "76950": "6",
  "79847": "6",
  "75929": "4",
  "79015": "2w",
  "79124": "2w",
  "78540": "4",
  "79601": "6",
  "75063": "3w",
  "75038": "3w",
  "76367": "3w",
  "75001": "3w",
  "75043": "3w",
  "76502": "6",
  "76366": "3w",
  "79091": "2w",
  "76548": "6",
  "76210": "3w",
  "78557": "4",
  "75460": "3w",
  "76903": "6",
  "78003": "6",
  "77802": "3w",
  "77803": "3w",
  "76661": "3w",
  "75601": "3w",
  "76524": "6",
  "78407": "4",
  "75436": "3w",
  "79901": "6",
  "78712": "6",
  "77968": "6",
  "76371": "3w",
  "76424": "6",
  "75433": "3w",
  "76935": "6",
  "79363": "6",
  "76652": "3w",
  "75846": "3w",
  "79330": "6",
  "75692": "3w",
  "79713": "6",
  "79036": "2w",
  "77467": "4",
  "79754": "6",
  "79345": "6",
  "78118": "6",
  "78839": "6",
  "75633": "3w",
  "76854": "6",
  "79093": "2w",
  "76384": "3w",
  "78353": "6",
  "78104": "6",
  "75784": "3w",
  "79339": "6",
  "75631": "3w",
  "79011": "2w",
  "26704": "2e",
  "26865": "2e",
  "26764": "2e",
  "25063": "3e",
  "26147": "2e",
  "26138": "2e",
  "26325": "2e",
  "26520": "2e",
  "26431": "2e",
  "25243": "3e",
  "26292": "2e",
  "26321": "2e",
  "26320": "2e",
  "26436": "2e",
  "26323": "2e",
  "26671": "3e",
  "26651": "3e",
  "25984": "3e",
  "26581": "2e",
  "26451": "2e",
  "26681": "3e",
  "24984": "3e",
  "25540": "3e",
  "24817": "3e",
  "24894": "3e",
  "24853": "3e",
  "25521": "3e",
  "25121": "3e",
  "26175": "2e",
  "25526": "3e",
  "25653": "3e",
  "25009": "3e",
  "25051": "3e",
  "25661": "3e",
  "25690": "3e",
  "25208": "3e",
  "25676": "3e",
  "25666": "3e",
  "25265": "2e",
  "26294": "3e",
  "26206": "3e",
  "26298": "3e",
  "26823": "2e",
  "25938": "3e",
  "25669": "3e",
  "25831": "3e",
  "25986": "3e",
  "71241": "3w",
  "70767": "4",
  "71407": "4",
  "70461": "4",
  "70392": "4",
  "70403": "4",
  "70774": "4",
  "70457": "4",
  "70776": "4",
  "70756": "4",
  "70757": "4",
  "70455": "4",
  "70442": "4",
  "70402": "4",
  "70773": "4",
  "71021": "3w",
  "70542": "4",
  "70585": "4",
  "71409": "4",
  "70818": "4",
  "71466": "4",
  "71272": "4",
  "70643": "4",
  "70577": "4",
  "71268": "4",
  "71104": "3w",
  "70339": "4",
  "70001": "4",
  "70633": "4",
  "48894": "1e",
  "49046": "2e",
  "49237": "2e",
  "49250": "2e",
  "49084": "2e",
  "49079": "2e",
  "48848": "1e",
  "49840": "1e",
  "49913": "1e",
  "49862": "1e",
  "49408": "2e",
  "48857": "1e",
  "48506": "1e",
  "49071": "2e",
  "48359": "2e",
  "48043": "2e",
  "48236": "2e",
  "48160": "2e",
  "48197": "2e",
  "48103": "2e",
  "48813": "2e",
  "49519": "1e",
  "49419": "2e",
  "48237": "2e",
  "49083": "2e",
  "49544": "1e",
  "49456": "1e",
  "49070": "2e",
  "48609": "1e",
  "48655": "1e",
  "48865": "1e",
  "49805": "1e",
  "49464": "2e",
  "49075": "2e",
  "49443": "1e",
  "48326": "2e",
  "48080": "2e",
  "48065": "1e",
  "74955": "3w",
  "73555": "3w",
  "74956": "3w",
  "74930": "3w",
  "74074": "3w",
  "74939": "3w",
  "73112": "3w",
  "73119": "3w",
  "73139": "3w",
  "74072": "2w",
  "74848": "3w",
  "74935": "3w",
  "74014": "3w",
  "73029": "3w",
  "74134": "3w",
  "74073": "3w",
  "74738": "3w",
  "73567": "3w",
  "74033": "3w",
  "73434": "3w",
  "73933": "2w",
  "73717": "2w",
  "08835": "2e",
  "07094": "2e",
  "07092": "2e",
  "07481": "2e",
  "07676": "2e",
  "07657": "2e",
  "07852": "2e",
  "07465": "2e",
  "07108": "2e",
  "08204": "2e",
  "07417": "2e",
  "08550": "2e",
  "08525": "2e",
  "07405": "2e",
  "07438": "2e",
  "98672": "5",
  "98552": "7",
  "99335": "5",
  "99371": "5",
  "99101": "5",
  "98626": "7",
  "99348": "5",
  "98329": "7",
  "98303": "7",
  "98590": "7",
  "99131": "5",
  "99017": "5",
  "98292": "5",
  "98802": "5",
  "99110": "5",
  "99116": "5",
  "98372": "5",
  "98502": "7",
  "98353": "7",
  "98047": "5",
  "98330": "5",
  "98560": "7",
  "99160": "5",
  "98236": "5",
  "98342": "7",
  "98421": "5",
  "98635": "5",
  "98617": "5",
  "98418": "7",
  "99004": "5",
  "98609": "7",
  "99136": "5",
  "99337": "5",
  "99036": "5",
  "99031": "5",
  "98589": "7",
  "98270": "5",
  "98272": "5",
  "98446": "7",
  "98014": "5",
  "98430": "7",
  "98043": "5",
  "98087": "5",
  "98070": "7",
  "98663": "7",
  "98946": "5",
  "98104": "5",
  "15545": "2e",
  "15559": "2e",
  "17057": "2e",
  "17321": "2e",
  "17349": "2e",
  "17361": "2e",
  "17368": "2e",
  "17407": "2e",
  "18504": "2e",
  "19057": "2e",
  "18509": "2e",
  "17853": "2e",
  "17049": "2e",
  "18519": "2e",
  "18923": "2e",
  "18921": "2e",
  "19454": "2e",
  "15717": "2e",
  "16025": "2e",
  "15655": "2e",
  "18435": "2e",
  "16950": "2e",
  "15633": "2e",
  "15684": "2e",
  "18851": "2e",
  "16201": "2e",
  "18810": "2e",
  "16647": "2e",
  "16683": "2e",
  "18336": "2e",
  "16921": "2e",
  "18455": "2e",
  "17212": "2e",
  "16238": "2e",
  "17228": "2e",
  "17255": "2e",
  "16667": "2e",
  "18326": "2e",
  "18437": "2e",
  "17253": "2e",
  "16634": "2e",
  "15533": "2e",
  "10172": "2e",
  "14043": "1e",
  "13029": "1e",
  "11706": "2e",
  "14864": "2e",
  "11703": "2e",
  "11722": "2e",
  "11741": "2e",
  "10523": "2e",
  "14871": "2e",
  "14905": "2e",
  "11516": "2e",
  "10021": "2e",
  "12533": "2e",
  "14224": "1e",
  "13416": "1e",
  "12780": "2e",
  "10974": "2e",
  "10594": "2e",
  "13787": "2e",
  "13803": "2e",
  "13904": "2e",
  "10998": "2e",
  "13863": "2e",
  "13841": "2e",
  "14219": "1e",
  "10526": "2e",
  "13748": "2e",
  "10968": "2e",
  "10597": "2e",
  "10162": "2e",
  "12205": "2e",
  "10926": "2e",
  "12110": "2e",
  "14468": "1e",
  "14170": "2e",
  "14004": "1e",
  "12211": "2e",
  "10928": "2e",
  "10023": "2e",
  "10471": "2e",
  "12056": "2e",
  "12137": "1e",
  "11370": "2e",
  "12008": "1e",
  "14487": "1e",
  "14470": "1e",
  "14747": "2e",
  "14728": "2e",
  "13143": "1e",
  "11235": "2e",
  "14726": "2e",
  "12564": "2e",
  "11224": "2e",
  "14469": "1e",
  "11237": "2e",
  "11209": "2e",
  "13138": "1e",
  "13413": "1e",
  "13903": "2e",
  "10473": "2e",
  "10011": "2e",
  "11421": "2e",
  "14212": "1e",
  "13905": "2e",
  "14904": "2e",
  "14215": "1e",
  "47552": "3e",
  "46952": "2e",
  "46617": "2e",
  "46544": "2e",
  "47885": "2e",
  "46721": "2e",
  "46730": "2e",
  "47805": "2e",
  "46012": "2e",
  "46514": "2e",
  "46803": "2e",
  "46936": "2e",
  "47909": "2e",
  "47710": "3e",
  "47468": "2e",
  "46561": "2e",
  "46237": "2e",
  "47022": "2e",
  "47115": "3e",
  "47114": "3e",
  "47244": "2e",
  "46064": "2e",
  "47974": "2e",
  "46635": "2e",
  "47869": "2e",
  "46154": "2e",
  "47831": "2e",
  "47986": "2e",
  "20851": "2e",
  "21776": "2e",
  "21252": "2e",
  "20623": "2e",
  "21798": "2e",
  "33607": "4",
  "32668": "4",
  "33634": "4",
  "32092": "4",
  "32656": "4",
  "33021": "4",
  "33009": "4",
  "32331": "4",
  "32713": "4",
  "34433": "4",
  "33314": "4",
  "32764": "4",
  "32094": "4",
  "34983": "4",
  "34453": "4",
  "32432": "4",
  "34946": "4",
  "32066": "4",
  "32425": "4",
  "33857": "4",
  "32060": "4",
  "32648": "4",
  "32683": "4",
  "33070": "4",
  "33548": "4",
  "33194": "4",
  "32068": "4",
  "32159": "4",
  "34731": "4",
  "33020": "4",
  "32130": "4",
  "33023": "4",
  "32055": "4",
  "33027": "4",
  "34465": "4",
  "32420": "4",
  "32754": "4",
  "32061": "4",
  "32190": "4",
  "32437": "4",
  "32426": "4",
  "34952": "4",
  "34450": "4",
  "34951": "4",
  "32348": "4",
  "32189": "4",
  "32112": "4",
  "32157": "4",
  "34452": "4",
  "32461": "4",
  "32053": "4",
  "27025": "3e",
  "27042": "3e",
  "27014": "3e",
  "28325": "3e",
  "28323": "3e",
  "27357": "3e",
  "28033": "3e",
  "28637": "3e",
  "74830": "3w",
  "74569": "3w",
  "74533": "3w",
  "73840": "2w",
  "74701": "3w",
  "73568": "3w",
  "73842": "2w",
  "73844": "2w",
  "73858": "2w",
  "73487": "3w",
  "73771": "2w",
  "73938": "2w",
  "73946": "2w",
  "73756": "2w",
  "73768": "2w",
  "73663": "2w",
  "73763": "2w",
  "73832": "2w",
  "73772": "2w",
  "73701": "2w",
  "73018": "3w",
  "74653": "2w",
  "73055": "3w",
  "74003": "2w",
  "73727": "2w",
  "73738": "2w",
  "74083": "2w",
  "74135": "3w",
  "74127": "3w",
  "73733": "2w",
  "73773": "2w",
  "73720": "2w",
  "73052": "3w",
  "73761": "2w",
  "73625": "2w",
  "84726": "5",
  "84045": "5",
  "84520": "5",
  "84542": "5",
  "84319": "5",
  "84532": "5",
  "84325": "5",
  "84735": "5",
  "84525": "5",
  "84764": "5",
  "84105": "5",
  "84761": "5",
  "84116": "5",
  "84760": "5",
  "84119": "5",
  "84124": "5",
  "84121": "5",
  "84772": "5",
  "84092": "5",
  "84075": "5",
  "84040": "5",
  "84405": "5",
  "84138": "5",
  "84779": "5",
  "84533": "5",
  "84021": "5",
  "84307": "5",
  "84017": "5",
  "84055": "5",
  "84631": "5",
  "84652": "5",
  "84642": "5",
  "84754": "5",
  "84513": "5",
  "84747": "5",
  "84749": "5",
  "84621": "5",
  "84008": "5",
  "84059": "5",
  "84333": "5",
  "84759": "5",
  "84626": "5",
  "84332": "5",
  "84540": "5",
  "84180": "5",
  "84731": "5",
  "84629": "5",
  "84093": "5",
  "84123": "5",
  "84757": "5",
  "84044": "5",
  "84741": "5",
  "84414": "5",
  "84783": "5",
  "84404": "5",
  "84337": "5",
  "84723": "5",
  "84331": "5",
  "84745": "5",
  "84334": "5",
  "84309": "5",
  "84002": "5",
  "84627": "5",
  "84521": "5",
  "84535": "5",
  "84667": "5",
  "84322": "5",
  "84736": "5",
  "84775": "5",
  "84601": "5",
  "84604": "5",
  "84043": "5",
  "84013": "5",
  "84104": "5",
  "84094": "5",
  "84006": "5",
  "84117": "5",
  "84009": "5",
  "84742": "5",
  "84128": "5",
  "84087": "5",
  "84729": "5",
  "84722": "5",
  "84781": "5",
  "84069": "5",
  "25201": "3e",
  "25067": "3e",
  "25134": "3e",
  "26143": "2e",
  "26278": "2e",
  "26218": "2e",
  "26447": "2e",
  "26362": "2e",
  "26337": "2e",
  "24846": "3e",
  "26804": "3e",
  "26886": "2e",
  "26855": "2e",
  "26270": "2e",
  "26268": "3e",
  "26335": "2e",
  "26627": "3e",
  "26430": "2e",
  "25560": "3e",
  "25118": "3e",
  "25840": "3e",
  "25186": "3e",
  "67672": "2w",
  "66940": "2w",
  "66102": "2w",
  "67648": "2w",
  "66769": "2w",
  "67751": "2w",
  "67752": "2w",
  "66868": "2w",
  "67491": "2w",
  "67501": "2w",
  "66517": "2w",
  "67223": "2w",
  "67135": "2w",
  "66061": "2w",
  "66103": "2w",
  "67213": "2w",
  "67149": "2w",
  "66087": "2w",
  "66542": "2w",
  "66509": "2w",
  "66422": "2w",
  "66094": "2w",
  "67050": "2w",
  "66833": "2w",
  "67002": "2w",
  "67301": "2w",
  "66226": "2w",
  "66111": "2w",
  "66216": "2w",
  "66520": "2w",
  "66213": "2w",
  "67576": "2w",
  "66951": "2w",
  "67446": "2w",
  "66538": "2w",
  "67464": "2w",
  "67732": "2w",
  "67740": "2w",
  "66772": "2w",
  "66771": "2w",
  "16878": "2e",
  "16651": "2e",
  "15767": "2e",
  "19316": "2e",
  "19390": "2e",
  "19362": "2e",
  "15824": "2e",
  "19063": "2e",
  "19008": "2e",
  "19026": "2e",
  "19312": "2e",
  "15101": "2e",
  "19070": "2e",
  "19015": "2e",
  "19014": "2e",
  "19052": "2e",
  "15006": "2e",
  "19036": "2e",
  "19032": "2e",
  "18414": "2e",
  "16738": "2e",
  "16732": "2e",
  "15086": "2e",
  "15031": "2e",
  "15229": "2e",
  "85297": "6",
  "85295": "6",
  "85043": "6",
  "85254": "6",
  "85251": "6",
  "85323": "6",
  "85383": "6",
  "85373": "6",
  "86039": "5",
  "85042": "6",
  "85045": "6",
  "86033": "5",
  "86504": "5",
  "86514": "5",
  "86545": "5",
  "86044": "5",
  "86047": "5",
  "85121": "6",
  "85929": "6",
  "86440": "6",
  "85208": "6",
  "85329": "6",
  "85304": "6",
  "86016": "5",
  "86432": "5",
  "86003": "5",
  "86426": "6",
  "86403": "6",
  "86040": "5",
  "86515": "5",
  "86444": "5",
  "86445": "5",
  "85365": "6",
  "86001": "5",
  "86332": "6",
  "85713": "6",
  "85931": "6",
  "85349": "6",
  "85356": "6",
  "85143": "6",
  "85613": "6",
  "85390": "6",
  "85357": "6",
  "85625": "6",
  "86324": "6",
  "86320": "5",
  "86335": "6",
  "85539": "6",
  "85392": "6",
  "85711": "6",
  "63824": "3w",
  "63055": "2w",
  "63784": "3w",
  "63774": "3w",
  "63874": "3w",
  "63745": "3w",
  "65017": "2w",
  "63435": "2w",
  "65305": "2w",
  "64064": "2w",
  "63473": "2w",
  "65243": "2w",
  "65441": "2w",
  "65644": "2w",
  "65793": "3w",
  "65051": "2w",
  "65744": "3w",
  "63965": "3w",
  "65536": "2w",
  "64020": "2w",
  "63862": "3w",
  "65463": "2w",
  "65283": "2w",
  "63463": "2w",
  "63628": "2w",
  "64437": "2w",
  "63440": "2w",
  "63448": "2w",
  "64761": "2w",
  "63851": "3w",
  "63841": "3w",
  "63556": "2w",
  "65661": "2w",
  "63545": "2w",
  "65334": "2w",
  "65606": "3w",
  "65473": "2w",
  "63833": "3w",
  "64648": "2w",
  "65682": "2w",
  "65601": "2w",
  "63543": "2w",
  "64468": "2w",
  "65340": "2w",
  "65724": "2w",
  "64476": "2w",
  "64433": "2w",
  "63853": "3e",
  "64428": "2w",
  "63546": "2w",
  "63901": "3w",
  "64642": "2w",
  "63834": "3w",
  "64424": "2w",
  "63377": "2w",
  "65675": "3w",
  "63955": "3w",
  "64772": "2w",
  "63954": "3w",
  "64633": "2w",
  "63869": "3w",
  "64451": "2w",
  "64622": "2w",
  "64668": "2w",
  "63532": "2w",
  "63437": "2w",
  "63014": "2w",
  "64701": "2w",
  "64161": "2w",
  "64098": "2w",
  "64439": "2w",
  "65789": "3w",
  "64076": "2w",
  "63137": "2w",
  "63038": "2w",
  "63129": "2w",
  "64866": "3w",
  "64157": "2w",
  "64129": "2w",
  "65714": "3w",
  "65742": "3w",
  "64080": "2w",
  "64747": "2w",
  "63147": "2w",
  "64739": "2w",
  "64670": "2w",
  "63088": "2w",
  "75237": "3w",
  "75567": "3w",
  "76537": "6",
  "79501": "6",
  "76372": "3w",
  "76364": "3w",
  "79839": "6",
  "75418": "3w",
  "78340": "4",
  "78830": "6",
  "77373": "4",
  "78006": "6",
  "77044": "4",
  "77073": "4",
  "78163": "6",
  "77034": "4",
  "77502": "4",
  "77042": "4",
  "77008": "4",
  "77092": "4",
  "77040": "4",
  "77064": "4",
  "77059": "4",
  "75939": "4",
  "77043": "4",
  "77086": "4",
  "77577": "4",
  "77369": "4",
  "77468": "4",
  "77555": "4",
  "76870": "6",
  "78162": "6",
  "76475": "3w",
  "78008": "6",
  "79546": "6",
  "79526": "6",
  "79066": "2w",
  "75783": "3w",
  "75839": "3w",
  "78602": "6",
  "73960": "2w",
  "76430": "6",
  "76834": "6",
  "79543": "6",
  "76567": "6",
  "76802": "6",
  "76577": "6",
  "79229": "6",
  "79056": "2w",
  "75067": "3w",
  "75019": "3w",
  "77376": "4",
  "78572": "4",
  "77374": "4",
  "79510": "6",
  "75452": "3w",
  "76360": "3w",
  "75006": "3w",
  "78628": "6",
  "76351": "3w",
  "79109": "2w",
  "75226": "3w",
  "79553": "6",
  "75211": "3w",
  "77611": "4",
  "79103": "2w",
  "75203": "3w",
  "77713": "4",
  "78056": "6",
  "78942": "6",
  "76706": "3w",
  "76273": "3w",
  "76701": "3w",
  "78063": "6",
  "77703": "4",
  "76253": "3w",
  "76685": "3w",
  "76632": "3w",
  "76705": "3w",
  "76691": "3w",
  "75434": "3w",
  "75968": "4",
  "76265": "3w",
  "77950": "4",
  "78591": "6",
  "76445": "6",
  "77473": "4",
  "75959": "4",
  "79234": "3w",
  "94587": "7",
  "95126": "7",
  "90602": "6",
  "95130": "7",
  "95035": "7",
  "92657": "6",
  "92704": "6",
  "92701": "6",
  "92697": "6",
  "92602": "6",
  "90249": "6",
  "94085": "7",
  "94128": "7",
  "90746": "6",
  "90505": "6",
  "94061": "7",
  "94403": "7",
  "94018": "7",
  "94401": "7",
  "93535": "6",
  "95625": "7",
  "95676": "7",
  "92683": "6",
  "92646": "6",
  "15693": "2e",
  "15679": "2e",
  "15625": "2e",
  "15087": "2e",
  "15695": "2e",
  "15347": "2e",
  "15616": "2e",
  "16503": "2e",
  "17976": "2e",
  "17949": "2e",
  "17042": "2e",
  "18102": "2e",
  "17931": "2e",
  "19102": "2e",
  "19147": "2e",
  "19141": "2e",
  "17936": "2e",
  "18018": "2e",
  "17943": "2e",
  "18078": "2e",
  "18069": "2e",
  "19138": "2e",
  "18067": "2e",
  "19132": "2e",
  "18042": "2e",
  "17961": "2e",
  "17110": "2e",
  "18250": "2e",
  "17771": "2e",
  "17220": "2e",
  "15282": "2e",
  "17744": "2e",
  "16116": "2e",
  "17251": "2e",
  "16127": "2e",
  "19122": "2e",
  "16051": "2e",
  "16844": "2e",
  "17222": "2e",
  "17022": "2e",
  "19565": "2e",
  "17846": "2e",
  "16155": "2e",
  "33446": "4",
  "30066": "4",
  "30060": "4",
  "30039": "4",
  "32327": "4",
  "33428": "4",
  "33496": "4",
  "36921": "4",
  "36915": "4",
  "36913": "4",
  "30228": "4",
  "30082": "4",
  "30513": "4",
  "30188": "4",
  "30090": "4",
  "34119": "4",
  "34116": "4",
  "33909": "4",
  "33982": "4",
  "32421": "4",
  "32564": "4",
  "33710": "4",
  "35083": "4",
  "35585": "4",
  "30439": "4",
  "39897": "4",
  "32811": "4",
  "31719": "4",
  "30642": "4",
  "32808": "4",
  "30033": "4",
  "30088": "4",
  "31036": "4",
  "30746": "4",
  "30102": "4",
  "31046": "4",
  "34287": "4",
  "34289": "4",
  "30346": "4",
  "36866": "4",
  "36075": "4",
  "30072": "4",
  "31047": "4",
  "36480": "4",
  "35959": "4",
  "36481": "4",
  "36801": "4",
  "35443": "4",
  "36558": "4",
  "36581": "4",
  "35968": "4",
  "36421": "4",
  "35981": "4",
  "35989": "4",
  "33437": "4",
  "30062": "4",
  "33991": "4",
  "33487": "4",
  "33621": "4",
  "33974": "4",
  "36908": "4",
  "35774": "3e",
  "30236": "4",
  "30143": "4",
  "34269": "4",
  "34104": "4",
  "33803": "4",
  "33196": "4",
  "33702": "4",
  "35053": "4",
  "35553": "4",
  "39813": "4",
  "30445": "4",
  "31021": "4",
  "32277": "4",
  "32250": "4",
  "39828": "4",
  "33896": "4",
  "33897": "4",
  "32807": "4",
  "32789": "4",
  "33844": "4",
  "39886": "4",
  "33837": "4",
  "94569": "7",
  "94708": "7",
  "94520": "7",
  "94530": "7",
  "94588": "7",
  "94705": "7",
  "94548": "7",
  "94560": "7",
  "94568": "7",
  "94555": "7",
  "94538": "7",
  "95119": "7",
  "92625": "6",
  "92201": "6",
  "92239": "6",
  "92663": "6",
  "92661": "6",
  "94014": "7",
  "90303": "6",
  "90822": "6",
  "94025": "7",
  "94021": "7",
  "93510": "6",
  "91350": "6",
  "93437": "7",
  "95993": "7",
  "95442": "7",
  "92655": "6",
  "92610": "6",
  "92868": "6",
  "94720": "7",
  "90502": "6",
  "94561": "7",
  "91203": "6",
  "94511": "7",
  "94536": "7",
  "94702": "7",
  "95148": "7",
  "92662": "6",
  "94949": "7",
  "92369": "6",
  "95613": "6",
  "94188": "7",
  "95073": "7",
  "91352": "6",
  "94901": "7",
  "92804": "6",
  "91326": "6",
  "94946": "7",
  "95019": "7",
  "94904": "7",
  "90037": "6",
  "93230": "6",
  "96134": "5",
  "95485": "7",
  "95971": "5",
  "93647": "6",
  "91731": "6",
  "90005": "6",
  "94577": "7",
  "95345": "6",
  "93110": "7",
  "96091": "7",
  "95325": "6",
  "90650": "6",
  "96093": "7",
  "93262": "6",
  "93237": "6",
  "94580": "7",
  "93644": "6",
  "95386": "6",
  "96006": "5",
  "95315": "7",
  "95685": "6",
  "93614": "6",
  "91801": "6",
  "95247": "6",
  "91708": "6",
  "96010": "7",
  "95601": "6",
  "94542": "7",
  "91103": "6",
  "95925": "6",
  "92624": "6",
  "96132": "5",
  "92551": "6",
  "92276": "6",
  "92258": "6",
  "92262": "6",
  "94589": "7",
  "95412": "7",
  "95430": "7",
  "95403": "7",
  "95401": "7",
  "90077": "6",
  "95480": "7",
  "94574": "7",
  "84058": "5",
  "84057": "5",
  "84328": "5",
  "84606": "5",
  "84005": "5",
  "84320": "5",
  "84501": "5",
  "84042": "5",
  "84022": "5",
  "84103": "5",
  "84115": "5",
  "84109": "5",
  "84633": "5",
  "84713": "5",
  "84150": "5",
  "84720": "5",
  "84095": "5",
  "84088": "5",
  "84065": "5",
  "84084": "5",
  "84120": "5",
  "84118": "5",
  "84755": "5",
  "84310": "5",
  "84770": "5",
  "84302": "5",
  "84031": "5",
  "84028": "5",
  "84313": "5",
  "84018": "5",
  "84643": "5",
  "84528": "5",
  "84739": "5",
  "84766": "5",
  "84530": "5",
  "84734": "5",
  "84715": "5",
  "84341": "5",
  "84529": "5",
  "84539": "5",
  "84762": "5",
  "84037": "5",
  "84515": "5",
  "84304": "5",
  "84718": "5",
  "84776": "5",
  "84004": "5",
  "84752": "5",
  "84025": "5",
  "84014": "5",
  "84041": "5",
  "84315": "5",
  "84056": "5",
  "84758": "5",
  "84403": "5",
  "84767": "5",
  "84080": "5",
  "84738": "5",
  "84038": "5",
  "84750": "5",
  "84073": "5",
  "84511": "5",
  "84746": "5",
  "84644": "5",
  "84635": "5",
  "84636": "5",
  "84647": "5",
  "84622": "5",
  "84632": "5",
  "84623": "5",
  "84339": "5",
  "84305": "5",
  "84062": "5",
  "84660": "5",
  "84326": "5",
  "84664": "5",
  "84015": "5",
  "84327": "5",
  "84112": "5",
  "84655": "5",
  "84645": "5",
  "84714": "5",
  "84751": "5",
  "84639": "5",
  "84081": "5",
  "84107": "5",
  "84047": "5",
  "84710": "5",
  "84067": "5",
  "84076": "5",
  "84053": "5",
  "84066": "5",
  "84052": "5",
  "84032": "5",
  "84740": "5",
  "84027": "5",
  "84744": "5",
  "84329": "5",
  "84033": "5",
  "84007": "5",
  "84024": "5",
  "84314": "5",
  "84534": "5",
  "84301": "5",
  "84665": "5",
  "84730": "5",
  "60604": "2e",
  "62254": "2e",
  "62269": "2e",
  "62232": "2e",
  "62206": "2e",
  "60025": "2e",
  "60056": "2e",
  "60016": "2e",
  "60004": "2e",
  "60089": "2e",
  "60074": "2e",
  "60022": "2e",
  "60202": "2e",
  "60169": "2e",
  "60712": "2e",
  "60482": "2e",
  "60406": "2e",
  "60203": "2e",
  "60464": "2e",
  "60162": "2e",
  "60525": "2e",
  "60526": "2e",
  "60188": "2e",
  "60542": "2e",
  "60124": "2e",
  "60564": "2e",
  "60060": "2e",
  "60030": "2e",
  "60081": "2e",
  "60040": "2e",
  "60432": "2e",
  "60503": "2e",
  "62644": "2e",
  "62401": "2e",
  "62426": "2e",
  "62418": "2e",
  "60948": "2e",
  "62471": "2e",
  "62017": "2e",
  "62431": "2e",
  "62036": "2w",
  "61335": "2e",
  "62868": "2e",
  "62446": "2e",
  "61432": "2e",
  "61919": "2e",
  "61751": "2e",
  "62330": "2e",
  "62321": "2e",
  "62538": "2e",
  "62049": "2e",
  "61524": "2e",
  "62354": "2e",
  "62541": "2e",
  "62380": "2e",
  "61519": "2e",
  "62818": "2e",
  "62655": "2e",
  "61567": "2e",
  "60931": "2e",
  "62214": "2e",
  "62076": "2e",
  "62463": "2e",
  "61078": "2e",
  "62568": "2e",
  "62531": "2e",
  "62827": "3e",
  "62862": "2e",
  "62567": "2e",
  "61764": "2e",
  "61741": "2e",
  "61007": "2e",
  "61006": "2e",
  "61329": "2e",
  "60551": "2e",
  "61360": "2e",
  "62622": "2e",
  "61317": "2e",
  "60557": "2e",
  "61777": "2e",
  "62434": "2e",
  "61750": "2e",
  "57331": "1w",
  "57706": "1w",
  "51023": "1w",
  "57068": "1w",
  "57718": "1w",
  "57787": "1w",
  "57580": "1w",
  "57273": "1w",
  "57314": "1w",
  "57256": "1w",
  "57794": "2w",
  "57341": "1w",
  "57313": "1w",
  "57559": "1w",
  "57577": "2w",
  "57659": "1w",
  "57323": "1w",
  "57026": "1w",
  "57467": "1w",
  "56136": "1w",
  "57268": "1w",
  "57057": "1w",
  "57537": "1w",
  "57016": "1w",
  "57058": "1w",
  "57328": "1w",
  "57354": "1w",
  "57344": "1w",
  "57364": "1w",
  "57649": "1w",
  "57335": "2w",
  "57067": "1w",
  "57536": "1w",
  "57620": "1w",
  "57534": "1w",
  "57239": "1w",
  "57422": "1w",
  "57237": "1w",
  "57236": "1w",
  "57225": "1w",
  "57386": "1w",
  "57218": "1w",
  "57241": "1w",
  "57584": "1w",
  "57773": "5",
  "57738": "5",
  "57457": "1w",
  "57106": "1w",
  "57105": "1w",
  "57363": "1w",
  "57461": "1w",
  "57475": "1w",
  "57348": "1w",
  "57476": "1w",
  "57035": "1w",
  "57219": "1w",
  "57004": "1w",
  "57703": "1w",
  "57201": "1w",
  "57334": "1w",
  "82701": "5",
  "57049": "2w",
  "57788": "1w",
  "57748": "1w",
  "57533": "1w",
  "57716": "2w",
  "57764": "5",
  "57658": "1w",
  "57329": "1w",
  "57544": "1w",
  "57552": "1w",
  "57315": "1w",
  "57543": "1w",
  "57574": "2w",
  "57381": "1w",
  "57231": "1w",
  "57353": "1w",
  "57220": "1w",
  "57061": "1w",
  "57376": "1w",
  "57052": "1w",
  "57059": "1w",
  "57317": "1w",
  "57529": "1w",
  "57779": "1w",
  "57651": "1w",
  "57776": "1w",
  "57755": "1w",
  "57040": "1w",
  "57031": "1w",
  "57520": "1w",
  "57382": "1w",
  "57043": "1w",
  "57479": "1w",
  "57247": "1w",
  "57439": "1w",
  "57421": "1w",
  "57264": "1w",
  "57217": "1w",
  "57368": "1w",
  "57365": "1w",
  "57346": "1w",
  "57632": "1w",
  "57456": "1w",
  "57646": "1w",
  "57448": "1w",
  "57047": "1w",
  "64112": "2w",
  "64647": "2w",
  "63654": "3w",
  "63665": "3w",
  "65355": "2w",
  "63664": "2w",
  "63330": "2w",
  "63622": "2w",
  "65732": "2w",
  "65329": "2w",
  "63620": "3w",
  "63848": "3w",
  "64689": "2w",
  "63541": "2w",
  "65618": "3w",
  "64625": "2w",
  "65666": "3w",
  "64458": "2w",
  "65768": "3w",
  "63453": "2w",
  "65230": "2w",
  "65324": "2w",
  "64656": "2w",
  "65555": "3w",
  "65541": "2w",
  "64153": "2w",
  "64628": "2w",
  "63056": "2w",
  "63090": "2w",
  "65632": "2w",
  "65058": "2w",
  "63636": "3w",
  "64688": "2w",
  "65259": "2w",
  "63025": "2w",
  "64040": "2w",
  "64672": "2w",
  "64655": "2w",
  "65274": "2w",
  "63539": "2w",
  "63401": "2w",
  "65254": "2w",
  "64475": "2w",
  "63438": "2w",
  "64093": "2w",
  "63381": "2w",
  "65767": "2w",
  "63877": "3e",
  "63936": "3w",
  "64641": "2w",
  "64434": "2w",
  "65556": "2w",
  "65774": "2w",
  "63870": "3w",
  "63070": "2w",
  "63742": "3w",
  "63866": "3w",
  "63010": "2w",
  "63763": "3w",
  "63964": "3w",
  "63077": "2w",
  "65622": "2w",
  "65350": "2w",
  "64658": "2w",
  "65035": "2w",
  "64651": "2w",
  "65680": "3w",
  "65345": "2w",
  "65717": "3w",
  "06492": "2e",
  "06751": "2e",
  "06424": "2e",
  "06460": "2e",
  "06405": "2e",
  "06029": "2e",
  "06063": "2e",
  "06488": "2e",
  "06001": "2e",
  "06032": "2e",
  "33138": "4",
  "34233": "4",
  "36568": "4",
  "36502": "4",
  "35475": "4",
  "35406": "4",
  "36047": "4",
  "31569": "4",
  "31632": "4",
  "30342": "4",
  "31201": "4",
  "31562": "4",
  "30529": "4",
  "30731": "4",
  "30258": "4",
  "30257": "4",
  "30724": "4",
  "30338": "4",
  "30285": "4",
  "30092": "4",
  "31796": "4",
  "30823": "4",
  "30178": "4",
  "34481": "4",
  "36567": "4",
  "35490": "4",
  "35173": "4",
  "35759": "3e",
  "35773": "3e",
  "35776": "4",
  "35972": "4",
  "35404": "4",
  "36009": "4",
  "36467": "4",
  "35006": "4",
  "31323": "4",
  "30565": "4",
  "30291": "4",
  "30268": "4",
  "35150": "4",
  "35760": "4",
  "35126": "4",
  "36580": "4",
  "35469": "4",
  "32694": "4",
  "34242": "4",
  "34231": "4",
  "30607": "4",
  "31408": "4",
  "33931": "4",
  "32508": "4",
  "34285": "4",
  "32507": "4",
  "30815": "4",
  "31791": "4",
  "31211": "4",
  "32534": "4",
  "35091": "4",
  "36542": "4",
  "36564": "4",
  "36067": "4",
  "35504": "4",
  "35501": "4",
  "35614": "3e",
  "35594": "4",
  "35226": "4",
  "35549": "4",
  "35586": "4",
  "36303": "4",
  "33463": "4",
  "30812": "4",
  "36051": "4",
  "35616": "3e",
  "35242": "4",
  "36080": "4",
  "35576": "4",
  "35592": "4",
  "35114": "4",
  "35118": "4",
  "36728": "4",
  "36020": "4",
  "36726": "4",
  "36832": "4",
  "36830": "4",
  "36321": "4",
  "35054": "4",
  "36741": "4",
  "35052": "4",
  "32254": "4",
  "31020": "4",
  "32533": "4",
  "19137": "2e",
  "16877": "2e",
  "16630": "2e",
  "17501": "2e",
  "15955": "2e",
  "16699": "2e",
  "17266": "2e",
  "19129": "2e",
  "18040": "2e",
  "17572": "2e",
  "19504": "2e",
  "15924": "2e",
  "15557": "2e",
  "15551": "2e",
  "17372": "2e",
  "18230": "2e",
  "18030": "2e",
  "15502": "2e",
  "15565": "2e",
  "17318": "2e",
  "15562": "2e",
  "17327": "2e",
  "17352": "2e",
  "17322": "2e",
  "17366": "2e",
  "18073": "2e",
  "18955": "2e",
  "18964": "2e",
  "18503": "2e",
  "15224": "2e",
  "18901": "2e",
  "17035": "2e",
  "18917": "2e",
  "17058": "2e",
  "15923": "2e",
  "15677": "2e",
  "15615": "2e",
  "15634": "2e",
  "16053": "2e",
  "15675": "2e",
  "15619": "2e",
  "16035": "2e",
  "16030": "2e",
  "16028": "2e",
  "15626": "2e",
  "15681": "2e",
  "15646": "2e",
  "16222": "2e",
  "16652": "2e",
  "16932": "2e",
  "16939": "2e",
  "16024": "2e",
  "76542": "6",
  "75409": "3w",
  "75024": "3w",
  "75424": "3w",
  "75002": "3w",
  "78737": "6",
  "78739": "6",
  "75189": "3w",
  "78615": "6",
  "78752": "6",
  "75114": "3w",
  "78634": "6",
  "78645": "6",
  "76107": "3w",
  "78641": "6",
  "76065": "3w",
  "75152": "3w",
  "77002": "4",
  "76135": "3w",
  "76112": "3w",
  "76126": "3w",
  "75089": "3w",
  "76118": "3w",
  "75142": "3w",
  "75147": "3w",
  "76123": "3w",
  "75146": "3w",
  "76002": "3w",
  "78205": "6",
  "76180": "3w",
  "75233": "3w",
  "78521": "4",
  "78575": "4",
  "79605": "6",
  "78592": "4",
  "77072": "4",
  "77435": "6",
  "77423": "4",
  "77583": "4",
  "77420": "4",
  "77464": "4",
  "77493": "4",
  "77301": "4",
  "77386": "4",
  "77379": "4",
  "76660": "3w",
  "78949": "6",
  "77429": "4",
  "77303": "4",
  "77433": "4",
  "77480": "4",
  "77340": "3w",
  "79086": "2w",
  "75482": "3w",
  "78944": "6",
  "75954": "3w",
  "76458": "3w",
  "76470": "6",
  "75789": "3w",
  "79043": "2w",
  "77470": "6",
  "77962": "6",
  "75639": "3w",
  "79731": "6",
  "76550": "6",
  "77448": "4",
  "78332": "6",
  "78606": "6",
  "79082": "6",
  "79088": "2w",
  "76442": "6",
  "77865": "3w",
  "76432": "6",
  "76401": "6",
  "79035": "2w",
  "78584": "6",
  "79022": "2w",
  "79081": "2w",
  "78057": "6",
  "79347": "6",
  "75686": "3w",
  "16849": "2e",
  "16876": "2e",
  "16879": "2e",
  "19310": "2e",
  "19460": "2e",
  "15227": "2e",
  "15090": "2e",
  "19465": "2e",
  "19335": "2e",
  "16059": "2e",
  "19094": "2e",
  "18612": "2e",
  "18629": "2e",
  "16735": "2e",
  "15026": "2e",
  "16727": "2e",
  "16748": "2e",
  "16750": "2e",
  "16333": "2e",
  "15082": "2e",
  "15102": "2e",
  "15221": "2e",
  "15047": "2e",
  "15206": "2e",
  "15001": "2e",
  "15301": "2e",
  "15225": "2e",
  "15367": "2e",
  "15434": "2e",
  "15423": "2e",
  "15213": "2e",
  "15358": "2e",
  "15317": "2e",
  "16321": "2e",
  "15219": "2e",
  "16229": "2e",
  "15211": "2e",
  "15483": "2e",
  "15004": "2e",
  "15060": "2e",
  "15378": "2e",
  "15650": "2e",
  "15670": "2e",
  "15611": "2e",
  "15688": "2e",
  "15492": "2e",
  "15781": "2e",
  "17051": "2e",
  "18443": "2e",
  "17267": "2e",
  "17238": "2e",
  "15777": "2e",
  "15686": "2e",
  "17213": "2e",
  "16672": "2e",
  "17075": "2e",
  "16246": "2e",
  "16365": "2e",
  "15750": "2e",
  "18454": "2e",
  "17768": "2e",
  "15949": "2e",
  "15327": "2e",
  "15310": "2e",
  "16230": "2e",
  "16232": "2e",
  "17024": "2e",
  "16124": "2e",
  "16146": "2e",
  "19135": "2e",
  "18603": "2e",
  "18256": "2e",
  "17866": "2e",
  "16319": "2e",
  "18621": "2e",
  "16360": "2e",
  "18433": "2e",
  "17850": "2e",
  "18407": "2e",
  "16364": "2e",
  "18353": "2e",
  "18334": "2e",
  "16406": "2e",
  "18342": "2e",
  "18947": "2e",
  "15461": "2e",
  "18707": "2e",
  "16657": "2e",
  "16901": "2e",
  "18340": "2e",
  "15868": "2e",
  "16228": "2e",
  "15763": "2e",
  "18453": "2e",
  "18465": "2e",
  "17731": "2e",
  "15734": "2e",
  "18616": "2e",
  "15733": "2e",
  "16212": "2e",
  "18472": "2e",
  "17009": "2e",
  "15535": "2e",
  "16689": "2e",
  "16345": "2e",
  "18463": "2e",
  "17099": "2e",
  "16691": "2e",
  "15357": "2e",
  "15783": "2e",
  "11362": "2e",
  "11721": "2e",
  "11901": "2e",
  "11719": "2e",
  "11720": "2e",
  "11970": "2e",
  "06390": "2e",
  "11948": "2e",
  "16343": "2e",
  "18323": "2e",
  "19352": "2e",
  "18517": "2e",
  "18518": "2e",
  "15478": "2e",
  "18074": "2e",
  "18826": "2e",
  "16121": "2e",
  "16148": "2e",
  "16154": "2e",
  "17858": "2e",
  "19380": "2e",
  "19341": "2e",
  "15490": "2e",
  "18954": "2e",
  "16848": "2e",
  "19477": "2e",
  "17884": "2e",
  "17779": "2e",
  "15476": "2e",
  "15761": "2e",
  "15325": "2e",
  "18466": "2e",
  "15746": "2e",
  "15741": "2e",
  "15341": "2e",
  "15352": "2e",
  "16371": "2e",
  "16329": "2e",
  "15364": "2e",
  "15316": "2e",
  "16248": "2e",
  "19446": "2e",
  "19044": "2e",
  "17037": "2e",
  "19035": "2e",
  "19422": "2e",
  "17851": "2e",
  "17777": "2e",
  "17830": "2e",
  "19012": "2e",
  "16433": "2e",
  "17832": "2e",
  "17778": "2e",
  "18360": "2e",
  "18610": "2e",
  "18332": "2e",
  "18350": "2e",
  "18938": "2e",
  "19009": "2e",
  "18915": "2e",
  "15454": "2e",
  "20418": "2e",
  "20003": "2e",
  "20002": "2e",
  "20012": "2e",
  "20510": "2e",
  "20230": "2e",
  "20427": "2e",
  "20390": "2e",
  "20011": "2e",
  "20220": "2e",
  "20540": "2e",
  "20057": "2e",
  "20045": "2e",
  "20001": "2e",
  "20024": "2e",
  "20431": "2e",
  "36313": "4",
  "36344": "4",
  "36583": "4",
  "35974": "4",
  "36454": "4",
  "36262": "4",
  "36269": "4",
  "34108": "4",
  "30757": "4",
  "36451": "4",
  "36030": "4",
  "31029": "4",
  "30175": "4",
  "30043": "4",
  "30067": "4",
  "31307": "4",
  "33801": "4",
  "33647": "4",
  "32424": "4",
  "32355": "4",
  "35055": "4",
  "35057": "4",
  "35058": "4",
  "36732": "4",
  "35593": "4",
  "31784": "4",
  "31305": "4",
  "39859": "4",
  "31045": "4",
  "32822": "4",
  "39836": "4",
  "30229": "4",
  "34137": "4",
  "32709": "4",
  "31821": "4",
  "31780": "4",
  "31771": "4",
  "31039": "4",
  "31814": "4",
  "31089": "4",
  "31019": "4",
  "30665": "4",
  "33855": "4",
  "36526": "4",
  "36532": "4",
  "35453": "4",
  "36527": "4",
  "35229": "4",
  "36530": "4",
  "36453": "4",
  "35757": "3e",
  "35739": "3e",
  "35480": "4",
  "33417": "4",
  "30214": "4",
  "31207": "4",
  "31410": "4",
  "31636": "4",
  "30009": "4",
  "35036": "4",
  "36922": "4",
  "35824": "3e",
  "35645": "3e",
  "35487": "4",
  "35652": "3e",
  "36511": "4",
  "35611": "3e",
  "35660": "3e",
  "35610": "3e",
  "36374": "4",
  "35554": "4",
  "35559": "4",
  "35563": "4",
  "38107": "3w",
  "38564": "3e",
  "38356": "3e",
  "37409": "4",
  "38105": "3w",
  "38104": "3w",
  "38106": "3w",
  "38482": "3e",
  "38114": "3w",
  "38401": "3e",
  "38118": "3e",
  "37803": "3e",
  "37338": "3e",
  "37310": "3e",
  "37201": "3e",
  "38053": "3w",
  "37710": "3e",
  "38134": "3e",
  "38018": "3e",
  "37238": "3e",
  "37771": "3e",
  "38139": "3e",
  "37128": "3e",
  "37060": "3e",
  "37130": "3e",
  "37848": "3e",
  "37012": "3e",
  "38063": "3e",
  "37870": "3e",
  "37396": "4",
  "38253": "3e",
  "37826": "3e",
  "37322": "3e",
  "38257": "3e",
  "38255": "3e",
  "38229": "3e",
  "38316": "3e",
  "37026": "3e",
  "38067": "3e",
  "38374": "3e",
  "37137": "3e",
  "38342": "3e",
  "38050": "3e",
  "37688": "3e",
  "37352": "3e",
  "38572": "3e",
  "37332": "3e",
  "37862": "3e",
  "37658": "3e",
  "38449": "3e",
  "37329": "3e",
  "38587": "3e",
  "37760": "3e",
  "38473": "3e",
  "38459": "3e",
  "37719": "3e",
  "37335": "3e",
  "38328": "3e",
  "38560": "3e",
  "38070": "3e",
  "37921": "3e",
  "38122": "3e",
  "37402": "3e",
  "37918": "3e",
  "37407": "4",
  "37412": "4",
  "37932": "3e",
  "37341": "3e",
  "37849": "3e",
  "37754": "3e",
  "37806": "3e",
  "55402": "1w",
  "56680": "1w",
  "56592": "1w",
  "56117": "1w",
  "56742": "1w",
  "56010": "1w",
  "56145": "1w",
  "55738": "1w",
  "55703": "1w",
  "56379": "1w",
  "55150": "1w",
  "56475": "1w",
  "56283": "1w",
  "56328": "1w",
  "56255": "1w",
  "56181": "1w",
  "55763": "1w",
  "56374": "1w",
  "55445": "1w",
  "55977": "1w",
  "55904": "1w",
  "55909": "1w",
  "56218": "1w",
  "55918": "1w",
  "50173": "2w",
  "51553": "2w",
  "50014": "2w",
  "52727": "2w",
  "50842": "2w",
  "50062": "2w",
  "50453": "1w",
  "52054": "2w",
  "12172": "2e",
  "13135": "1e",
  "13132": "1e",
  "14489": "1e",
  "14513": "1e",
  "13827": "2e",
  "14094": "1e",
  "13492": "1e",
  "13409": "1e",
  "13037": "1e",
  "11418": "2e",
  "13030": "1e",
  "14516": "1e",
  "13478": "1e",
  "14414": "1e",
  "11372": "2e",
  "10303": "2e",
  "13495": "1e",
  "10039": "2e",
  "14589": "1e",
  "13076": "1e",
  "11219": "2e",
  "13219": "1e",
  "14209": "1e",
  "13051": "1e",
  "14055": "2e",
  "12302": "1e",
  "14437": "2e",
  "13021": "1e",
  "10458": "2e",
  "14710": "2e",
  "14775": "2e",
  "13072": "2e",
  "12185": "1e",
  "11375": "2e",
  "12182": "2e",
  "13408": "1e",
  "14462": "2e",
  "12094": "1e",
  "14723": "2e",
  "13485": "2e",
  "14722": "2e",
  "11211": "2e",
  "13424": "1e",
  "12516": "2e",
  "31315": "4",
  "31645": "4",
  "30530": "4",
  "31820": "4",
  "32405": "4",
  "33462": "4",
  "33603": "4",
  "30179": "4",
  "30817": "4",
  "30664": "4",
  "31829": "4",
  "31316": "4",
  "30708": "4",
  "36330": "4",
  "36559": "4",
  "35044": "4",
  "36477": "4",
  "35466": "4",
  "35463": "4",
  "36360": "4",
  "30213": "4",
  "31535": "4",
  "31601": "4",
  "34956": "4",
  "33438": "4",
  "32658": "4",
  "34217": "4",
  "31763": "4",
  "34292": "4",
  "30076": "4",
  "30022": "4",
  "35116": "4",
  "35073": "4",
  "36561": "4",
  "35071": "4",
  "36549": "4",
  "35677": "3e",
  "35151": "4",
  "35079": "4",
  "35661": "3e",
  "35584": "4",
  "36066": "4",
  "35620": "3e",
  "36362": "4",
  "36310": "4",
  "36352": "4",
  "36022": "4",
  "35976": "4",
  "35043": "4",
  "35186": "4",
  "36003": "4",
  "35010": "4",
  "35007": "4",
  "35080": "4",
  "36375": "4",
  "35120": "4",
  "36769": "4",
  "31016": "4",
  "30296": "4",
  "32311": "4",
  "34251": "4",
  "32616": "4",
  "31309": "4",
  "30646": "4",
  "32210": "4",
  "31217": "4",
  "31411": "4",
  "31328": "4",
  "35117": "4",
  "36925": "4",
  "35063": "4",
  "35148": "4",
  "35648": "3e",
  "36350": "4",
  "35672": "3e",
  "35570": "4",
  "35574": "4",
  "35244": "4",
  "35654": "3e",
  "31213": "4",
  "34202": "4",
  "34212": "4",
  "30622": "4",
  "35649": "4",
  "35587": "4",
  "35147": "4",
  "36758": "4",
  "35615": "3e",
  "36305": "4",
  "35980": "4",
  "35461": "4",
  "35131": "4",
  "36852": "4",
  "36854": "4",
  "36870": "4",
  "36776": "4",
  "30005": "4",
  "31066": "4",
  "41725": "3e",
  "41535": "3e",
  "40346": "3e",
  "41714": "3e",
  "41548": "3e",
  "46385": "2e",
  "47838": "2e",
  "46301": "2e",
  "47129": "3e",
  "46550": "2e",
  "47989": "2e",
  "46030": "2e",
  "46034": "2e",
  "47117": "3e",
  "46992": "2e",
  "47142": "3e",
  "46946": "2e",
  "47110": "3e",
  "46057": "2e",
  "46049": "2e",
  "47520": "3e",
  "46570": "2e",
  "46911": "2e",
  "46793": "2e",
  "46320": "2e",
  "47807": "2e",
  "46808": "2e",
  "47203": "2e",
  "46933": "2e",
  "46938": "2e",
  "46536": "2e",
  "47713": "3e",
  "46615": "2e",
  "46613": "2e",
  "46809": "2e",
  "46748": "2e",
  "46816": "2e",
  "46225": "2e",
  "46186": "2e",
  "47338": "2e",
  "46501": "2e",
  "46742": "2e",
  "47863": "2e",
  "47941": "2e",
  "46989": "2e",
  "46705": "2e",
  "46556": "2e",
  "46930": "2e",
  "47930": "2e",
  "47021": "2e",
  "47875": "2e",
  "46170": "2e",
  "46980": "2e",
  "46779": "2e",
  "46794": "2e",
  "46760": "2e",
  "46379": "2e",
  "47836": "2e",
  "47925": "2e",
  "46959": "2e",
  "46393": "2e",
  "40858": "3e",
  "40806": "3e",
  "40744": "3e",
  "41773": "3e",
  "41632": "3e",
  "40831": "3e",
  "41843": "3e",
  "17235": "2e",
  "16820": "2e",
  "16421": "2e",
  "16655": "2e",
  "15960": "2e",
  "15922": "2e",
  "16407": "2e",
  "16668": "2e",
  "19518": "2e",
  "17081": "2e",
  "17505": "2e",
  "19503": "2e",
  "19538": "2e",
  "18063": "2e",
  "17566": "2e",
  "15547": "2e",
  "15531": "2e",
  "17562": "2e",
  "15956": "2e",
  "18195": "2e",
  "17543": "2e",
  "16874": "2e",
  "19126": "2e",
  "18088": "2e",
  "19516": "2e",
  "19554": "2e",
  "17246": "2e",
  "16140": "2e",
  "17756": "2e",
  "17742": "2e",
  "16853": "2e",
  "16832": "2e",
  "16160": "2e",
  "16641": "2e",
  "16801": "2e",
  "16851": "2e",
  "18055": "2e",
  "16637": "2e",
  "15957": "2e",
  "15961": "2e",
  "16639": "2e",
  "17247": "2e",
  "17519": "2e",
  "19505": "2e",
  "17250": "2e",
  "19547": "2e",
  "19536": "2e",
  "15501": "2e",
  "17364": "2e",
  "06254": "2e",
  "06365": "2e",
  "06039": "2e",
  "06332": "2e",
  "06280": "2e",
  "06238": "2e",
  "06066": "2e",
  "06754": "2e",
  "06111": "2e",
  "06059": "2e",
  "06061": "2e",
  "06758": "2e",
  "06444": "2e",
  "06376": "2e",
  "06260": "2e",
  "06335": "2e",
  "06355": "2e",
  "06384": "2e",
  "06359": "2e",
  "06226": "2e",
  "06266": "2e",
  "06256": "2e",
  "06259": "2e",
  "06282": "2e",
  "06338": "2e",
  "50034": "2w",
  "52134": "1w",
  "51543": "2w",
  "52146": "1w",
  "50257": "2w",
  "50657": "2w",
  "50603": "1w",
  "50249": "2w",
  "51459": "2w",
  "50230": "2w",
  "51558": "2w",
  "51578": "2w",
  "52644": "2w",
  "50548": "2w",
  "51648": "2w",
  "52654": "2w",
  "51020": "2w",
  "51649": "2w",
  "51650": "2w",
  "52635": "2w",
  "50430": "1w",
  "50501": "2w",
  "50317": "2w",
  "52068": "2w",
  "52560": "2w",
  "50424": "1w",
  "51201": "1w",
  "50841": "2w",
  "50029": "2w",
  "50861": "2w",
  "52205": "2w",
  "50314": "2w",
  "50035": "2w",
  "50026": "2w",
  "50211": "2w",
  "52033": "2w",
  "51301": "1w",
  "52142": "2w",
  "51054": "2w",
  "51016": "2w",
  "50655": "2w",
  "52754": "2w",
  "51250": "1w",
  "52321": "2w",
  "51632": "2w",
  "50607": "2w",
  "51248": "1w",
  "52045": "2w",
  "50277": "2w",
  "50073": "2w",
  "50243": "2w",
  "51545": "2w",
  "52544": "2w",
  "50559": "1w",
  "51230": "1w",
  "50648": "2w",
  "51241": "1w",
  "50262": "2w",
  "50275": "2w",
  "52334": "2w",
  "50598": "1w",
  "50561": "2w",
  "50067": "2w",
  "50628": "1w",
  "51444": "2w",
  "51430": "2w",
  "52144": "1w",
  "50256": "2w",
  "50133": "2w",
  "51247": "1w",
  "50510": "2w",
  "50271": "2w",
  "51010": "2w",
  "52352": "2w",
  "52170": "1w",
  "50132": "2w",
  "52222": "2w",
  "52210": "2w",
  "50643": "2w",
  "82643": "5",
  "82210": "5",
  "82215": "5",
  "82412": "5",
  "82421": "5",
  "82423": "5",
  "82420": "5",
  "82332": "5",
  "83414": "5",
  "82939": "5",
  "83118": "5",
  "82712": "5",
  "82510": "5",
  "83001": "5",
  "83013": "5",
  "82422": "5",
  "83128": "5",
  "82901": "5",
  "83101": "5",
  "83112": "5",
  "82929": "5",
  "82336": "5",
  "82322": "5",
  "82007": "5",
  "82831": "5",
  "82401": "5",
  "82837": "5",
  "83115": "5",
  "82515": "5",
  "82050": "5",
  "82731": "5",
  "82243": "5",
  "82723": "5",
  "82224": "5",
  "82244": "5",
  "29589": "4",
  "29370": "4",
  "29613": "4",
  "29368": "3e",
  "29665": "4",
  "29046": "4",
  "29519": "4",
  "29122": "4",
  "29175": "4",
  "29316": "3e",
  "29801": "4",
  "29164": "4",
  "29322": "3e",
  "29426": "4",
  "29016": "4",
  "29456": "4",
  "29650": "4",
  "29639": "4",
  "29474": "4",
  "29403": "4",
  "29320": "4",
  "29627": "4",
  "29135": "4",
  "29625": "4",
  "29436": "4",
  "29860": "4",
  "29150": "4",
  "29080": "4",
  "29036": "4",
  "29828": "4",
  "29410": "4",
  "29030": "4",
  "29128": "4",
  "29630": "4",
  "58415": "1w",
  "58271": "1w",
  "58012": "1w",
  "58538": "1w",
  "58430": "1w",
  "58009": "1w",
  "58370": "1w",
  "58311": "1w",
  "58001": "1w",
  "73170": "3w",
  "74116": "3w",
  "73003": "3w",
  "73051": "3w",
  "74462": "3w",
  "73160": "3w",
  "73121": "3w",
  "73102": "3w",
  "74030": "3w",
  "74039": "3w",
  "74012": "3w",
  "73131": "3w",
  "73145": "3w",
  "74350": "3w",
  "74458": "3w",
  "74839": "3w",
  "74728": "3w",
  "74820": "3w",
  "74745": "3w",
  "74724": "3w",
  "74571": "3w",
  "73034": "3w",
  "73120": "3w",
  "74951": "3w",
  "74953": "3w",
  "73401": "3w",
  "74036": "3w",
  "73546": "3w",
  "73071": "3w",
  "74342": "3w",
  "73072": "3w",
  "74441": "3w",
  "74037": "3w",
  "74082": "3w",
  "74760": "3w",
  "74051": "2w",
  "73645": "3w",
  "73757": "2w",
  "74426": "3w",
  "74081": "3w",
  "74045": "2w",
  "74878": "3w",
  "74565": "3w",
  "74442": "3w",
  "73050": "3w",
  "73455": "3w",
  "73848": "2w",
  "73531": "3w",
  "74747": "3w",
  "73061": "2w",
  "73728": "2w",
  "73658": "2w",
  "73857": "2w",
  "73002": "3w",
  "73703": "2w",
  "74104": "3w",
  "73730": "2w",
  "74434": "3w",
  "74631": "2w",
  "74436": "3w",
  "73425": "3w",
  "73739": "2w",
  "74112": "3w",
  "73660": "2w",
  "74851": "3w",
  "73566": "3w",
  "73554": "3w",
  "73523": "3w",
  "73435": "3w",
  "74171": "3w",
  "74464": "3w",
  "47467": "2e",
  "46996": "2e",
  "47920": "2e",
  "47923": "2e",
  "47596": "2e",
  "47524": "2e",
  "47232": "2e",
  "47231": "2e",
  "47126": "2e",
  "46346": "2e",
  "46303": "2e",
  "47969": "2e",
  "46060": "2e",
  "46037": "2e",
  "47122": "3e",
  "47119": "2e",
  "47141": "2e",
  "47143": "2e",
  "47665": "2e",
  "47163": "2e",
  "46341": "2e",
  "47522": "2e",
  "40351": "3e",
  "41240": "3e",
  "40813": "3e",
  "41849": "3e",
  "42344": "3e",
  "40380": "3e",
  "41238": "3e",
  "42140": "3e",
  "40914": "3e",
  "42031": "3e",
  "40844": "3e",
  "42782": "3e",
  "40923": "3e",
  "41759": "3e",
  "41622": "3e",
  "41607": "3e",
  "40051": "3e",
  "42339": "3e",
  "41234": "3e",
  "41669": "3e",
  "42153": "3e",
  "41848": "3e",
  "40874": "3e",
  "41831": "3e",
  "41567": "3e",
  "41775": "3e",
  "42372": "3e",
  "40157": "3e",
  "42753": "3e",
  "41719": "3e",
  "40737": "3e",
  "40863": "3e",
  "47551": "3e",
  "47358": "2e",
  "47550": "3e",
  "47634": "3e",
  "47393": "2e",
  "47302": "2e",
  "46507": "2e",
  "47201": "2e",
  "46001": "2e",
  "47327": "2e",
  "47345": "2e",
  "47711": "3e",
  "47339": "2e",
  "46063": "2e",
  "47832": "2e",
  "46011": "2e",
  "46902": "2e",
  "46807": "2e",
  "46806": "2e",
  "47396": "2e",
  "46545": "2e",
  "47992": "2e",
  "46517": "2e",
  "46013": "2e",
  "46221": "2e",
  "46241": "2e",
  "46239": "2e",
  "47342": "2e",
  "47161": "3e",
  "46928": "2e",
  "62225": "2e",
  "62285": "2e",
  "62223": "2e",
  "62059": "2e",
  "60005": "2e",
  "62279": "2e",
  "62277": "2w",
  "60171": "2e",
  "60131": "2e",
  "60103": "2e",
  "60173": "2e",
  "60194": "2e",
  "60053": "2e",
  "60164": "2e",
  "60172": "2e",
  "60472": "2e",
  "60463": "2e",
  "60411": "2e",
  "60449": "2e",
  "60108": "2e",
  "60532": "2e",
  "60140": "2e",
  "60504": "2e",
  "60440": "2e",
  "60061": "2e",
  "60002": "2e",
  "60045": "2e",
  "60087": "2e",
  "60069": "2e",
  "62427": "2e",
  "60560": "2e",
  "60585": "2e",
  "62473": "2e",
  "62424": "2e",
  "60927": "2e",
  "60956": "2e",
  "60945": "2e",
  "62019": "2e",
  "62246": "2e",
  "62241": "2w",
  "62923": "3e",
  "62628": "2e",
  "62665": "2e",
  "62011": "2e",
  "62032": "2e",
  "62881": "2e",
  "61327": "2e",
  "62842": "2e",
  "62694": "2e",
  "62356": "2w",
  "62082": "2e",
  "61941": "2e",
  "61563": "2e",
  "62519": "2e",
  "62518": "2e",
  "62671": "2e",
  "62643": "2e",
  "62674": "2e",
  "62093": "2e",
  "62965": "3e",
  "62977": "3e",
  "60420": "2e",
  "62571": "2e",
  "62962": "3w",
  "62887": "2e",
  "62861": "3e",
  "62871": "3e",
  "60921": "2e",
  "61375": "2e",
  "60517": "2e",
  "60109": "2e",
  "60519": "2e",
  "60084": "2e",
  "60083": "2e",
  "60050": "2e",
  "60072": "2e",
  "62634": "2e",
  "61423": "2e",
  "62417": "2e",
  "62451": "2e",
  "60544": "2e",
  "62466": "2e",
  "60491": "2e",
  "61435": "2e",
  "60408": "2e",
  "60490": "2e",
  "60415": "2e",
  "60523": "2e",
  "60422": "2e",
  "60478": "2e",
  "60443": "2e",
  "60301": "2e",
  "04496": "1e",
  "04923": "1e",
  "04408": "1e",
  "04785": "1e",
  "04774": "1e",
  "04438": "1e",
  "03901": "1e",
  "04849": "1e",
  "04925": "1e",
  "04951": "1e",
  "04974": "1e",
  "04758": "1e",
  "04489": "1e",
  "04286": "1e",
  "04918": "1e",
  "04673": "1e",
  "04975": "1e",
  "87416": "5",
  "87455": "5",
  "87413": "5",
  "87022": "5",
  "87711": "5",
  "87701": "5",
  "87745": "5",
  "87552": "5",
  "87535": "5",
  "88047": "6",
  "88002": "6",
  "87317": "5",
  "87581": "5",
  "87417": "5",
  "87579": "5",
  "88337": "6",
  "88419": "2w",
  "87740": "5",
  "88342": "6",
  "88422": "5",
  "87521": "5",
  "87525": "5",
  "87564": "5",
  "87729": "5",
  "79837": "6",
  "87554": "5",
  "87027": "5",
  "88338": "6",
  "88020": "6",
  "87933": "6",
  "87827": "6",
  "88045": "6",
  "88049": "6",
  "88028": "6",
  "88120": "2w",
  "88022": "6",
  "88053": "6",
  "88427": "5",
  "87532": "5",
  "88040": "6",
  "87544": "5",
  "87325": "5",
  "87144": "5",
  "87935": "6",
  "87014": "5",
  "87049": "5",
  "87044": "5",
  "87002": "5",
  "87312": "5",
  "87347": "5",
  "88021": "6",
  "87567": "5",
  "87364": "5",
  "87499": "5",
  "87001": "5",
  "16509": "2e",
  "19140": "2e",
  "17957": "2e",
  "16506": "2e",
  "18049": "2e",
  "17039": "2e",
  "17010": "2e",
  "16938": "2e",
  "16822": "2e",
  "17765": "2e",
  "16156": "2e",
  "15942": "2e",
  "17262": "2e",
  "17727": "2e",
  "16142": "2e",
  "19533": "2e",
  "16401": "2e",
  "16417": "2e",
  "16411": "2e",
  "17224": "2e",
  "15945": "2e",
  "19526": "2e",
  "16870": "2e",
  "16648": "2e",
  "16617": "2e",
  "17268": "2e",
  "19609": "2e",
  "16828": "2e",
  "16852": "2e",
  "15946": "2e",
  "64840": "2w",
  "63045": "2w",
  "63044": "2w",
  "64469": "2w",
  "65720": "3w",
  "64862": "2w",
  "65737": "3w",
  "63124": "2w",
  "63367": "2w",
  "63119": "2w",
  "63114": "2w",
  "65728": "3w",
  "65080": "2w",
  "64024": "2w",
  "65626": "3w",
  "63115": "2w",
  "64850": "3w",
  "65077": "2w",
  "65067": "2w",
  "64745": "2w",
  "63143": "2w",
  "64167": "2w",
  "64086": "2w",
  "64120": "2w",
  "64030": "2w",
  "02382": "2e",
  "02045": "2e",
  "02770": "2e",
  "02576": "2e",
  "02558": "2e",
  "02553": "2e",
  "02633": "2e",
  "02643": "2e",
  "02650": "2e",
  "02630": "2e",
  "02664": "2e",
  "02467": "2e",
  "02215": "2e",
  "02561": "2e",
  "02127": "2e",
  "02659": "2e",
  "02170": "2e",
  "01347": "2e",
  "01039": "2e",
  "02119": "2e",
  "02121": "2e",
  "01054": "2e",
  "71663": "3w",
  "72141": "3w",
  "72088": "3w",
  "72311": "3w",
  "72523": "3w",
  "72473": "3w",
  "72179": "3w",
  "72457": "3w",
  "72679": "3w",
  "72550": "3w",
  "71831": "3w",
  "72075": "3w",
  "72527": "3w",
  "72633": "3w",
  "71959": "3w",
  "72855": "3w",
  "72157": "3w",
  "71724": "3w",
  "72063": "3w",
  "71937": "3w",
  "72926": "3w",
  "72846": "3w",
  "72326": "3w",
  "72642": "3w",
  "72517": "3w",
  "72536": "3w",
  "71772": "3w",
  "71952": "3w",
  "71721": "3w",
  "71998": "3w",
  "72456": "3w",
  "72865": "3w",
  "72539": "3w",
  "71759": "3w",
  "72631": "3w",
  "71945": "3w",
  "65761": "3w",
  "71652": "3w",
  "72636": "3w",
  "71603": "3w",
  "72205": "3w",
  "72206": "3w",
  "71644": "3w",
  "71857": "3w",
  "72046": "3w",
  "72076": "3w",
  "72103": "3w",
  "71909": "3w",
  "72937": "3w",
  "72762": "3w",
  "71956": "3w",
  "72019": "3w",
  "72930": "3w",
  "72734": "3w",
  "72774": "3w",
  "72395": "3w",
  "72761": "3w",
  "72758": "3w",
  "72338": "3w",
  "72176": "3w",
  "72712": "3w",
  "72313": "3w",
  "72719": "3w",
  "72935": "3w",
  "71943": "3w",
  "75556": "3w",
  "72136": "3w",
  "72121": "3w",
  "72752": "3w",
  "72020": "3w",
  "72060": "3w",
  "71833": "3w",
  "71827": "3w",
  "72041": "3w",
  "72554": "3w",
  "72415": "3w",
  "72513": "3w",
  "72839": "3w",
  "72003": "3w",
  "72577": "3w",
  "72461": "3w",
  "72048": "3w",
  "72546": "3w",
  "72611": "3w",
  "71701": "3w",
  "72431": "3w",
  "72006": "3w",
  "72524": "3w",
  "71642": "3w",
  "72324": "3w",
  "17601": "2e",
  "16827": "2e",
  "16802": "2e",
  "19508": "2e",
  "15775": "2e",
  "16403": "2e",
  "16627": "2e",
  "16619": "2e",
  "86441": "5",
  "86437": "5",
  "86438": "6",
  "85901": "6",
  "86038": "5",
  "85719": "6",
  "86305": "6",
  "85706": "6",
  "85653": "6",
  "85622": "6",
  "85923": "6",
  "85624": "6",
  "85324": "6",
  "85140": "6",
  "85541": "6",
  "86325": "6",
  "86326": "6",
  "85631": "6",
  "85141": "6",
  "85123": "6",
  "85374": "6",
  "85626": "6",
  "85712": "6",
  "85938": "6",
  "86011": "5",
  "85920": "6",
  "85535": "6",
  "85942": "5",
  "85648": "6",
  "86028": "5",
  "86313": "6",
  "85343": "6",
  "85236": "6",
  "85298": "6",
  "85307": "6",
  "85007": "6",
  "86520": "5",
  "85746": "6",
  "85550": "6",
  "86434": "5",
  "85083": "6",
  "85020": "6",
  "86508": "5",
  "86021": "5",
  "85933": "6",
  "85546": "6",
  "85360": "6",
  "86323": "6",
  "85534": "6",
  "85552": "6",
  "85606": "6",
  "85118": "6",
  "86315": "6",
  "85347": "6",
  "85352": "6",
  "85131": "6",
  "85396": "6",
  "86329": "6",
  "86023": "5",
  "85747": "6",
  "85619": "6",
  "85381": "6",
  "85014": "6",
  "85927": "6",
  "85922": "6",
  "85721": "6",
  "85224": "6",
  "85331": "6",
  "87070": "5",
  "87023": "5",
  "87117": "5",
  "88061": "6",
  "88101": "2w",
  "87013": "5",
  "88253": "6",
  "87108": "5",
  "88005": "6",
  "88044": "6",
  "75261": "3w",
  "78607": "6",
  "78027": "6",
  "78243": "6",
  "78938": "6",
  "75756": "3w",
  "78545": "6",
  "77624": "4",
  "75071": "3w",
  "79846": "6",
  "78573": "4",
  "75075": "3w",
  "76377": "3w",
  "75166": "3w",
  "75098": "3w",
  "78736": "6",
  "75080": "3w",
  "75094": "3w",
  "78660": "6",
  "75088": "3w",
  "76084": "3w",
  "75165": "3w",
  "78729": "6",
  "77003": "4",
  "75143": "3w",
  "75474": "3w",
  "76008": "3w",
  "78212": "6",
  "78207": "6",
  "76053": "3w",
  "76148": "3w",
  "78203": "6",
  "76248": "3w",
  "76179": "3w",
  "78218": "6",
  "76051": "3w",
  "75050": "3w",
  "76085": "3w",
  "76031": "3w",
  "78266": "6",
  "78260": "6",
  "76067": "3w",
  "76490": "3w",
  "78073": "6",
  "77861": "3w",
  "78230": "6",
  "78236": "6",
  "78254": "6",
  "77351": "4",
  "77049": "4",
  "77026": "4",
  "77506": "4",
  "77045": "4",
  "77204": "4",
  "77033": "4",
  "77562": "4",
  "77077": "4",
  "77401": "4",
  "77061": "4",
  "77058": "4",
  "77068": "4",
  "77095": "4",
  "77091": "4",
  "77534": "4",
  "75904": "3w",
  "77436": "6",
  "68304": "2w",
  "68058": "2w",
  "68622": "2w",
  "68723": "2w",
  "68728": "2w",
  "68736": "2w",
  "68717": "2w",
  "69217": "2w",
  "68760": "2w",
  "69127": "2w",
  "69147": "2w",
  "68956": "2w",
  "68832": "2w",
  "68521": "2w",
  "68522": "2w",
  "68404": "2w",
  "68333": "2w",
  "68701": "2w",
  "68961": "2w",
  "68781": "2w",
  "68314": "2w",
  "68752": "2w",
  "69025": "2w",
  "68937": "2w",
  "68456": "2w",
  "68453": "2w",
  "68128": "2w",
  "68136": "2w",
  "68144": "2w",
  "69336": "5",
  "69341": "5",
  "68342": "2w",
  "68926": "2w",
  "68971": "2w",
  "68979": "2w",
  "68134": "2w",
  "69150": "2w",
  "69134": "2w",
  "68932": "2w",
  "68444": "2w",
  "69352": "5",
  "68601": "2w",
  "68366": "2w",
  "68029": "2w",
  "68863": "2w",
  "69166": "2w",
  "68981": "2w",
  "68826": "2w",
  "69214": "2w",
  "68430": "2w",
  "68031": "2w",
  "68072": "2w",
  "69138": "2w",
  "68532": "2w",
  "69212": "2w",
  "69029": "2w",
  "69340": "2w",
  "68663": "2w",
  "69220": "2w",
  "68071": "2w",
  "68045": "2w",
  "68768": "2w",
  "68315": "2w",
  "68770": "2w",
  "68056": "2w",
  "68068": "2w",
  "68316": "2w",
  "68850": "2w",
  "41527": "3e",
  "42154": "3e",
  "42631": "3e",
  "40849": "3e",
  "40376": "3e",
  "40830": "3e",
  "41713": "3e",
  "40165": "3e",
  "40068": "3e",
  "40057": "3e",
  "40045": "2e",
  "40228": "3e",
  "40118": "3e",
  "42053": "3e",
  "42001": "3e",
  "40077": "3e",
  "42303": "3e",
  "40475": "3e",
  "40515": "3e",
  "40031": "3e",
  "40110": "3e",
  "46112": "2e",
  "46123": "2e",
  "47453": "2e",
  "46975": "2e",
  "46711": "2e",
  "46391": "2e",
  "47638": "3e",
  "46171": "2e",
  "46307": "2e",
  "46791": "2e",
  "46322": "2e",
  "47640": "2e",
  "47355": "2e",
  "46994": "2e",
  "47145": "3e",
  "47260": "2e",
  "47362": "2e",
  "47281": "2e",
  "47035": "2e",
  "46404": "2e",
  "47353": "2e",
  "47265": "2e",
  "46982": "2e",
  "47950": "2e",
  "46041": "2e",
  "47456": "2e",
  "46035": "2e",
  "47970": "2e",
  "46539": "2e",
  "47147": "2e",
  "47177": "2e",
  "47954": "2e",
  "46175": "2e",
  "47230": "2e",
  "47535": "2e",
  "47449": "2e",
  "47011": "2e",
  "47001": "2e",
  "46725": "2e",
  "46311": "2e",
  "46382": "2e",
  "46375": "2e",
  "47666": "2e",
  "47649": "2e",
  "47613": "3e",
  "47443": "2e",
  "46542": "2e",
  "46040": "2e",
  "46706": "2e",
  "46563": "2e",
  "46327": "2e",
  "46979": "2e",
  "46075": "2e",
  "46601": "2e",
  "46616": "2e",
  "47725": "3e",
  "46044": "2e",
  "46723": "2e",
  "46402": "2e",
  "47859": "2e",
  "46825": "2e",
  "46573": "2e",
  "46201": "2e",
  "46202": "2e",
  "46516": "2e",
  "46217": "2e",
  "46107": "2e",
  "46167": "2e",
  "47330": "2e",
  "47246": "2e",
  "46804": "2e",
  "40207": "3e",
  "40206": "3e",
  "42078": "3e",
  "40210": "3e",
  "42378": "3e",
  "97065": "5",
  "97884": "5",
  "97103": "7",
  "97470": "7",
  "97813": "5",
  "97761": "5",
  "97868": "5",
  "97731": "5",
  "97870": "5",
  "97812": "5",
  "97741": "5",
  "97848": "5",
  "97835": "5",
  "97343": "7",
  "97121": "7",
  "97538": "7",
  "97534": "7",
  "97874": "5",
  "97828": "5",
  "97734": "5",
  "97722": "5",
  "97710": "5",
  "97738": "5",
  "97904": "5",
  "97636": "5",
  "97827": "5",
  "97841": "5",
  "97622": "5",
  "97149": "7",
  "97917": "5",
  "97021": "5",
  "97333": "7",
  "97478": "7",
  "97439": "7",
  "97756": "5",
  "97209": "7",
  "97702": "5",
  "97215": "7",
  "97455": "7",
  "97526": "7",
  "97230": "7",
  "97361": "7",
  "97346": "7",
  "97350": "7",
  "97342": "7",
  "34990": "4",
  "33149": "4",
  "34431": "4",
  "33186": "4",
  "32666": "4",
  "33034": "4",
  "33018": "4",
  "34759": "4",
  "33033": "4",
  "32539": "4",
  "32578": "4",
  "32720": "4",
  "33315": "4",
  "32140": "4",
  "32174": "4",
  "32114": "4",
  "33026": "4",
  "33019": "4",
  "32180": "4",
  "32340": "4",
  "32336": "4",
  "33025": "4",
  "33028": "4",
  "32460": "4",
  "32446": "4",
  "32431": "4",
  "32038": "4",
  "32443": "4",
  "32423": "4",
  "32128": "4",
  "32696": "4",
  "32054": "4",
  "34953": "4",
  "34448": "4",
  "32334": "4",
  "32177": "4",
  "32433": "4",
  "32619": "4",
  "32008": "4",
  "34945": "4",
  "34982": "4",
  "32052": "4",
  "33876": "4",
  "32147": "4",
  "32697": "4",
  "33873": "4",
  "33001": "4",
  "33043": "4",
  "32608": "4",
  "33139": "4",
  "33406": "4",
  "33412": "4",
  "33132": "4",
  "32466": "4",
  "32567": "4",
  "34434": "4",
  "32920": "4",
  "33054": "4",
  "28707": "3e",
  "28337": "3e",
  "28020": "3e",
  "28394": "3e",
  "27974": "3e",
  "28373": "3e",
  "28768": "3e",
  "28167": "3e",
  "28018": "3e",
  "27247": "3e",
  "27957": "3e",
  "28644": "3e",
  "28017": "3e",
  "28718": "3e",
  "04841": "1e",
  "04548": "1e",
  "04623": "1e",
  "04564": "1e",
  "04937": "1e",
  "04451": "1e",
  "04419": "1e",
  "04015": "1e",
  "04071": "1e",
  "04265": "1e",
  "04024": "1e",
  "04401": "1e",
  "04032": "1e",
  "04038": "1e",
  "04444": "1e",
  "04106": "1e",
  "04351": "1e",
  "04666": "1e",
  "04471": "1e",
  "04479": "1e",
  "04929": "1e",
  "04965": "1e",
  "04634": "1e",
  "04677": "1e",
  "04967": "1e",
  "04281": "1e",
  "04226": "1e",
  "04650": "1e",
  "04852": "1e",
  "04459": "1e",
  "04289": "1e",
  "04685": "1e",
  "04730": "1e",
  "04414": "1e",
  "04628": "1e",
  "04468": "1e",
  "04495": "1e",
  "04418": "1e",
  "04240": "1e",
  "49894": "1e",
  "49872": "1e",
  "48852": "1e",
  "49425": "1e",
  "49736": "1e",
  "49725": "1e",
  "49726": "1e",
  "48884": "1e",
  "48466": "1e",
  "49303": "1e",
  "49784": "1e",
  "48915": "2e",
  "49455": "1e",
  "49090": "2e",
  "49241": "2e",
  "48808": "1e",
  "49072": "2e",
  "49261": "2e",
  "49417": "1e",
  "49525": "1e",
  "49436": "1e",
  "49301": "1e",
  "49753": "1e",
  "49883": "1e",
  "49945": "1e",
  "49348": "2e",
  "48348": "2e",
  "49067": "2e",
  "48360": "2e",
  "49009": "2e",
  "48201": "2e",
  "48187": "2e",
  "48001": "2e",
  "48140": "2e",
  "48006": "1e",
  "48032": "1e",
  "48430": "2e",
  "49431": "1e",
  "49762": "1e",
  "49030": "2e",
  "48468": "1e",
  "49454": "1e",
  "49730": "1e",
  "49968": "1e",
  "49760": "1e",
  "49834": "1e",
  "49877": "1e",
  "49245": "2e",
  "49815": "1e",
  "49831": "1e",
  "49405": "1e",
  "49852": "1e",
  "49727": "1e",
  "49445": "1e",
  "48070": "2e",
  "49931": "1e",
  "33467": "4",
  "33483": "4",
  "35962": "4",
  "35975": "4",
  "30628": "4",
  "30633": "4",
  "30629": "4",
  "30032": "4",
  "30730": "4",
  "31512": "4",
  "31565": "4",
  "31568": "4",
  "30621": "4",
  "31798": "4",
  "30641": "4",
  "30751": "4",
  "33130": "4",
  "35763": "4",
  "35952": "4",
  "35149": "4",
  "35405": "4",
  "35121": "4",
  "35243": "4",
  "35401": "4",
  "35457": "4",
  "34474": "4",
  "33478": "4",
  "32317": "4",
  "30328": "4",
  "31301": "4",
  "34293": "4",
  "34223": "4",
  "34275": "4",
  "31698": "4",
  "31302": "4",
  "30905": "4",
  "35180": "4",
  "35442": "4",
  "35464": "4",
  "36907": "4",
  "30309": "4",
  "31525": "4",
  "31701": "4",
  "34210": "4",
  "33010": "4",
  "33919": "4",
  "33461": "4",
  "33605": "4",
  "30173": "4",
  "31903": "4",
  "30517": "4",
  "30548": "4",
  "30518": "4",
  "30334": "4",
  "30567": "4",
  "30331": "4",
  "31907": "4",
  "34235": "4",
  "30736": "4",
  "31063": "4",
  "32622": "4",
  "34112": "4",
  "33455": "4",
  "32606": "4",
  "35184": "4",
  "35035": "4",
  "36750": "4",
  "35754": "4",
  "35741": "3e",
  "35452": "4",
  "35775": "4",
  "35750": "3e",
  "30176": "4",
  "30286": "4",
  "30673": "4",
  "31605": "4",
  "30907": "4",
  "30014": "4",
  "31204": "4",
  "30705": "4",
  "31314": "4",
  "31635": "4",
  "30660": "4",
  "31072": "4",
  "31808": "4",
  "30319": "4",
  "30813": "4",
  "30820": "4",
  "30153": "4",
  "34432": "4",
  "35634": "3e",
  "36316": "4",
  "36318": "4",
  "35146": "4",
  "36576": "4",
  "36535": "4",
  "35808": "4",
  "36574": "4",
  "31320": "4",
  "30349": "4",
  "31547": "4",
  "32615": "4",
  "34216": "4",
  "34219": "4",
  "30337": "4",
  "32561": "4",
  "35756": "3e",
  "35552": "4",
  "35550": "4",
  "43447": "2e",
  "44436": "2e",
  "44608": "2e",
  "44454": "2e",
  "44612": "2e",
  "45622": "2e",
  "43527": "2e",
  "43457": "2e",
  "43469": "2e",
  "43406": "2e",
  "45764": "2e",
  "43314": "2e",
  "43350": "2e",
  "45166": "2e",
  "44805": "2e",
  "44287": "2e",
  "43724": "2e",
  "43325": "2e",
  "43716": "2e",
  "44683": "2e",
  "44820": "2e",
  "44827": "2e",
  "45845": "2e",
  "44881": "2e",
  "45740": "2e",
  "43931": "2e",
  "45746": "2e",
  "44611": "2e",
  "45719": "2e",
  "45778": "2e",
  "43219": "2e",
  "44681": "2e",
  "44875": "2e",
  "44690": "2e",
  "43981": "2e",
  "43608": "2e",
  "45840": "2e",
  "45662": "3e",
  "45323": "2e",
  "44425": "2e",
  "45220": "2e",
  "45015": "2e",
  "43202": "2e",
  "44321": "2e",
  "43085": "2e",
  "45843": "2e",
  "45897": "2e",
  "43318": "2e",
  "45868": "2e",
  "45817": "2e",
  "43337": "2e",
  "43332": "2e",
  "43324": "2e",
  "43333": "2e",
  "43002": "2e",
  "43021": "2e",
  "43619": "2e",
  "45891": "2e",
  "45750": "2e",
  "44697": "2e",
  "43512": "2e",
  "45130": "2e",
  "45168": "2e",
  "45682": "2e",
  "44883": "2e",
  "44836": "2e",
  "43435": "2e",
  "44828": "2e",
  "43824": "2e",
  "43442": "2e",
  "44637": "2e",
  "43805": "2e",
  "45672": "2e",
  "43840": "2e",
  "43731": "2e",
  "43730": "2e",
  "43338": "2e",
  "45855": "2e",
  "43148": "2e",
  "43158": "2e",
  "45831": "2e",
  "45767": "2e",
  "43915": "2e",
  "43907": "2e",
  "44699": "2e",
  "45822": "2e",
  "45898": "2e",
  "45363": "2e",
  "08065": "2e",
  "08511": "2e",
  "08640": "2e",
  "08006": "2e",
  "07750": "2e",
  "07740": "2e",
  "07728": "2e",
  "08730": "2e",
  "07717": "2e",
  "08302": "2e",
  "07305": "2e",
  "08879": "2e",
  "08502": "2e",
  "08833": "2e",
  "08551": "2e",
  "07607": "2e",
  "07974": "2e",
  "07062": "2e",
  "07090": "2e",
  "08553": "2e",
  "07022": "2e",
  "08406": "2e",
  "07109": "2e",
  "07079": "2e",
  "08608": "2e",
  "07036": "2e",
  "07522": "2e",
  "07012": "2e",
  "07630": "2e",
  "07029": "2e",
  "07869": "2e",
  "07652": "2e",
  "97404": "7",
  "97502": "7",
  "97864": "5",
  "97016": "7",
  "97376": "7",
  "97544": "7",
  "97735": "5",
  "97845": "5",
  "97885": "5",
  "97102": "7",
  "97620": "5",
  "97733": "7",
  "97018": "7",
  "97633": "5",
  "97911": "5",
  "97906": "5",
  "97902": "5",
  "97202": "7",
  "97739": "5",
  "97211": "7",
  "97412": "7",
  "97413": "7",
  "97220": "7",
  "97458": "7",
  "97530": "7",
  "97525": "7",
  "97305": "7",
  "97492": "7",
  "97232": "7",
  "97539": "7",
  "97527": "7",
  "97056": "7",
  "97321": "7",
  "97331": "7",
  "97436": "7",
  "97140": "7",
  "97013": "7",
  "97355": "7",
  "97022": "7",
  "97374": "7",
  "97345": "7",
  "97067": "7",
  "97003": "7",
  "97877": "5",
  "97429": "7",
  "97417": "7",
  "97432": "7",
  "97457": "7",
  "97484": "7",
  "97523": "7",
  "97826": "5",
  "97905": "5",
  "97640": "5",
  "97364": "7",
  "97882": "5",
  "97531": "7",
  "97836": "5",
  "97839": "5",
  "97635": "5",
  "97737": "5",
  "97603": "5",
  "97632": "5",
  "97908": "5",
  "97920": "5",
  "97625": "5",
  "97122": "7",
  "97063": "5",
  "97501": "7",
  "97213": "7",
  "97520": "7",
  "97453": "7",
  "89060": "5",
  "89831": "5",
  "89430": "5",
  "89104": "5",
  "89431": "5",
  "89117": "5",
  "89301": "5",
  "89412": "5",
  "89131": "5",
  "89156": "5",
  "89015": "5",
  "89034": "5",
  "89421": "5",
  "89418": "5",
  "89438": "5",
  "89423": "5",
  "89102": "5",
  "89108": "5",
  "89501": "5",
  "89310": "5",
  "89169": "5",
  "89122": "5",
  "89411": "5",
  "89052": "5",
  "89103": "5",
  "89118": "5",
  "89506": "5",
  "89178": "5",
  "89424": "5",
  "89135": "5",
  "89040": "5",
  "89004": "5",
  "89027": "5",
  "89012": "5",
  "89011": "5",
  "89425": "5",
  "89409": "5",
  "89883": "5",
  "89440": "5",
  "89460": "5",
  "89512": "5",
  "03751": "1e",
  "03464": "1e",
  "03053": "2e",
  "03104": "2e",
  "03254": "1e",
  "03853": "1e",
  "03779": "1e",
  "03575": "1e",
  "03043": "2e",
  "03051": "2e",
  "03217": "1e",
  "03303": "1e",
  "03582": "1e",
  "03458": "2e",
  "03290": "2e",
  "69301": "5",
  "68183": "2w",
  "68105": "2w",
  "68528": "2w",
  "68157": "2w",
  "68123": "2w",
  "68059": "2w",
  "68354": "2w",
  "68343": "2w",
  "68662": "2w",
  "69022": "2w",
  "68122": "2w",
  "68512": "2w",
  "68664": "2w",
  "68920": "2w",
  "69140": "2w",
  "68643": "2w",
  "68463": "2w",
  "63043": "2w",
  "63933": "3w",
  "65610": "3w",
  "65321": "2w",
  "65609": "3w",
  "64854": "3w",
  "65320": "2w",
  "65619": "3w",
  "63105": "2w",
  "65202": "2w",
  "65806": "2w",
  "64833": "2w",
  "64101": "2w",
  "64092": "2w",
  "63140": "2w",
  "63301": "2w",
  "65287": "2w",
  "63826": "3w",
  "65244": "2w",
  "63701": "3w",
  "65637": "3w",
  "64498": "2w",
  "64426": "2w",
  "63382": "2w",
  "63730": "3w",
  "63369": "2w",
  "63383": "2w",
  "63840": "3w",
  "63365": "2w",
  "63380": "2w",
  "64427": "2w",
  "63769": "3w",
  "64442": "2w",
  "64636": "2w",
  "63445": "2w",
  "63780": "3w",
  "63552": "2w",
  "65565": "2w",
  "65081": "2w",
  "63439": "2w",
  "65655": "3w",
  "65676": "3w",
  "65326": "2w",
  "64661": "2w",
  "65354": "2w",
  "63339": "2w",
  "64431": "2w",
  "63673": "3w",
  "64445": "2w",
  "63433": "2w",
  "63674": "2w",
  "63467": "2w",
  "63801": "3w",
  "65286": "2w",
  "64487": "2w",
  "64654": "2w",
  "63436": "2w",
  "65741": "3w",
  "63501": "2w",
  "63882": "3w",
  "64790": "2w",
  "63559": "2w",
  "63540": "2w",
  "63036": "2w",
  "63932": "3w",
  "65020": "2w",
  "63551": "2w",
  "64420": "2w",
  "63637": "3w",
  "65783": "2w",
  "63945": "3w",
  "63820": "3w",
  "63750": "3w",
  "63782": "3w",
  "63016": "2w",
  "63019": "2w",
  "48375": "2e",
  "48356": "2e",
  "49430": "1e",
  "48817": "1e",
  "49227": "2e",
  "48449": "1e",
  "48165": "2e",
  "45105": "2e",
  "45469": "2e",
  "45636": "3e",
  "43925": "2e",
  "43569": "2e",
  "43403": "2e",
  "45433": "2e",
  "44046": "2e",
  "45384": "2e",
  "45324": "2e",
  "45382": "2e",
  "44620": "2e",
  "43908": "2e",
  "43054": "2e",
  "44643": "2e",
  "44139": "2e",
  "44116": "2e",
  "44108": "2e",
  "43791": "2e",
  "45154": "2e",
  "43740": "2e",
  "44301": "2e",
  "45303": "2e",
  "43142": "2e",
  "45387": "2e",
  "44024": "2e",
  "44086": "2e",
  "44136": "2e",
  "44138": "2e",
  "44124": "2e",
  "43821": "2e",
  "44432": "2e",
  "44625": "2e",
  "45176": "2e",
  "44320": "2e",
  "44319": "2e",
  "45870": "2e",
  "45350": "2e",
  "44314": "2e",
  "44333": "2e",
  "45309": "2e",
  "45405": "2e",
  "44135": "2e",
  "44685": "2e",
  "44720": "2e",
  "44706": "2e",
  "44714": "2e",
  "44240": "2e",
  "43030": "2e",
  "44704": "2e",
  "44412": "2e",
  "44644": "2e",
  "43143": "2e",
  "45245": "2e",
  "45865": "2e",
  "45326": "2e",
  "54933": "1e",
  "54950": "1e",
  "53948": "1e",
  "54949": "1e",
  "54128": "1e",
  "53538": "1e",
  "54149": "1e",
  "54945": "1e",
  "54114": "1e",
  "54828": "1e",
  "54170": "1e",
  "53589": "1e",
  "53149": "1e",
  "53150": "1e",
  "53046": "1e",
  "53048": "1e",
  "53057": "1e",
  "53223": "1e",
  "54204": "1e",
  "53119": "1e",
  "53029": "1e",
  "53560": "1e",
  "48756": "1e",
  "49721": "1e",
  "49648": "1e",
  "49854": "1e",
  "49783": "1e",
  "49791": "1e",
  "49412": "1e",
  "48705": "1e",
  "48885": "1e",
  "49326": "1e",
  "48630": "1e",
  "48933": "2e",
  "49048": "2e",
  "49446": "1e",
  "48837": "2e",
  "49002": "2e",
  "49269": "2e",
  "49246": "2e",
  "22664": "2e",
  "22844": "3e",
  "23284": "3e",
  "24066": "3e",
  "22657": "2e",
  "22652": "2e",
  "24230": "3e",
  "24217": "3e",
  "24593": "3e",
  "24538": "3e",
  "23453": "3e",
  "23461": "3e",
  "24366": "3e",
  "22815": "3e",
  "24312": "3e",
  "22603": "2e",
  "22645": "2e",
  "24368": "3e",
  "23665": "3e",
  "22853": "3e",
  "24258": "3e",
  "24251": "3e",
  "24354": "3e",
  "22554": "3e",
  "22405": "3e",
  "23227": "3e",
  "24607": "3e",
  "24319": "3e",
  "24089": "3e",
  "29040": "4",
  "29907": "4",
  "29742": "4",
  "29073": "4",
  "29101": "4",
  "29472": "4",
  "29532": "4",
  "29162": "4",
  "29593": "4",
  "29123": "4",
  "29667": "4",
  "29378": "4",
  "29375": "4",
  "29112": "4",
  "29684": "4",
  "29927": "4",
  "29438": "4",
  "29113": "4",
  "29530": "4",
  "29645": "4",
  "29585": "4",
  "29576": "4",
  "29596": "4",
  "29520": "4",
  "29108": "4",
  "29571": "4",
  "29741": "4",
  "29916": "4",
  "29710": "3e",
  "29676": "4",
  "29372": "4",
  "29664": "4",
  "29730": "4",
  "29565": "4",
  "29554": "4",
  "29081": "4",
  "29567": "4",
  "29435": "4",
  "29577": "4",
  "29582": "4",
  "29010": "4",
  "29911": "4",
  "29666": "4",
  "29819": "4",
  "29006": "4",
  "29445": "4",
  "29910": "4",
  "29114": "4",
  "29926": "4",
  "29429": "4",
  "29072": "4",
  "29569": "4",
  "29856": "4",
  "29853": "4",
  "29669": "4",
  "29056": "4",
  "29341": "3e",
  "29929": "4",
  "29058": "4",
  "29105": "4",
  "29670": "4",
  "29640": "4",
  "06498": "2e",
  "06013": "2e",
  "06027": "2e",
  "06073": "2e",
  "06052": "2e",
  "06467": "2e",
  "06091": "2e",
  "06090": "2e",
  "06708": "2e",
  "06472": "2e",
  "06373": "2e",
  "06712": "2e",
  "06907": "2e",
  "06451": "2e",
  "06385": "2e",
  "06336": "2e",
  "06279": "2e",
  "06095": "2e",
  "06798": "2e",
  "06109": "2e",
  "06414": "2e",
  "06513": "2e",
  "06517": "2e",
  "06706": "2e",
  "06079": "2e",
  "06459": "2e",
  "06606": "2e",
  "06604": "2e",
  "06902": "2e",
  "06065": "2e",
  "06605": "2e",
  "06437": "2e",
  "06051": "2e",
  "06401": "2e",
  "06776": "2e",
  "06811": "2e",
  "06416": "2e",
  "06380": "2e",
  "06389": "2e",
  "06320": "2e",
  "06043": "2e",
  "06105": "2e",
  "06878": "2e",
  "06018": "2e",
  "06770": "2e",
  "06794": "2e",
  "06031": "2e",
  "06374": "2e",
  "06357": "2e",
  "06269": "2e",
  "06277": "2e",
  "06339": "2e",
  "06234": "2e",
  "06264": "2e",
  "06258": "2e",
  "06053": "2e",
  "06070": "2e",
  "83401": "5",
  "83544": "5",
  "83325": "5",
  "83832": "5",
  "83427": "5",
  "83434": "5",
  "83244": "5",
  "83533": "5",
  "83220": "5",
  "83687": "5",
  "83670": "5",
  "83856": "5",
  "83346": "5",
  "83822": "5",
  "83468": "5",
  "83212": "5",
  "83555": "5",
  "83810": "5",
  "83834": "5",
  "83227": "5",
  "83636": "5",
  "83422": "5",
  "83337": "5",
  "83460": "5",
  "83666": "5",
  "83232": "5",
  "83676": "5",
  "83626": "5",
  "83349": "5",
  "83446": "5",
  "83324": "5",
  "83251": "5",
  "83449": "5",
  "83301": "5",
  "83835": "5",
  "83202": "5",
  "83448": "5",
  "83876": "5",
  "83837": "5",
  "83849": "5",
  "83250": "5",
  "83616": "5",
  "83553": "5",
  "83823": "5",
  "83851": "5",
  "83276": "5",
  "83322": "5",
  "83871": "5",
  "83646": "5",
  "83864": "5",
  "83821": "5",
  "83813": "5",
  "83661": "5",
  "83278": "5",
  "83330": "5",
  "83431": "5",
  "83271": "5",
  "83235": "5",
  "83215": "5",
  "83354": "5",
  "83641": "5",
  "83612": "5",
  "83272": "5",
  "83638": "5",
  "83805": "5",
  "83333": "5",
  "83542": "5",
  "83552": "5",
  "83815": "5",
  "83706": "5",
  "88242": "6",
  "88252": "6",
  "87311": "5",
  "88424": "5",
  "88418": "5",
  "88414": "5",
  "88349": "6",
  "87728": "5",
  "87713": "5",
  "79922": "6",
  "88323": "6",
  "87583": "5",
  "87820": "6",
  "87931": "6",
  "88321": "5",
  "87401": "5",
  "88011": "6",
  "87106": "5",
  "88343": "6",
  "88112": "2w",
  "87539": "5",
  "88072": "6",
  "87008": "5",
  "87501": "5",
  "87523": "5",
  "88250": "6",
  "87020": "5",
  "87043": "5",
  "87114": "5",
  "88318": "6",
  "87011": "6",
  "87937": "6",
  "87562": "5",
  "87005": "5",
  "87029": "5",
  "87028": "6",
  "87047": "5",
  "88027": "6",
  "87107": "5",
  "88113": "6",
  "88260": "6",
  "87112": "5",
  "88256": "6",
  "87010": "5",
  "87056": "5",
  "87527": "5",
  "87415": "5",
  "87747": "5",
  "87734": "5",
  "88351": "6",
  "87543": "5",
  "87524": "5",
  "88244": "6",
  "88311": "6",
  "04353": "1e",
  "04051": "1e",
  "04086": "1e",
  "04966": "1e",
  "04348": "1e",
  "04460": "1e",
  "04068": "1e",
  "04737": "1e",
  "04488": "1e",
  "04006": "1e",
  "04096": "1e",
  "04473": "1e",
  "04359": "1e",
  "04102": "1e",
  "04050": "1e",
  "04354": "1e",
  "03909": "2e",
  "03902": "1e",
  "04290": "1e",
  "04684": "1e",
  "04612": "1e",
  "04216": "1e",
  "04981": "1e",
  "04746": "1e",
  "03906": "1e",
  "04660": "1e",
  "04254": "1e",
  "04292": "1e",
  "04952": "1e",
  "04280": "1e",
  "04988": "1e",
  "04787": "1e",
  "03911": "2e",
  "04231": "1e",
  "85627": "6",
  "80504": "5",
  "81004": "5",
  "80525": "5",
  "80648": "5",
  "81007": "5",
  "81001": "5",
  "80819": "5",
  "80221": "5",
  "80137": "5",
  "81640": "5",
  "80816": "5",
  "80424": "5",
  "80723": "5",
  "80487": "5",
  "80917": "5",
  "80224": "5",
  "81082": "5",
  "80123": "5",
  "80654": "5",
  "81201": "5",
  "80421": "5",
  "80440": "5",
  "80631": "5",
  "81507": "5",
  "80903": "5",
  "80808": "5",
  "80831": "5",
  "80435": "5",
  "80122": "5",
  "81653": "5",
  "81242": "5",
  "81059": "5",
  "80132": "5",
  "80237": "5",
  "80470": "5",
  "80479": "5",
  "81521": "5",
  "80514": "5",
  "80447": "5",
  "80478": "5",
  "80468": "5",
  "80741": "5",
  "80729": "5",
  "81043": "2w",
  "81064": "2w",
  "80938": "5",
  "80927": "5",
  "80234": "5",
  "80305": "5",
  "80476": "5",
  "81650": "5",
  "81647": "5",
  "81144": "5",
  "81326": "5",
  "80807": "2w",
  "80804": "2w",
  "81029": "2w",
  "81225": "5",
  "80526": "5",
  "80209": "5",
  "80610": "5",
  "80926": "5",
  "81226": "5",
  "80649": "5",
  "80011": "5",
  "80229": "5",
  "80003": "5",
  "81642": "5",
  "81625": "5",
  "80621": "5",
  "80230": "5",
  "80465": "5",
  "80214": "5",
  "80204": "5",
  "80705": "5",
  "81320": "5",
  "81236": "5",
  "81503": "5",
  "80547": "5",
  "81621": "5",
  "80540": "5",
  "80428": "5",
  "81323": "5",
  "80921": "5",
  "80731": "2w",
  "81527": "5",
  "80102": "5",
  "80012": "5",
  "80829": "5",
  "81005": "5",
  "80426": "5",
  "81069": "5",
  "80814": "5",
  "81633": "5",
  "80264": "5",
  "80914": "5",
  "80031": "5",
  "80138": "5",
  "80422": "5",
  "80304": "5",
  "80124": "5",
  "80301": "5",
  "80026": "5",
  "80027": "5",
  "80825": "2w",
  "81045": "2w",
  "80430": "5",
  "81601": "5",
  "38773": "3e",
  "39402": "4",
  "39503": "4",
  "39753": "4",
  "39406": "4",
  "39330": "4",
  "39323": "4",
  "39174": "4",
  "38635": "3e",
  "39117": "4",
  "39218": "4",
  "39429": "4",
  "39148": "4",
  "39553": "4",
  "39669": "4",
  "38847": "3e",
  "38948": "3e",
  "38617": "3e",
  "38670": "3e",
  "39113": "4",
  "39153": "4",
  "38927": "3e",
  "38621": "3e",
  "38866": "3e",
  "39663": "4",
  "38665": "3e",
  "38962": "3e",
  "38855": "3e",
  "39462": "4",
  "39169": "4",
  "38857": "4",
  "38622": "3e",
  "38964": "3e",
  "38946": "4",
  "38725": "3w",
  "39348": "4",
  "39173": "4",
  "71859": "3w",
  "72134": "3w",
  "72166": "3w",
  "72429": "3w",
  "72851": "3w",
  "72441": "3w",
  "72156": "3w",
  "71660": "3w",
  "72435": "3w",
  "72413": "3w",
  "71972": "3w",
  "72938": "3w",
  "72933": "3w",
  "72801": "3w",
  "72824": "3w",
  "72660": "3w",
  "72001": "3w",
  "72125": "3w",
  "72845": "3w",
  "72584": "3w",
  "72682": "3w",
  "72359": "3w",
  "71748": "3w",
  "72669": "3w",
  "72587": "3w",
  "72401": "3w",
  "72904": "3w",
  "72414": "3w",
  "72419": "3w",
  "72202": "3w",
  "72427": "3w",
  "72479": "3w",
  "72227": "3w",
  "72118": "3w",
  "72132": "3w",
  "72175": "3w",
  "72160": "3w",
  "72120": "3w",
  "72106": "3w",
  "72703": "3w",
  "72015": "3w",
  "72022": "3w",
  "72011": "3w",
  "71860": "3w",
  "72143": "3w",
  "72753": "3w",
  "72370": "3w",
  "72952": "3w",
  "72747": "3w",
  "72376": "3w",
  "72047": "3w",
  "71866": "3w",
  "72331": "3w",
  "71853": "3w",
  "71865": "3w",
  "71820": "3w",
  "71640": "3w",
  "71653": "3w",
  "72010": "3w",
  "72045": "3w",
  "72640": "3w",
  "71770": "3w",
  "72031": "3w",
  "72645": "3w",
  "72368": "3w",
  "72080": "3w",
  "72320": "3w",
  "71826": "3w",
  "72579": "3w",
  "71744": "3w",
  "72042": "3w",
  "72026": "3w",
  "71862": "3w",
  "71852": "3w",
  "72425": "3w",
  "72101": "3w",
  "72526": "3w",
  "72369": "3w",
  "72036": "3w",
  "71646": "3w",
  "72576": "3w",
  "72958": "3w",
  "37330": "3e",
  "38588": "3e",
  "37680": "3e",
  "37166": "3e",
  "38575": "3e",
  "37010": "3e",
  "37722": "3e",
  "37191": "3e",
  "37142": "3e",
  "37877": "3e",
  "37643": "3e",
  "38485": "3e",
  "37762": "3e",
  "38060": "3e",
  "38046": "3e",
  "37727": "3e",
  "37387": "3e",
  "37681": "3e",
  "38382": "3e",
  "38369": "3e",
  "37303": "3e",
  "37801": "3e",
  "37807": "3e",
  "37015": "3e",
  "37138": "3e",
  "37343": "3e",
  "38483": "3e",
  "37737": "3e",
  "37219": "3e",
  "37214": "3e",
  "37350": "4",
  "38002": "3e",
  "38054": "3e",
  "37763": "3e",
  "37748": "3e",
  "38138": "3e",
  "38049": "3e",
  "37046": "3e",
  "37095": "3e",
  "37069": "3e",
  "37374": "3e",
  "37724": "3e",
  "37355": "3e",
  "38571": "3e",
  "38259": "3e",
  "38044": "3e",
  "38338": "3e",
  "38039": "3e",
  "38329": "3e",
  "37757": "3e",
  "38052": "3e",
  "37714": "3e",
  "38080": "3e",
  "37691": "3e",
  "38001": "3e",
  "37313": "3e",
  "38456": "3e",
  "38469": "3e",
  "37388": "3e",
  "37328": "3e",
  "38021": "3e",
  "38542": "3e",
  "37863": "3e",
  "37146": "3e",
  "37650": "3e",
  "37810": "3e",
  "37074": "3e",
  "37753": "3e",
  "38453": "3e",
  "37385": "3e",
  "38012": "3e",
  "38581": "3e",
  "38381": "3e",
  "38475": "3e",
  "38478": "3e",
  "37843": "3e",
  "38556": "3e",
  "37035": "3e",
  "38057": "3e",
  "37614": "3e",
  "38036": "3e",
  "37185": "3e",
  "37845": "3e",
  "38379": "3e",
  "38352": "3e",
  "37309": "3e",
  "37337": "3e",
  "38007": "3e",
  "38367": "3e",
  "38452": "3e",
  "38506": "3e",
  "38545": "3e",
  "37902": "3e",
  "38103": "3w",
  "37929": "3e",
  "38391": "3e",
  "37415": "3e",
  "37914": "3e",
  "37421": "4",
  "38111": "3e",
  "38117": "3e",
  "37721": "3e",
  "38119": "3e",
  "37373": "3e",
  "38365": "3e",
  "37829": "3e",
  "37028": "3e",
  "37370": "3e",
  "38504": "3e",
  "37841": "3e",
  "37030": "3e",
  "38488": "3e",
  "38221": "3e",
  "38232": "3e",
  "37216": "3e",
  "38451": "3e",
  "37886": "3e",
  "37315": "3e",
  "37209": "3e",
  "37215": "3e",
  "28715": "3e",
  "28395": "3e",
  "27050": "3e",
  "27886": "3e",
  "27572": "3e",
  "28753": "3e",
  "27009": "3e",
  "28216": "3e",
  "28031": "3e",
  "28401": "3e",
  "28504": "3e",
  "28609": "3e",
  "32462": "4",
  "33960": "4",
  "34957": "4",
  "34461": "4",
  "32347": "4",
  "33514": "4",
  "34987": "4",
  "32181": "4",
  "32465": "4",
  "32625": "4",
  "32071": "4",
  "33890": "4",
  "32639": "4",
  "32463": "4",
  "27549": "3e",
  "27292": "3e",
  "27801": "3e",
  "28110": "3e",
  "27011": "3e",
  "27607": "3e",
  "27713": "3e",
  "27518": "3e",
  "28071": "3e",
  "28202": "3e",
  "27883": "3e",
  "28540": "3e",
  "27569": "3e",
  "27260": "3e",
  "28578": "3e",
  "28590": "3e",
  "28305": "3e",
  "27879": "3e",
  "28314": "3e",
  "27812": "3e",
  "28344": "3e",
  "28759": "3e",
  "27021": "3e",
  "28310": "3e",
  "28356": "3e",
  "28269": "3e",
  "27406": "3e",
  "28658": "3e",
  "28405": "3e",
  "27541": "3e",
  "27016": "3e",
  "27030": "3e",
  "28341": "3e",
  "27370": "3e",
  "28112": "3e",
  "28127": "3e",
  "28671": "3e",
  "28034": "3e",
  "27282": "3e",
  "28428": "3e",
  "27313": "3e",
  "27577": "3e",
  "28366": "3e",
  "27326": "3e",
  "28144": "3e",
  "28137": "3e",
  "27608": "3e",
  "27027": "3e",
  "28088": "3e",
  "27342": "3e",
  "28170": "3e",
  "28692": "3e",
  "28782": "3e",
  "28091": "3e",
  "28573": "3e",
  "27965": "3e",
  "27810": "3e",
  "27804": "3e",
  "28650": "3e",
  "27028": "3e",
  "28508": "3e",
  "28090": "3e",
  "28638": "3e",
  "27350": "3e",
  "28469": "4",
  "28409": "3e",
  "27455": "3e",
  "27599": "3e",
  "27248": "3e",
  "27341": "3e",
  "27325": "3e",
  "28023": "3e",
  "27697": "3e",
  "27695": "3e",
  "28478": "3e",
  "27842": "3e",
  "27343": "3e",
  "27958": "3e",
  "28393": "3e",
  "27876": "3e",
  "28618": "3e",
  "27824": "3e",
  "28773": "3e",
  "27007": "3e",
  "28731": "3e",
  "27615": "3e",
  "28790": "3e",
  "28713": "3e",
  "28430": "4",
  "28150": "3e",
  "28552": "3e",
  "27922": "3e",
  "27563": "3e",
  "27921": "3e",
  "27356": "3e",
  "28631": "3e",
  "05862": "1e",
  "05672": "1e",
  "05678": "1e",
  "05819": "1e",
  "05658": "1e",
  "05867": "1e",
  "05069": "1e",
  "05753": "1e",
  "05734": "1e",
  "05083": "1e",
  "05032": "1e",
  "05763": "1e",
  "05344": "2e",
  "05351": "2e",
  "05034": "1e",
  "05261": "2e",
  "05744": "1e",
  "05353": "1e",
  "05757": "1e",
  "05341": "2e",
  "79311": "6",
  "79918": "6",
  "79934": "6",
  "76597": "6",
  "79920": "6",
  "78588": "6",
  "75651": "3w",
  "75851": "3w",
  "79046": "2w",
  "76875": "6",
  "76523": "6",
  "79851": "6",
  "76836": "6",
  "75056": "3w",
  "78595": "4",
  "78562": "4",
  "79012": "2w",
  "78558": "4",
  "76444": "6",
  "79356": "6",
  "75758": "3w",
  "75760": "3w",
  "76518": "6",
  "78840": "6",
  "75662": "3w",
  "79018": "2w",
  "79755": "6",
  "75936": "4",
  "75684": "3w",
  "78005": "6",
  "75691": "3w",
  "78357": "6",
  "79358": "6",
  "77475": "6",
  "75948": "4",
  "75845": "3w",
  "75855": "3w",
  "78021": "6",
  "75645": "3w",
  "78383": "6",
  "76864": "6",
  "76436": "6",
  "79749": "6",
  "76462": "3w",
  "79044": "2w",
  "79788": "6",
  "79561": "6",
  "75630": "3w",
  "76825": "6",
  "78539": "4",
  "75035": "3w",
  "78731": "6",
  "76534": "6",
  "76513": "6",
  "75033": "3w",
  "75009": "3w",
  "78759": "6",
  "78570": "4",
  "76527": "6",
  "78757": "6",
  "76305": "3w",
  "77659": "4",
  "78748": "6",
  "75287": "3w",
  "75013": "3w",
  "75082": "3w",
  "78735": "6",
  "78653": "6",
  "75126": "3w",
  "75160": "3w",
  "78754": "6",
  "76111": "3w",
  "78726": "6",
  "78613": "6",
  "76670": "3w",
  "75101": "3w",
  "76641": "3w",
  "76117": "3w",
  "75154": "3w",
  "75169": "3w",
  "76109": "3w",
  "76018": "3w",
  "76115": "3w",
  "78201": "6",
  "76071": "3w",
  "76034": "3w",
  "40348": "3e",
  "40056": "3e",
  "40701": "3e",
  "42240": "3e",
  "40510": "3e",
  "42351": "3e",
  "41092": "2e",
  "40940": "3e",
  "41606": "3e",
  "40078": "3e",
  "42064": "3e",
  "42261": "3e",
  "41314": "3e",
  "40734": "3e",
  "41230": "3e",
  "41224": "3e",
  "42539": "3e",
  "42754": "3e",
  "40862": "3e",
  "42726": "3e",
  "42528": "3e",
  "40372": "3e",
  "42023": "3e",
  "42716": "3e",
  "42717": "3e",
  "40075": "2e",
  "42087": "3w",
  "42325": "3e",
  "40111": "3e",
  "42134": "3e",
  "40855": "3e",
  "42409": "3e",
  "40972": "3e",
  "40856": "3e",
  "40011": "3e",
  "41812": "3e",
  "42464": "3e",
  "41055": "3e",
  "42286": "3e",
  "41064": "3e",
  "40927": "3e",
  "42371": "3e",
  "41385": "3e",
  "41817": "3e",
  "41271": "3e",
  "41263": "3e",
  "40935": "3e",
  "41836": "3e",
  "40828": "3e",
  "40763": "3e",
  "41264": "3e",
  "41825": "3e",
  "40012": "3e",
  "42204": "3e",
  "40006": "2e",
  "41833": "3e",
  "41845": "3e",
  "41572": "3e",
  "41647": "3e",
  "41513": "3e",
  "41766": "3e",
  "41777": "3e",
  "41524": "3e",
  "40921": "3e",
  "41615": "3e",
  "42746": "3e",
  "46637": "2e",
  "46513": "2e",
  "47033": "2e",
  "46572": "2e",
  "47871": "2e",
  "47352": "2e",
  "47385": "2e",
  "47448": "2e",
  "46156": "2e",
  "46146": "2e",
  "46144": "2e",
  "46595": "2e",
  "47331": "2e",
  "47564": "2e",
  "47427": "2e",
  "47557": "2e",
  "46214": "2e",
  "47946": "2e",
  "47917": "2e",
  "46349": "2e",
  "47521": "2e",
  "46405": "2e",
  "47834": "2e",
  "46312": "2e",
  "47601": "3e",
  "46799": "2e",
  "46406": "2e",
  "46740": "2e",
  "47874": "2e",
  "47802": "2e",
  "46968": "2e",
  "46951": "2e",
  "47140": "3e",
  "46932": "2e",
  "47116": "3e",
  "47274": "2e",
  "47165": "2e",
  "47384": "2e",
  "47016": "2e",
  "47235": "2e",
  "47034": "2e",
  "46543": "2e",
  "46815": "2e",
  "47250": "2e",
  "46056": "2e",
  "47102": "2e",
  "47018": "2e",
  "46151": "2e",
  "46131": "2e",
  "46508": "2e",
  "47470": "2e",
  "46140": "2e",
  "46106": "2e",
  "47993": "2e",
  "46058": "2e",
  "47906": "2e",
  "15007": "2e",
  "19023": "2e",
  "19018": "2e",
  "19113": "2e",
  "18657": "2e",
  "18636": "2e",
  "18625": "2e",
  "18846": "2e",
  "15238": "2e",
  "15144": "2e",
  "15057": "2e",
  "15017": "2e",
  "15049": "2e",
  "15214": "2e",
  "16725": "2e",
  "16744": "2e",
  "16239": "2e",
  "15132": "2e",
  "15025": "2e",
  "15063": "2e",
  "15148": "2e",
  "15668": "2e",
  "15208": "2e",
  "15420": "2e",
  "15421": "2e",
  "49650": "1e",
  "48867": "1e",
  "49328": "2e",
  "49032": "2e",
  "48866": "1e",
  "49076": "2e",
  "49021": "2e",
  "49918": "1e",
  "48851": "1e",
  "48890": "2e",
  "49404": "1e",
  "49424": "2e",
  "48439": "1e",
  "49435": "1e",
  "48701": "1e",
  "49675": "1e",
  "48334": "2e",
  "49534": "1e",
  "49955": "1e",
  "49253": "2e",
  "49265": "2e",
  "49321": "1e",
  "48436": "1e",
  "48374": "2e",
  "48393": "2e",
  "48377": "2e",
  "49826": "1e",
  "49626": "1e",
  "49922": "1e",
  "49796": "1e",
  "48093": "2e",
  "48085": "2e",
  "15901": "2e",
  "18231": "2e",
  "18242": "2e",
  "17923": "2e",
  "17974": "2e",
  "17968": "2e",
  "18080": "2e",
  "18211": "2e",
  "81415": "5",
  "80736": "2w",
  "80722": "5",
  "81044": "2w",
  "81418": "5",
  "81426": "5",
  "81235": "5",
  "81132": "5",
  "81128": "5",
  "81244": "5",
  "80742": "5",
  "80644": "5",
  "80538": "5",
  "80611": "5",
  "80920": "5",
  "80045": "5",
  "80449": "5",
  "81632": "5",
  "80827": "5",
  "81211": "5",
  "80701": "5",
  "80223": "5",
  "80911": "5",
  "80916": "5",
  "80928": "5",
  "81008": "5",
  "94060": "7",
  "92707": "6",
  "92660": "6",
  "93550": "6",
  "93551": "6",
  "90742": "6",
  "92096": "6",
  "95065": "7",
  "94964": "7",
  "90740": "6",
  "95033": "7",
  "91401": "6",
  "95041": "7",
  "90035": "6",
  "90015": "6",
  "90008": "6",
  "90048": "6",
  "96101": "5",
  "96075": "7",
  "93631": "6",
  "95819": "7",
  "90020": "6",
  "95957": "7",
  "95075": "7",
  "95973": "7",
  "95045": "7",
  "93529": "5",
  "90805": "6",
  "93604": "6",
  "93643": "6",
  "93633": "6",
  "93286": "6",
  "90755": "6",
  "95563": "7",
  "95699": "6",
  "95221": "6",
  "95324": "7",
  "93706": "6",
  "90017": "6",
  "90266": "6",
  "95226": "6",
  "95225": "6",
  "96097": "7",
  "96116": "5",
  "94544": "7",
  "95548": "7",
  "91766": "6",
  "90057": "6",
  "96112": "5",
  "95665": "6",
  "95255": "6",
  "95257": "6",
  "93666": "6",
  "90201": "6",
  "91776": "6",
  "90230": "6",
  "95348": "6",
  "95814": "7",
  "95923": "5",
  "93108": "7",
  "93670": "6",
  "90403": "6",
  "96027": "7",
  "62990": "3e",
  "62313": "2e",
  "62083": "2e",
  "62334": "2e",
  "62843": "2e",
  "62553": "2e",
  "62630": "2e",
  "62886": "2e",
  "62565": "2e",
  "61046": "2e",
  "62691": "2e",
  "62534": "2e",
  "62835": "3e",
  "62969": "3e",
  "60959": "2e",
  "61015": "2e",
  "60129": "2e",
  "61775": "2e",
  "60113": "2e",
  "61328": "2e",
  "61376": "2e",
  "61320": "2e",
  "61341": "2e",
  "61321": "2e",
  "61778": "2e",
  "61031": "2e",
  "62448": "2e",
  "62964": "3e",
  "62960": "3e",
  "62624": "2e",
  "62908": "3e",
  "62829": "3e",
  "61460": "2e",
  "62953": "3e",
  "62480": "2e",
  "62436": "2e",
  "62459": "2e",
  "62419": "2e",
  "61018": "2e",
  "61013": "2e",
  "62301": "2w",
  "61010": "2e",
  "61370": "2e",
  "61359": "2e",
  "60549": "2e",
  "61727": "2e",
  "61091": "2e",
  "62910": "3e",
  "62956": "3e",
  "62931": "3e",
  "62440": "2e",
  "62468": "2e",
  "62979": "3e",
  "62469": "2e",
  "62452": "2e",
  "61252": "2e",
  "61070": "2e",
  "61060": "2e",
  "61057": "2e",
  "61402": "2e",
  "60115": "2e",
  "61401": "2e",
  "61054": "2e",
  "60481": "2e",
  "61602": "2e",
  "62526": "2e",
  "62521": "2e",
  "61101": "2e",
  "61108": "2e",
  "62543": "2e",
  "62544": "2e",
  "61615": "2e",
  "60550": "2e",
  "60618": "2e",
  "62501": "2e",
  "61531": "2e",
  "61914": "2e",
  "60520": "2e",
  "62535": "2e",
  "60620": "2e",
  "61016": "2e",
  "61725": "2e",
  "61019": "2e",
  "61761": "2e",
  "61533": "2e",
  "61547": "2e",
  "61020": "2e",
  "60645": "2e",
  "62951": "3e",
  "89138": "5",
  "89148": "5",
  "89044": "5",
  "89446": "5",
  "89314": "5",
  "89414": "5",
  "89801": "5",
  "89042": "5",
  "97426": "7",
  "97214": "7",
  "97405": "7",
  "97498": "7",
  "97414": "7",
  "97438": "7",
  "97540": "7",
  "97522": "7",
  "97541": "7",
  "97229": "7",
  "97221": "7",
  "97210": "7",
  "97080": "7",
  "97060": "7",
  "97473": "7",
  "97373": "7",
  "97322": "7",
  "97127": "7",
  "97132": "7",
  "97062": "7",
  "97038": "7",
  "97004": "7",
  "97462": "7",
  "97223": "7",
  "97111": "7",
  "97007": "7",
  "97109": "7",
  "97368": "7",
  "97532": "7",
  "97810": "5",
  "97447": "7",
  "97415": "7",
  "97823": "5",
  "97391": "7",
  "97058": "5",
  "97107": "7",
  "97136": "7",
  "97721": "5",
  "97130": "7",
  "97818": "5",
  "97876": "5",
  "97626": "7",
  "97048": "7",
  "97623": "5",
  "97621": "5",
  "97634": "5",
  "97001": "5",
  "97480": "7",
  "97448": "7",
  "97402": "7",
  "97493": "7",
  "97310": "7",
  "97302": "7",
  "97487": "7",
  "97406": "7",
  "97304": "7",
  "97101": "7",
  "97360": "7",
  "97385": "7",
  "97384": "7",
  "97009": "7",
  "97486": "7",
  "97015": "7",
  "97224": "7",
  "97116": "7"
};

// For use in browser
if (typeof window !== 'undefined') {
  window.zipToClimateRegion = zipToClimateRegion;
}

// For use in Node.js
if (typeof module !== 'undefined' && module.exports) {
  module.exports = zipToClimateRegion;
}
